const changsanjiaoMapJson = {
    name: 'changsanjiaoMap',
    type: 'FeatureCollection',
    features: [
        {
            type: 'Feature',
            properties: {
                adcode: 320000,
                name: '江苏省',
                center: [118.767413, 32.041544],
                centroid: [119.486395, 32.983908],
                childrenNum: 13,
                level: 'province',
                acroutes: [100000],
                parent: { adcode: 100000 },
            },
            geometry: {
                type: 'MultiPolygon',
                coordinates: [
                    [
                        [
                            [118.408205, 34.435512],
                            [118.416231, 34.473885],
                            [118.421395, 34.48324],
                            [118.43088, 34.489076],
                            [118.439523, 34.507995],
                            [118.440421, 34.52751],
                            [118.428017, 34.561169],
                            [118.423864, 34.592929],
                            [118.439186, 34.626305],
                            [118.45434, 34.617737],
                            [118.463657, 34.625277],
                            [118.473816, 34.623435],
                            [118.474882, 34.637184],
                            [118.466463, 34.643137],
                            [118.460851, 34.657569],
                            [118.468484, 34.674309],
                            [118.484255, 34.670884],
                            [118.500812, 34.675165],
                            [118.508164, 34.687066],
                            [118.522701, 34.692288],
                            [118.525226, 34.712573],
                            [118.539314, 34.711503],
                            [118.546105, 34.706197],
                            [118.558901, 34.706839],
                            [118.570463, 34.71253],
                            [118.601332, 34.714156],
                            [118.604924, 34.696482],
                            [118.633716, 34.687023],
                            [118.650554, 34.69507],
                            [118.664304, 34.693443],
                            [118.681366, 34.678333],
                            [118.69029, 34.67859],
                            [118.704041, 34.688778],
                            [118.720093, 34.694214],
                            [118.744732, 34.695284],
                            [118.766228, 34.705213],
                            [118.76735, 34.710519],
                            [118.783402, 34.722029],
                            [118.768529, 34.738072],
                            [118.759212, 34.740853],
                            [118.74013, 34.736917],
                            [118.730364, 34.74543],
                            [118.716501, 34.747739],
                            [118.716445, 34.76382],
                            [118.727221, 34.768738],
                            [118.738502, 34.766857],
                            [118.740186, 34.781224],
                            [118.728399, 34.786867],
                            [118.737548, 34.792083],
                            [118.759998, 34.790287],
                            [118.77358, 34.795332],
                            [118.779024, 34.809608],
                            [118.776611, 34.818754],
                            [118.781999, 34.827472],
                            [118.768248, 34.838795],
                            [118.769034, 34.846143],
                            [118.788734, 34.845673],
                            [118.797265, 34.842853],
                            [118.804617, 34.852466],
                            [118.804449, 34.870277],
                            [118.807199, 34.877708],
                            [118.829761, 34.91114],
                            [118.860799, 34.944003],
                            [118.859227, 34.962647],
                            [118.86512, 34.99323],
                            [118.862482, 35.025719],
                            [118.865345, 35.029854],
                            [118.885774, 35.034244],
                            [118.903847, 35.041319],
                            [118.911143, 35.047754],
                            [118.926521, 35.05078],
                            [118.945155, 35.040808],
                            [118.965641, 35.046476],
                            [118.992132, 35.048181],
                            [118.999877, 35.053039],
                            [119.02721, 35.05534],
                            [119.037368, 35.051334],
                            [119.06139, 35.05159],
                            [119.073625, 35.056661],
                            [119.114597, 35.054956],
                            [119.120378, 35.058024],
                            [119.12049, 35.070083],
                            [119.12947, 35.076175],
                            [119.138057, 35.09628],
                            [119.159048, 35.100965],
                            [119.171395, 35.107183],
                            [119.203218, 35.110888],
                            [119.220729, 35.107183],
                            [119.24071, 35.122938],
                            [119.252665, 35.122683],
                            [119.273768, 35.115487],
                            [119.286677, 35.115146],
                            [119.30183, 35.093171],
                            [119.305871, 35.076686],
                            [119.293524, 35.07298],
                            [119.292682, 35.068506],
                            [119.307162, 35.03305],
                            [119.29184, 35.02849],
                            [119.281064, 35.053678],
                            [119.285442, 35.068506],
                            [119.279436, 35.071105],
                            [119.238072, 35.048479],
                            [119.232572, 35.041831],
                            [119.227521, 35.020944],
                            [119.21899, 35.004828],
                            [119.211357, 34.981715],
                            [119.211806, 34.957912],
                            [119.214612, 34.937687],
                            [119.212704, 34.917799],
                            [119.202433, 34.890433],
                            [119.21377, 34.876726],
                            [119.210515, 34.862333],
                            [119.218035, 34.852594],
                            [119.220393, 34.841187],
                            [119.213602, 34.833924],
                            [119.238577, 34.799563],
                            [119.250756, 34.794049],
                            [119.272196, 34.797811],
                            [119.312831, 34.774724],
                            [119.324393, 34.770406],
                            [119.342689, 34.769251],
                            [119.355037, 34.775751],
                            [119.370864, 34.772971],
                            [119.378497, 34.764547],
                            [119.440684, 34.769208],
                            [119.438271, 34.784302],
                            [119.456175, 34.779813],
                            [119.459486, 34.77109],
                            [119.477165, 34.769037],
                            [119.480421, 34.76412],
                            [119.49709, 34.759458],
                            [119.48839, 34.747868],
                            [119.468241, 34.748167],
                            [119.460777, 34.754069],
                            [119.444332, 34.758432],
                            [119.399993, 34.755823],
                            [119.378273, 34.761383],
                            [119.381809, 34.752444],
                            [119.457129, 34.748167],
                            [119.483508, 34.736404],
                            [119.508427, 34.729217],
                            [119.525714, 34.733281],
                            [119.522795, 34.722329],
                            [119.507978, 34.711032],
                            [119.492488, 34.711546],
                            [119.491814, 34.69554],
                            [119.484855, 34.692716],
                            [119.474584, 34.696054],
                            [119.464986, 34.674694],
                            [119.537051, 34.633758],
                            [119.560736, 34.63153],
                            [119.56893, 34.615381],
                            [119.584926, 34.601328],
                            [119.611248, 34.592929],
                            [119.62528, 34.585901],
                            [119.641388, 34.568971],
                            [119.697906, 34.546593],
                            [119.741066, 34.532871],
                            [119.781813, 34.515759],
                            [119.811615, 34.485557],
                            [119.823009, 34.481996],
                            [119.8495, 34.477404],
                            [119.919039, 34.469122],
                            [119.962536, 34.458907],
                            [120.043019, 34.422201],
                            [120.103691, 34.391622],
                            [120.233284, 34.337179],
                            [120.292833, 34.318092],
                            [120.311635, 34.307042],
                            [120.308492, 34.297452],
                            [120.314272, 34.255814],
                            [120.331671, 34.209333],
                            [120.347499, 34.179236],
                            [120.355973, 34.149559],
                            [120.359846, 34.121897],
                            [120.367591, 34.091424],
                            [120.424671, 33.975121],
                            [120.485454, 33.859221],
                            [120.500384, 33.817928],
                            [120.534508, 33.782587],
                            [120.570596, 33.702247],
                            [120.583786, 33.668462],
                            [120.611175, 33.627251],
                            [120.622849, 33.615113],
                            [120.651136, 33.575699],
                            [120.680153, 33.520297],
                            [120.717476, 33.436715],
                            [120.719833, 33.420467],
                            [120.728252, 33.384571],
                            [120.730777, 33.365183],
                            [120.740992, 33.337615],
                            [120.760748, 33.319869],
                            [120.769335, 33.306818],
                            [120.782862, 33.304208],
                            [120.796388, 33.306122],
                            [120.81373, 33.303425],
                            [120.821812, 33.298552],
                            [120.832589, 33.282148],
                            [120.831971, 33.26883],
                            [120.820297, 33.256077],
                            [120.819455, 33.238184],
                            [120.843028, 33.22965],
                            [120.846844, 33.219852],
                            [120.843757, 33.209835],
                            [120.859865, 33.142781],
                            [120.874065, 33.093645],
                            [120.87182, 33.04723],
                            [120.894438, 33.038634],
                            [120.917843, 33.02576],
                            [120.932604, 33.005899],
                            [120.940124, 32.975467],
                            [120.950395, 32.916405],
                            [120.957579, 32.893504],
                            [120.972677, 32.88568],
                            [120.978682, 32.875712],
                            [120.981376, 32.85971],
                            [120.971947, 32.761182],
                            [120.963136, 32.750238],
                            [120.952865, 32.714068],
                            [120.93294, 32.715688],
                            [120.915036, 32.711703],
                            [120.915934, 32.701234],
                            [120.933838, 32.69221],
                            [120.950059, 32.689581],
                            [120.963585, 32.682396],
                            [120.976044, 32.658426],
                            [120.979637, 32.636335],
                            [120.961733, 32.612178],
                            [120.988448, 32.606741],
                            [121.020496, 32.605513],
                            [121.051701, 32.587137],
                            [121.076901, 32.576391],
                            [121.153119, 32.529266],
                            [121.269523, 32.483434],
                            [121.287652, 32.480185],
                            [121.351915, 32.474256],
                            [121.390529, 32.460729],
                            [121.417413, 32.443115],
                            [121.425495, 32.431033],
                            [121.440536, 32.366071],
                            [121.447047, 32.299258],
                            [121.45019, 32.282272],
                            [121.457767, 32.27391],
                            [121.493912, 32.263478],
                            [121.49958, 32.211169],
                            [121.479263, 32.197999],
                            [121.461527, 32.193726],
                            [121.458609, 32.17769],
                            [121.473089, 32.169803],
                            [121.50306, 32.170067],
                            [121.542291, 32.152131],
                            [121.52551, 32.136528],
                            [121.544368, 32.123039],
                            [121.59258, 32.112943],
                            [121.729637, 32.069194],
                            [121.759047, 32.0594],
                            [121.772405, 32.033235],
                            [121.856031, 31.955225],
                            [121.870287, 31.928279],
                            [121.874833, 31.90212],
                            [121.889145, 31.866627],
                            [121.897452, 31.85354],
                            [121.941005, 31.776572],
                            [121.960143, 31.736868],
                            [121.970302, 31.718892],
                            [121.96772, 31.703924],
                            [121.975185, 31.617035],
                            [121.81781, 31.652049],
                            [121.715269, 31.673848],
                            [121.642643, 31.697458],
                            [121.63327, 31.696173],
                            [121.600886, 31.70698],
                            [121.599651, 31.703127],
                            [121.565022, 31.716722],
                            [121.539429, 31.735496],
                            [121.51305, 31.743686],
                            [121.49857, 31.753247],
                            [121.487738, 31.753424],
                            [121.455578, 31.759356],
                            [121.4315, 31.76927],
                            [121.420893, 31.779581],
                            [121.410902, 31.795598],
                            [121.41629, 31.797634],
                            [121.385029, 31.833552],
                            [121.369314, 31.843281],
                            [121.323066, 31.868528],
                            [121.301907, 31.872727],
                            [121.265594, 31.864107],
                            [121.225296, 31.84704],
                            [121.200321, 31.835144],
                            [121.181519, 31.820416],
                            [121.149247, 31.78728],
                            [121.11849, 31.75909],
                            [121.145318, 31.753911],
                            [121.289111, 31.616282],
                            [121.345573, 31.571676],
                            [121.372232, 31.553224],
                            [121.343496, 31.512049],
                            [121.319923, 31.499711],
                            [121.310326, 31.505925],
                            [121.299943, 31.499756],
                            [121.298596, 31.4915],
                            [121.26885, 31.48746],
                            [121.261441, 31.478848],
                            [121.247073, 31.477072],
                            [121.240899, 31.493675],
                            [121.234725, 31.492698],
                            [121.230348, 31.477427],
                            [121.219067, 31.475207],
                            [121.214352, 31.479114],
                            [121.186065, 31.460822],
                            [121.186065, 31.454339],
                            [121.174952, 31.449276],
                            [121.160921, 31.449676],
                            [121.147339, 31.443947],
                            [121.14689, 31.437241],
                            [121.162717, 31.432222],
                            [121.164288, 31.427203],
                            [121.146272, 31.421072],
                            [121.158844, 31.4101],
                            [121.143803, 31.392327],
                            [121.148461, 31.385395],
                            [121.113776, 31.374462],
                            [121.12023, 31.368684],
                            [121.109286, 31.364684],
                            [121.108332, 31.350637],
                            [121.117255, 31.351704],
                            [121.117985, 31.343435],
                            [121.130445, 31.344191],
                            [121.133307, 31.325561],
                            [121.127246, 31.319291],
                            [121.12994, 31.302613],
                            [121.139649, 31.302969],
                            [121.143803, 31.309685],
                            [121.151267, 31.291937],
                            [121.161314, 31.283975],
                            [121.154242, 31.276723],
                            [121.142905, 31.277657],
                            [121.120342, 31.286154],
                            [121.11501, 31.285265],
                            [121.105469, 31.273653],
                            [121.09879, 31.276233],
                            [121.090147, 31.291893],
                            [121.084703, 31.287622],
                            [121.080437, 31.270138],
                            [121.063263, 31.267913],
                            [121.060962, 31.246509],
                            [121.064329, 31.246153],
                            [121.062646, 31.224655],
                            [121.075442, 31.173449],
                            [121.077014, 31.158438],
                            [121.065733, 31.148593],
                            [121.062533, 31.153137],
                            [121.041486, 31.14984],
                            [121.041823, 31.13888],
                            [121.025659, 31.140751],
                            [121.018475, 31.134113],
                            [120.983902, 31.131706],
                            [120.930359, 31.14142],
                            [120.905383, 31.134202],
                            [120.881305, 31.134736],
                            [120.872325, 31.127161],
                            [120.870585, 31.119719],
                            [120.857901, 31.108533],
                            [120.856778, 31.102828],
                            [120.869575, 31.097212],
                            [120.892193, 31.094181],
                            [120.902128, 31.085666],
                            [120.894551, 31.053875],
                            [120.901959, 31.037641],
                            [120.901342, 31.017479],
                            [120.895168, 31.017345],
                            [120.891352, 31.003737],
                            [120.86806, 30.995348],
                            [120.865646, 30.989815],
                            [120.853692, 30.993206],
                            [120.847349, 30.989592],
                            [120.840053, 30.997803],
                            [120.820914, 31.006369],
                            [120.802898, 31.005388],
                            [120.769953, 30.996642],
                            [120.770177, 30.978078],
                            [120.760692, 30.975445],
                            [120.745931, 30.9625],
                            [120.736109, 30.963706],
                            [120.725614, 30.971517],
                            [120.710067, 30.971919],
                            [120.705521, 30.966473],
                            [120.698225, 30.970803],
                            [120.684474, 30.95518],
                            [120.697551, 30.950358],
                            [120.70945, 30.933169],
                            [120.712705, 30.919683],
                            [120.709843, 30.907535],
                            [120.713266, 30.885067],
                            [120.702546, 30.884039],
                            [120.704286, 30.872959],
                            [120.699909, 30.867821],
                            [120.68279, 30.882565],
                            [120.673642, 30.87573],
                            [120.66309, 30.861342],
                            [120.658713, 30.865274],
                            [120.655401, 30.847489],
                            [120.644176, 30.855354],
                            [120.626216, 30.856069],
                            [120.615496, 30.849589],
                            [120.60298, 30.848919],
                            [120.588949, 30.854416],
                            [120.580867, 30.845656],
                            [120.563805, 30.835511],
                            [120.518231, 30.773227],
                            [120.504425, 30.757974],
                            [120.489439, 30.763432],
                            [120.476979, 30.785571],
                            [120.477204, 30.800014],
                            [120.455259, 30.816825],
                            [120.460984, 30.828269],
                            [120.460422, 30.839846],
                            [120.454473, 30.849634],
                            [120.441284, 30.856292],
                            [120.45234, 30.867911],
                            [120.439544, 30.885201],
                            [120.436345, 30.896949],
                            [120.442294, 30.900612],
                            [120.434998, 30.920799],
                            [120.423436, 30.927453],
                            [120.417992, 30.925578],
                            [120.423492, 30.903069],
                            [120.3947, 30.890785],
                            [120.379434, 30.890785],
                            [120.372418, 30.882163],
                            [120.364673, 30.880465],
                            [120.357994, 30.887077],
                            [120.360127, 30.892795],
                            [120.356928, 30.908875],
                            [120.362709, 30.921648],
                            [120.359453, 30.931919],
                            [120.371127, 30.948751],
                            [120.343514, 30.94],
                            [120.308099, 30.932276],
                            [120.250739, 30.926248],
                            [120.221778, 30.926873],
                            [120.149657, 30.937455],
                            [120.135121, 30.941875],
                            [120.111043, 30.955894],
                            [120.103971, 30.965223],
                            [120.052449, 31.005745],
                            [120.017034, 31.017791],
                            [120.001711, 31.027114],
                            [119.988522, 31.059226],
                            [119.969776, 31.074298],
                            [119.94626, 31.106215],
                            [119.936775, 31.146543],
                            [119.921059, 31.1612],
                            [119.919993, 31.17091],
                            [119.900237, 31.169173],
                            [119.878348, 31.160799],
                            [119.866618, 31.168327],
                            [119.842147, 31.168772],
                            [119.837545, 31.173671],
                            [119.826489, 31.173181],
                            [119.823458, 31.165832],
                            [119.829744, 31.161378],
                            [119.823289, 31.154117],
                            [119.809875, 31.148504],
                            [119.801008, 31.156344],
                            [119.791298, 31.156611],
                            [119.793375, 31.168059],
                            [119.779343, 31.178793],
                            [119.755378, 31.170776],
                            [119.740505, 31.173404],
                            [119.713116, 31.167614],
                            [119.703855, 31.151889],
                            [119.682752, 31.160487],
                            [119.678037, 31.168193],
                            [119.663726, 31.165966],
                            [119.662491, 31.159863],
                            [119.641837, 31.148414],
                            [119.638132, 31.135538],
                            [119.63078, 31.131261],
                            [119.613718, 31.129167],
                            [119.599799, 31.109157],
                            [119.582007, 31.108667],
                            [119.574094, 31.11397],
                            [119.571343, 31.128988],
                            [119.560231, 31.140707],
                            [119.545863, 31.147835],
                            [119.532617, 31.159106],
                            [119.514376, 31.156077],
                            [119.494508, 31.164006],
                            [119.485584, 31.161601],
                            [119.482497, 31.152513],
                            [119.475818, 31.158928],
                            [119.460608, 31.156389],
                            [119.454771, 31.164897],
                            [119.438832, 31.177056],
                            [119.423454, 31.181866],
                            [119.415428, 31.172959],
                            [119.400611, 31.178749],
                            [119.391182, 31.174518],
                            [119.389329, 31.188324],
                            [119.395335, 31.193356],
                            [119.405662, 31.192777],
                            [119.394886, 31.19959],
                            [119.379171, 31.189214],
                            [119.371369, 31.197719],
                            [119.365757, 31.195938],
                            [119.360088, 31.212145],
                            [119.365196, 31.232667],
                            [119.370528, 31.242548],
                            [119.379676, 31.269382],
                            [119.371594, 31.271606],
                            [119.367946, 31.288957],
                            [119.356609, 31.30328],
                            [119.350154, 31.301012],
                            [119.35021, 31.280905],
                            [119.345945, 31.268981],
                            [119.337526, 31.258881],
                            [119.33326, 31.264131],
                            [119.314851, 31.265733],
                            [119.294815, 31.263241],
                            [119.266977, 31.250425],
                            [119.26142, 31.261328],
                            [119.249746, 31.261995],
                            [119.249971, 31.256967],
                            [119.238577, 31.254653],
                            [119.236276, 31.259326],
                            [119.218148, 31.264799],
                            [119.215285, 31.274098],
                            [119.204229, 31.265689],
                            [119.197157, 31.27352],
                            [119.199458, 31.293583],
                            [119.181105, 31.300478],
                            [119.176222, 31.293939],
                            [119.15815, 31.294784],
                            [119.149787, 31.276945],
                            [119.140695, 31.276011],
                            [119.13222, 31.262752],
                            [119.120041, 31.261684],
                            [119.10702, 31.250603],
                            [119.10528, 31.235293],
                            [119.083728, 31.239744],
                            [119.073794, 31.23289],
                            [119.062344, 31.238498],
                            [119.048818, 31.233557],
                            [119.014526, 31.241524],
                            [119.0033, 31.233735],
                            [118.986463, 31.231154],
                            [118.984218, 31.237474],
                            [118.92495, 31.2397],
                            [118.915184, 31.244195],
                            [118.891219, 31.237964],
                            [118.869666, 31.242237],
                            [118.840481, 31.236361],
                            [118.831277, 31.229462],
                            [118.819491, 31.236005],
                            [118.806357, 31.229507],
                            [118.79575, 31.229373],
                            [118.781382, 31.239833],
                            [118.778575, 31.261684],
                            [118.761401, 31.277702],
                            [118.726603, 31.28224],
                            [118.707914, 31.296786],
                            [118.704434, 31.302791],
                            [118.719588, 31.294784],
                            [118.721103, 31.32267],
                            [118.735078, 31.344769],
                            [118.745742, 31.372684],
                            [118.75461, 31.385084],
                            [118.765386, 31.387928],
                            [118.770886, 31.376951],
                            [118.767575, 31.363973],
                            [118.784525, 31.368595],
                            [118.80024, 31.368995],
                            [118.829481, 31.377529],
                            [118.847385, 31.393927],
                            [118.851145, 31.392549],
                            [118.86961, 31.421561],
                            [118.866074, 31.44488],
                            [118.870508, 31.463042],
                            [118.883193, 31.496471],
                            [118.886279, 31.527669],
                            [118.873539, 31.532062],
                            [118.875111, 31.551982],
                            [118.881958, 31.565156],
                            [118.873315, 31.578417],
                            [118.877299, 31.589902],
                            [118.862258, 31.595001],
                            [118.870789, 31.599346],
                            [118.868768, 31.611139],
                            [118.858554, 31.62395],
                            [118.832848, 31.630377],
                            [118.819547, 31.628516],
                            [118.814495, 31.619252],
                            [118.802765, 31.619473],
                            [118.79603, 31.628294],
                            [118.789576, 31.646554],
                            [118.782953, 31.656258],
                            [118.799005, 31.666361],
                            [118.774141, 31.682619],
                            [118.768304, 31.677481],
                            [118.760503, 31.680271],
                            [118.748099, 31.675753],
                            [118.745125, 31.656524],
                            [118.7394, 31.651074],
                            [118.735976, 31.633436],
                            [118.72868, 31.634233],
                            [118.719419, 31.627452],
                            [118.71695, 31.639463],
                            [118.694949, 31.639729],
                            [118.685127, 31.636139],
                            [118.673846, 31.640527],
                            [118.65785, 31.641103],
                            [118.643594, 31.649656],
                            [118.647972, 31.65936],
                            [118.643257, 31.671367],
                            [118.646962, 31.679873],
                            [118.654931, 31.67562],
                            [118.671432, 31.688201],
                            [118.674407, 31.696483],
                            [118.680749, 31.696616],
                            [118.697699, 31.709416],
                            [118.687372, 31.716147],
                            [118.684902, 31.724914],
                            [118.677269, 31.728589],
                            [118.653977, 31.730139],
                            [118.652125, 31.73979],
                            [118.641686, 31.743996],
                            [118.648365, 31.748821],
                            [118.641686, 31.758249],
                            [118.627037, 31.759444],
                            [118.619068, 31.75006],
                            [118.609358, 31.757187],
                            [118.600995, 31.754133],
                            [118.593082, 31.744438],
                            [118.57529, 31.740941],
                            [118.571698, 31.746253],
                            [118.55312, 31.729032],
                            [118.529772, 31.742358],
                            [118.529379, 31.748555],
                            [118.538696, 31.749352],
                            [118.53965, 31.761569],
                            [118.533869, 31.767234],
                            [118.523599, 31.762011],
                            [118.510746, 31.765641],
                            [118.502608, 31.778342],
                            [118.482178, 31.778342],
                            [118.486107, 31.795421],
                            [118.504741, 31.841733],
                            [118.490597, 31.843148],
                            [118.475443, 31.850312],
                            [118.466744, 31.858005],
                            [118.467081, 31.868881],
                            [118.4723, 31.879623],
                            [118.452263, 31.884663],
                            [118.44014, 31.892707],
                            [118.41595, 31.901457],
                            [118.402986, 31.914007],
                            [118.386036, 31.914803],
                            [118.375316, 31.925319],
                            [118.364371, 31.930178],
                            [118.369198, 31.94299],
                            [118.368974, 31.956196],
                            [118.379974, 31.968341],
                            [118.376719, 31.981721],
                            [118.387158, 31.983267],
                            [118.390975, 31.989536],
                            [118.389628, 32.01205],
                            [118.401526, 32.018671],
                            [118.38598, 32.033147],
                            [118.394342, 32.048414],
                            [118.385025, 32.060768],
                            [118.393276, 32.062665],
                            [118.405455, 32.080794],
                            [118.433518, 32.086661],
                            [118.441095, 32.092041],
                            [118.462871, 32.10064],
                            [118.473647, 32.11065],
                            [118.472974, 32.114839],
                            [118.489474, 32.120746],
                            [118.500812, 32.121584],
                            [118.494694, 32.130974],
                            [118.500587, 32.14173],
                            [118.507435, 32.137895],
                            [118.495648, 32.165176],
                            [118.495592, 32.177073],
                            [118.50648, 32.182096],
                            [118.509848, 32.194299],
                            [118.521859, 32.188219],
                            [118.532354, 32.195797],
                            [118.539594, 32.192449],
                            [118.551717, 32.199629],
                            [118.561708, 32.196898],
                            [118.575627, 32.202536],
                            [118.580902, 32.19866],
                            [118.598357, 32.199497],
                            [118.619629, 32.205443],
                            [118.626588, 32.202536],
                            [118.644099, 32.20998],
                            [118.667504, 32.235918],
                            [118.675137, 32.255862],
                            [118.667447, 32.257535],
                            [118.659253, 32.266119],
                            [118.670759, 32.285617],
                            [118.667335, 32.296354],
                            [118.659983, 32.296354],
                            [118.660263, 32.305418],
                            [118.678448, 32.316549],
                            [118.696352, 32.317736],
                            [118.683948, 32.324071],
                            [118.687652, 32.330009],
                            [118.703199, 32.328954],
                            [118.707914, 32.33841],
                            [118.697531, 32.342632],
                            [118.699832, 32.349757],
                            [118.692928, 32.351692],
                            [118.702021, 32.357936],
                            [118.696071, 32.367961],
                            [118.698878, 32.383085],
                            [118.690178, 32.378293],
                            [118.678672, 32.393943],
                            [118.685744, 32.404975],
                            [118.688887, 32.418202],
                            [118.687091, 32.431297],
                            [118.692648, 32.465122],
                            [118.68928, 32.47351],
                            [118.672892, 32.469865],
                            [118.647691, 32.47654],
                            [118.643426, 32.47048],
                            [118.628104, 32.467669],
                            [118.608572, 32.470567],
                            [118.608067, 32.475837],
                            [118.59673, 32.476628],
                            [118.592127, 32.482029],
                            [118.592464, 32.500207],
                            [118.608011, 32.501744],
                            [118.617496, 32.512411],
                            [118.614465, 32.5204],
                            [118.604812, 32.52299],
                            [118.608853, 32.537034],
                            [118.598975, 32.54467],
                            [118.584663, 32.549014],
                            [118.56805, 32.558755],
                            [118.563728, 32.564371],
                            [118.569509, 32.586435],
                            [118.598077, 32.601347],
                            [118.601781, 32.597356],
                            [118.623838, 32.592444],
                            [118.633043, 32.578979],
                            [118.641237, 32.587093],
                            [118.658411, 32.594812],
                            [118.668794, 32.5949],
                            [118.689561, 32.588541],
                            [118.700842, 32.588541],
                            [118.69798, 32.60639],
                            [118.725312, 32.608232],
                            [118.725986, 32.596523],
                            [118.740691, 32.589374],
                            [118.743273, 32.597751],
                            [118.757528, 32.603978],
                            [118.775769, 32.597751],
                            [118.774815, 32.587663],
                            [118.784749, 32.582444],
                            [118.801811, 32.58433],
                            [118.805291, 32.593453],
                            [118.820501, 32.604241],
                            [118.824542, 32.602531],
                            [118.824654, 32.589637],
                            [118.820501, 32.582532],
                            [118.827573, 32.581172],
                            [118.827011, 32.572662],
                            [118.842502, 32.572969],
                            [118.848507, 32.568187],
                            [118.855972, 32.574373],
                            [118.872641, 32.576084],
                            [118.874998, 32.58297],
                            [118.884203, 32.580426],
                            [118.885101, 32.586348],
                            [118.901995, 32.589023],
                            [118.909347, 32.586874],
                            [118.896382, 32.577268],
                            [118.898627, 32.560466],
                            [118.887907, 32.55485],
                            [118.914005, 32.548839],
                            [118.919786, 32.557263],
                            [118.936568, 32.557526],
                            [118.940609, 32.547785],
                            [118.964799, 32.526721],
                            [118.967942, 32.514562],
                            [118.97984, 32.503851],
                            [118.997463, 32.503895],
                            [119.00751, 32.514079],
                            [119.01924, 32.517986],
                            [119.041409, 32.514782],
                            [119.043318, 32.502841],
                            [119.050502, 32.492919],
                            [119.062793, 32.484576],
                            [119.067452, 32.462398],
                            [119.073681, 32.455371],
                            [119.085131, 32.452735],
                            [119.096019, 32.466088],
                            [119.115495, 32.476979],
                            [119.134521, 32.491558],
                            [119.147767, 32.492655],
                            [119.142266, 32.499417],
                            [119.150124, 32.509821],
                            [119.155568, 32.528081],
                            [119.167803, 32.536332],
                            [119.166681, 32.545986],
                            [119.154502, 32.554938],
                            [119.153828, 32.56187],
                            [119.175212, 32.571083],
                            [119.176952, 32.593848],
                            [119.187167, 32.599944],
                            [119.193733, 32.579154],
                            [119.20928, 32.573583],
                            [119.220168, 32.57661],
                            [119.220056, 32.592444],
                            [119.231, 32.607135],
                            [119.220505, 32.609854],
                            [119.216913, 32.617308],
                            [119.220224, 32.629628],
                            [119.208719, 32.641508],
                            [119.211637, 32.708199],
                            [119.208943, 32.71525],
                            [119.208214, 32.740518],
                            [119.200861, 32.750982],
                            [119.19132, 32.788844],
                            [119.188906, 32.810854],
                            [119.184922, 32.82564],
                            [119.113081, 32.822928],
                            [119.10427, 32.826734],
                            [119.071324, 32.864738],
                            [119.055104, 32.874751],
                            [119.045731, 32.892455],
                            [119.045002, 32.911424],
                            [119.021541, 32.905961],
                            [119.015592, 32.907534],
                            [119.019801, 32.925713],
                            [119.030016, 32.927854],
                            [119.023281, 32.935063],
                            [119.026312, 32.947251],
                            [119.020812, 32.955813],
                            [119.008913, 32.959395],
                            [118.993647, 32.958215],
                            [118.961207, 32.94581],
                            [118.941619, 32.946116],
                            [118.933818, 32.938645],
                            [118.921414, 32.939563],
                            [118.90626, 32.944936],
                            [118.893239, 32.940873],
                            [118.891162, 32.951489],
                            [118.896214, 32.957735],
                            [118.884652, 32.960618],
                            [118.865233, 32.955027],
                            [118.849349, 32.956643],
                            [118.849405, 32.945897],
                            [118.842502, 32.943669],
                            [118.848956, 32.927198],
                            [118.839471, 32.922523],
                            [118.836945, 32.911424],
                            [118.818985, 32.920644],
                            [118.812194, 32.91693],
                            [118.809332, 32.907884],
                            [118.814608, 32.902727],
                            [118.81124, 32.875494],
                            [118.806189, 32.870247],
                            [118.812531, 32.865219],
                            [118.811689, 32.854987],
                            [118.791035, 32.848384],
                            [118.747875, 32.858704],
                            [118.741813, 32.853369],
                            [118.746808, 32.800353],
                            [118.736874, 32.793351],
                            [118.737941, 32.773264],
                            [118.746359, 32.759256],
                            [118.752702, 32.755842],
                            [118.756294, 32.737059],
                            [118.736706, 32.73233],
                            [118.724471, 32.721951],
                            [118.70724, 32.720287],
                            [118.694163, 32.726637],
                            [118.657569, 32.736096],
                            [118.654033, 32.740693],
                            [118.639385, 32.744809],
                            [118.632313, 32.739993],
                            [118.617047, 32.738942],
                            [118.607562, 32.726637],
                            [118.59078, 32.724841],
                            [118.576581, 32.719104],
                            [118.559743, 32.729921],
                            [118.544702, 32.729396],
                            [118.520456, 32.723221],
                            [118.489755, 32.724491],
                            [118.483469, 32.721426],
                            [118.459279, 32.726111],
                            [118.450467, 32.743364],
                            [118.422854, 32.718097],
                            [118.411011, 32.716039],
                            [118.398664, 32.721426],
                            [118.375316, 32.719017],
                            [118.368188, 32.724754],
                            [118.36628, 32.735001],
                            [118.372285, 32.741744],
                            [118.371163, 32.757724],
                            [118.366224, 32.768318],
                            [118.348769, 32.773001],
                            [118.334064, 32.761576],
                            [118.326431, 32.763459],
                            [118.322334, 32.777465],
                            [118.307124, 32.778735],
                            [118.298761, 32.785562],
                            [118.294439, 32.800134],
                            [118.306619, 32.810591],
                            [118.297863, 32.83207],
                            [118.301736, 32.846241],
                            [118.289557, 32.845498],
                            [118.284618, 32.857305],
                            [118.263178, 32.856168],
                            [118.250606, 32.848384],
                            [118.244432, 32.874488],
                            [118.239774, 32.883363],
                            [118.233039, 32.916231],
                            [118.235396, 32.926543],
                            [118.251335, 32.936155],
                            [118.293373, 32.947164],
                            [118.309649, 32.959002],
                            [118.303812, 32.968654],
                            [118.269352, 32.969178],
                            [118.252402, 32.982148],
                            [118.244825, 32.998303],
                            [118.243478, 33.027767],
                            [118.239605, 33.046445],
                            [118.233375, 33.060014],
                            [118.212441, 33.061934],
                            [118.214854, 33.070833],
                            [118.22765, 33.069525],
                            [118.223666, 33.083439],
                            [118.202899, 33.088106],
                            [118.206491, 33.091246],
                            [118.221308, 33.087626],
                            [118.220915, 33.105855],
                            [118.20969, 33.104329],
                            [118.210476, 33.111829],
                            [118.219625, 33.114096],
                            [118.223722, 33.155464],
                            [118.221364, 33.180693],
                            [118.211599, 33.19912],
                            [118.194368, 33.211664],
                            [118.178204, 33.217979],
                            [118.168382, 33.21345],
                            [118.156315, 33.195461],
                            [118.159964, 33.181042],
                            [118.149019, 33.169495],
                            [118.11888, 33.160562],
                            [118.088292, 33.149667],
                            [118.069153, 33.139948],
                            [118.046871, 33.138422],
                            [118.038228, 33.135196],
                            [118.036713, 33.1525],
                            [118.025656, 33.155943],
                            [118.017406, 33.164615],
                            [118.008482, 33.16784],
                            [118.003879, 33.177033],
                            [117.989175, 33.179648],
                            [117.986424, 33.193371],
                            [117.980924, 33.200166],
                            [117.993608, 33.20561],
                            [117.993496, 33.211272],
                            [117.977444, 33.226253],
                            [117.953816, 33.223945],
                            [117.942366, 33.225078],
                            [117.938999, 33.234309],
                            [117.948035, 33.252115],
                            [117.939448, 33.262606],
                            [117.974245, 33.279711],
                            [117.983281, 33.296768],
                            [117.985919, 33.32026],
                            [117.99243, 33.333135],
                            [117.975368, 33.335745],
                            [117.971607, 33.349313],
                            [117.995517, 33.347095],
                            [118.0059, 33.352095],
                            [118.029304, 33.372269],
                            [118.028238, 33.390569],
                            [118.016844, 33.406692],
                            [118.021952, 33.421596],
                            [118.023579, 33.440928],
                            [118.028631, 33.458432],
                            [118.04356, 33.473718],
                            [118.050632, 33.49204],
                            [118.05776, 33.491693],
                            [118.108104, 33.475107],
                            [118.106813, 33.503934],
                            [118.107992, 33.520167],
                            [118.099124, 33.52941],
                            [118.108384, 33.530017],
                            [118.117252, 33.591657],
                            [118.112257, 33.617064],
                            [118.120115, 33.621659],
                            [118.168102, 33.663739],
                            [118.164005, 33.692633],
                            [118.167709, 33.714979],
                            [118.153341, 33.720175],
                            [118.160862, 33.735327],
                            [118.177811, 33.736107],
                            [118.185332, 33.744937],
                            [118.168326, 33.749569],
                            [118.149187, 33.746452],
                            [118.133472, 33.75143],
                            [118.117982, 33.766534],
                            [118.105971, 33.76463],
                            [118.065561, 33.765798],
                            [118.062418, 33.758398],
                            [118.045749, 33.750045],
                            [118.02835, 33.746625],
                            [118.030876, 33.740479],
                            [118.019931, 33.738704],
                            [118.018809, 33.745846],
                            [118.003936, 33.744937],
                            [117.99445, 33.750045],
                            [117.972505, 33.749872],
                            [117.96549, 33.763461],
                            [117.954321, 33.75104],
                            [117.952749, 33.738185],
                            [117.936754, 33.729353],
                            [117.918176, 33.734332],
                            [117.915819, 33.738358],
                            [117.900497, 33.735674],
                            [117.897578, 33.72931],
                            [117.901675, 33.720131],
                            [117.8877, 33.722599],
                            [117.879955, 33.727751],
                            [117.848357, 33.73602],
                            [117.835841, 33.734115],
                            [117.828151, 33.736972],
                            [117.805589, 33.736193],
                            [117.791277, 33.733163],
                            [117.777919, 33.722513],
                            [117.767031, 33.72182],
                            [117.752663, 33.711515],
                            [117.735264, 33.722729],
                            [117.731953, 33.734765],
                            [117.723478, 33.739007],
                            [117.724713, 33.749569],
                            [117.734086, 33.751776],
                            [117.741831, 33.762769],
                            [117.749015, 33.791629],
                            [117.752495, 33.812868],
                            [117.746153, 33.823724],
                            [117.750081, 33.827183],
                            [117.753, 33.847203],
                            [117.752439, 33.863241],
                            [117.75923, 33.874522],
                            [117.758668, 33.885672],
                            [117.753729, 33.891419],
                            [117.740821, 33.891981],
                            [117.715396, 33.879233],
                            [117.70361, 33.887789],
                            [117.690084, 33.915398],
                            [117.672629, 33.934965],
                            [117.67246, 33.952411],
                            [117.662975, 33.968732],
                            [117.671338, 33.986733],
                            [117.666286, 33.998688],
                            [117.645801, 34.013619],
                            [117.629749, 34.02872],
                            [117.616391, 34.032257],
                            [117.610217, 34.029281],
                            [117.618131, 34.017071],
                            [117.616672, 34.004946],
                            [117.610273, 33.999249],
                            [117.59787, 33.997005],
                            [117.58816, 33.987855],
                            [117.575757, 33.982891],
                            [117.568909, 33.985222],
                            [117.556449, 34.007319],
                            [117.544663, 34.013619],
                            [117.54253, 34.021644],
                            [117.545337, 34.035191],
                            [117.530632, 34.050676],
                            [117.514805, 34.060854],
                            [117.50487, 34.06163],
                            [117.500437, 34.052272],
                            [117.476808, 34.047614],
                            [117.460251, 34.037391],
                            [117.435444, 34.028332],
                            [117.415631, 34.025916],
                            [117.405753, 34.030057],
                            [117.400253, 34.041575],
                            [117.388242, 34.055593],
                            [117.371124, 34.060682],
                            [117.377803, 34.071462],
                            [117.357149, 34.088234],
                            [117.343398, 34.08056],
                            [117.319489, 34.084397],
                            [117.311463, 34.068056],
                            [117.29384, 34.071074],
                            [117.287778, 34.078663],
                            [117.277002, 34.078922],
                            [117.257639, 34.0659],
                            [117.224693, 34.064175],
                            [117.212121, 34.074696],
                            [117.20707, 34.068616],
                            [117.192702, 34.068746],
                            [117.182094, 34.076076],
                            [117.161272, 34.084354],
                            [117.15145, 34.083707],
                            [117.157961, 34.09871],
                            [117.146567, 34.097804],
                            [117.130291, 34.10177],
                            [117.129954, 34.117459],
                            [117.123837, 34.128232],
                            [117.106438, 34.13043],
                            [117.089993, 34.145682],
                            [117.072314, 34.146716],
                            [117.054915, 34.155073],
                            [117.047057, 34.151412],
                            [117.038358, 34.167436],
                            [117.025337, 34.167651],
                            [117.030837, 34.186342],
                            [117.040322, 34.201498],
                            [117.047226, 34.205803],
                            [117.051042, 34.221558],
                            [117.044868, 34.224743],
                            [117.049583, 34.242432],
                            [117.045261, 34.24781],
                            [117.027526, 34.240194],
                            [117.020791, 34.243335],
                            [117.018882, 34.255512],
                            [117.010632, 34.2559],
                            [116.984365, 34.269839],
                            [116.968987, 34.28369],
                            [116.969717, 34.293109],
                            [116.976283, 34.304892],
                            [116.969268, 34.323122],
                            [116.982962, 34.345775],
                            [116.980773, 34.358109],
                            [116.961242, 34.363266],
                            [116.960961, 34.371989],
                            [116.969324, 34.38883],
                            [116.945639, 34.395531],
                            [116.920551, 34.406999],
                            [116.909214, 34.408287],
                            [116.883509, 34.403047],
                            [116.867008, 34.39218],
                            [116.848543, 34.389045],
                            [116.828057, 34.389216],
                            [116.804709, 34.412754],
                            [116.782146, 34.431089],
                            [116.782708, 34.438302],
                            [116.773728, 34.453456],
                            [116.76065, 34.462598],
                            [116.745104, 34.468263],
                            [116.722878, 34.472684],
                            [116.662544, 34.473027],
                            [116.623424, 34.488646],
                            [116.575101, 34.488947],
                            [116.568646, 34.492508],
                            [116.573641, 34.497699],
                            [116.592443, 34.493838],
                            [116.598954, 34.500145],
                            [116.595193, 34.511512],
                            [116.587673, 34.512542],
                            [116.570555, 34.523393],
                            [116.548048, 34.542905],
                            [116.52919, 34.540676],
                            [116.520659, 34.543162],
                            [116.526159, 34.553367],
                            [116.509546, 34.557525],
                            [116.490408, 34.573343],
                            [116.491418, 34.588944],
                            [116.478341, 34.603856],
                            [116.477218, 34.615081],
                            [116.447584, 34.620564],
                            [116.432823, 34.63016],
                            [116.430466, 34.650803],
                            [116.393367, 34.643052],
                            [116.382591, 34.63864],
                            [116.37058, 34.642238],
                            [116.364407, 34.651831],
                            [116.378214, 34.668016],
                            [116.378101, 34.684155],
                            [116.385229, 34.68668],
                            [116.38551, 34.694727],
                            [116.392694, 34.703886],
                            [116.391796, 34.710348],
                            [116.377091, 34.718136],
                            [116.363789, 34.715226],
                            [116.368448, 34.725324],
                            [116.365698, 34.742778],
                            [116.371535, 34.750177],
                            [116.403189, 34.756293],
                            [116.405827, 34.817386],
                            [116.408297, 34.826147],
                            [116.40796, 34.850714],
                            [116.436079, 34.883046],
                            [116.445283, 34.88864],
                            [116.445059, 34.895429],
                            [116.455779, 34.900638],
                            [116.480698, 34.89735],
                            [116.500566, 34.90115],
                            [116.502755, 34.906102],
                            [116.523073, 34.903968],
                            [116.54614, 34.909389],
                            [116.560059, 34.909304],
                            [116.613883, 34.922792],
                            [116.622526, 34.940034],
                            [116.631787, 34.940717],
                            [116.639981, 34.932609],
                            [116.657885, 34.928981],
                            [116.658447, 34.93342],
                            [116.675733, 34.933121],
                            [116.677978, 34.939181],
                            [116.696948, 34.932737],
                            [116.706209, 34.933974],
                            [116.721363, 34.925908],
                            [116.745328, 34.921],
                            [116.746002, 34.91575],
                            [116.756609, 34.9175],
                            [116.781192, 34.916561],
                            [116.786973, 34.940461],
                            [116.797637, 34.938754],
                            [116.796907, 34.944131],
                            [116.785458, 34.947288],
                            [116.781641, 34.961922],
                            [116.789106, 34.959789],
                            [116.789106, 34.975104],
                            [116.803699, 34.970369],
                            [116.803867, 34.928298],
                            [116.812173, 34.927957],
                            [116.80875, 34.96879],
                            [116.815878, 34.965292],
                            [116.822164, 34.929323],
                            [116.858084, 34.928384],
                            [116.8761, 34.912548],
                            [116.899055, 34.904693],
                            [116.922291, 34.89449],
                            [116.922123, 34.87143],
                            [116.945302, 34.873779],
                            [116.945246, 34.876811],
                            [116.966967, 34.875616],
                            [116.976845, 34.868526],
                            [116.933741, 34.861906],
                            [116.930092, 34.859685],
                            [116.928858, 34.842896],
                            [116.966125, 34.844477],
                            [116.979146, 34.81495],
                            [116.971681, 34.811873],
                            [116.951139, 34.810591],
                            [116.951644, 34.794562],
                            [116.965844, 34.785071],
                            [116.967921, 34.772971],
                            [116.976789, 34.771261],
                            [116.978472, 34.763606],
                            [116.989697, 34.765146],
                            [116.995647, 34.758261],
                            [117.021913, 34.759202],
                            [117.043185, 34.736532],
                            [117.061145, 34.723997],
                            [117.070518, 34.713685],
                            [117.069058, 34.708294],
                            [117.077365, 34.696482],
                            [117.072033, 34.694214],
                            [117.061706, 34.675722],
                            [117.062323, 34.657697],
                            [117.072987, 34.639069],
                            [117.081518, 34.638212],
                            [117.095886, 34.647548],
                            [117.103912, 34.648961],
                            [117.115249, 34.628147],
                            [117.123724, 34.60467],
                            [117.13349, 34.586073],
                            [117.147634, 34.570257],
                            [117.151282, 34.559283],
                            [117.140618, 34.538703],
                            [117.139383, 34.526653],
                            [117.14595, 34.503963],
                            [117.156614, 34.480923],
                            [117.159869, 34.453113],
                            [117.166043, 34.434653],
                            [117.199549, 34.434481],
                            [117.200223, 34.441608],
                            [117.223122, 34.446459],
                            [117.222336, 34.450623],
                            [117.234628, 34.454486],
                            [117.247929, 34.451052],
                            [117.255843, 34.46204],
                            [117.255113, 34.472555],
                            [117.24271, 34.47852],
                            [117.252363, 34.486501],
                            [117.256011, 34.476331],
                            [117.263588, 34.472641],
                            [117.267461, 34.480022],
                            [117.259323, 34.497056],
                            [117.274364, 34.503534],
                            [117.270828, 34.516145],
                            [117.275206, 34.520606],
                            [117.268078, 34.532828],
                            [117.287441, 34.5336],
                            [117.302651, 34.541362],
                            [117.303381, 34.548351],
                            [117.294513, 34.554139],
                            [117.321341, 34.565413],
                            [117.333015, 34.56177],
                            [117.330938, 34.567985],
                            [117.318086, 34.566228],
                            [117.31904, 34.573643],
                            [117.333745, 34.572657],
                            [117.344016, 34.582044],
                            [117.36321, 34.586158],
                            [117.374435, 34.584187],
                            [117.402554, 34.5694],
                            [117.403789, 34.546893],
                            [117.424499, 34.537031],
                            [117.426744, 34.525237],
                            [117.439428, 34.520005],
                            [117.43825, 34.516445],
                            [117.451439, 34.506279],
                            [117.466481, 34.484656],
                            [117.482084, 34.485943],
                            [117.486686, 34.482039],
                            [117.487359, 34.466332],
                            [117.493252, 34.472641],
                            [117.512952, 34.472598],
                            [117.538265, 34.467233],
                            [117.547806, 34.475173],
                            [117.561332, 34.471954],
                            [117.569807, 34.46307],
                            [117.592257, 34.462512],
                            [117.603202, 34.476846],
                            [117.609656, 34.490491],
                            [117.629244, 34.488518],
                            [117.638224, 34.49727],
                            [117.647035, 34.492937],
                            [117.659102, 34.501045],
                            [117.673414, 34.515845],
                            [117.682001, 34.529569],
                            [117.684471, 34.547322],
                            [117.699344, 34.545607],
                            [117.748622, 34.533386],
                            [117.773991, 34.529054],
                            [117.790491, 34.518933],
                            [117.80166, 34.518761],
                            [117.799303, 34.535015],
                            [117.794813, 34.539947],
                            [117.794589, 34.559755],
                            [117.791446, 34.585087],
                            [117.798517, 34.62185],
                            [117.793634, 34.625619],
                            [117.796048, 34.637741],
                            [117.793634, 34.651788],
                            [117.79964, 34.647291],
                            [117.820126, 34.646178],
                            [117.831743, 34.653458],
                            [117.834494, 34.647291],
                            [117.847515, 34.652387],
                            [117.849367, 34.647206],
                            [117.863454, 34.645193],
                            [117.877934, 34.650203],
                            [117.881021, 34.64515],
                            [117.903135, 34.64455],
                            [117.909701, 34.670199],
                            [117.939672, 34.664847],
                            [117.951683, 34.678462],
                            [117.963301, 34.678547],
                            [117.9917, 34.670071],
                            [117.990802, 34.661722],
                            [118.007415, 34.656113],
                            [118.007864, 34.647505],
                            [118.018191, 34.647034],
                            [118.020661, 34.660437],
                            [118.053943, 34.650931],
                            [118.057423, 34.654999],
                            [118.077796, 34.653715],
                            [118.08397, 34.655899],
                            [118.10266, 34.64772],
                            [118.094578, 34.636584],
                            [118.100527, 34.626562],
                            [118.113043, 34.621464],
                            [118.114727, 34.614396],
                            [118.102828, 34.593443],
                            [118.082399, 34.579858],
                            [118.078975, 34.569786],
                            [118.100471, 34.564727],
                            [118.127243, 34.555382],
                            [118.137177, 34.563227],
                            [118.140713, 34.55401],
                            [118.153734, 34.549165],
                            [118.163556, 34.55148],
                            [118.184659, 34.544192],
                            [118.167597, 34.519705],
                            [118.164959, 34.504906],
                            [118.141611, 34.496884],
                            [118.132855, 34.483412],
                            [118.139927, 34.475344],
                            [118.177755, 34.453241],
                            [118.178878, 34.425207],
                            [118.177138, 34.408717],
                            [118.170403, 34.381355],
                            [118.179271, 34.379422],
                            [118.183368, 34.390333],
                            [118.189598, 34.380624],
                            [118.204359, 34.377359],
                            [118.217716, 34.379121],
                            [118.220298, 34.405925],
                            [118.230962, 34.398709],
                            [118.242411, 34.40571],
                            [118.277377, 34.40468],
                            [118.279903, 34.412152],
                            [118.289164, 34.412281],
                            [118.290679, 34.424563],
                            [118.320931, 34.421342],
                            [118.352248, 34.422845],
                            [118.353203, 34.417435],
                            [118.379974, 34.415545],
                            [118.395184, 34.427053],
                            [118.40495, 34.42774],
                            [118.408205, 34.435512],
                        ],
                    ],
                    [
                        [
                            [118.868207, 31.520525],
                            [118.855691, 31.504726],
                            [118.846711, 31.50304],
                            [118.846262, 31.50912],
                            [118.857824, 31.523809],
                            [118.870452, 31.526028],
                            [118.868207, 31.520525],
                        ],
                    ],
                    [
                        [
                            [121.403775, 32.530583],
                            [121.429255, 32.531505],
                            [121.436495, 32.529266],
                            [121.435205, 32.520005],
                            [121.408601, 32.519566],
                            [121.402652, 32.521541],
                            [121.403775, 32.530583],
                        ],
                    ],
                ],
            },
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 320100,
                "name": "南京市",
                "center": [118.767413, 32.041544],
                "centroid": [118.847868, 31.927725],
                "childrenNum": 11,
                "level": "city",
                "parent": {
                    "adcode": 320000
                },
                "subFeatureIndex": 0,
                "acroutes": [100000, 320000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [119.234087, 31.627053],
                            [119.221852, 31.59478],
                            [119.216239, 31.585423],
                            [119.21579, 31.570389],
                            [119.197662, 31.551849],
                            [119.189075, 31.55176],
                            [119.181105, 31.538096],
                            [119.180656, 31.526959],
                            [119.198616, 31.530021],
                            [119.199458, 31.524519],
                            [119.183518, 31.500199],
                            [119.1664, 31.493453],
                            [119.152986, 31.493186],
                            [119.149114, 31.483998],
                            [119.156017, 31.480135],
                            [119.152481, 31.464374],
                            [119.141481, 31.451674],
                            [119.140919, 31.444969],
                            [119.155568, 31.438618],
                            [119.164155, 31.441105],
                            [119.169207, 31.421739],
                            [119.169207, 31.394015],
                            [119.174089, 31.380906],
                            [119.190085, 31.379084],
                            [119.2003, 31.368817],
                            [119.204509, 31.357838],
                            [119.214107, 31.355883],
                            [119.218035, 31.348859],
                            [119.198336, 31.330674],
                            [119.193172, 31.318935],
                            [119.195361, 31.309373],
                            [119.181105, 31.300478],
                            [119.176222, 31.293939],
                            [119.15815, 31.294784],
                            [119.149787, 31.276945],
                            [119.140695, 31.276011],
                            [119.13222, 31.262752],
                            [119.120041, 31.261684],
                            [119.10702, 31.250603],
                            [119.10528, 31.235293],
                            [119.083728, 31.239744],
                            [119.073794, 31.23289],
                            [119.062344, 31.238498],
                            [119.048818, 31.233557],
                            [119.014526, 31.241524],
                            [119.0033, 31.233735],
                            [118.986463, 31.231154],
                            [118.984218, 31.237474],
                            [118.92495, 31.2397],
                            [118.915184, 31.244195],
                            [118.891219, 31.237964],
                            [118.869666, 31.242237],
                            [118.840481, 31.236361],
                            [118.831277, 31.229462],
                            [118.819491, 31.236005],
                            [118.806357, 31.229507],
                            [118.79575, 31.229373],
                            [118.781382, 31.239833],
                            [118.778575, 31.261684],
                            [118.761401, 31.277702],
                            [118.726603, 31.28224],
                            [118.707914, 31.296786],
                            [118.704434, 31.302791],
                            [118.719588, 31.294784],
                            [118.721103, 31.32267],
                            [118.735078, 31.344769],
                            [118.745742, 31.372684],
                            [118.75461, 31.385084],
                            [118.765386, 31.387928],
                            [118.770886, 31.376951],
                            [118.767575, 31.363973],
                            [118.784525, 31.368595],
                            [118.80024, 31.368995],
                            [118.829481, 31.377529],
                            [118.847385, 31.393927],
                            [118.851145, 31.392549],
                            [118.86961, 31.421561],
                            [118.866074, 31.44488],
                            [118.870508, 31.463042],
                            [118.883193, 31.496471],
                            [118.886279, 31.527669],
                            [118.873539, 31.532062],
                            [118.875111, 31.551982],
                            [118.881958, 31.565156],
                            [118.873315, 31.578417],
                            [118.877299, 31.589902],
                            [118.862258, 31.595001],
                            [118.870789, 31.599346],
                            [118.868768, 31.611139],
                            [118.858554, 31.62395],
                            [118.832848, 31.630377],
                            [118.819547, 31.628516],
                            [118.814495, 31.619252],
                            [118.802765, 31.619473],
                            [118.79603, 31.628294],
                            [118.789576, 31.646554],
                            [118.782953, 31.656258],
                            [118.799005, 31.666361],
                            [118.774141, 31.682619],
                            [118.768304, 31.677481],
                            [118.760503, 31.680271],
                            [118.748099, 31.675753],
                            [118.745125, 31.656524],
                            [118.7394, 31.651074],
                            [118.735976, 31.633436],
                            [118.72868, 31.634233],
                            [118.719419, 31.627452],
                            [118.71695, 31.639463],
                            [118.694949, 31.639729],
                            [118.685127, 31.636139],
                            [118.673846, 31.640527],
                            [118.65785, 31.641103],
                            [118.643594, 31.649656],
                            [118.647972, 31.65936],
                            [118.643257, 31.671367],
                            [118.646962, 31.679873],
                            [118.654931, 31.67562],
                            [118.671432, 31.688201],
                            [118.674407, 31.696483],
                            [118.680749, 31.696616],
                            [118.697699, 31.709416],
                            [118.687372, 31.716147],
                            [118.684902, 31.724914],
                            [118.677269, 31.728589],
                            [118.653977, 31.730139],
                            [118.652125, 31.73979],
                            [118.641686, 31.743996],
                            [118.648365, 31.748821],
                            [118.641686, 31.758249],
                            [118.627037, 31.759444],
                            [118.619068, 31.75006],
                            [118.609358, 31.757187],
                            [118.600995, 31.754133],
                            [118.593082, 31.744438],
                            [118.57529, 31.740941],
                            [118.571698, 31.746253],
                            [118.55312, 31.729032],
                            [118.529772, 31.742358],
                            [118.529379, 31.748555],
                            [118.538696, 31.749352],
                            [118.53965, 31.761569],
                            [118.533869, 31.767234],
                            [118.523599, 31.762011],
                            [118.510746, 31.765641],
                            [118.502608, 31.778342],
                            [118.482178, 31.778342],
                            [118.486107, 31.795421],
                            [118.504741, 31.841733],
                            [118.490597, 31.843148],
                            [118.475443, 31.850312],
                            [118.466744, 31.858005],
                            [118.467081, 31.868881],
                            [118.4723, 31.879623],
                            [118.452263, 31.884663],
                            [118.44014, 31.892707],
                            [118.41595, 31.901457],
                            [118.402986, 31.914007],
                            [118.386036, 31.914803],
                            [118.375316, 31.925319],
                            [118.364371, 31.930178],
                            [118.369198, 31.94299],
                            [118.368974, 31.956196],
                            [118.379974, 31.968341],
                            [118.376719, 31.981721],
                            [118.387158, 31.983267],
                            [118.390975, 31.989536],
                            [118.389628, 32.01205],
                            [118.401526, 32.018671],
                            [118.38598, 32.033147],
                            [118.394342, 32.048414],
                            [118.385025, 32.060768],
                            [118.393276, 32.062665],
                            [118.405455, 32.080794],
                            [118.433518, 32.086661],
                            [118.441095, 32.092041],
                            [118.462871, 32.10064],
                            [118.473647, 32.11065],
                            [118.472974, 32.114839],
                            [118.489474, 32.120746],
                            [118.500812, 32.121584],
                            [118.494694, 32.130974],
                            [118.500587, 32.14173],
                            [118.507435, 32.137895],
                            [118.495648, 32.165176],
                            [118.495592, 32.177073],
                            [118.50648, 32.182096],
                            [118.509848, 32.194299],
                            [118.521859, 32.188219],
                            [118.532354, 32.195797],
                            [118.539594, 32.192449],
                            [118.551717, 32.199629],
                            [118.561708, 32.196898],
                            [118.575627, 32.202536],
                            [118.580902, 32.19866],
                            [118.598357, 32.199497],
                            [118.619629, 32.205443],
                            [118.626588, 32.202536],
                            [118.644099, 32.20998],
                            [118.667504, 32.235918],
                            [118.675137, 32.255862],
                            [118.667447, 32.257535],
                            [118.659253, 32.266119],
                            [118.670759, 32.285617],
                            [118.667335, 32.296354],
                            [118.659983, 32.296354],
                            [118.660263, 32.305418],
                            [118.678448, 32.316549],
                            [118.696352, 32.317736],
                            [118.683948, 32.324071],
                            [118.687652, 32.330009],
                            [118.703199, 32.328954],
                            [118.707914, 32.33841],
                            [118.697531, 32.342632],
                            [118.699832, 32.349757],
                            [118.692928, 32.351692],
                            [118.702021, 32.357936],
                            [118.696071, 32.367961],
                            [118.698878, 32.383085],
                            [118.690178, 32.378293],
                            [118.678672, 32.393943],
                            [118.685744, 32.404975],
                            [118.688887, 32.418202],
                            [118.687091, 32.431297],
                            [118.692648, 32.465122],
                            [118.68928, 32.47351],
                            [118.672892, 32.469865],
                            [118.647691, 32.47654],
                            [118.643426, 32.47048],
                            [118.628104, 32.467669],
                            [118.608572, 32.470567],
                            [118.608067, 32.475837],
                            [118.59673, 32.476628],
                            [118.592127, 32.482029],
                            [118.592464, 32.500207],
                            [118.608011, 32.501744],
                            [118.617496, 32.512411],
                            [118.614465, 32.5204],
                            [118.604812, 32.52299],
                            [118.608853, 32.537034],
                            [118.598975, 32.54467],
                            [118.584663, 32.549014],
                            [118.56805, 32.558755],
                            [118.563728, 32.564371],
                            [118.569509, 32.586435],
                            [118.598077, 32.601347],
                            [118.601781, 32.597356],
                            [118.623838, 32.592444],
                            [118.633043, 32.578979],
                            [118.641237, 32.587093],
                            [118.658411, 32.594812],
                            [118.668794, 32.5949],
                            [118.689561, 32.588541],
                            [118.700842, 32.588541],
                            [118.69798, 32.60639],
                            [118.725312, 32.608232],
                            [118.725986, 32.596523],
                            [118.740691, 32.589374],
                            [118.743273, 32.597751],
                            [118.757528, 32.603978],
                            [118.775769, 32.597751],
                            [118.774815, 32.587663],
                            [118.784749, 32.582444],
                            [118.801811, 32.58433],
                            [118.805291, 32.593453],
                            [118.820501, 32.604241],
                            [118.824542, 32.602531],
                            [118.824654, 32.589637],
                            [118.820501, 32.582532],
                            [118.827573, 32.581172],
                            [118.827011, 32.572662],
                            [118.842502, 32.572969],
                            [118.848507, 32.568187],
                            [118.855972, 32.574373],
                            [118.872641, 32.576084],
                            [118.874998, 32.58297],
                            [118.884203, 32.580426],
                            [118.885101, 32.586348],
                            [118.901995, 32.589023],
                            [118.909347, 32.586874],
                            [118.896382, 32.577268],
                            [118.898627, 32.560466],
                            [118.887907, 32.55485],
                            [118.914005, 32.548839],
                            [118.919786, 32.557263],
                            [118.936568, 32.557526],
                            [118.940609, 32.547785],
                            [118.964799, 32.526721],
                            [118.967942, 32.514562],
                            [118.97984, 32.503851],
                            [118.997463, 32.503895],
                            [119.00751, 32.514079],
                            [119.01924, 32.517986],
                            [119.041409, 32.514782],
                            [119.043318, 32.502841],
                            [119.050502, 32.492919],
                            [119.062793, 32.484576],
                            [119.067452, 32.462398],
                            [119.047022, 32.462882],
                            [119.035909, 32.452428],
                            [119.02373, 32.456073],
                            [119.022495, 32.440303],
                            [119.029455, 32.428836],
                            [119.016434, 32.413193],
                            [119.017556, 32.399261],
                            [119.02749, 32.388316],
                            [119.037425, 32.388844],
                            [119.038435, 32.38159],
                            [119.022551, 32.380447],
                            [119.02171, 32.375436],
                            [119.043823, 32.365191],
                            [119.027322, 32.35134],
                            [119.028445, 32.345095],
                            [119.041971, 32.333264],
                            [119.035853, 32.325435],
                            [119.035572, 32.308718],
                            [119.040006, 32.303394],
                            [119.041073, 32.271709],
                            [119.037088, 32.259868],
                            [119.056563, 32.25168],
                            [119.074748, 32.248951],
                            [119.086029, 32.241158],
                            [119.132332, 32.245164],
                            [119.153772, 32.243668],
                            [119.177232, 32.238912],
                            [119.229036, 32.222179],
                            [119.241664, 32.216278],
                            [119.221403, 32.201127],
                            [119.216239, 32.190686],
                            [119.191095, 32.1854],
                            [119.184529, 32.189629],
                            [119.154446, 32.186193],
                            [119.13671, 32.193374],
                            [119.121332, 32.187603],
                            [119.086871, 32.178527],
                            [119.078677, 32.178747],
                            [119.076039, 32.161695],
                            [119.047976, 32.161254],
                            [119.058472, 32.15645],
                            [119.039333, 32.157023],
                            [119.031756, 32.14865],
                            [119.022383, 32.130886],
                            [119.00925, 32.12467],
                            [119.008913, 32.115941],
                            [119.026649, 32.115941],
                            [119.049772, 32.109768],
                            [119.057686, 32.102228],
                            [119.069248, 32.107916],
                            [119.079799, 32.107343],
                            [119.089733, 32.089704],
                            [119.098882, 32.091027],
                            [119.098489, 32.07162],
                            [119.08659, 32.053224],
                            [119.092652, 32.037604],
                            [119.097928, 32.011256],
                            [119.092371, 32.004105],
                            [119.10281, 32.004899],
                            [119.112464, 32.000441],
                            [119.114204, 31.988212],
                            [119.121612, 31.984812],
                            [119.121107, 31.977571],
                            [119.113923, 31.979823],
                            [119.111061, 31.96949],
                            [119.102979, 31.965603],
                            [119.090126, 31.974126],
                            [119.073738, 31.969622],
                            [119.06487, 31.97342],
                            [119.046854, 31.968562],
                            [119.02923, 31.95708],
                            [119.029455, 31.950013],
                            [119.037537, 31.93897],
                            [119.051512, 31.935922],
                            [119.06762, 31.940207],
                            [119.104157, 31.933624],
                            [119.108423, 31.922977],
                            [119.111173, 31.901634],
                            [119.116449, 31.890497],
                            [119.107806, 31.885149],
                            [119.100341, 31.865787],
                            [119.092427, 31.860437],
                            [119.075421, 31.864195],
                            [119.069753, 31.868793],
                            [119.043374, 31.854424],
                            [119.032822, 31.853761],
                            [119.025919, 31.846376],
                            [119.003357, 31.845757],
                            [118.979672, 31.842352],
                            [118.969457, 31.834613],
                            [118.970411, 31.826077],
                            [118.986407, 31.81785],
                            [118.998137, 31.80166],
                            [119.006387, 31.798607],
                            [119.002908, 31.783431],
                            [118.982534, 31.782988],
                            [118.980458, 31.764667],
                            [118.998867, 31.76719],
                            [119.00504, 31.777766],
                            [119.021541, 31.778607],
                            [119.029679, 31.784714],
                            [119.055665, 31.788962],
                            [119.065768, 31.78197],
                            [119.077105, 31.783962],
                            [119.077835, 31.773916],
                            [119.089902, 31.769624],
                            [119.093999, 31.756036],
                            [119.105392, 31.751344],
                            [119.114428, 31.740233],
                            [119.12498, 31.735806],
                            [119.129245, 31.723586],
                            [119.138674, 31.722125],
                            [119.157701, 31.699362],
                            [119.186437, 31.694136],
                            [119.190422, 31.687049],
                            [119.186605, 31.677658],
                            [119.192274, 31.659847],
                            [119.187335, 31.649168],
                            [119.204734, 31.646642],
                            [119.212423, 31.627718],
                            [119.232516, 31.632283],
                            [119.234087, 31.627053]
                        ]
                    ],
                    [
                        [
                            [118.868207, 31.520525],
                            [118.855691, 31.504726],
                            [118.846711, 31.50304],
                            [118.846262, 31.50912],
                            [118.857824, 31.523809],
                            [118.870452, 31.526028],
                            [118.868207, 31.520525]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 320200,
                "name": "无锡市",
                "center": [120.301663, 31.574729],
                "childrenNum": 7,
                "level": "city",
                "parent": {
                    "adcode": 320000
                },
                "subFeatureIndex": 1,
                "acroutes": [100000, 320000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [120.370678, 31.990817],
                            [120.368882, 31.961099],
                            [120.375337, 31.941709],
                            [120.390322, 31.932211],
                            [120.39049, 31.925849],
                            [120.379322, 31.91414],
                            [120.392062, 31.905302],
                            [120.402389, 31.907379],
                            [120.425007, 31.898408],
                            [120.449534, 31.891955],
                            [120.466484, 31.889967],
                            [120.468841, 31.879623],
                            [120.490898, 31.871313],
                            [120.502067, 31.852125],
                            [120.503302, 31.841733],
                            [120.514415, 31.841512],
                            [120.531309, 31.827847],
                            [120.529962, 31.814666],
                            [120.522553, 31.806305],
                            [120.531533, 31.787811],
                            [120.544386, 31.787148],
                            [120.555499, 31.79405],
                            [120.558361, 31.785732],
                            [120.570708, 31.793784],
                            [120.584235, 31.782147],
                            [120.588556, 31.762542],
                            [120.594842, 31.760418],
                            [120.600006, 31.744616],
                            [120.581709, 31.727615],
                            [120.585076, 31.71442],
                            [120.600792, 31.70884],
                            [120.584908, 31.692807],
                            [120.570035, 31.688909],
                            [120.562851, 31.680493],
                            [120.568744, 31.668576],
                            [120.561055, 31.655682],
                            [120.571719, 31.655771],
                            [120.592148, 31.650276],
                            [120.595853, 31.643762],
                            [120.589566, 31.636538],
                            [120.595572, 31.631397],
                            [120.592092, 31.625059],
                            [120.600623, 31.617124],
                            [120.591475, 31.611494],
                            [120.577107, 31.614154],
                            [120.566443, 31.601918],
                            [120.55707, 31.600322],
                            [120.553085, 31.605598],
                            [120.543095, 31.601741],
                            [120.547978, 31.576598],
                            [120.563637, 31.579614],
                            [120.567397, 31.584004],
                            [120.584235, 31.585157],
                            [120.594562, 31.576022],
                            [120.599276, 31.548477],
                            [120.605787, 31.525229],
                            [120.595628, 31.517153],
                            [120.592766, 31.527536],
                            [120.568576, 31.51236],
                            [120.555218, 31.507567],
                            [120.548483, 31.497403],
                            [120.555218, 31.480313],
                            [120.536135, 31.467083],
                            [120.523844, 31.46837],
                            [120.515986, 31.464418],
                            [120.51739, 31.457847],
                            [120.501394, 31.457536],
                            [120.495781, 31.447944],
                            [120.480571, 31.449143],
                            [120.460198, 31.445501],
                            [120.438197, 31.448788],
                            [120.418834, 31.448388],
                            [120.355805, 31.416452],
                            [120.335544, 31.407345],
                            [120.253096, 31.366106],
                            [120.209599, 31.345658],
                            [120.173735, 31.308795],
                            [120.110201, 31.263998],
                            [119.919993, 31.17091],
                            [119.900237, 31.169173],
                            [119.878348, 31.160799],
                            [119.866618, 31.168327],
                            [119.842147, 31.168772],
                            [119.837545, 31.173671],
                            [119.826489, 31.173181],
                            [119.823458, 31.165832],
                            [119.829744, 31.161378],
                            [119.823289, 31.154117],
                            [119.809875, 31.148504],
                            [119.801008, 31.156344],
                            [119.791298, 31.156611],
                            [119.793375, 31.168059],
                            [119.779343, 31.178793],
                            [119.755378, 31.170776],
                            [119.740505, 31.173404],
                            [119.713116, 31.167614],
                            [119.703855, 31.151889],
                            [119.682752, 31.160487],
                            [119.678037, 31.168193],
                            [119.663726, 31.165966],
                            [119.662491, 31.159863],
                            [119.641837, 31.148414],
                            [119.638132, 31.135538],
                            [119.63078, 31.131261],
                            [119.613718, 31.129167],
                            [119.599799, 31.109157],
                            [119.582007, 31.108667],
                            [119.574094, 31.11397],
                            [119.571343, 31.128988],
                            [119.560231, 31.140707],
                            [119.545863, 31.147835],
                            [119.532617, 31.159106],
                            [119.543, 31.175498],
                            [119.553552, 31.17915],
                            [119.552542, 31.212412],
                            [119.553832, 31.221049],
                            [119.534469, 31.236762],
                            [119.522571, 31.242192],
                            [119.532224, 31.259014],
                            [119.530933, 31.277657],
                            [119.535199, 31.291226],
                            [119.523693, 31.301145],
                            [119.520045, 31.318223],
                            [119.53054, 31.330897],
                            [119.527566, 31.360328],
                            [119.530428, 31.370818],
                            [119.540699, 31.39015],
                            [119.53649, 31.408234],
                            [119.553327, 31.411699],
                            [119.554562, 31.43391],
                            [119.576675, 31.430712],
                            [119.5879, 31.445812],
                            [119.591717, 31.463042],
                            [119.588349, 31.466683],
                            [119.56517, 31.46433],
                            [119.56517, 31.471389],
                            [119.572971, 31.471744],
                            [119.57516, 31.480801],
                            [119.567976, 31.490434],
                            [119.567022, 31.504726],
                            [119.583635, 31.504549],
                            [119.593625, 31.532195],
                            [119.600921, 31.538717],
                            [119.613325, 31.557882],
                            [119.627918, 31.559922],
                            [119.640939, 31.569281],
                            [119.646776, 31.577663],
                            [119.642679, 31.582364],
                            [119.639367, 31.600277],
                            [119.657945, 31.609322],
                            [119.673042, 31.609322],
                            [119.684941, 31.604046],
                            [119.699814, 31.576554],
                            [119.709973, 31.576022],
                            [119.712891, 31.558281],
                            [119.721198, 31.556861],
                            [119.733265, 31.56316],
                            [119.768567, 31.553801],
                            [119.792196, 31.553401],
                            [119.807406, 31.548522],
                            [119.832326, 31.529178],
                            [119.847816, 31.529799],
                            [119.861904, 31.546259],
                            [119.897599, 31.546747],
                            [119.935652, 31.552736],
                            [119.948336, 31.543376],
                            [119.971741, 31.535967],
                            [119.973593, 31.515866],
                            [119.996099, 31.497492],
                            [119.997165, 31.508099],
                            [120.005528, 31.503306],
                            [120.015799, 31.505437],
                            [120.036228, 31.497891],
                            [120.045489, 31.490257],
                            [120.046219, 31.47978],
                            [120.037631, 31.42587],
                            [120.027866, 31.409033],
                            [120.021075, 31.382995],
                            [120.023712, 31.364951],
                            [120.041785, 31.34588],
                            [120.060643, 31.339122],
                            [120.089603, 31.332453],
                            [120.100155, 31.335343],
                            [120.09617, 31.352504],
                            [120.057275, 31.356105],
                            [120.044872, 31.358816],
                            [120.040157, 31.364506],
                            [120.039708, 31.378106],
                            [120.044591, 31.406234],
                            [120.054806, 31.434309],
                            [120.06098, 31.440439],
                            [120.089996, 31.454738],
                            [120.110089, 31.461532],
                            [120.105711, 31.470501],
                            [120.108742, 31.480979],
                            [120.129733, 31.504726],
                            [120.113457, 31.518129],
                            [120.107451, 31.512005],
                            [120.10341, 31.518573],
                            [120.101726, 31.542],
                            [120.09415, 31.541912],
                            [120.097349, 31.548744],
                            [120.069174, 31.55247],
                            [120.056153, 31.563382],
                            [120.057051, 31.580412],
                            [120.074899, 31.595356],
                            [120.075572, 31.607105],
                            [120.093981, 31.618099],
                            [120.104477, 31.628782],
                            [120.119462, 31.630909],
                            [120.124457, 31.648238],
                            [120.128554, 31.684613],
                            [120.143259, 31.676063],
                            [120.15106, 31.682398],
                            [120.142978, 31.688334],
                            [120.14528, 31.697059],
                            [120.156841, 31.703836],
                            [120.155719, 31.713224],
                            [120.161387, 31.718051],
                            [120.154765, 31.741428],
                            [120.155607, 31.756833],
                            [120.169021, 31.760949],
                            [120.178674, 31.758382],
                            [120.18395, 31.749928],
                            [120.20118, 31.753292],
                            [120.192537, 31.767367],
                            [120.185577, 31.786528],
                            [120.17424, 31.80104],
                            [120.179235, 31.812852],
                            [120.17048, 31.817275],
                            [120.164081, 31.832712],
                            [120.173174, 31.83877],
                            [120.185185, 31.860437],
                            [120.175868, 31.870208],
                            [120.158132, 31.86782],
                            [120.144213, 31.858934],
                            [120.122829, 31.859332],
                            [120.117385, 31.854999],
                            [120.098696, 31.855574],
                            [120.08545, 31.853053],
                            [120.080287, 31.847482],
                            [120.056377, 31.833331],
                            [120.044984, 31.821743],
                            [120.025284, 31.831694],
                            [120.019279, 31.822804],
                            [120.003339, 31.828245],
                            [120.000477, 31.845625],
                            [119.990206, 31.854866],
                            [120.003283, 31.859155],
                            [120.013217, 31.871666],
                            [120.014789, 31.881789],
                            [119.997839, 31.894342],
                            [120.005472, 31.911886],
                            [120.022422, 31.919707],
                            [120.00738, 31.935922],
                            [120.007661, 31.947981],
                            [120.022422, 31.967767],
                            [120.064908, 31.95549],
                            [120.134784, 31.939367],
                            [120.17525, 31.933845],
                            [120.205895, 31.931504],
                            [120.236595, 31.932918],
                            [120.262974, 31.941841],
                            [120.353055, 31.980617],
                            [120.370678, 31.990817]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 320300,
                "name": "徐州市",
                "center": [117.184811, 34.261792],
                "centroid": [117.521691, 34.355494],
                "childrenNum": 10,
                "level": "city",
                "parent": {
                    "adcode": 320000
                },
                "subFeatureIndex": 2,
                "acroutes": [100000, 320000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [118.408205, 34.435512],
                            [118.415221, 34.420269],
                            [118.422124, 34.423275],
                            [118.434696, 34.413269],
                            [118.452825, 34.411895],
                            [118.462422, 34.40687],
                            [118.489699, 34.416189],
                            [118.489811, 34.420398],
                            [118.50373, 34.430746],
                            [118.524216, 34.440191],
                            [118.532298, 34.435512],
                            [118.548069, 34.432893],
                            [118.572147, 34.422931],
                            [118.574616, 34.416662],
                            [118.585617, 34.419496],
                            [118.590444, 34.435984],
                            [118.597796, 34.445429],
                            [118.607899, 34.446931],
                            [118.634502, 34.439977],
                            [118.646457, 34.439547],
                            [118.648814, 34.426796],
                            [118.656784, 34.420655],
                            [118.669075, 34.419281],
                            [118.673958, 34.400728],
                            [118.654482, 34.383288],
                            [118.644773, 34.383632],
                            [118.644268, 34.359012],
                            [118.635232, 34.355058],
                            [118.633155, 34.344744],
                            [118.621986, 34.341133],
                            [118.631752, 34.337179],
                            [118.634895, 34.320456],
                            [118.632706, 34.308246],
                            [118.624063, 34.305752],
                            [118.593362, 34.308031],
                            [118.571473, 34.298957],
                            [118.57456, 34.278399],
                            [118.566871, 34.274184],
                            [118.56109, 34.247983],
                            [118.565468, 34.236794],
                            [118.573494, 34.233566],
                            [118.559687, 34.187806],
                            [118.560192, 34.165454],
                            [118.519221, 34.168598],
                            [118.505358, 34.158562],
                            [118.50968, 34.148784],
                            [118.503674, 34.137194],
                            [118.503225, 34.123147],
                            [118.517705, 34.117545],
                            [118.489923, 34.106684],
                            [118.482627, 34.100046],
                            [118.469718, 34.097201],
                            [118.451029, 34.106598],
                            [118.43436, 34.105089],
                            [118.428466, 34.108623],
                            [118.382949, 34.117286],
                            [118.363586, 34.118795],
                            [118.306001, 34.11358],
                            [118.292307, 34.109701],
                            [118.28922, 34.102589],
                            [118.232646, 34.100304],
                            [118.222824, 34.106986],
                            [118.213619, 34.127241],
                            [118.213844, 34.14202],
                            [118.187745, 34.161664],
                            [118.177306, 34.156366],
                            [118.15654, 34.161147],
                            [118.150703, 34.158476],
                            [118.154239, 34.148784],
                            [118.150534, 34.137281],
                            [118.139309, 34.136419],
                            [118.120732, 34.144045],
                            [118.10294, 34.139521],
                            [118.097047, 34.150292],
                            [118.088292, 34.15503],
                            [118.083072, 34.165411],
                            [118.072408, 34.170924],
                            [118.060622, 34.157055],
                            [118.064158, 34.152532],
                            [118.055571, 34.148827],
                            [117.998997, 34.140038],
                            [117.994394, 34.123793],
                            [117.996583, 34.105649],
                            [118.007696, 34.100348],
                            [118.005507, 34.09164],
                            [118.013084, 34.083923],
                            [118.048611, 34.092545],
                            [118.063821, 34.053781],
                            [118.059836, 34.048174],
                            [118.063653, 34.020738],
                            [118.054168, 34.009692],
                            [118.049621, 34.01336],
                            [118.034917, 34.01267],
                            [118.028406, 33.998386],
                            [118.03385, 33.983927],
                            [118.046254, 33.98151],
                            [118.053045, 33.971883],
                            [118.072408, 33.965408],
                            [118.085654, 33.965192],
                            [118.085766, 33.942048],
                            [118.100022, 33.941184],
                            [118.106139, 33.935138],
                            [118.113772, 33.936865],
                            [118.117589, 33.954614],
                            [118.125896, 33.954959],
                            [118.141162, 33.934749],
                            [118.149356, 33.901011],
                            [118.156428, 33.889691],
                            [118.168495, 33.881005],
                            [118.174612, 33.865186],
                            [118.176015, 33.844133],
                            [118.184771, 33.844176],
                            [118.18797, 33.822945],
                            [118.183368, 33.816155],
                            [118.169056, 33.820134],
                            [118.168887, 33.807591],
                            [118.159515, 33.795653],
                            [118.170459, 33.786221],
                            [118.178597, 33.763115],
                            [118.170852, 33.759134],
                            [118.168326, 33.749569],
                            [118.149187, 33.746452],
                            [118.133472, 33.75143],
                            [118.117982, 33.766534],
                            [118.105971, 33.76463],
                            [118.065561, 33.765798],
                            [118.062418, 33.758398],
                            [118.045749, 33.750045],
                            [118.02835, 33.746625],
                            [118.030876, 33.740479],
                            [118.019931, 33.738704],
                            [118.018809, 33.745846],
                            [118.003936, 33.744937],
                            [117.99445, 33.750045],
                            [117.972505, 33.749872],
                            [117.96549, 33.763461],
                            [117.954321, 33.75104],
                            [117.952749, 33.738185],
                            [117.936754, 33.729353],
                            [117.918176, 33.734332],
                            [117.915819, 33.738358],
                            [117.900497, 33.735674],
                            [117.897578, 33.72931],
                            [117.901675, 33.720131],
                            [117.8877, 33.722599],
                            [117.879955, 33.727751],
                            [117.848357, 33.73602],
                            [117.835841, 33.734115],
                            [117.828151, 33.736972],
                            [117.805589, 33.736193],
                            [117.791277, 33.733163],
                            [117.777919, 33.722513],
                            [117.767031, 33.72182],
                            [117.752663, 33.711515],
                            [117.735264, 33.722729],
                            [117.731953, 33.734765],
                            [117.723478, 33.739007],
                            [117.724713, 33.749569],
                            [117.734086, 33.751776],
                            [117.741831, 33.762769],
                            [117.749015, 33.791629],
                            [117.752495, 33.812868],
                            [117.746153, 33.823724],
                            [117.750081, 33.827183],
                            [117.753, 33.847203],
                            [117.752439, 33.863241],
                            [117.75923, 33.874522],
                            [117.758668, 33.885672],
                            [117.753729, 33.891419],
                            [117.740821, 33.891981],
                            [117.715396, 33.879233],
                            [117.70361, 33.887789],
                            [117.690084, 33.915398],
                            [117.672629, 33.934965],
                            [117.67246, 33.952411],
                            [117.662975, 33.968732],
                            [117.671338, 33.986733],
                            [117.666286, 33.998688],
                            [117.645801, 34.013619],
                            [117.629749, 34.02872],
                            [117.616391, 34.032257],
                            [117.610217, 34.029281],
                            [117.618131, 34.017071],
                            [117.616672, 34.004946],
                            [117.610273, 33.999249],
                            [117.59787, 33.997005],
                            [117.58816, 33.987855],
                            [117.575757, 33.982891],
                            [117.568909, 33.985222],
                            [117.556449, 34.007319],
                            [117.544663, 34.013619],
                            [117.54253, 34.021644],
                            [117.545337, 34.035191],
                            [117.530632, 34.050676],
                            [117.514805, 34.060854],
                            [117.50487, 34.06163],
                            [117.500437, 34.052272],
                            [117.476808, 34.047614],
                            [117.460251, 34.037391],
                            [117.435444, 34.028332],
                            [117.415631, 34.025916],
                            [117.405753, 34.030057],
                            [117.400253, 34.041575],
                            [117.388242, 34.055593],
                            [117.371124, 34.060682],
                            [117.377803, 34.071462],
                            [117.357149, 34.088234],
                            [117.343398, 34.08056],
                            [117.319489, 34.084397],
                            [117.311463, 34.068056],
                            [117.29384, 34.071074],
                            [117.287778, 34.078663],
                            [117.277002, 34.078922],
                            [117.257639, 34.0659],
                            [117.224693, 34.064175],
                            [117.212121, 34.074696],
                            [117.20707, 34.068616],
                            [117.192702, 34.068746],
                            [117.182094, 34.076076],
                            [117.161272, 34.084354],
                            [117.15145, 34.083707],
                            [117.157961, 34.09871],
                            [117.146567, 34.097804],
                            [117.130291, 34.10177],
                            [117.129954, 34.117459],
                            [117.123837, 34.128232],
                            [117.106438, 34.13043],
                            [117.089993, 34.145682],
                            [117.072314, 34.146716],
                            [117.054915, 34.155073],
                            [117.047057, 34.151412],
                            [117.038358, 34.167436],
                            [117.025337, 34.167651],
                            [117.030837, 34.186342],
                            [117.040322, 34.201498],
                            [117.047226, 34.205803],
                            [117.051042, 34.221558],
                            [117.044868, 34.224743],
                            [117.049583, 34.242432],
                            [117.045261, 34.24781],
                            [117.027526, 34.240194],
                            [117.020791, 34.243335],
                            [117.018882, 34.255512],
                            [117.010632, 34.2559],
                            [116.984365, 34.269839],
                            [116.968987, 34.28369],
                            [116.969717, 34.293109],
                            [116.976283, 34.304892],
                            [116.969268, 34.323122],
                            [116.982962, 34.345775],
                            [116.980773, 34.358109],
                            [116.961242, 34.363266],
                            [116.960961, 34.371989],
                            [116.969324, 34.38883],
                            [116.945639, 34.395531],
                            [116.920551, 34.406999],
                            [116.909214, 34.408287],
                            [116.883509, 34.403047],
                            [116.867008, 34.39218],
                            [116.848543, 34.389045],
                            [116.828057, 34.389216],
                            [116.804709, 34.412754],
                            [116.782146, 34.431089],
                            [116.782708, 34.438302],
                            [116.773728, 34.453456],
                            [116.76065, 34.462598],
                            [116.745104, 34.468263],
                            [116.722878, 34.472684],
                            [116.662544, 34.473027],
                            [116.623424, 34.488646],
                            [116.575101, 34.488947],
                            [116.568646, 34.492508],
                            [116.573641, 34.497699],
                            [116.592443, 34.493838],
                            [116.598954, 34.500145],
                            [116.595193, 34.511512],
                            [116.587673, 34.512542],
                            [116.570555, 34.523393],
                            [116.548048, 34.542905],
                            [116.52919, 34.540676],
                            [116.520659, 34.543162],
                            [116.526159, 34.553367],
                            [116.509546, 34.557525],
                            [116.490408, 34.573343],
                            [116.491418, 34.588944],
                            [116.478341, 34.603856],
                            [116.477218, 34.615081],
                            [116.447584, 34.620564],
                            [116.432823, 34.63016],
                            [116.430466, 34.650803],
                            [116.393367, 34.643052],
                            [116.382591, 34.63864],
                            [116.37058, 34.642238],
                            [116.364407, 34.651831],
                            [116.378214, 34.668016],
                            [116.378101, 34.684155],
                            [116.385229, 34.68668],
                            [116.38551, 34.694727],
                            [116.392694, 34.703886],
                            [116.391796, 34.710348],
                            [116.377091, 34.718136],
                            [116.363789, 34.715226],
                            [116.368448, 34.725324],
                            [116.365698, 34.742778],
                            [116.371535, 34.750177],
                            [116.403189, 34.756293],
                            [116.405827, 34.817386],
                            [116.408297, 34.826147],
                            [116.40796, 34.850714],
                            [116.436079, 34.883046],
                            [116.445283, 34.88864],
                            [116.445059, 34.895429],
                            [116.455779, 34.900638],
                            [116.480698, 34.89735],
                            [116.500566, 34.90115],
                            [116.502755, 34.906102],
                            [116.523073, 34.903968],
                            [116.54614, 34.909389],
                            [116.560059, 34.909304],
                            [116.613883, 34.922792],
                            [116.622526, 34.940034],
                            [116.631787, 34.940717],
                            [116.639981, 34.932609],
                            [116.657885, 34.928981],
                            [116.658447, 34.93342],
                            [116.675733, 34.933121],
                            [116.677978, 34.939181],
                            [116.696948, 34.932737],
                            [116.706209, 34.933974],
                            [116.721363, 34.925908],
                            [116.745328, 34.921],
                            [116.746002, 34.91575],
                            [116.756609, 34.9175],
                            [116.781192, 34.916561],
                            [116.786973, 34.940461],
                            [116.797637, 34.938754],
                            [116.796907, 34.944131],
                            [116.785458, 34.947288],
                            [116.781641, 34.961922],
                            [116.789106, 34.959789],
                            [116.789106, 34.975104],
                            [116.803699, 34.970369],
                            [116.803867, 34.928298],
                            [116.812173, 34.927957],
                            [116.80875, 34.96879],
                            [116.815878, 34.965292],
                            [116.822164, 34.929323],
                            [116.858084, 34.928384],
                            [116.8761, 34.912548],
                            [116.899055, 34.904693],
                            [116.922291, 34.89449],
                            [116.922123, 34.87143],
                            [116.945302, 34.873779],
                            [116.945246, 34.876811],
                            [116.966967, 34.875616],
                            [116.976845, 34.868526],
                            [116.933741, 34.861906],
                            [116.930092, 34.859685],
                            [116.928858, 34.842896],
                            [116.966125, 34.844477],
                            [116.979146, 34.81495],
                            [116.971681, 34.811873],
                            [116.951139, 34.810591],
                            [116.951644, 34.794562],
                            [116.965844, 34.785071],
                            [116.967921, 34.772971],
                            [116.976789, 34.771261],
                            [116.978472, 34.763606],
                            [116.989697, 34.765146],
                            [116.995647, 34.758261],
                            [117.021913, 34.759202],
                            [117.043185, 34.736532],
                            [117.061145, 34.723997],
                            [117.070518, 34.713685],
                            [117.069058, 34.708294],
                            [117.077365, 34.696482],
                            [117.072033, 34.694214],
                            [117.061706, 34.675722],
                            [117.062323, 34.657697],
                            [117.072987, 34.639069],
                            [117.081518, 34.638212],
                            [117.095886, 34.647548],
                            [117.103912, 34.648961],
                            [117.115249, 34.628147],
                            [117.123724, 34.60467],
                            [117.13349, 34.586073],
                            [117.147634, 34.570257],
                            [117.151282, 34.559283],
                            [117.140618, 34.538703],
                            [117.139383, 34.526653],
                            [117.14595, 34.503963],
                            [117.156614, 34.480923],
                            [117.159869, 34.453113],
                            [117.166043, 34.434653],
                            [117.199549, 34.434481],
                            [117.200223, 34.441608],
                            [117.223122, 34.446459],
                            [117.222336, 34.450623],
                            [117.234628, 34.454486],
                            [117.247929, 34.451052],
                            [117.255843, 34.46204],
                            [117.255113, 34.472555],
                            [117.24271, 34.47852],
                            [117.252363, 34.486501],
                            [117.256011, 34.476331],
                            [117.263588, 34.472641],
                            [117.267461, 34.480022],
                            [117.259323, 34.497056],
                            [117.274364, 34.503534],
                            [117.270828, 34.516145],
                            [117.275206, 34.520606],
                            [117.268078, 34.532828],
                            [117.287441, 34.5336],
                            [117.302651, 34.541362],
                            [117.303381, 34.548351],
                            [117.294513, 34.554139],
                            [117.321341, 34.565413],
                            [117.333015, 34.56177],
                            [117.330938, 34.567985],
                            [117.318086, 34.566228],
                            [117.31904, 34.573643],
                            [117.333745, 34.572657],
                            [117.344016, 34.582044],
                            [117.36321, 34.586158],
                            [117.374435, 34.584187],
                            [117.402554, 34.5694],
                            [117.403789, 34.546893],
                            [117.424499, 34.537031],
                            [117.426744, 34.525237],
                            [117.439428, 34.520005],
                            [117.43825, 34.516445],
                            [117.451439, 34.506279],
                            [117.466481, 34.484656],
                            [117.482084, 34.485943],
                            [117.486686, 34.482039],
                            [117.487359, 34.466332],
                            [117.493252, 34.472641],
                            [117.512952, 34.472598],
                            [117.538265, 34.467233],
                            [117.547806, 34.475173],
                            [117.561332, 34.471954],
                            [117.569807, 34.46307],
                            [117.592257, 34.462512],
                            [117.603202, 34.476846],
                            [117.609656, 34.490491],
                            [117.629244, 34.488518],
                            [117.638224, 34.49727],
                            [117.647035, 34.492937],
                            [117.659102, 34.501045],
                            [117.673414, 34.515845],
                            [117.682001, 34.529569],
                            [117.684471, 34.547322],
                            [117.699344, 34.545607],
                            [117.748622, 34.533386],
                            [117.773991, 34.529054],
                            [117.790491, 34.518933],
                            [117.80166, 34.518761],
                            [117.799303, 34.535015],
                            [117.794813, 34.539947],
                            [117.794589, 34.559755],
                            [117.791446, 34.585087],
                            [117.798517, 34.62185],
                            [117.793634, 34.625619],
                            [117.796048, 34.637741],
                            [117.793634, 34.651788],
                            [117.79964, 34.647291],
                            [117.820126, 34.646178],
                            [117.831743, 34.653458],
                            [117.834494, 34.647291],
                            [117.847515, 34.652387],
                            [117.849367, 34.647206],
                            [117.863454, 34.645193],
                            [117.877934, 34.650203],
                            [117.881021, 34.64515],
                            [117.903135, 34.64455],
                            [117.909701, 34.670199],
                            [117.939672, 34.664847],
                            [117.951683, 34.678462],
                            [117.963301, 34.678547],
                            [117.9917, 34.670071],
                            [117.990802, 34.661722],
                            [118.007415, 34.656113],
                            [118.007864, 34.647505],
                            [118.018191, 34.647034],
                            [118.020661, 34.660437],
                            [118.053943, 34.650931],
                            [118.057423, 34.654999],
                            [118.077796, 34.653715],
                            [118.08397, 34.655899],
                            [118.10266, 34.64772],
                            [118.094578, 34.636584],
                            [118.100527, 34.626562],
                            [118.113043, 34.621464],
                            [118.114727, 34.614396],
                            [118.102828, 34.593443],
                            [118.082399, 34.579858],
                            [118.078975, 34.569786],
                            [118.100471, 34.564727],
                            [118.127243, 34.555382],
                            [118.137177, 34.563227],
                            [118.140713, 34.55401],
                            [118.153734, 34.549165],
                            [118.163556, 34.55148],
                            [118.184659, 34.544192],
                            [118.167597, 34.519705],
                            [118.164959, 34.504906],
                            [118.141611, 34.496884],
                            [118.132855, 34.483412],
                            [118.139927, 34.475344],
                            [118.177755, 34.453241],
                            [118.178878, 34.425207],
                            [118.177138, 34.408717],
                            [118.170403, 34.381355],
                            [118.179271, 34.379422],
                            [118.183368, 34.390333],
                            [118.189598, 34.380624],
                            [118.204359, 34.377359],
                            [118.217716, 34.379121],
                            [118.220298, 34.405925],
                            [118.230962, 34.398709],
                            [118.242411, 34.40571],
                            [118.277377, 34.40468],
                            [118.279903, 34.412152],
                            [118.289164, 34.412281],
                            [118.290679, 34.424563],
                            [118.320931, 34.421342],
                            [118.352248, 34.422845],
                            [118.353203, 34.417435],
                            [118.379974, 34.415545],
                            [118.395184, 34.427053],
                            [118.40495, 34.42774],
                            [118.408205, 34.435512]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 320400,
                "name": "常州市",
                "center": [119.946973, 31.772752],
                "centroid": [119.641923, 31.623535],
                "childrenNum": 6,
                "level": "city",
                "parent": {
                    "adcode": 320000
                },
                "subFeatureIndex": 3,
                "acroutes": [100000, 320000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [119.975501, 32.006886],
                            [119.980103, 31.998057],
                            [120.016248, 31.970461],
                            [120.022422, 31.967767],
                            [120.007661, 31.947981],
                            [120.00738, 31.935922],
                            [120.022422, 31.919707],
                            [120.005472, 31.911886],
                            [119.997839, 31.894342],
                            [120.014789, 31.881789],
                            [120.013217, 31.871666],
                            [120.003283, 31.859155],
                            [119.990206, 31.854866],
                            [120.000477, 31.845625],
                            [120.003339, 31.828245],
                            [120.019279, 31.822804],
                            [120.025284, 31.831694],
                            [120.044984, 31.821743],
                            [120.056377, 31.833331],
                            [120.080287, 31.847482],
                            [120.08545, 31.853053],
                            [120.098696, 31.855574],
                            [120.117385, 31.854999],
                            [120.122829, 31.859332],
                            [120.144213, 31.858934],
                            [120.158132, 31.86782],
                            [120.175868, 31.870208],
                            [120.185185, 31.860437],
                            [120.173174, 31.83877],
                            [120.164081, 31.832712],
                            [120.17048, 31.817275],
                            [120.179235, 31.812852],
                            [120.17424, 31.80104],
                            [120.185577, 31.786528],
                            [120.192537, 31.767367],
                            [120.20118, 31.753292],
                            [120.18395, 31.749928],
                            [120.178674, 31.758382],
                            [120.169021, 31.760949],
                            [120.155607, 31.756833],
                            [120.154765, 31.741428],
                            [120.161387, 31.718051],
                            [120.155719, 31.713224],
                            [120.156841, 31.703836],
                            [120.14528, 31.697059],
                            [120.142978, 31.688334],
                            [120.15106, 31.682398],
                            [120.143259, 31.676063],
                            [120.128554, 31.684613],
                            [120.124457, 31.648238],
                            [120.119462, 31.630909],
                            [120.104477, 31.628782],
                            [120.093981, 31.618099],
                            [120.075572, 31.607105],
                            [120.074899, 31.595356],
                            [120.057051, 31.580412],
                            [120.056153, 31.563382],
                            [120.069174, 31.55247],
                            [120.097349, 31.548744],
                            [120.09415, 31.541912],
                            [120.101726, 31.542],
                            [120.10341, 31.518573],
                            [120.107451, 31.512005],
                            [120.113457, 31.518129],
                            [120.129733, 31.504726],
                            [120.108742, 31.480979],
                            [120.105711, 31.470501],
                            [120.110089, 31.461532],
                            [120.089996, 31.454738],
                            [120.06098, 31.440439],
                            [120.054806, 31.434309],
                            [120.044591, 31.406234],
                            [120.039708, 31.378106],
                            [120.040157, 31.364506],
                            [120.044872, 31.358816],
                            [120.057275, 31.356105],
                            [120.09617, 31.352504],
                            [120.100155, 31.335343],
                            [120.089603, 31.332453],
                            [120.060643, 31.339122],
                            [120.041785, 31.34588],
                            [120.023712, 31.364951],
                            [120.021075, 31.382995],
                            [120.027866, 31.409033],
                            [120.037631, 31.42587],
                            [120.046219, 31.47978],
                            [120.045489, 31.490257],
                            [120.036228, 31.497891],
                            [120.015799, 31.505437],
                            [120.005528, 31.503306],
                            [119.997165, 31.508099],
                            [119.996099, 31.497492],
                            [119.973593, 31.515866],
                            [119.971741, 31.535967],
                            [119.948336, 31.543376],
                            [119.935652, 31.552736],
                            [119.897599, 31.546747],
                            [119.861904, 31.546259],
                            [119.847816, 31.529799],
                            [119.832326, 31.529178],
                            [119.807406, 31.548522],
                            [119.792196, 31.553401],
                            [119.768567, 31.553801],
                            [119.733265, 31.56316],
                            [119.721198, 31.556861],
                            [119.712891, 31.558281],
                            [119.709973, 31.576022],
                            [119.699814, 31.576554],
                            [119.684941, 31.604046],
                            [119.673042, 31.609322],
                            [119.657945, 31.609322],
                            [119.639367, 31.600277],
                            [119.642679, 31.582364],
                            [119.646776, 31.577663],
                            [119.640939, 31.569281],
                            [119.627918, 31.559922],
                            [119.613325, 31.557882],
                            [119.600921, 31.538717],
                            [119.593625, 31.532195],
                            [119.583635, 31.504549],
                            [119.567022, 31.504726],
                            [119.567976, 31.490434],
                            [119.57516, 31.480801],
                            [119.572971, 31.471744],
                            [119.56517, 31.471389],
                            [119.56517, 31.46433],
                            [119.588349, 31.466683],
                            [119.591717, 31.463042],
                            [119.5879, 31.445812],
                            [119.576675, 31.430712],
                            [119.554562, 31.43391],
                            [119.553327, 31.411699],
                            [119.53649, 31.408234],
                            [119.540699, 31.39015],
                            [119.530428, 31.370818],
                            [119.527566, 31.360328],
                            [119.53054, 31.330897],
                            [119.520045, 31.318223],
                            [119.523693, 31.301145],
                            [119.535199, 31.291226],
                            [119.530933, 31.277657],
                            [119.532224, 31.259014],
                            [119.522571, 31.242192],
                            [119.534469, 31.236762],
                            [119.553832, 31.221049],
                            [119.552542, 31.212412],
                            [119.553552, 31.17915],
                            [119.543, 31.175498],
                            [119.532617, 31.159106],
                            [119.514376, 31.156077],
                            [119.494508, 31.164006],
                            [119.485584, 31.161601],
                            [119.482497, 31.152513],
                            [119.475818, 31.158928],
                            [119.460608, 31.156389],
                            [119.454771, 31.164897],
                            [119.438832, 31.177056],
                            [119.423454, 31.181866],
                            [119.415428, 31.172959],
                            [119.400611, 31.178749],
                            [119.391182, 31.174518],
                            [119.389329, 31.188324],
                            [119.395335, 31.193356],
                            [119.405662, 31.192777],
                            [119.394886, 31.19959],
                            [119.379171, 31.189214],
                            [119.371369, 31.197719],
                            [119.365757, 31.195938],
                            [119.360088, 31.212145],
                            [119.365196, 31.232667],
                            [119.370528, 31.242548],
                            [119.379676, 31.269382],
                            [119.371594, 31.271606],
                            [119.367946, 31.288957],
                            [119.356609, 31.30328],
                            [119.350154, 31.301012],
                            [119.35021, 31.280905],
                            [119.345945, 31.268981],
                            [119.337526, 31.258881],
                            [119.33326, 31.264131],
                            [119.314851, 31.265733],
                            [119.294815, 31.263241],
                            [119.266977, 31.250425],
                            [119.26142, 31.261328],
                            [119.249746, 31.261995],
                            [119.249971, 31.256967],
                            [119.238577, 31.254653],
                            [119.236276, 31.259326],
                            [119.218148, 31.264799],
                            [119.215285, 31.274098],
                            [119.204229, 31.265689],
                            [119.197157, 31.27352],
                            [119.199458, 31.293583],
                            [119.181105, 31.300478],
                            [119.195361, 31.309373],
                            [119.193172, 31.318935],
                            [119.198336, 31.330674],
                            [119.218035, 31.348859],
                            [119.214107, 31.355883],
                            [119.204509, 31.357838],
                            [119.2003, 31.368817],
                            [119.190085, 31.379084],
                            [119.174089, 31.380906],
                            [119.169207, 31.394015],
                            [119.169207, 31.421739],
                            [119.164155, 31.441105],
                            [119.155568, 31.438618],
                            [119.140919, 31.444969],
                            [119.141481, 31.451674],
                            [119.152481, 31.464374],
                            [119.156017, 31.480135],
                            [119.149114, 31.483998],
                            [119.152986, 31.493186],
                            [119.1664, 31.493453],
                            [119.183518, 31.500199],
                            [119.199458, 31.524519],
                            [119.198616, 31.530021],
                            [119.180656, 31.526959],
                            [119.181105, 31.538096],
                            [119.189075, 31.55176],
                            [119.197662, 31.551849],
                            [119.21579, 31.570389],
                            [119.216239, 31.585423],
                            [119.221852, 31.59478],
                            [119.234087, 31.627053],
                            [119.23695, 31.625192],
                            [119.258389, 31.632195],
                            [119.282804, 31.642787],
                            [119.299922, 31.654752],
                            [119.316535, 31.671013],
                            [119.328658, 31.704013],
                            [119.321081, 31.707644],
                            [119.321586, 31.715527],
                            [119.331072, 31.727305],
                            [119.321643, 31.73222],
                            [119.305647, 31.733017],
                            [119.304637, 31.767367],
                            [119.307387, 31.776527],
                            [119.314683, 31.777324],
                            [119.320071, 31.797058],
                            [119.314571, 31.796616],
                            [119.313785, 31.813825],
                            [119.320015, 31.825414],
                            [119.332643, 31.836338],
                            [119.3295, 31.845757],
                            [119.342072, 31.859553],
                            [119.364129, 31.857961],
                            [119.372436, 31.845802],
                            [119.387028, 31.846642],
                            [119.40409, 31.832092],
                            [119.422331, 31.829395],
                            [119.429347, 31.832314],
                            [119.432995, 31.825812],
                            [119.443378, 31.828908],
                            [119.432041, 31.840362],
                            [119.42553, 31.852788],
                            [119.419525, 31.852081],
                            [119.423229, 31.871666],
                            [119.437541, 31.876397],
                            [119.448822, 31.885414],
                            [119.46392, 31.881215],
                            [119.468803, 31.871666],
                            [119.508203, 31.851859],
                            [119.550016, 31.856458],
                            [119.556077, 31.862515],
                            [119.559894, 31.85606],
                            [119.570053, 31.854557],
                            [119.576731, 31.848366],
                            [119.586946, 31.847438],
                            [119.59211, 31.835321],
                            [119.589416, 31.826962],
                            [119.597329, 31.827847],
                            [119.605131, 31.822052],
                            [119.605692, 31.806128],
                            [119.615009, 31.796174],
                            [119.629601, 31.801173],
                            [119.644643, 31.795554],
                            [119.650817, 31.777678],
                            [119.656541, 31.773607],
                            [119.688196, 31.769402],
                            [119.693303, 31.756966],
                            [119.706717, 31.747139],
                            [119.708289, 31.737931],
                            [119.723892, 31.732928],
                            [119.74, 31.731157],
                            [119.734724, 31.74373],
                            [119.736295, 31.7621],
                            [119.748755, 31.780333],
                            [119.757342, 31.786218],
                            [119.763965, 31.808119],
                            [119.790456, 31.806968],
                            [119.785461, 31.816745],
                            [119.790344, 31.826564],
                            [119.800503, 31.833331],
                            [119.811784, 31.852213],
                            [119.782262, 31.852081],
                            [119.769914, 31.847615],
                            [119.763348, 31.8569],
                            [119.764077, 31.872595],
                            [119.75521, 31.880331],
                            [119.771823, 31.900839],
                            [119.780466, 31.901634],
                            [119.781757, 31.913875],
                            [119.759643, 31.921121],
                            [119.760485, 31.926644],
                            [119.78389, 31.919354],
                            [119.789446, 31.926909],
                            [119.777154, 31.944624],
                            [119.767613, 31.949306],
                            [119.778165, 31.984106],
                            [119.775639, 31.986446],
                            [119.784788, 32.012315],
                            [119.777435, 32.014257],
                            [119.796293, 32.049032],
                            [119.804768, 32.056091],
                            [119.822223, 32.055827],
                            [119.829014, 32.0519],
                            [119.843831, 32.059841],
                            [119.859939, 32.051547],
                            [119.869593, 32.058121],
                            [119.878629, 32.042193],
                            [119.883736, 32.039281],
                            [119.890864, 32.046164],
                            [119.895972, 32.040163],
                            [119.905906, 32.015361],
                            [119.919712, 32.003663],
                            [119.951704, 32.002339],
                            [119.975501, 32.006886]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 320500,
                "name": "苏州市",
                "center": [120.619585, 31.299379],
                "centroid": [120.660804, 31.382866],
                "childrenNum": 10,
                "level": "city",
                "parent": {
                    "adcode": 320000
                },
                "subFeatureIndex": 4,
                "acroutes": [100000, 320000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [119.919993, 31.17091],
                            [120.110201, 31.263998],
                            [120.173735, 31.308795],
                            [120.209599, 31.345658],
                            [120.253096, 31.366106],
                            [120.335544, 31.407345],
                            [120.355805, 31.416452],
                            [120.418834, 31.448388],
                            [120.438197, 31.448788],
                            [120.460198, 31.445501],
                            [120.480571, 31.449143],
                            [120.495781, 31.447944],
                            [120.501394, 31.457536],
                            [120.51739, 31.457847],
                            [120.515986, 31.464418],
                            [120.523844, 31.46837],
                            [120.536135, 31.467083],
                            [120.555218, 31.480313],
                            [120.548483, 31.497403],
                            [120.555218, 31.507567],
                            [120.568576, 31.51236],
                            [120.592766, 31.527536],
                            [120.595628, 31.517153],
                            [120.605787, 31.525229],
                            [120.599276, 31.548477],
                            [120.594562, 31.576022],
                            [120.584235, 31.585157],
                            [120.567397, 31.584004],
                            [120.563637, 31.579614],
                            [120.547978, 31.576598],
                            [120.543095, 31.601741],
                            [120.553085, 31.605598],
                            [120.55707, 31.600322],
                            [120.566443, 31.601918],
                            [120.577107, 31.614154],
                            [120.591475, 31.611494],
                            [120.600623, 31.617124],
                            [120.592092, 31.625059],
                            [120.595572, 31.631397],
                            [120.589566, 31.636538],
                            [120.595853, 31.643762],
                            [120.592148, 31.650276],
                            [120.571719, 31.655771],
                            [120.561055, 31.655682],
                            [120.568744, 31.668576],
                            [120.562851, 31.680493],
                            [120.570035, 31.688909],
                            [120.584908, 31.692807],
                            [120.600792, 31.70884],
                            [120.585076, 31.71442],
                            [120.581709, 31.727615],
                            [120.600006, 31.744616],
                            [120.594842, 31.760418],
                            [120.588556, 31.762542],
                            [120.584235, 31.782147],
                            [120.570708, 31.793784],
                            [120.558361, 31.785732],
                            [120.555499, 31.79405],
                            [120.544386, 31.787148],
                            [120.531533, 31.787811],
                            [120.522553, 31.806305],
                            [120.529962, 31.814666],
                            [120.531309, 31.827847],
                            [120.514415, 31.841512],
                            [120.503302, 31.841733],
                            [120.502067, 31.852125],
                            [120.490898, 31.871313],
                            [120.468841, 31.879623],
                            [120.466484, 31.889967],
                            [120.449534, 31.891955],
                            [120.425007, 31.898408],
                            [120.402389, 31.907379],
                            [120.392062, 31.905302],
                            [120.379322, 31.91414],
                            [120.39049, 31.925849],
                            [120.390322, 31.932211],
                            [120.375337, 31.941709],
                            [120.368882, 31.961099],
                            [120.370678, 31.990817],
                            [120.387853, 32.006665],
                            [120.403736, 32.016199],
                            [120.465642, 32.045811],
                            [120.503807, 32.041002],
                            [120.52463, 32.030455],
                            [120.553141, 32.021143],
                            [120.588276, 32.009711],
                            [120.628405, 32.001147],
                            [120.652651, 32.002383],
                            [120.70249, 32.013375],
                            [120.76159, 32.020437],
                            [120.78202, 32.015979],
                            [120.790102, 31.998101],
                            [120.803123, 31.988432],
                            [120.853467, 31.888641],
                            [120.860314, 31.873037],
                            [120.883831, 31.834702],
                            [120.916664, 31.793652],
                            [120.932884, 31.786705],
                            [120.959488, 31.783032],
                            [121.060625, 31.783077],
                            [121.076845, 31.777014],
                            [121.101204, 31.762542],
                            [121.11849, 31.75909],
                            [121.145318, 31.753911],
                            [121.289111, 31.616282],
                            [121.345573, 31.571676],
                            [121.372232, 31.553224],
                            [121.343496, 31.512049],
                            [121.319923, 31.499711],
                            [121.310326, 31.505925],
                            [121.299943, 31.499756],
                            [121.298596, 31.4915],
                            [121.26885, 31.48746],
                            [121.261441, 31.478848],
                            [121.247073, 31.477072],
                            [121.240899, 31.493675],
                            [121.234725, 31.492698],
                            [121.230348, 31.477427],
                            [121.219067, 31.475207],
                            [121.214352, 31.479114],
                            [121.186065, 31.460822],
                            [121.186065, 31.454339],
                            [121.174952, 31.449276],
                            [121.160921, 31.449676],
                            [121.147339, 31.443947],
                            [121.14689, 31.437241],
                            [121.162717, 31.432222],
                            [121.164288, 31.427203],
                            [121.146272, 31.421072],
                            [121.158844, 31.4101],
                            [121.143803, 31.392327],
                            [121.148461, 31.385395],
                            [121.113776, 31.374462],
                            [121.12023, 31.368684],
                            [121.109286, 31.364684],
                            [121.108332, 31.350637],
                            [121.117255, 31.351704],
                            [121.117985, 31.343435],
                            [121.130445, 31.344191],
                            [121.133307, 31.325561],
                            [121.127246, 31.319291],
                            [121.12994, 31.302613],
                            [121.139649, 31.302969],
                            [121.143803, 31.309685],
                            [121.151267, 31.291937],
                            [121.161314, 31.283975],
                            [121.154242, 31.276723],
                            [121.142905, 31.277657],
                            [121.120342, 31.286154],
                            [121.11501, 31.285265],
                            [121.105469, 31.273653],
                            [121.09879, 31.276233],
                            [121.090147, 31.291893],
                            [121.084703, 31.287622],
                            [121.080437, 31.270138],
                            [121.063263, 31.267913],
                            [121.060962, 31.246509],
                            [121.064329, 31.246153],
                            [121.062646, 31.224655],
                            [121.075442, 31.173449],
                            [121.077014, 31.158438],
                            [121.065733, 31.148593],
                            [121.062533, 31.153137],
                            [121.041486, 31.14984],
                            [121.041823, 31.13888],
                            [121.025659, 31.140751],
                            [121.018475, 31.134113],
                            [120.983902, 31.131706],
                            [120.930359, 31.14142],
                            [120.905383, 31.134202],
                            [120.881305, 31.134736],
                            [120.872325, 31.127161],
                            [120.870585, 31.119719],
                            [120.857901, 31.108533],
                            [120.856778, 31.102828],
                            [120.869575, 31.097212],
                            [120.892193, 31.094181],
                            [120.902128, 31.085666],
                            [120.894551, 31.053875],
                            [120.901959, 31.037641],
                            [120.901342, 31.017479],
                            [120.895168, 31.017345],
                            [120.891352, 31.003737],
                            [120.86806, 30.995348],
                            [120.865646, 30.989815],
                            [120.853692, 30.993206],
                            [120.847349, 30.989592],
                            [120.840053, 30.997803],
                            [120.820914, 31.006369],
                            [120.802898, 31.005388],
                            [120.769953, 30.996642],
                            [120.770177, 30.978078],
                            [120.760692, 30.975445],
                            [120.745931, 30.9625],
                            [120.736109, 30.963706],
                            [120.725614, 30.971517],
                            [120.710067, 30.971919],
                            [120.705521, 30.966473],
                            [120.698225, 30.970803],
                            [120.684474, 30.95518],
                            [120.697551, 30.950358],
                            [120.70945, 30.933169],
                            [120.712705, 30.919683],
                            [120.709843, 30.907535],
                            [120.713266, 30.885067],
                            [120.702546, 30.884039],
                            [120.704286, 30.872959],
                            [120.699909, 30.867821],
                            [120.68279, 30.882565],
                            [120.673642, 30.87573],
                            [120.66309, 30.861342],
                            [120.658713, 30.865274],
                            [120.655401, 30.847489],
                            [120.644176, 30.855354],
                            [120.626216, 30.856069],
                            [120.615496, 30.849589],
                            [120.60298, 30.848919],
                            [120.588949, 30.854416],
                            [120.580867, 30.845656],
                            [120.563805, 30.835511],
                            [120.518231, 30.773227],
                            [120.504425, 30.757974],
                            [120.489439, 30.763432],
                            [120.476979, 30.785571],
                            [120.477204, 30.800014],
                            [120.455259, 30.816825],
                            [120.460984, 30.828269],
                            [120.460422, 30.839846],
                            [120.454473, 30.849634],
                            [120.441284, 30.856292],
                            [120.45234, 30.867911],
                            [120.439544, 30.885201],
                            [120.436345, 30.896949],
                            [120.442294, 30.900612],
                            [120.434998, 30.920799],
                            [120.423436, 30.927453],
                            [120.417992, 30.925578],
                            [120.423492, 30.903069],
                            [120.3947, 30.890785],
                            [120.379434, 30.890785],
                            [120.372418, 30.882163],
                            [120.364673, 30.880465],
                            [120.357994, 30.887077],
                            [120.360127, 30.892795],
                            [120.356928, 30.908875],
                            [120.362709, 30.921648],
                            [120.359453, 30.931919],
                            [120.371127, 30.948751],
                            [120.343514, 30.94],
                            [120.308099, 30.932276],
                            [120.250739, 30.926248],
                            [120.221778, 30.926873],
                            [120.149657, 30.937455],
                            [120.135121, 30.941875],
                            [120.111043, 30.955894],
                            [120.103971, 30.965223],
                            [120.052449, 31.005745],
                            [120.017034, 31.017791],
                            [120.001711, 31.027114],
                            [119.988522, 31.059226],
                            [119.969776, 31.074298],
                            [119.94626, 31.106215],
                            [119.936775, 31.146543],
                            [119.921059, 31.1612],
                            [119.919993, 31.17091]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 320600,
                "name": "南通市",
                "center": [120.864608, 32.016212],
                "centroid": [121.047869, 32.182015],
                "childrenNum": 7,
                "level": "city",
                "parent": {
                    "adcode": 320000
                },
                "subFeatureIndex": 5,
                "acroutes": [100000, 320000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [120.976044, 32.658426],
                            [120.979637, 32.636335],
                            [120.961733, 32.612178],
                            [120.988448, 32.606741],
                            [121.020496, 32.605513],
                            [121.051701, 32.587137],
                            [121.076901, 32.576391],
                            [121.153119, 32.529266],
                            [121.269523, 32.483434],
                            [121.287652, 32.480185],
                            [121.351915, 32.474256],
                            [121.390529, 32.460729],
                            [121.417413, 32.443115],
                            [121.425495, 32.431033],
                            [121.440536, 32.366071],
                            [121.447047, 32.299258],
                            [121.45019, 32.282272],
                            [121.457767, 32.27391],
                            [121.493912, 32.263478],
                            [121.49958, 32.211169],
                            [121.479263, 32.197999],
                            [121.461527, 32.193726],
                            [121.458609, 32.17769],
                            [121.473089, 32.169803],
                            [121.50306, 32.170067],
                            [121.542291, 32.152131],
                            [121.52551, 32.136528],
                            [121.544368, 32.123039],
                            [121.59258, 32.112943],
                            [121.729637, 32.069194],
                            [121.759047, 32.0594],
                            [121.772405, 32.033235],
                            [121.856031, 31.955225],
                            [121.870287, 31.928279],
                            [121.874833, 31.90212],
                            [121.889145, 31.866627],
                            [121.897452, 31.85354],
                            [121.941005, 31.776572],
                            [121.960143, 31.736868],
                            [121.970302, 31.718892],
                            [121.96772, 31.703924],
                            [121.975185, 31.617035],
                            [121.81781, 31.652049],
                            [121.715269, 31.673848],
                            [121.642643, 31.697458],
                            [121.63327, 31.696173],
                            [121.600886, 31.70698],
                            [121.599651, 31.703127],
                            [121.565022, 31.716722],
                            [121.539429, 31.735496],
                            [121.51305, 31.743686],
                            [121.49857, 31.753247],
                            [121.487738, 31.753424],
                            [121.455578, 31.759356],
                            [121.4315, 31.76927],
                            [121.420893, 31.779581],
                            [121.410902, 31.795598],
                            [121.41629, 31.797634],
                            [121.385029, 31.833552],
                            [121.369314, 31.843281],
                            [121.323066, 31.868528],
                            [121.301907, 31.872727],
                            [121.265594, 31.864107],
                            [121.225296, 31.84704],
                            [121.200321, 31.835144],
                            [121.181519, 31.820416],
                            [121.149247, 31.78728],
                            [121.11849, 31.75909],
                            [121.101204, 31.762542],
                            [121.076845, 31.777014],
                            [121.060625, 31.783077],
                            [120.959488, 31.783032],
                            [120.932884, 31.786705],
                            [120.916664, 31.793652],
                            [120.883831, 31.834702],
                            [120.860314, 31.873037],
                            [120.853467, 31.888641],
                            [120.803123, 31.988432],
                            [120.790102, 31.998101],
                            [120.78202, 32.015979],
                            [120.76159, 32.020437],
                            [120.70249, 32.013375],
                            [120.652651, 32.002383],
                            [120.628405, 32.001147],
                            [120.588276, 32.009711],
                            [120.553141, 32.021143],
                            [120.558529, 32.03372],
                            [120.547922, 32.041046],
                            [120.550503, 32.050929],
                            [120.5294, 32.056444],
                            [120.518456, 32.065885],
                            [120.512843, 32.091732],
                            [120.486745, 32.099141],
                            [120.482255, 32.102933],
                            [120.440779, 32.119865],
                            [120.435166, 32.123921],
                            [120.417038, 32.124847],
                            [120.387909, 32.129696],
                            [120.374383, 32.128065],
                            [120.356198, 32.130754],
                            [120.351034, 32.149487],
                            [120.347442, 32.150545],
                            [120.343233, 32.170067],
                            [120.346488, 32.179232],
                            [120.35457, 32.182052],
                            [120.355581, 32.1917],
                            [120.371632, 32.217555],
                            [120.364617, 32.237812],
                            [120.35704, 32.238736],
                            [120.345927, 32.249919],
                            [120.350866, 32.255995],
                            [120.347218, 32.266515],
                            [120.352381, 32.278663],
                            [120.352325, 32.30445],
                            [120.365234, 32.308806],
                            [120.354234, 32.324951],
                            [120.353111, 32.335947],
                            [120.346208, 32.343996],
                            [120.359734, 32.35798],
                            [120.352381, 32.368929],
                            [120.351652, 32.377898],
                            [120.323028, 32.368445],
                            [120.310119, 32.361542],
                            [120.302542, 32.37249],
                            [120.292608, 32.369544],
                            [120.284526, 32.379876],
                            [120.289185, 32.384975],
                            [120.279924, 32.421454],
                            [120.280654, 32.430989],
                            [120.275153, 32.438897],
                            [120.271393, 32.47228],
                            [120.258316, 32.498934],
                            [120.270102, 32.501788],
                            [120.263704, 32.514562],
                            [120.270102, 32.548707],
                            [120.262301, 32.562001],
                            [120.262862, 32.574855],
                            [120.255734, 32.597619],
                            [120.23059, 32.58683],
                            [120.224584, 32.58183],
                            [120.207635, 32.591567],
                            [120.202303, 32.600908],
                            [120.213584, 32.602706],
                            [120.209375, 32.608188],
                            [120.213528, 32.625639],
                            [120.222171, 32.634319],
                            [120.221722, 32.64839],
                            [120.228906, 32.649924],
                            [120.224809, 32.658382],
                            [120.225651, 32.675911],
                            [120.251861, 32.679898],
                            [120.276276, 32.679285],
                            [120.292664, 32.687566],
                            [120.315563, 32.704388],
                            [120.319492, 32.699306],
                            [120.333018, 32.699788],
                            [120.340988, 32.705351],
                            [120.366693, 32.704913],
                            [120.376122, 32.71087],
                            [120.392511, 32.707235],
                            [120.389592, 32.69072],
                            [120.394251, 32.687478],
                            [120.410471, 32.689406],
                            [120.415747, 32.679416],
                            [120.431855, 32.676525],
                            [120.436962, 32.647075],
                            [120.443192, 32.639097],
                            [120.44308, 32.629277],
                            [120.465642, 32.631469],
                            [120.475576, 32.628664],
                            [120.484669, 32.63125],
                            [120.496511, 32.624367],
                            [120.495276, 32.639492],
                            [120.506838, 32.640763],
                            [120.51217, 32.636116],
                            [120.544554, 32.632258],
                            [120.549886, 32.635765],
                            [120.578903, 32.63502],
                            [120.590521, 32.639667],
                            [120.600455, 32.650011],
                            [120.614767, 32.639755],
                            [120.612746, 32.635634],
                            [120.621838, 32.626033],
                            [120.615216, 32.606127],
                            [120.620267, 32.601873],
                            [120.629752, 32.617527],
                            [120.643952, 32.613187],
                            [120.656917, 32.603496],
                            [120.656075, 32.594637],
                            [120.649284, 32.585032],
                            [120.653381, 32.571872],
                            [120.663034, 32.572048],
                            [120.671565, 32.587883],
                            [120.680938, 32.594812],
                            [120.701031, 32.603496],
                            [120.720282, 32.599724],
                            [120.721012, 32.591611],
                            [120.740319, 32.585427],
                            [120.74363, 32.598321],
                            [120.793469, 32.600601],
                            [120.792627, 32.578452],
                            [120.805031, 32.582619],
                            [120.818277, 32.592006],
                            [120.832589, 32.597005],
                            [120.837247, 32.606741],
                            [120.85459, 32.605074],
                            [120.868453, 32.609766],
                            [120.856891, 32.612178],
                            [120.851166, 32.607442],
                            [120.851447, 32.618273],
                            [120.862728, 32.618755],
                            [120.863233, 32.630242],
                            [120.895336, 32.631601],
                            [120.908133, 32.639316],
                            [120.976044, 32.658426]
                        ]
                    ],
                    [
                        [
                            [121.403775, 32.530583],
                            [121.429255, 32.531505],
                            [121.436495, 32.529266],
                            [121.435205, 32.520005],
                            [121.408601, 32.519566],
                            [121.402652, 32.521541],
                            [121.403775, 32.530583]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 320700,
                "name": "连云港市",
                "center": [119.178821, 34.600018],
                "centroid": [119.144784, 34.536075],
                "childrenNum": 6,
                "level": "city",
                "parent": {
                    "adcode": 320000
                },
                "subFeatureIndex": 6,
                "acroutes": [100000, 320000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [119.823009, 34.481996],
                            [119.819192, 34.462856],
                            [119.81184, 34.462298],
                            [119.808585, 34.450065],
                            [119.795564, 34.450494],
                            [119.798875, 34.430316],
                            [119.788492, 34.408073],
                            [119.791186, 34.400299],
                            [119.803814, 34.385651],
                            [119.802411, 34.376156],
                            [119.782486, 34.369754],
                            [119.771766, 34.354285],
                            [119.758745, 34.350546],
                            [119.753582, 34.343239],
                            [119.753975, 34.326088],
                            [119.743087, 34.319038],
                            [119.740449, 34.308805],
                            [119.727877, 34.303086],
                            [119.702059, 34.281152],
                            [119.662715, 34.255943],
                            [119.629826, 34.242948],
                            [119.612259, 34.229951],
                            [119.597442, 34.224528],
                            [119.573476, 34.207783],
                            [119.557424, 34.205372],
                            [119.552485, 34.207955],
                            [119.532561, 34.188538],
                            [119.503881, 34.172561],
                            [119.510279, 34.160501],
                            [119.529306, 34.166833],
                            [119.533403, 34.145423],
                            [119.529025, 34.137711],
                            [119.521392, 34.13672],
                            [119.5375, 34.108968],
                            [119.55097, 34.115605],
                            [119.558828, 34.10177],
                            [119.569716, 34.10621],
                            [119.588406, 34.091338],
                            [119.585712, 34.078792],
                            [119.577012, 34.069737],
                            [119.563598, 34.069004],
                            [119.553889, 34.060466],
                            [119.569716, 34.032775],
                            [119.571905, 34.02104],
                            [119.568257, 34.013187],
                            [119.563318, 34.01021],
                            [119.555236, 34.018624],
                            [119.541148, 34.016596],
                            [119.53576, 34.030877],
                            [119.517968, 34.031351],
                            [119.519596, 34.025743],
                            [119.509269, 34.017157],
                            [119.497819, 34.014568],
                            [119.474135, 33.999206],
                            [119.439169, 33.979611],
                            [119.43002, 33.985611],
                            [119.425474, 34.003521],
                            [119.40931, 34.001925],
                            [119.403305, 34.022335],
                            [119.397917, 34.024449],
                            [119.392809, 34.036787],
                            [119.370752, 34.032991],
                            [119.337919, 34.029669],
                            [119.320015, 34.026131],
                            [119.319285, 34.032861],
                            [119.303458, 34.034544],
                            [119.302897, 34.04041],
                            [119.26838, 34.042438],
                            [119.268211, 34.034285],
                            [119.248624, 34.033767],
                            [119.236164, 34.036312],
                            [119.235715, 34.043991],
                            [119.227352, 34.052703],
                            [119.209504, 34.05624],
                            [119.190534, 34.076723],
                            [119.18408, 34.089786],
                            [119.174931, 34.093494],
                            [119.166849, 34.10746],
                            [119.176166, 34.118579],
                            [119.168421, 34.129654],
                            [119.15641, 34.133618],
                            [119.150348, 34.140555],
                            [119.142828, 34.134049],
                            [119.129077, 34.145768],
                            [119.145409, 34.158692],
                            [119.141874, 34.161578],
                            [119.144287, 34.176265],
                            [119.136991, 34.177858],
                            [119.13295, 34.205415],
                            [119.099667, 34.208042],
                            [119.09703, 34.232921],
                            [119.09108, 34.23688],
                            [119.091866, 34.262353],
                            [119.074074, 34.265107],
                            [119.082774, 34.310868],
                            [119.073008, 34.331763],
                            [119.075477, 34.342681],
                            [119.062232, 34.338683],
                            [119.057068, 34.356176],
                            [119.056227, 34.3823],
                            [119.065263, 34.409232],
                            [119.086871, 34.409747],
                            [119.089565, 34.42087],
                            [119.061222, 34.420183],
                            [119.041409, 34.421901],
                            [119.038659, 34.403735],
                            [119.033215, 34.398881],
                            [119.015311, 34.405324],
                            [118.994994, 34.404121],
                            [118.995162, 34.39029],
                            [118.980794, 34.379636],
                            [118.974901, 34.36911],
                            [118.96463, 34.36086],
                            [118.963788, 34.350546],
                            [118.95363, 34.350116],
                            [118.953237, 34.368508],
                            [118.939991, 34.382343],
                            [118.931909, 34.374738],
                            [118.924837, 34.379293],
                            [118.913388, 34.378262],
                            [118.907439, 34.368036],
                            [118.874942, 34.367692],
                            [118.864335, 34.365887],
                            [118.837787, 34.368809],
                            [118.825328, 34.358797],
                            [118.812138, 34.357336],
                            [118.810903, 34.343196],
                            [118.78531, 34.311814],
                            [118.766564, 34.308891],
                            [118.758258, 34.312932],
                            [118.759829, 34.321058],
                            [118.748268, 34.330817],
                            [118.739905, 34.325056],
                            [118.708194, 34.336362],
                            [118.693265, 34.345904],
                            [118.676371, 34.345345],
                            [118.676596, 34.339414],
                            [118.6661, 34.342423],
                            [118.644268, 34.359012],
                            [118.644773, 34.383632],
                            [118.654482, 34.383288],
                            [118.673958, 34.400728],
                            [118.669075, 34.419281],
                            [118.656784, 34.420655],
                            [118.648814, 34.426796],
                            [118.646457, 34.439547],
                            [118.634502, 34.439977],
                            [118.607899, 34.446931],
                            [118.597796, 34.445429],
                            [118.590444, 34.435984],
                            [118.585617, 34.419496],
                            [118.574616, 34.416662],
                            [118.572147, 34.422931],
                            [118.548069, 34.432893],
                            [118.532298, 34.435512],
                            [118.524216, 34.440191],
                            [118.50373, 34.430746],
                            [118.489811, 34.420398],
                            [118.489699, 34.416189],
                            [118.462422, 34.40687],
                            [118.452825, 34.411895],
                            [118.434696, 34.413269],
                            [118.422124, 34.423275],
                            [118.415221, 34.420269],
                            [118.408205, 34.435512],
                            [118.416231, 34.473885],
                            [118.421395, 34.48324],
                            [118.43088, 34.489076],
                            [118.439523, 34.507995],
                            [118.440421, 34.52751],
                            [118.428017, 34.561169],
                            [118.423864, 34.592929],
                            [118.439186, 34.626305],
                            [118.45434, 34.617737],
                            [118.463657, 34.625277],
                            [118.473816, 34.623435],
                            [118.474882, 34.637184],
                            [118.466463, 34.643137],
                            [118.460851, 34.657569],
                            [118.468484, 34.674309],
                            [118.484255, 34.670884],
                            [118.500812, 34.675165],
                            [118.508164, 34.687066],
                            [118.522701, 34.692288],
                            [118.525226, 34.712573],
                            [118.539314, 34.711503],
                            [118.546105, 34.706197],
                            [118.558901, 34.706839],
                            [118.570463, 34.71253],
                            [118.601332, 34.714156],
                            [118.604924, 34.696482],
                            [118.633716, 34.687023],
                            [118.650554, 34.69507],
                            [118.664304, 34.693443],
                            [118.681366, 34.678333],
                            [118.69029, 34.67859],
                            [118.704041, 34.688778],
                            [118.720093, 34.694214],
                            [118.744732, 34.695284],
                            [118.766228, 34.705213],
                            [118.76735, 34.710519],
                            [118.783402, 34.722029],
                            [118.768529, 34.738072],
                            [118.759212, 34.740853],
                            [118.74013, 34.736917],
                            [118.730364, 34.74543],
                            [118.716501, 34.747739],
                            [118.716445, 34.76382],
                            [118.727221, 34.768738],
                            [118.738502, 34.766857],
                            [118.740186, 34.781224],
                            [118.728399, 34.786867],
                            [118.737548, 34.792083],
                            [118.759998, 34.790287],
                            [118.77358, 34.795332],
                            [118.779024, 34.809608],
                            [118.776611, 34.818754],
                            [118.781999, 34.827472],
                            [118.768248, 34.838795],
                            [118.769034, 34.846143],
                            [118.788734, 34.845673],
                            [118.797265, 34.842853],
                            [118.804617, 34.852466],
                            [118.804449, 34.870277],
                            [118.807199, 34.877708],
                            [118.829761, 34.91114],
                            [118.860799, 34.944003],
                            [118.859227, 34.962647],
                            [118.86512, 34.99323],
                            [118.862482, 35.025719],
                            [118.865345, 35.029854],
                            [118.885774, 35.034244],
                            [118.903847, 35.041319],
                            [118.911143, 35.047754],
                            [118.926521, 35.05078],
                            [118.945155, 35.040808],
                            [118.965641, 35.046476],
                            [118.992132, 35.048181],
                            [118.999877, 35.053039],
                            [119.02721, 35.05534],
                            [119.037368, 35.051334],
                            [119.06139, 35.05159],
                            [119.073625, 35.056661],
                            [119.114597, 35.054956],
                            [119.120378, 35.058024],
                            [119.12049, 35.070083],
                            [119.12947, 35.076175],
                            [119.138057, 35.09628],
                            [119.159048, 35.100965],
                            [119.171395, 35.107183],
                            [119.203218, 35.110888],
                            [119.220729, 35.107183],
                            [119.24071, 35.122938],
                            [119.252665, 35.122683],
                            [119.273768, 35.115487],
                            [119.286677, 35.115146],
                            [119.30183, 35.093171],
                            [119.305871, 35.076686],
                            [119.293524, 35.07298],
                            [119.292682, 35.068506],
                            [119.307162, 35.03305],
                            [119.29184, 35.02849],
                            [119.281064, 35.053678],
                            [119.285442, 35.068506],
                            [119.279436, 35.071105],
                            [119.238072, 35.048479],
                            [119.232572, 35.041831],
                            [119.227521, 35.020944],
                            [119.21899, 35.004828],
                            [119.211357, 34.981715],
                            [119.211806, 34.957912],
                            [119.214612, 34.937687],
                            [119.212704, 34.917799],
                            [119.202433, 34.890433],
                            [119.21377, 34.876726],
                            [119.210515, 34.862333],
                            [119.218035, 34.852594],
                            [119.220393, 34.841187],
                            [119.213602, 34.833924],
                            [119.238577, 34.799563],
                            [119.250756, 34.794049],
                            [119.272196, 34.797811],
                            [119.312831, 34.774724],
                            [119.324393, 34.770406],
                            [119.342689, 34.769251],
                            [119.355037, 34.775751],
                            [119.370864, 34.772971],
                            [119.378497, 34.764547],
                            [119.440684, 34.769208],
                            [119.438271, 34.784302],
                            [119.456175, 34.779813],
                            [119.459486, 34.77109],
                            [119.477165, 34.769037],
                            [119.480421, 34.76412],
                            [119.49709, 34.759458],
                            [119.48839, 34.747868],
                            [119.468241, 34.748167],
                            [119.460777, 34.754069],
                            [119.444332, 34.758432],
                            [119.399993, 34.755823],
                            [119.378273, 34.761383],
                            [119.381809, 34.752444],
                            [119.457129, 34.748167],
                            [119.483508, 34.736404],
                            [119.508427, 34.729217],
                            [119.525714, 34.733281],
                            [119.522795, 34.722329],
                            [119.507978, 34.711032],
                            [119.492488, 34.711546],
                            [119.491814, 34.69554],
                            [119.484855, 34.692716],
                            [119.474584, 34.696054],
                            [119.464986, 34.674694],
                            [119.537051, 34.633758],
                            [119.560736, 34.63153],
                            [119.56893, 34.615381],
                            [119.584926, 34.601328],
                            [119.611248, 34.592929],
                            [119.62528, 34.585901],
                            [119.641388, 34.568971],
                            [119.697906, 34.546593],
                            [119.741066, 34.532871],
                            [119.781813, 34.515759],
                            [119.811615, 34.485557],
                            [119.823009, 34.481996]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 320800,
                "name": "淮安市",
                "center": [119.021265, 33.597506],
                "centroid": [118.971034, 33.352326],
                "childrenNum": 7,
                "level": "city",
                "parent": {
                    "adcode": 320000
                },
                "subFeatureIndex": 7,
                "acroutes": [100000, 320000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [119.184922, 32.82564],
                            [119.113081, 32.822928],
                            [119.10427, 32.826734],
                            [119.071324, 32.864738],
                            [119.055104, 32.874751],
                            [119.045731, 32.892455],
                            [119.045002, 32.911424],
                            [119.021541, 32.905961],
                            [119.015592, 32.907534],
                            [119.019801, 32.925713],
                            [119.030016, 32.927854],
                            [119.023281, 32.935063],
                            [119.026312, 32.947251],
                            [119.020812, 32.955813],
                            [119.008913, 32.959395],
                            [118.993647, 32.958215],
                            [118.961207, 32.94581],
                            [118.941619, 32.946116],
                            [118.933818, 32.938645],
                            [118.921414, 32.939563],
                            [118.90626, 32.944936],
                            [118.893239, 32.940873],
                            [118.891162, 32.951489],
                            [118.896214, 32.957735],
                            [118.884652, 32.960618],
                            [118.865233, 32.955027],
                            [118.849349, 32.956643],
                            [118.849405, 32.945897],
                            [118.842502, 32.943669],
                            [118.848956, 32.927198],
                            [118.839471, 32.922523],
                            [118.836945, 32.911424],
                            [118.818985, 32.920644],
                            [118.812194, 32.91693],
                            [118.809332, 32.907884],
                            [118.814608, 32.902727],
                            [118.81124, 32.875494],
                            [118.806189, 32.870247],
                            [118.812531, 32.865219],
                            [118.811689, 32.854987],
                            [118.791035, 32.848384],
                            [118.747875, 32.858704],
                            [118.741813, 32.853369],
                            [118.746808, 32.800353],
                            [118.736874, 32.793351],
                            [118.737941, 32.773264],
                            [118.746359, 32.759256],
                            [118.752702, 32.755842],
                            [118.756294, 32.737059],
                            [118.736706, 32.73233],
                            [118.724471, 32.721951],
                            [118.70724, 32.720287],
                            [118.694163, 32.726637],
                            [118.657569, 32.736096],
                            [118.654033, 32.740693],
                            [118.639385, 32.744809],
                            [118.632313, 32.739993],
                            [118.617047, 32.738942],
                            [118.607562, 32.726637],
                            [118.59078, 32.724841],
                            [118.576581, 32.719104],
                            [118.559743, 32.729921],
                            [118.544702, 32.729396],
                            [118.520456, 32.723221],
                            [118.489755, 32.724491],
                            [118.483469, 32.721426],
                            [118.459279, 32.726111],
                            [118.450467, 32.743364],
                            [118.422854, 32.718097],
                            [118.411011, 32.716039],
                            [118.398664, 32.721426],
                            [118.375316, 32.719017],
                            [118.368188, 32.724754],
                            [118.36628, 32.735001],
                            [118.372285, 32.741744],
                            [118.371163, 32.757724],
                            [118.366224, 32.768318],
                            [118.348769, 32.773001],
                            [118.334064, 32.761576],
                            [118.326431, 32.763459],
                            [118.322334, 32.777465],
                            [118.307124, 32.778735],
                            [118.298761, 32.785562],
                            [118.294439, 32.800134],
                            [118.306619, 32.810591],
                            [118.297863, 32.83207],
                            [118.301736, 32.846241],
                            [118.289557, 32.845498],
                            [118.284618, 32.857305],
                            [118.263178, 32.856168],
                            [118.250606, 32.848384],
                            [118.244432, 32.874488],
                            [118.239774, 32.883363],
                            [118.233039, 32.916231],
                            [118.235396, 32.926543],
                            [118.251335, 32.936155],
                            [118.293373, 32.947164],
                            [118.309649, 32.959002],
                            [118.303812, 32.968654],
                            [118.269352, 32.969178],
                            [118.252402, 32.982148],
                            [118.244825, 32.998303],
                            [118.243478, 33.027767],
                            [118.239605, 33.046445],
                            [118.233375, 33.060014],
                            [118.212441, 33.061934],
                            [118.214854, 33.070833],
                            [118.22765, 33.069525],
                            [118.223666, 33.083439],
                            [118.202899, 33.088106],
                            [118.206491, 33.091246],
                            [118.221308, 33.087626],
                            [118.220915, 33.105855],
                            [118.20969, 33.104329],
                            [118.210476, 33.111829],
                            [118.219625, 33.114096],
                            [118.223722, 33.155464],
                            [118.221364, 33.180693],
                            [118.261718, 33.199948],
                            [118.320201, 33.196246],
                            [118.424313, 33.187141],
                            [118.443452, 33.204783],
                            [118.511083, 33.263868],
                            [118.667784, 33.311734],
                            [118.703424, 33.323697],
                            [118.780147, 33.345834],
                            [118.746921, 33.386701],
                            [118.782841, 33.444012],
                            [118.779866, 33.487568],
                            [118.785591, 33.493082],
                            [118.789969, 33.508709],
                            [118.789744, 33.5367],
                            [118.797433, 33.560604],
                            [118.803102, 33.561776],
                            [118.806357, 33.572749],
                            [118.78531, 33.587018],
                            [118.770605, 33.60705],
                            [118.757977, 33.635746],
                            [118.799566, 33.64671],
                            [118.792607, 33.666555],
                            [118.798612, 33.69155],
                            [118.813148, 33.700948],
                            [118.809276, 33.715975],
                            [118.814215, 33.730868],
                            [118.80226, 33.741215],
                            [118.805122, 33.763245],
                            [118.79575, 33.772852],
                            [118.805628, 33.794355],
                            [118.799847, 33.813517],
                            [118.807311, 33.819356],
                            [118.818985, 33.844954],
                            [118.828751, 33.858615],
                            [118.857151, 33.880227],
                            [118.863661, 33.891376],
                            [118.874493, 33.892543],
                            [118.885381, 33.885888],
                            [118.907383, 33.889777],
                            [118.922143, 33.902524],
                            [118.933088, 33.900709],
                            [118.941338, 33.907751],
                            [118.948803, 33.906801],
                            [118.950767, 33.914275],
                            [118.972263, 33.919372],
                            [118.987585, 33.904554],
                            [118.999708, 33.9049],
                            [118.997295, 33.897296],
                            [119.008015, 33.896604],
                            [119.024853, 33.911164],
                            [119.035853, 33.928054],
                            [119.044553, 33.929436],
                            [119.053252, 33.937383],
                            [119.050951, 33.957507],
                            [119.040736, 33.959622],
                            [119.0427, 33.968905],
                            [119.055441, 33.973135],
                            [119.058864, 33.978359],
                            [119.07312, 33.98151],
                            [119.081932, 33.987769],
                            [119.08384, 34.001407],
                            [119.114541, 34.024406],
                            [119.129751, 34.028849],
                            [119.148833, 34.045845],
                            [119.155119, 34.056973],
                            [119.15815, 34.076421],
                            [119.166456, 34.088105],
                            [119.174931, 34.093494],
                            [119.18408, 34.089786],
                            [119.190534, 34.076723],
                            [119.209504, 34.05624],
                            [119.227352, 34.052703],
                            [119.235715, 34.043991],
                            [119.236164, 34.036312],
                            [119.248624, 34.033767],
                            [119.268211, 34.034285],
                            [119.26838, 34.042438],
                            [119.302897, 34.04041],
                            [119.303458, 34.034544],
                            [119.319285, 34.032861],
                            [119.320015, 34.026131],
                            [119.337919, 34.029669],
                            [119.370752, 34.032991],
                            [119.392809, 34.036787],
                            [119.397917, 34.024449],
                            [119.403305, 34.022335],
                            [119.40931, 34.001925],
                            [119.425474, 34.003521],
                            [119.43002, 33.985611],
                            [119.439169, 33.979611],
                            [119.474135, 33.999206],
                            [119.497819, 34.014568],
                            [119.509269, 34.017157],
                            [119.519596, 34.025743],
                            [119.517968, 34.031351],
                            [119.53576, 34.030877],
                            [119.541148, 34.016596],
                            [119.555236, 34.018624],
                            [119.563318, 34.01021],
                            [119.568257, 34.013187],
                            [119.57892, 33.999896],
                            [119.597273, 33.995926],
                            [119.601427, 33.980129],
                            [119.595309, 33.976805],
                            [119.615121, 33.9547],
                            [119.620397, 33.946107],
                            [119.63426, 33.951289],
                            [119.644026, 33.947014],
                            [119.637571, 33.939024],
                            [119.64599, 33.924772],
                            [119.638974, 33.904597],
                            [119.639199, 33.893752],
                            [119.617871, 33.879276],
                            [119.598733, 33.874522],
                            [119.584814, 33.858961],
                            [119.559389, 33.840069],
                            [119.555292, 33.827572],
                            [119.543169, 33.812392],
                            [119.545526, 33.803569],
                            [119.536153, 33.79721],
                            [119.53228, 33.776573],
                            [119.524311, 33.770299],
                            [119.508988, 33.739526],
                            [119.508932, 33.72208],
                            [119.48261, 33.69809],
                            [119.481655, 33.685963],
                            [119.492263, 33.673097],
                            [119.484911, 33.667162],
                            [119.483732, 33.658453],
                            [119.496136, 33.654207],
                            [119.467624, 33.638303],
                            [119.463751, 33.645323],
                            [119.456455, 33.64164],
                            [119.464369, 33.627121],
                            [119.471104, 33.597338],
                            [119.477783, 33.588362],
                            [119.486594, 33.560691],
                            [119.493329, 33.545941],
                            [119.492712, 33.536006],
                            [119.498156, 33.520297],
                            [119.520775, 33.500896],
                            [119.532449, 33.501503],
                            [119.55894, 33.471416],
                            [119.576282, 33.474239],
                            [119.580997, 33.464512],
                            [119.591436, 33.464078],
                            [119.604121, 33.455435],
                            [119.605299, 33.449572],
                            [119.620004, 33.43741],
                            [119.617983, 33.427201],
                            [119.604177, 33.422291],
                            [119.566853, 33.399348],
                            [119.559164, 33.400913],
                            [119.553103, 33.410516],
                            [119.543898, 33.414905],
                            [119.53127, 33.414905],
                            [119.504498, 33.407301],
                            [119.48839, 33.407909],
                            [119.476773, 33.403737],
                            [119.448429, 33.384832],
                            [119.416831, 33.376181],
                            [119.401284, 33.375182],
                            [119.36542, 33.369574],
                            [119.310979, 33.3674],
                            [119.29184, 33.3634],
                            [119.254517, 33.352878],
                            [119.243123, 33.352443],
                            [119.235041, 33.345138],
                            [119.248848, 33.318129],
                            [119.262655, 33.303033],
                            [119.239924, 33.301511],
                            [119.210683, 33.292504],
                            [119.184697, 33.289763],
                            [119.160114, 33.283453],
                            [119.153435, 33.285281],
                            [119.163145, 33.271529],
                            [119.155512, 33.254466],
                            [119.146644, 33.248589],
                            [119.143277, 33.230042],
                            [119.150685, 33.212797],
                            [119.165222, 33.207614],
                            [119.199907, 33.205915],
                            [119.211413, 33.203084],
                            [119.219158, 33.206002],
                            [119.22202, 33.188056],
                            [119.229541, 33.165879],
                            [119.22376, 33.16126],
                            [119.228531, 33.151106],
                            [119.250251, 33.157643],
                            [119.271467, 33.146834],
                            [119.305422, 33.13463],
                            [119.313897, 33.128614],
                            [119.321081, 33.102279],
                            [119.334776, 33.084442],
                            [119.343251, 33.065119],
                            [119.363736, 33.053513],
                            [119.364185, 33.03859],
                            [119.359246, 33.029688],
                            [119.343082, 33.011443],
                            [119.325122, 32.998434],
                            [119.324954, 32.96861],
                            [119.328265, 32.945897],
                            [119.345608, 32.890182],
                            [119.349817, 32.868411],
                            [119.345383, 32.838325],
                            [119.332699, 32.81501],
                            [119.313729, 32.804859],
                            [119.278651, 32.798909],
                            [119.190927, 32.825421],
                            [119.184922, 32.82564]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 320900,
                "name": "盐城市",
                "center": [120.139998, 33.377631],
                "centroid": [120.198551, 33.516451],
                "childrenNum": 9,
                "level": "city",
                "parent": {
                    "adcode": 320000
                },
                "subFeatureIndex": 8,
                "acroutes": [100000, 320000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [119.823009, 34.481996],
                            [119.8495, 34.477404],
                            [119.919039, 34.469122],
                            [119.962536, 34.458907],
                            [120.043019, 34.422201],
                            [120.103691, 34.391622],
                            [120.233284, 34.337179],
                            [120.292833, 34.318092],
                            [120.311635, 34.307042],
                            [120.308492, 34.297452],
                            [120.314272, 34.255814],
                            [120.331671, 34.209333],
                            [120.347499, 34.179236],
                            [120.355973, 34.149559],
                            [120.359846, 34.121897],
                            [120.367591, 34.091424],
                            [120.424671, 33.975121],
                            [120.485454, 33.859221],
                            [120.500384, 33.817928],
                            [120.534508, 33.782587],
                            [120.570596, 33.702247],
                            [120.583786, 33.668462],
                            [120.611175, 33.627251],
                            [120.622849, 33.615113],
                            [120.651136, 33.575699],
                            [120.680153, 33.520297],
                            [120.717476, 33.436715],
                            [120.719833, 33.420467],
                            [120.728252, 33.384571],
                            [120.730777, 33.365183],
                            [120.740992, 33.337615],
                            [120.760748, 33.319869],
                            [120.769335, 33.306818],
                            [120.782862, 33.304208],
                            [120.796388, 33.306122],
                            [120.81373, 33.303425],
                            [120.821812, 33.298552],
                            [120.832589, 33.282148],
                            [120.831971, 33.26883],
                            [120.820297, 33.256077],
                            [120.819455, 33.238184],
                            [120.843028, 33.22965],
                            [120.846844, 33.219852],
                            [120.843757, 33.209835],
                            [120.859865, 33.142781],
                            [120.874065, 33.093645],
                            [120.87182, 33.04723],
                            [120.894438, 33.038634],
                            [120.917843, 33.02576],
                            [120.932604, 33.005899],
                            [120.940124, 32.975467],
                            [120.950395, 32.916405],
                            [120.957579, 32.893504],
                            [120.972677, 32.88568],
                            [120.978682, 32.875712],
                            [120.981376, 32.85971],
                            [120.971947, 32.761182],
                            [120.963136, 32.750238],
                            [120.952865, 32.714068],
                            [120.93294, 32.715688],
                            [120.915036, 32.711703],
                            [120.915934, 32.701234],
                            [120.933838, 32.69221],
                            [120.950059, 32.689581],
                            [120.963585, 32.682396],
                            [120.976044, 32.658426],
                            [120.908133, 32.639316],
                            [120.895336, 32.631601],
                            [120.863233, 32.630242],
                            [120.862728, 32.618755],
                            [120.851447, 32.618273],
                            [120.851166, 32.607442],
                            [120.856891, 32.612178],
                            [120.868453, 32.609766],
                            [120.85459, 32.605074],
                            [120.837247, 32.606741],
                            [120.832589, 32.597005],
                            [120.818277, 32.592006],
                            [120.805031, 32.582619],
                            [120.792627, 32.578452],
                            [120.793469, 32.600601],
                            [120.74363, 32.598321],
                            [120.740319, 32.585427],
                            [120.721012, 32.591611],
                            [120.720282, 32.599724],
                            [120.701031, 32.603496],
                            [120.680938, 32.594812],
                            [120.671565, 32.587883],
                            [120.663034, 32.572048],
                            [120.653381, 32.571872],
                            [120.649284, 32.585032],
                            [120.656075, 32.594637],
                            [120.656917, 32.603496],
                            [120.643952, 32.613187],
                            [120.629752, 32.617527],
                            [120.620267, 32.601873],
                            [120.615216, 32.606127],
                            [120.621838, 32.626033],
                            [120.612746, 32.635634],
                            [120.614767, 32.639755],
                            [120.600455, 32.650011],
                            [120.590521, 32.639667],
                            [120.578903, 32.63502],
                            [120.549886, 32.635765],
                            [120.544554, 32.632258],
                            [120.51217, 32.636116],
                            [120.506838, 32.640763],
                            [120.495276, 32.639492],
                            [120.496511, 32.624367],
                            [120.484669, 32.63125],
                            [120.475576, 32.628664],
                            [120.465642, 32.631469],
                            [120.44308, 32.629277],
                            [120.443192, 32.639097],
                            [120.436962, 32.647075],
                            [120.431855, 32.676525],
                            [120.415747, 32.679416],
                            [120.410471, 32.689406],
                            [120.394251, 32.687478],
                            [120.389592, 32.69072],
                            [120.392511, 32.707235],
                            [120.376122, 32.71087],
                            [120.366693, 32.704913],
                            [120.340988, 32.705351],
                            [120.333018, 32.699788],
                            [120.319492, 32.699306],
                            [120.315563, 32.704388],
                            [120.292664, 32.687566],
                            [120.276276, 32.679285],
                            [120.251861, 32.679898],
                            [120.225651, 32.675911],
                            [120.224809, 32.658382],
                            [120.228906, 32.649924],
                            [120.221722, 32.64839],
                            [120.222171, 32.634319],
                            [120.213528, 32.625639],
                            [120.209375, 32.608188],
                            [120.213584, 32.602706],
                            [120.202303, 32.600908],
                            [120.196017, 32.603013],
                            [120.197251, 32.619281],
                            [120.17598, 32.629102],
                            [120.176317, 32.62121],
                            [120.154372, 32.616037],
                            [120.140846, 32.6163],
                            [120.122661, 32.610293],
                            [120.113176, 32.613801],
                            [120.109079, 32.630505],
                            [120.120977, 32.633267],
                            [120.121651, 32.679197],
                            [120.129508, 32.689055],
                            [120.138096, 32.687171],
                            [120.145055, 32.705877],
                            [120.157571, 32.703249],
                            [120.155382, 32.714199],
                            [120.164811, 32.720331],
                            [120.17323, 32.715688],
                            [120.181705, 32.723177],
                            [120.180863, 32.741832],
                            [120.196129, 32.739336],
                            [120.202583, 32.74297],
                            [120.206624, 32.756586],
                            [120.21465, 32.767442],
                            [120.228176, 32.77856],
                            [120.222396, 32.792301],
                            [120.199328, 32.786962],
                            [120.197027, 32.781492],
                            [120.18294, 32.772913],
                            [120.174184, 32.779654],
                            [120.162454, 32.780967],
                            [120.159255, 32.787881],
                            [120.168179, 32.793045],
                            [120.161107, 32.809935],
                            [120.167225, 32.81501],
                            [120.187037, 32.812166],
                            [120.193379, 32.826078],
                            [120.181031, 32.82529],
                            [120.184848, 32.834126],
                            [120.194894, 32.842786],
                            [120.195231, 32.851358],
                            [120.205895, 32.852189],
                            [120.20842, 32.864345],
                            [120.198767, 32.866925],
                            [120.200226, 32.874488],
                            [120.177046, 32.877767],
                            [120.181873, 32.903907],
                            [120.177495, 32.909064],
                            [120.176373, 32.932529],
                            [120.201068, 32.930519],
                            [120.204997, 32.9206],
                            [120.220431, 32.917017],
                            [120.238447, 32.921168],
                            [120.23884, 32.927985],
                            [120.280766, 32.924926],
                            [120.291991, 32.933621],
                            [120.295078, 32.94546],
                            [120.286378, 32.949392],
                            [120.287389, 32.955202],
                            [120.300353, 32.954153],
                            [120.299063, 32.966601],
                            [120.312364, 32.992583],
                            [120.308884, 33.024407],
                            [120.313038, 33.048059],
                            [120.30939, 33.062283],
                            [120.291991, 33.081128],
                            [120.293675, 33.096698],
                            [120.28969, 33.104242],
                            [120.296761, 33.129573],
                            [120.214145, 33.13742],
                            [120.168852, 33.15311],
                            [120.153418, 33.157207],
                            [120.094093, 33.178645],
                            [120.080848, 33.181782],
                            [120.048183, 33.164049],
                            [120.023993, 33.158035],
                            [120.003451, 33.15603],
                            [119.988073, 33.151585],
                            [119.968373, 33.149885],
                            [119.936438, 33.155377],
                            [119.916569, 33.149449],
                            [119.8944, 33.151062],
                            [119.890247, 33.144306],
                            [119.877282, 33.146834],
                            [119.867572, 33.143391],
                            [119.86847, 33.154461],
                            [119.843494, 33.153459],
                            [119.787313, 33.13912],
                            [119.772272, 33.130924],
                            [119.74926, 33.131012],
                            [119.739775, 33.147401],
                            [119.753077, 33.16065],
                            [119.751281, 33.170803],
                            [119.730346, 33.172851],
                            [119.728775, 33.188709],
                            [119.733489, 33.205349],
                            [119.731469, 33.211664],
                            [119.712611, 33.219068],
                            [119.693247, 33.224294],
                            [119.685727, 33.238619],
                            [119.690778, 33.242668],
                            [119.704248, 33.269788],
                            [119.71508, 33.271877],
                            [119.700319, 33.294245],
                            [119.6864, 33.288892],
                            [119.659516, 33.285846],
                            [119.654016, 33.280711],
                            [119.640546, 33.293635],
                            [119.641388, 33.311038],
                            [119.632408, 33.317042],
                            [119.636, 33.326611],
                            [119.631959, 33.335353],
                            [119.616356, 33.333135],
                            [119.613101, 33.358357],
                            [119.605411, 33.379702],
                            [119.589865, 33.380963],
                            [119.576731, 33.378442],
                            [119.566853, 33.399348],
                            [119.604177, 33.422291],
                            [119.617983, 33.427201],
                            [119.620004, 33.43741],
                            [119.605299, 33.449572],
                            [119.604121, 33.455435],
                            [119.591436, 33.464078],
                            [119.580997, 33.464512],
                            [119.576282, 33.474239],
                            [119.55894, 33.471416],
                            [119.532449, 33.501503],
                            [119.520775, 33.500896],
                            [119.498156, 33.520297],
                            [119.492712, 33.536006],
                            [119.493329, 33.545941],
                            [119.486594, 33.560691],
                            [119.477783, 33.588362],
                            [119.471104, 33.597338],
                            [119.464369, 33.627121],
                            [119.456455, 33.64164],
                            [119.463751, 33.645323],
                            [119.467624, 33.638303],
                            [119.496136, 33.654207],
                            [119.483732, 33.658453],
                            [119.484911, 33.667162],
                            [119.492263, 33.673097],
                            [119.481655, 33.685963],
                            [119.48261, 33.69809],
                            [119.508932, 33.72208],
                            [119.508988, 33.739526],
                            [119.524311, 33.770299],
                            [119.53228, 33.776573],
                            [119.536153, 33.79721],
                            [119.545526, 33.803569],
                            [119.543169, 33.812392],
                            [119.555292, 33.827572],
                            [119.559389, 33.840069],
                            [119.584814, 33.858961],
                            [119.598733, 33.874522],
                            [119.617871, 33.879276],
                            [119.639199, 33.893752],
                            [119.638974, 33.904597],
                            [119.64599, 33.924772],
                            [119.637571, 33.939024],
                            [119.644026, 33.947014],
                            [119.63426, 33.951289],
                            [119.620397, 33.946107],
                            [119.615121, 33.9547],
                            [119.595309, 33.976805],
                            [119.601427, 33.980129],
                            [119.597273, 33.995926],
                            [119.57892, 33.999896],
                            [119.568257, 34.013187],
                            [119.571905, 34.02104],
                            [119.569716, 34.032775],
                            [119.553889, 34.060466],
                            [119.563598, 34.069004],
                            [119.577012, 34.069737],
                            [119.585712, 34.078792],
                            [119.588406, 34.091338],
                            [119.569716, 34.10621],
                            [119.558828, 34.10177],
                            [119.55097, 34.115605],
                            [119.5375, 34.108968],
                            [119.521392, 34.13672],
                            [119.529025, 34.137711],
                            [119.533403, 34.145423],
                            [119.529306, 34.166833],
                            [119.510279, 34.160501],
                            [119.503881, 34.172561],
                            [119.532561, 34.188538],
                            [119.552485, 34.207955],
                            [119.557424, 34.205372],
                            [119.573476, 34.207783],
                            [119.597442, 34.224528],
                            [119.612259, 34.229951],
                            [119.629826, 34.242948],
                            [119.662715, 34.255943],
                            [119.702059, 34.281152],
                            [119.727877, 34.303086],
                            [119.740449, 34.308805],
                            [119.743087, 34.319038],
                            [119.753975, 34.326088],
                            [119.753582, 34.343239],
                            [119.758745, 34.350546],
                            [119.771766, 34.354285],
                            [119.782486, 34.369754],
                            [119.802411, 34.376156],
                            [119.803814, 34.385651],
                            [119.791186, 34.400299],
                            [119.788492, 34.408073],
                            [119.798875, 34.430316],
                            [119.795564, 34.450494],
                            [119.808585, 34.450065],
                            [119.81184, 34.462298],
                            [119.819192, 34.462856],
                            [119.823009, 34.481996]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 321000,
                "name": "扬州市",
                "center": [119.421003, 32.393159],
                "centroid": [119.479719, 32.737223],
                "childrenNum": 6,
                "level": "city",
                "parent": {
                    "adcode": 320000
                },
                "subFeatureIndex": 9,
                "acroutes": [100000, 320000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [119.712611, 33.219068],
                            [119.708177, 33.198336],
                            [119.701835, 33.201821],
                            [119.692069, 33.186923],
                            [119.657271, 33.162349],
                            [119.653679, 33.156553],
                            [119.646158, 33.130096],
                            [119.649245, 33.120244],
                            [119.640321, 33.119241],
                            [119.64773, 33.104111],
                            [119.669731, 33.089807],
                            [119.683931, 33.072535],
                            [119.696615, 33.016899],
                            [119.708008, 33.005681],
                            [119.706661, 32.989614],
                            [119.696727, 32.961316],
                            [119.703069, 32.944893],
                            [119.714743, 32.936374],
                            [119.712386, 32.921955],
                            [119.719514, 32.906179],
                            [119.72507, 32.901721],
                            [119.746173, 32.898706],
                            [119.761888, 32.904082],
                            [119.775302, 32.915968],
                            [119.782599, 32.914832],
                            [119.789334, 32.881177],
                            [119.802691, 32.862727],
                            [119.79736, 32.857086],
                            [119.805778, 32.851926],
                            [119.795956, 32.841474],
                            [119.801513, 32.837669],
                            [119.800895, 32.828265],
                            [119.790849, 32.820041],
                            [119.78866, 32.810197],
                            [119.794666, 32.803853],
                            [119.806508, 32.800572],
                            [119.82357, 32.807966],
                            [119.830249, 32.806872],
                            [119.824917, 32.794927],
                            [119.833504, 32.781973],
                            [119.863082, 32.775715],
                            [119.866899, 32.768493],
                            [119.84529, 32.752952],
                            [119.843663, 32.736709],
                            [119.858031, 32.721163],
                            [119.85848, 32.710608],
                            [119.877282, 32.69843],
                            [119.870659, 32.679066],
                            [119.883512, 32.673895],
                            [119.894849, 32.674334],
                            [119.899171, 32.65698],
                            [119.89715, 32.646242],
                            [119.911855, 32.625156],
                            [119.90063, 32.623973],
                            [119.898666, 32.616519],
                            [119.890527, 32.620334],
                            [119.869537, 32.619369],
                            [119.866618, 32.627611],
                            [119.855056, 32.631908],
                            [119.844617, 32.640368],
                            [119.832999, 32.640894],
                            [119.828734, 32.629365],
                            [119.814365, 32.627085],
                            [119.816105, 32.614897],
                            [119.821774, 32.607267],
                            [119.815769, 32.605644],
                            [119.820034, 32.592751],
                            [119.815656, 32.578759],
                            [119.827162, 32.55915],
                            [119.835525, 32.54976],
                            [119.823402, 32.535367],
                            [119.824524, 32.4963],
                            [119.818182, 32.491645],
                            [119.814534, 32.468855],
                            [119.829688, 32.460334],
                            [119.84052, 32.464463],
                            [119.853372, 32.46275],
                            [119.859266, 32.444477],
                            [119.868526, 32.438722],
                            [119.863812, 32.417104],
                            [119.851745, 32.411171],
                            [119.853878, 32.401854],
                            [119.844561, 32.395964],
                            [119.856179, 32.379744],
                            [119.853709, 32.361498],
                            [119.842709, 32.360662],
                            [119.847311, 32.328426],
                            [119.843887, 32.321872],
                            [119.819192, 32.302514],
                            [119.802299, 32.312809],
                            [119.786022, 32.317912],
                            [119.768623, 32.318924],
                            [119.745163, 32.313865],
                            [119.730683, 32.30401],
                            [119.708401, 32.276374],
                            [119.688589, 32.282492],
                            [119.678094, 32.270125],
                            [119.661368, 32.263742],
                            [119.633923, 32.257755],
                            [119.627581, 32.248731],
                            [119.629714, 32.227728],
                            [119.621744, 32.217423],
                            [119.622081, 32.237415],
                            [119.615795, 32.250668],
                            [119.607207, 32.252913],
                            [119.597947, 32.246265],
                            [119.599406, 32.234553],
                            [119.570894, 32.230062],
                            [119.570838, 32.271621],
                            [119.577854, 32.273029],
                            [119.576395, 32.28456],
                            [119.544852, 32.282756],
                            [119.546424, 32.278839],
                            [119.536714, 32.267924],
                            [119.514769, 32.248907],
                            [119.504442, 32.254938],
                            [119.478569, 32.261277],
                            [119.462461, 32.26251],
                            [119.433893, 32.257535],
                            [119.412678, 32.246617],
                            [119.396738, 32.235126],
                            [119.388375, 32.225086],
                            [119.367609, 32.225526],
                            [119.336403, 32.230987],
                            [119.286115, 32.23288],
                            [119.254966, 32.23222],
                            [119.229036, 32.222179],
                            [119.177232, 32.238912],
                            [119.153772, 32.243668],
                            [119.132332, 32.245164],
                            [119.086029, 32.241158],
                            [119.074748, 32.248951],
                            [119.056563, 32.25168],
                            [119.037088, 32.259868],
                            [119.041073, 32.271709],
                            [119.040006, 32.303394],
                            [119.035572, 32.308718],
                            [119.035853, 32.325435],
                            [119.041971, 32.333264],
                            [119.028445, 32.345095],
                            [119.027322, 32.35134],
                            [119.043823, 32.365191],
                            [119.02171, 32.375436],
                            [119.022551, 32.380447],
                            [119.038435, 32.38159],
                            [119.037425, 32.388844],
                            [119.02749, 32.388316],
                            [119.017556, 32.399261],
                            [119.016434, 32.413193],
                            [119.029455, 32.428836],
                            [119.022495, 32.440303],
                            [119.02373, 32.456073],
                            [119.035909, 32.452428],
                            [119.047022, 32.462882],
                            [119.067452, 32.462398],
                            [119.073681, 32.455371],
                            [119.085131, 32.452735],
                            [119.096019, 32.466088],
                            [119.115495, 32.476979],
                            [119.134521, 32.491558],
                            [119.147767, 32.492655],
                            [119.142266, 32.499417],
                            [119.150124, 32.509821],
                            [119.155568, 32.528081],
                            [119.167803, 32.536332],
                            [119.166681, 32.545986],
                            [119.154502, 32.554938],
                            [119.153828, 32.56187],
                            [119.175212, 32.571083],
                            [119.176952, 32.593848],
                            [119.187167, 32.599944],
                            [119.193733, 32.579154],
                            [119.20928, 32.573583],
                            [119.220168, 32.57661],
                            [119.220056, 32.592444],
                            [119.231, 32.607135],
                            [119.220505, 32.609854],
                            [119.216913, 32.617308],
                            [119.220224, 32.629628],
                            [119.208719, 32.641508],
                            [119.211637, 32.708199],
                            [119.208943, 32.71525],
                            [119.208214, 32.740518],
                            [119.200861, 32.750982],
                            [119.19132, 32.788844],
                            [119.188906, 32.810854],
                            [119.184922, 32.82564],
                            [119.190927, 32.825421],
                            [119.278651, 32.798909],
                            [119.313729, 32.804859],
                            [119.332699, 32.81501],
                            [119.345383, 32.838325],
                            [119.349817, 32.868411],
                            [119.345608, 32.890182],
                            [119.328265, 32.945897],
                            [119.324954, 32.96861],
                            [119.325122, 32.998434],
                            [119.343082, 33.011443],
                            [119.359246, 33.029688],
                            [119.364185, 33.03859],
                            [119.363736, 33.053513],
                            [119.343251, 33.065119],
                            [119.334776, 33.084442],
                            [119.321081, 33.102279],
                            [119.313897, 33.128614],
                            [119.305422, 33.13463],
                            [119.271467, 33.146834],
                            [119.250251, 33.157643],
                            [119.228531, 33.151106],
                            [119.22376, 33.16126],
                            [119.229541, 33.165879],
                            [119.22202, 33.188056],
                            [119.219158, 33.206002],
                            [119.211413, 33.203084],
                            [119.199907, 33.205915],
                            [119.165222, 33.207614],
                            [119.150685, 33.212797],
                            [119.143277, 33.230042],
                            [119.146644, 33.248589],
                            [119.155512, 33.254466],
                            [119.163145, 33.271529],
                            [119.153435, 33.285281],
                            [119.160114, 33.283453],
                            [119.184697, 33.289763],
                            [119.210683, 33.292504],
                            [119.239924, 33.301511],
                            [119.262655, 33.303033],
                            [119.248848, 33.318129],
                            [119.235041, 33.345138],
                            [119.243123, 33.352443],
                            [119.254517, 33.352878],
                            [119.29184, 33.3634],
                            [119.310979, 33.3674],
                            [119.36542, 33.369574],
                            [119.401284, 33.375182],
                            [119.416831, 33.376181],
                            [119.448429, 33.384832],
                            [119.476773, 33.403737],
                            [119.48839, 33.407909],
                            [119.504498, 33.407301],
                            [119.53127, 33.414905],
                            [119.543898, 33.414905],
                            [119.553103, 33.410516],
                            [119.559164, 33.400913],
                            [119.566853, 33.399348],
                            [119.576731, 33.378442],
                            [119.589865, 33.380963],
                            [119.605411, 33.379702],
                            [119.613101, 33.358357],
                            [119.616356, 33.333135],
                            [119.631959, 33.335353],
                            [119.636, 33.326611],
                            [119.632408, 33.317042],
                            [119.641388, 33.311038],
                            [119.640546, 33.293635],
                            [119.654016, 33.280711],
                            [119.659516, 33.285846],
                            [119.6864, 33.288892],
                            [119.700319, 33.294245],
                            [119.71508, 33.271877],
                            [119.704248, 33.269788],
                            [119.690778, 33.242668],
                            [119.685727, 33.238619],
                            [119.693247, 33.224294],
                            [119.712611, 33.219068]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 321100,
                "name": "镇江市",
                "center": [119.452753, 32.204402],
                "centroid": [119.458183, 32.014028],
                "childrenNum": 6,
                "level": "city",
                "parent": {
                    "adcode": 320000
                },
                "subFeatureIndex": 10,
                "acroutes": [100000, 320000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [119.234087, 31.627053],
                            [119.232516, 31.632283],
                            [119.212423, 31.627718],
                            [119.204734, 31.646642],
                            [119.187335, 31.649168],
                            [119.192274, 31.659847],
                            [119.186605, 31.677658],
                            [119.190422, 31.687049],
                            [119.186437, 31.694136],
                            [119.157701, 31.699362],
                            [119.138674, 31.722125],
                            [119.129245, 31.723586],
                            [119.12498, 31.735806],
                            [119.114428, 31.740233],
                            [119.105392, 31.751344],
                            [119.093999, 31.756036],
                            [119.089902, 31.769624],
                            [119.077835, 31.773916],
                            [119.077105, 31.783962],
                            [119.065768, 31.78197],
                            [119.055665, 31.788962],
                            [119.029679, 31.784714],
                            [119.021541, 31.778607],
                            [119.00504, 31.777766],
                            [118.998867, 31.76719],
                            [118.980458, 31.764667],
                            [118.982534, 31.782988],
                            [119.002908, 31.783431],
                            [119.006387, 31.798607],
                            [118.998137, 31.80166],
                            [118.986407, 31.81785],
                            [118.970411, 31.826077],
                            [118.969457, 31.834613],
                            [118.979672, 31.842352],
                            [119.003357, 31.845757],
                            [119.025919, 31.846376],
                            [119.032822, 31.853761],
                            [119.043374, 31.854424],
                            [119.069753, 31.868793],
                            [119.075421, 31.864195],
                            [119.092427, 31.860437],
                            [119.100341, 31.865787],
                            [119.107806, 31.885149],
                            [119.116449, 31.890497],
                            [119.111173, 31.901634],
                            [119.108423, 31.922977],
                            [119.104157, 31.933624],
                            [119.06762, 31.940207],
                            [119.051512, 31.935922],
                            [119.037537, 31.93897],
                            [119.029455, 31.950013],
                            [119.02923, 31.95708],
                            [119.046854, 31.968562],
                            [119.06487, 31.97342],
                            [119.073738, 31.969622],
                            [119.090126, 31.974126],
                            [119.102979, 31.965603],
                            [119.111061, 31.96949],
                            [119.113923, 31.979823],
                            [119.121107, 31.977571],
                            [119.121612, 31.984812],
                            [119.114204, 31.988212],
                            [119.112464, 32.000441],
                            [119.10281, 32.004899],
                            [119.092371, 32.004105],
                            [119.097928, 32.011256],
                            [119.092652, 32.037604],
                            [119.08659, 32.053224],
                            [119.098489, 32.07162],
                            [119.098882, 32.091027],
                            [119.089733, 32.089704],
                            [119.079799, 32.107343],
                            [119.069248, 32.107916],
                            [119.057686, 32.102228],
                            [119.049772, 32.109768],
                            [119.026649, 32.115941],
                            [119.008913, 32.115941],
                            [119.00925, 32.12467],
                            [119.022383, 32.130886],
                            [119.031756, 32.14865],
                            [119.039333, 32.157023],
                            [119.058472, 32.15645],
                            [119.047976, 32.161254],
                            [119.076039, 32.161695],
                            [119.078677, 32.178747],
                            [119.086871, 32.178527],
                            [119.121332, 32.187603],
                            [119.13671, 32.193374],
                            [119.154446, 32.186193],
                            [119.184529, 32.189629],
                            [119.191095, 32.1854],
                            [119.216239, 32.190686],
                            [119.221403, 32.201127],
                            [119.241664, 32.216278],
                            [119.229036, 32.222179],
                            [119.254966, 32.23222],
                            [119.286115, 32.23288],
                            [119.336403, 32.230987],
                            [119.367609, 32.225526],
                            [119.388375, 32.225086],
                            [119.396738, 32.235126],
                            [119.412678, 32.246617],
                            [119.433893, 32.257535],
                            [119.462461, 32.26251],
                            [119.478569, 32.261277],
                            [119.504442, 32.254938],
                            [119.514769, 32.248907],
                            [119.536714, 32.267924],
                            [119.546424, 32.278839],
                            [119.544852, 32.282756],
                            [119.576395, 32.28456],
                            [119.577854, 32.273029],
                            [119.570838, 32.271621],
                            [119.570894, 32.230062],
                            [119.599406, 32.234553],
                            [119.597947, 32.246265],
                            [119.607207, 32.252913],
                            [119.615795, 32.250668],
                            [119.622081, 32.237415],
                            [119.621744, 32.217423],
                            [119.629714, 32.227728],
                            [119.627581, 32.248731],
                            [119.633923, 32.257755],
                            [119.661368, 32.263742],
                            [119.678094, 32.270125],
                            [119.688589, 32.282492],
                            [119.708401, 32.276374],
                            [119.730683, 32.30401],
                            [119.745163, 32.313865],
                            [119.768623, 32.318924],
                            [119.786022, 32.317912],
                            [119.802299, 32.312809],
                            [119.819192, 32.302514],
                            [119.834571, 32.295694],
                            [119.852699, 32.28192],
                            [119.869537, 32.262686],
                            [119.87846, 32.247542],
                            [119.891987, 32.201083],
                            [119.894063, 32.182889],
                            [119.930601, 32.078942],
                            [119.948729, 32.047488],
                            [119.975501, 32.006886],
                            [119.951704, 32.002339],
                            [119.919712, 32.003663],
                            [119.905906, 32.015361],
                            [119.895972, 32.040163],
                            [119.890864, 32.046164],
                            [119.883736, 32.039281],
                            [119.878629, 32.042193],
                            [119.869593, 32.058121],
                            [119.859939, 32.051547],
                            [119.843831, 32.059841],
                            [119.829014, 32.0519],
                            [119.822223, 32.055827],
                            [119.804768, 32.056091],
                            [119.796293, 32.049032],
                            [119.777435, 32.014257],
                            [119.784788, 32.012315],
                            [119.775639, 31.986446],
                            [119.778165, 31.984106],
                            [119.767613, 31.949306],
                            [119.777154, 31.944624],
                            [119.789446, 31.926909],
                            [119.78389, 31.919354],
                            [119.760485, 31.926644],
                            [119.759643, 31.921121],
                            [119.781757, 31.913875],
                            [119.780466, 31.901634],
                            [119.771823, 31.900839],
                            [119.75521, 31.880331],
                            [119.764077, 31.872595],
                            [119.763348, 31.8569],
                            [119.769914, 31.847615],
                            [119.782262, 31.852081],
                            [119.811784, 31.852213],
                            [119.800503, 31.833331],
                            [119.790344, 31.826564],
                            [119.785461, 31.816745],
                            [119.790456, 31.806968],
                            [119.763965, 31.808119],
                            [119.757342, 31.786218],
                            [119.748755, 31.780333],
                            [119.736295, 31.7621],
                            [119.734724, 31.74373],
                            [119.74, 31.731157],
                            [119.723892, 31.732928],
                            [119.708289, 31.737931],
                            [119.706717, 31.747139],
                            [119.693303, 31.756966],
                            [119.688196, 31.769402],
                            [119.656541, 31.773607],
                            [119.650817, 31.777678],
                            [119.644643, 31.795554],
                            [119.629601, 31.801173],
                            [119.615009, 31.796174],
                            [119.605692, 31.806128],
                            [119.605131, 31.822052],
                            [119.597329, 31.827847],
                            [119.589416, 31.826962],
                            [119.59211, 31.835321],
                            [119.586946, 31.847438],
                            [119.576731, 31.848366],
                            [119.570053, 31.854557],
                            [119.559894, 31.85606],
                            [119.556077, 31.862515],
                            [119.550016, 31.856458],
                            [119.508203, 31.851859],
                            [119.468803, 31.871666],
                            [119.46392, 31.881215],
                            [119.448822, 31.885414],
                            [119.437541, 31.876397],
                            [119.423229, 31.871666],
                            [119.419525, 31.852081],
                            [119.42553, 31.852788],
                            [119.432041, 31.840362],
                            [119.443378, 31.828908],
                            [119.432995, 31.825812],
                            [119.429347, 31.832314],
                            [119.422331, 31.829395],
                            [119.40409, 31.832092],
                            [119.387028, 31.846642],
                            [119.372436, 31.845802],
                            [119.364129, 31.857961],
                            [119.342072, 31.859553],
                            [119.3295, 31.845757],
                            [119.332643, 31.836338],
                            [119.320015, 31.825414],
                            [119.313785, 31.813825],
                            [119.314571, 31.796616],
                            [119.320071, 31.797058],
                            [119.314683, 31.777324],
                            [119.307387, 31.776527],
                            [119.304637, 31.767367],
                            [119.305647, 31.733017],
                            [119.321643, 31.73222],
                            [119.331072, 31.727305],
                            [119.321586, 31.715527],
                            [119.321081, 31.707644],
                            [119.328658, 31.704013],
                            [119.316535, 31.671013],
                            [119.299922, 31.654752],
                            [119.282804, 31.642787],
                            [119.258389, 31.632195],
                            [119.23695, 31.625192],
                            [119.234087, 31.627053]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 321200,
                "name": "泰州市",
                "center": [119.915176, 32.484882],
                "centroid": [120.060841, 32.571433],
                "childrenNum": 6,
                "level": "city",
                "parent": {
                    "adcode": 320000
                },
                "subFeatureIndex": 11,
                "acroutes": [100000, 320000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [119.819192, 32.302514],
                            [119.843887, 32.321872],
                            [119.847311, 32.328426],
                            [119.842709, 32.360662],
                            [119.853709, 32.361498],
                            [119.856179, 32.379744],
                            [119.844561, 32.395964],
                            [119.853878, 32.401854],
                            [119.851745, 32.411171],
                            [119.863812, 32.417104],
                            [119.868526, 32.438722],
                            [119.859266, 32.444477],
                            [119.853372, 32.46275],
                            [119.84052, 32.464463],
                            [119.829688, 32.460334],
                            [119.814534, 32.468855],
                            [119.818182, 32.491645],
                            [119.824524, 32.4963],
                            [119.823402, 32.535367],
                            [119.835525, 32.54976],
                            [119.827162, 32.55915],
                            [119.815656, 32.578759],
                            [119.820034, 32.592751],
                            [119.815769, 32.605644],
                            [119.821774, 32.607267],
                            [119.816105, 32.614897],
                            [119.814365, 32.627085],
                            [119.828734, 32.629365],
                            [119.832999, 32.640894],
                            [119.844617, 32.640368],
                            [119.855056, 32.631908],
                            [119.866618, 32.627611],
                            [119.869537, 32.619369],
                            [119.890527, 32.620334],
                            [119.898666, 32.616519],
                            [119.90063, 32.623973],
                            [119.911855, 32.625156],
                            [119.89715, 32.646242],
                            [119.899171, 32.65698],
                            [119.894849, 32.674334],
                            [119.883512, 32.673895],
                            [119.870659, 32.679066],
                            [119.877282, 32.69843],
                            [119.85848, 32.710608],
                            [119.858031, 32.721163],
                            [119.843663, 32.736709],
                            [119.84529, 32.752952],
                            [119.866899, 32.768493],
                            [119.863082, 32.775715],
                            [119.833504, 32.781973],
                            [119.824917, 32.794927],
                            [119.830249, 32.806872],
                            [119.82357, 32.807966],
                            [119.806508, 32.800572],
                            [119.794666, 32.803853],
                            [119.78866, 32.810197],
                            [119.790849, 32.820041],
                            [119.800895, 32.828265],
                            [119.801513, 32.837669],
                            [119.795956, 32.841474],
                            [119.805778, 32.851926],
                            [119.79736, 32.857086],
                            [119.802691, 32.862727],
                            [119.789334, 32.881177],
                            [119.782599, 32.914832],
                            [119.775302, 32.915968],
                            [119.761888, 32.904082],
                            [119.746173, 32.898706],
                            [119.72507, 32.901721],
                            [119.719514, 32.906179],
                            [119.712386, 32.921955],
                            [119.714743, 32.936374],
                            [119.703069, 32.944893],
                            [119.696727, 32.961316],
                            [119.706661, 32.989614],
                            [119.708008, 33.005681],
                            [119.696615, 33.016899],
                            [119.683931, 33.072535],
                            [119.669731, 33.089807],
                            [119.64773, 33.104111],
                            [119.640321, 33.119241],
                            [119.649245, 33.120244],
                            [119.646158, 33.130096],
                            [119.653679, 33.156553],
                            [119.657271, 33.162349],
                            [119.692069, 33.186923],
                            [119.701835, 33.201821],
                            [119.708177, 33.198336],
                            [119.712611, 33.219068],
                            [119.731469, 33.211664],
                            [119.733489, 33.205349],
                            [119.728775, 33.188709],
                            [119.730346, 33.172851],
                            [119.751281, 33.170803],
                            [119.753077, 33.16065],
                            [119.739775, 33.147401],
                            [119.74926, 33.131012],
                            [119.772272, 33.130924],
                            [119.787313, 33.13912],
                            [119.843494, 33.153459],
                            [119.86847, 33.154461],
                            [119.867572, 33.143391],
                            [119.877282, 33.146834],
                            [119.890247, 33.144306],
                            [119.8944, 33.151062],
                            [119.916569, 33.149449],
                            [119.936438, 33.155377],
                            [119.968373, 33.149885],
                            [119.988073, 33.151585],
                            [120.003451, 33.15603],
                            [120.023993, 33.158035],
                            [120.048183, 33.164049],
                            [120.080848, 33.181782],
                            [120.094093, 33.178645],
                            [120.153418, 33.157207],
                            [120.168852, 33.15311],
                            [120.214145, 33.13742],
                            [120.296761, 33.129573],
                            [120.28969, 33.104242],
                            [120.293675, 33.096698],
                            [120.291991, 33.081128],
                            [120.30939, 33.062283],
                            [120.313038, 33.048059],
                            [120.308884, 33.024407],
                            [120.312364, 32.992583],
                            [120.299063, 32.966601],
                            [120.300353, 32.954153],
                            [120.287389, 32.955202],
                            [120.286378, 32.949392],
                            [120.295078, 32.94546],
                            [120.291991, 32.933621],
                            [120.280766, 32.924926],
                            [120.23884, 32.927985],
                            [120.238447, 32.921168],
                            [120.220431, 32.917017],
                            [120.204997, 32.9206],
                            [120.201068, 32.930519],
                            [120.176373, 32.932529],
                            [120.177495, 32.909064],
                            [120.181873, 32.903907],
                            [120.177046, 32.877767],
                            [120.200226, 32.874488],
                            [120.198767, 32.866925],
                            [120.20842, 32.864345],
                            [120.205895, 32.852189],
                            [120.195231, 32.851358],
                            [120.194894, 32.842786],
                            [120.184848, 32.834126],
                            [120.181031, 32.82529],
                            [120.193379, 32.826078],
                            [120.187037, 32.812166],
                            [120.167225, 32.81501],
                            [120.161107, 32.809935],
                            [120.168179, 32.793045],
                            [120.159255, 32.787881],
                            [120.162454, 32.780967],
                            [120.174184, 32.779654],
                            [120.18294, 32.772913],
                            [120.197027, 32.781492],
                            [120.199328, 32.786962],
                            [120.222396, 32.792301],
                            [120.228176, 32.77856],
                            [120.21465, 32.767442],
                            [120.206624, 32.756586],
                            [120.202583, 32.74297],
                            [120.196129, 32.739336],
                            [120.180863, 32.741832],
                            [120.181705, 32.723177],
                            [120.17323, 32.715688],
                            [120.164811, 32.720331],
                            [120.155382, 32.714199],
                            [120.157571, 32.703249],
                            [120.145055, 32.705877],
                            [120.138096, 32.687171],
                            [120.129508, 32.689055],
                            [120.121651, 32.679197],
                            [120.120977, 32.633267],
                            [120.109079, 32.630505],
                            [120.113176, 32.613801],
                            [120.122661, 32.610293],
                            [120.140846, 32.6163],
                            [120.154372, 32.616037],
                            [120.176317, 32.62121],
                            [120.17598, 32.629102],
                            [120.197251, 32.619281],
                            [120.196017, 32.603013],
                            [120.202303, 32.600908],
                            [120.207635, 32.591567],
                            [120.224584, 32.58183],
                            [120.23059, 32.58683],
                            [120.255734, 32.597619],
                            [120.262862, 32.574855],
                            [120.262301, 32.562001],
                            [120.270102, 32.548707],
                            [120.263704, 32.514562],
                            [120.270102, 32.501788],
                            [120.258316, 32.498934],
                            [120.271393, 32.47228],
                            [120.275153, 32.438897],
                            [120.280654, 32.430989],
                            [120.279924, 32.421454],
                            [120.289185, 32.384975],
                            [120.284526, 32.379876],
                            [120.292608, 32.369544],
                            [120.302542, 32.37249],
                            [120.310119, 32.361542],
                            [120.323028, 32.368445],
                            [120.351652, 32.377898],
                            [120.352381, 32.368929],
                            [120.359734, 32.35798],
                            [120.346208, 32.343996],
                            [120.353111, 32.335947],
                            [120.354234, 32.324951],
                            [120.365234, 32.308806],
                            [120.352325, 32.30445],
                            [120.352381, 32.278663],
                            [120.347218, 32.266515],
                            [120.350866, 32.255995],
                            [120.345927, 32.249919],
                            [120.35704, 32.238736],
                            [120.364617, 32.237812],
                            [120.371632, 32.217555],
                            [120.355581, 32.1917],
                            [120.35457, 32.182052],
                            [120.346488, 32.179232],
                            [120.343233, 32.170067],
                            [120.347442, 32.150545],
                            [120.351034, 32.149487],
                            [120.356198, 32.130754],
                            [120.374383, 32.128065],
                            [120.387909, 32.129696],
                            [120.417038, 32.124847],
                            [120.435166, 32.123921],
                            [120.440779, 32.119865],
                            [120.482255, 32.102933],
                            [120.486745, 32.099141],
                            [120.512843, 32.091732],
                            [120.518456, 32.065885],
                            [120.5294, 32.056444],
                            [120.550503, 32.050929],
                            [120.547922, 32.041046],
                            [120.558529, 32.03372],
                            [120.553141, 32.021143],
                            [120.52463, 32.030455],
                            [120.503807, 32.041002],
                            [120.465642, 32.045811],
                            [120.403736, 32.016199],
                            [120.387853, 32.006665],
                            [120.370678, 31.990817],
                            [120.353055, 31.980617],
                            [120.262974, 31.941841],
                            [120.236595, 31.932918],
                            [120.205895, 31.931504],
                            [120.17525, 31.933845],
                            [120.134784, 31.939367],
                            [120.064908, 31.95549],
                            [120.022422, 31.967767],
                            [120.016248, 31.970461],
                            [119.980103, 31.998057],
                            [119.975501, 32.006886],
                            [119.948729, 32.047488],
                            [119.930601, 32.078942],
                            [119.894063, 32.182889],
                            [119.891987, 32.201083],
                            [119.87846, 32.247542],
                            [119.869537, 32.262686],
                            [119.852699, 32.28192],
                            [119.834571, 32.295694],
                            [119.819192, 32.302514]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 321300,
                "name": "宿迁市",
                "center": [118.275162, 33.963008],
                "centroid": [118.526352, 33.784713],
                "childrenNum": 5,
                "level": "city",
                "parent": {
                    "adcode": 320000
                },
                "subFeatureIndex": 12,
                "acroutes": [100000, 320000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [119.174931, 34.093494],
                            [119.166456, 34.088105],
                            [119.15815, 34.076421],
                            [119.155119, 34.056973],
                            [119.148833, 34.045845],
                            [119.129751, 34.028849],
                            [119.114541, 34.024406],
                            [119.08384, 34.001407],
                            [119.081932, 33.987769],
                            [119.07312, 33.98151],
                            [119.058864, 33.978359],
                            [119.055441, 33.973135],
                            [119.0427, 33.968905],
                            [119.040736, 33.959622],
                            [119.050951, 33.957507],
                            [119.053252, 33.937383],
                            [119.044553, 33.929436],
                            [119.035853, 33.928054],
                            [119.024853, 33.911164],
                            [119.008015, 33.896604],
                            [118.997295, 33.897296],
                            [118.999708, 33.9049],
                            [118.987585, 33.904554],
                            [118.972263, 33.919372],
                            [118.950767, 33.914275],
                            [118.948803, 33.906801],
                            [118.941338, 33.907751],
                            [118.933088, 33.900709],
                            [118.922143, 33.902524],
                            [118.907383, 33.889777],
                            [118.885381, 33.885888],
                            [118.874493, 33.892543],
                            [118.863661, 33.891376],
                            [118.857151, 33.880227],
                            [118.828751, 33.858615],
                            [118.818985, 33.844954],
                            [118.807311, 33.819356],
                            [118.799847, 33.813517],
                            [118.805628, 33.794355],
                            [118.79575, 33.772852],
                            [118.805122, 33.763245],
                            [118.80226, 33.741215],
                            [118.814215, 33.730868],
                            [118.809276, 33.715975],
                            [118.813148, 33.700948],
                            [118.798612, 33.69155],
                            [118.792607, 33.666555],
                            [118.799566, 33.64671],
                            [118.757977, 33.635746],
                            [118.770605, 33.60705],
                            [118.78531, 33.587018],
                            [118.806357, 33.572749],
                            [118.803102, 33.561776],
                            [118.797433, 33.560604],
                            [118.789744, 33.5367],
                            [118.789969, 33.508709],
                            [118.785591, 33.493082],
                            [118.779866, 33.487568],
                            [118.782841, 33.444012],
                            [118.746921, 33.386701],
                            [118.780147, 33.345834],
                            [118.703424, 33.323697],
                            [118.667784, 33.311734],
                            [118.511083, 33.263868],
                            [118.443452, 33.204783],
                            [118.424313, 33.187141],
                            [118.320201, 33.196246],
                            [118.261718, 33.199948],
                            [118.221364, 33.180693],
                            [118.211599, 33.19912],
                            [118.194368, 33.211664],
                            [118.178204, 33.217979],
                            [118.168382, 33.21345],
                            [118.156315, 33.195461],
                            [118.159964, 33.181042],
                            [118.149019, 33.169495],
                            [118.11888, 33.160562],
                            [118.088292, 33.149667],
                            [118.069153, 33.139948],
                            [118.046871, 33.138422],
                            [118.038228, 33.135196],
                            [118.036713, 33.1525],
                            [118.025656, 33.155943],
                            [118.017406, 33.164615],
                            [118.008482, 33.16784],
                            [118.003879, 33.177033],
                            [117.989175, 33.179648],
                            [117.986424, 33.193371],
                            [117.980924, 33.200166],
                            [117.993608, 33.20561],
                            [117.993496, 33.211272],
                            [117.977444, 33.226253],
                            [117.953816, 33.223945],
                            [117.942366, 33.225078],
                            [117.938999, 33.234309],
                            [117.948035, 33.252115],
                            [117.939448, 33.262606],
                            [117.974245, 33.279711],
                            [117.983281, 33.296768],
                            [117.985919, 33.32026],
                            [117.99243, 33.333135],
                            [117.975368, 33.335745],
                            [117.971607, 33.349313],
                            [117.995517, 33.347095],
                            [118.0059, 33.352095],
                            [118.029304, 33.372269],
                            [118.028238, 33.390569],
                            [118.016844, 33.406692],
                            [118.021952, 33.421596],
                            [118.023579, 33.440928],
                            [118.028631, 33.458432],
                            [118.04356, 33.473718],
                            [118.050632, 33.49204],
                            [118.05776, 33.491693],
                            [118.108104, 33.475107],
                            [118.106813, 33.503934],
                            [118.107992, 33.520167],
                            [118.099124, 33.52941],
                            [118.108384, 33.530017],
                            [118.117252, 33.591657],
                            [118.112257, 33.617064],
                            [118.120115, 33.621659],
                            [118.168102, 33.663739],
                            [118.164005, 33.692633],
                            [118.167709, 33.714979],
                            [118.153341, 33.720175],
                            [118.160862, 33.735327],
                            [118.177811, 33.736107],
                            [118.185332, 33.744937],
                            [118.168326, 33.749569],
                            [118.170852, 33.759134],
                            [118.178597, 33.763115],
                            [118.170459, 33.786221],
                            [118.159515, 33.795653],
                            [118.168887, 33.807591],
                            [118.169056, 33.820134],
                            [118.183368, 33.816155],
                            [118.18797, 33.822945],
                            [118.184771, 33.844176],
                            [118.176015, 33.844133],
                            [118.174612, 33.865186],
                            [118.168495, 33.881005],
                            [118.156428, 33.889691],
                            [118.149356, 33.901011],
                            [118.141162, 33.934749],
                            [118.125896, 33.954959],
                            [118.117589, 33.954614],
                            [118.113772, 33.936865],
                            [118.106139, 33.935138],
                            [118.100022, 33.941184],
                            [118.085766, 33.942048],
                            [118.085654, 33.965192],
                            [118.072408, 33.965408],
                            [118.053045, 33.971883],
                            [118.046254, 33.98151],
                            [118.03385, 33.983927],
                            [118.028406, 33.998386],
                            [118.034917, 34.01267],
                            [118.049621, 34.01336],
                            [118.054168, 34.009692],
                            [118.063653, 34.020738],
                            [118.059836, 34.048174],
                            [118.063821, 34.053781],
                            [118.048611, 34.092545],
                            [118.013084, 34.083923],
                            [118.005507, 34.09164],
                            [118.007696, 34.100348],
                            [117.996583, 34.105649],
                            [117.994394, 34.123793],
                            [117.998997, 34.140038],
                            [118.055571, 34.148827],
                            [118.064158, 34.152532],
                            [118.060622, 34.157055],
                            [118.072408, 34.170924],
                            [118.083072, 34.165411],
                            [118.088292, 34.15503],
                            [118.097047, 34.150292],
                            [118.10294, 34.139521],
                            [118.120732, 34.144045],
                            [118.139309, 34.136419],
                            [118.150534, 34.137281],
                            [118.154239, 34.148784],
                            [118.150703, 34.158476],
                            [118.15654, 34.161147],
                            [118.177306, 34.156366],
                            [118.187745, 34.161664],
                            [118.213844, 34.14202],
                            [118.213619, 34.127241],
                            [118.222824, 34.106986],
                            [118.232646, 34.100304],
                            [118.28922, 34.102589],
                            [118.292307, 34.109701],
                            [118.306001, 34.11358],
                            [118.363586, 34.118795],
                            [118.382949, 34.117286],
                            [118.428466, 34.108623],
                            [118.43436, 34.105089],
                            [118.451029, 34.106598],
                            [118.469718, 34.097201],
                            [118.482627, 34.100046],
                            [118.489923, 34.106684],
                            [118.517705, 34.117545],
                            [118.503225, 34.123147],
                            [118.503674, 34.137194],
                            [118.50968, 34.148784],
                            [118.505358, 34.158562],
                            [118.519221, 34.168598],
                            [118.560192, 34.165454],
                            [118.559687, 34.187806],
                            [118.573494, 34.233566],
                            [118.565468, 34.236794],
                            [118.56109, 34.247983],
                            [118.566871, 34.274184],
                            [118.57456, 34.278399],
                            [118.571473, 34.298957],
                            [118.593362, 34.308031],
                            [118.624063, 34.305752],
                            [118.632706, 34.308246],
                            [118.634895, 34.320456],
                            [118.631752, 34.337179],
                            [118.621986, 34.341133],
                            [118.633155, 34.344744],
                            [118.635232, 34.355058],
                            [118.644268, 34.359012],
                            [118.6661, 34.342423],
                            [118.676596, 34.339414],
                            [118.676371, 34.345345],
                            [118.693265, 34.345904],
                            [118.708194, 34.336362],
                            [118.739905, 34.325056],
                            [118.748268, 34.330817],
                            [118.759829, 34.321058],
                            [118.758258, 34.312932],
                            [118.766564, 34.308891],
                            [118.78531, 34.311814],
                            [118.810903, 34.343196],
                            [118.812138, 34.357336],
                            [118.825328, 34.358797],
                            [118.837787, 34.368809],
                            [118.864335, 34.365887],
                            [118.874942, 34.367692],
                            [118.907439, 34.368036],
                            [118.913388, 34.378262],
                            [118.924837, 34.379293],
                            [118.931909, 34.374738],
                            [118.939991, 34.382343],
                            [118.953237, 34.368508],
                            [118.95363, 34.350116],
                            [118.963788, 34.350546],
                            [118.96463, 34.36086],
                            [118.974901, 34.36911],
                            [118.980794, 34.379636],
                            [118.995162, 34.39029],
                            [118.994994, 34.404121],
                            [119.015311, 34.405324],
                            [119.033215, 34.398881],
                            [119.038659, 34.403735],
                            [119.041409, 34.421901],
                            [119.061222, 34.420183],
                            [119.089565, 34.42087],
                            [119.086871, 34.409747],
                            [119.065263, 34.409232],
                            [119.056227, 34.3823],
                            [119.057068, 34.356176],
                            [119.062232, 34.338683],
                            [119.075477, 34.342681],
                            [119.073008, 34.331763],
                            [119.082774, 34.310868],
                            [119.074074, 34.265107],
                            [119.091866, 34.262353],
                            [119.09108, 34.23688],
                            [119.09703, 34.232921],
                            [119.099667, 34.208042],
                            [119.13295, 34.205415],
                            [119.136991, 34.177858],
                            [119.144287, 34.176265],
                            [119.141874, 34.161578],
                            [119.145409, 34.158692],
                            [119.129077, 34.145768],
                            [119.142828, 34.134049],
                            [119.150348, 34.140555],
                            [119.15641, 34.133618],
                            [119.168421, 34.129654],
                            [119.176166, 34.118579],
                            [119.166849, 34.10746],
                            [119.174931, 34.093494]
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                adcode: 340000,
                name: '安徽省',
                center: [117.283042, 31.86119],
                centroid: [117.226862, 31.849273],
                childrenNum: 16,
                level: 'province',
                acroutes: [100000],
                parent: { adcode: 100000 },
            },
            geometry: {
                type: 'MultiPolygon',
                coordinates: [
                    [
                        [
                            [115.639757, 33.585115],
                            [115.625029, 33.625633],
                            [115.617784, 33.632608],
                            [115.601626, 33.657662],
                            [115.602531, 33.67264],
                            [115.599624, 33.688286],
                            [115.607155, 33.68906],
                            [115.596287, 33.700315],
                            [115.601578, 33.718537],
                            [115.59624, 33.731233],
                            [115.583561, 33.747229],
                            [115.574838, 33.752234],
                            [115.570024, 33.765286],
                            [115.56316, 33.771683],
                            [115.56521, 33.780193],
                            [115.582226, 33.788703],
                            [115.59052, 33.783701],
                            [115.614257, 33.775654],
                            [115.621168, 33.796799],
                            [115.623313, 33.811959],
                            [115.616592, 33.820001],
                            [115.625601, 33.823662],
                            [115.626268, 33.836187],
                            [115.636135, 33.841187],
                            [115.633513, 33.867314],
                            [115.620882, 33.876124],
                            [115.605725, 33.867417],
                            [115.592331, 33.868241],
                            [115.579509, 33.877],
                            [115.564209, 33.871333],
                            [115.556678, 33.876897],
                            [115.546192, 33.875506],
                            [115.546573, 33.888436],
                            [115.555296, 33.888591],
                            [115.556821, 33.903682],
                            [115.568308, 33.906927],
                            [115.559776, 33.914549],
                            [115.562588, 33.927164],
                            [115.569976, 33.932828],
                            [115.569166, 33.945492],
                            [115.577555, 33.950125],
                            [115.579033, 33.973954],
                            [115.588375, 33.97699],
                            [115.591044, 33.986201],
                            [115.584085, 33.988619],
                            [115.592665, 34.009865],
                            [115.606583, 34.013209],
                            [115.601054, 34.022981],
                            [115.615067, 34.033369],
                            [115.621359, 34.03013],
                            [115.642236, 34.032289],
                            [115.649576, 34.035632],
                            [115.648003, 34.046327],
                            [115.65358, 34.060106],
                            [115.669166, 34.056713],
                            [115.681845, 34.065503],
                            [115.699814, 34.066017],
                            [115.705963, 34.059797],
                            [115.735849, 34.076811],
                            [115.753437, 34.067714],
                            [115.769118, 34.067405],
                            [115.777603, 34.073727],
                            [115.793427, 34.063653],
                            [115.809109, 34.06247],
                            [115.815543, 34.052908],
                            [115.832226, 34.038563],
                            [115.845238, 34.03085],
                            [115.845477, 34.012026],
                            [115.852722, 34.003847],
                            [115.877078, 34.003178],
                            [115.877555, 34.029872],
                            [115.887278, 34.032804],
                            [115.895334, 34.028741],
                            [115.899338, 34.014752],
                            [115.904342, 34.009968],
                            [115.919738, 34.010791],
                            [115.926697, 34.007911],
                            [115.957583, 34.007756],
                            [115.984037, 33.987847],
                            [115.994952, 33.975086],
                            [116.000338, 33.963198],
                            [115.995524, 33.947551],
                            [115.982703, 33.917175],
                            [115.98704, 33.901159],
                            [115.999147, 33.901931],
                            [116.012493, 33.897399],
                            [116.013446, 33.885706],
                            [116.034561, 33.880039],
                            [116.034752, 33.873754],
                            [116.043475, 33.874888],
                            [116.054914, 33.860873],
                            [116.056725, 33.850928],
                            [116.065067, 33.847475],
                            [116.063494, 33.826188],
                            [116.045953, 33.829023],
                            [116.045429, 33.822991],
                            [116.05806, 33.821393],
                            [116.06235, 33.814485],
                            [116.055438, 33.804792],
                            [116.073313, 33.794066],
                            [116.074457, 33.781534],
                            [116.099099, 33.783133],
                            [116.098908, 33.774881],
                            [116.109299, 33.758219],
                            [116.131654, 33.752234],
                            [116.14276, 33.738458],
                            [116.14214, 33.734432],
                            [116.155391, 33.709917],
                            [116.174027, 33.708988],
                            [116.197288, 33.72535],
                            [116.230367, 33.730562],
                            [116.246048, 33.728704],
                            [116.263589, 33.730098],
                            [116.284657, 33.750119],
                            [116.308155, 33.757548],
                            [116.31683, 33.77127],
                            [116.328746, 33.76637],
                            [116.3307, 33.773849],
                            [116.348718, 33.778749],
                            [116.361063, 33.776273],
                            [116.372502, 33.780245],
                            [116.393713, 33.783082],
                            [116.40825, 33.805514],
                            [116.420929, 33.796696],
                            [116.432607, 33.795304],
                            [116.436944, 33.80309],
                            [116.432988, 33.814846],
                            [116.437326, 33.846547],
                            [116.453007, 33.846959],
                            [116.460157, 33.859946],
                            [116.47398, 33.861337],
                            [116.484895, 33.869787],
                            [116.501911, 33.864686],
                            [116.505295, 33.872363],
                            [116.521215, 33.871075],
                            [116.525219, 33.880503],
                            [116.536897, 33.882255],
                            [116.53928, 33.874218],
                            [116.546668, 33.882512],
                            [116.558393, 33.881482],
                            [116.555104, 33.888282],
                            [116.558346, 33.901674],
                            [116.567068, 33.908214],
                            [116.581606, 33.908317],
                            [116.597097, 33.904146],
                            [116.611825, 33.894617],
                            [116.627316, 33.888591],
                            [116.642712, 33.892454],
                            [116.638517, 33.917175],
                            [116.645762, 33.929893],
                            [116.639995, 33.948889],
                            [116.650338, 33.959081],
                            [116.64805, 33.973336],
                            [116.633512, 33.977093],
                            [116.629937, 33.984039],
                            [116.607249, 33.999886],
                            [116.60315, 34.007911],
                            [116.604199, 34.021335],
                            [116.595619, 34.040106],
                            [116.587421, 34.04571],
                            [116.576887, 34.064064],
                            [116.580319, 34.065555],
                            [116.567735, 34.075938],
                            [116.566877, 34.083801],
                            [116.557964, 34.097779],
                            [116.539613, 34.103482],
                            [116.541472, 34.109956],
                            [116.528031, 34.122851],
                            [116.534656, 34.126601],
                            [116.535991, 34.150997],
                            [116.545857, 34.161061],
                            [116.565495, 34.169533],
                            [116.559966, 34.186166],
                            [116.546143, 34.195508],
                            [116.542712, 34.218858],
                            [116.547144, 34.228196],
                            [116.543617, 34.239533],
                            [116.55396, 34.241893],
                            [116.56764, 34.251229],
                            [116.582321, 34.266512],
                            [116.582416, 34.27523],
                            [116.568975, 34.283434],
                            [116.511873, 34.296456],
                            [116.490138, 34.290919],
                            [116.466306, 34.271179],
                            [116.456868, 34.269127],
                            [116.44581, 34.28815],
                            [116.4307, 34.27805],
                            [116.433226, 34.270153],
                            [116.416258, 34.268256],
                            [116.406105, 34.276512],
                            [116.393951, 34.276101],
                            [116.375934, 34.271281],
                            [116.372216, 34.266102],
                            [116.363255, 34.276255],
                            [116.37336, 34.293944],
                            [116.368832, 34.310244],
                            [116.363541, 34.316856],
                            [116.329652, 34.329719],
                            [116.301577, 34.342119],
                            [116.288803, 34.358923],
                            [116.276792, 34.360409],
                            [116.270834, 34.370704],
                            [116.255629, 34.376492],
                            [116.2399, 34.374545],
                            [116.213589, 34.382227],
                            [116.209919, 34.390216],
                            [116.217068, 34.395541],
                            [116.215877, 34.403324],
                            [116.205295, 34.415662],
                            [116.179223, 34.430506],
                            [116.174933, 34.444682],
                            [116.162064, 34.459419],
                            [116.178842, 34.483565],
                            [116.178603, 34.496044],
                            [116.189471, 34.497067],
                            [116.203913, 34.508675],
                            [116.203818, 34.518748],
                            [116.190948, 34.53567],
                            [116.196334, 34.555654],
                            [116.197002, 34.57594],
                            [116.206296, 34.578086],
                            [116.216925, 34.575123],
                            [116.233417, 34.555143],
                            [116.247717, 34.55177],
                            [116.25296, 34.565721],
                            [116.259156, 34.567612],
                            [116.266067, 34.583757],
                            [116.274885, 34.584626],
                            [116.278651, 34.602096],
                            [116.286086, 34.608838],
                            [116.301101, 34.607765],
                            [116.310872, 34.601432],
                            [116.324981, 34.601125],
                            [116.333989, 34.62089],
                            [116.350958, 34.621145],
                            [116.372121, 34.633451],
                            [116.374218, 34.639986],
                            [116.382559, 34.638659],
                            [116.393379, 34.643049],
                            [116.43051, 34.650809],
                            [116.432845, 34.630132],
                            [116.447573, 34.620532],
                            [116.477221, 34.615119],
                            [116.478365, 34.603832],
                            [116.491425, 34.588968],
                            [116.492378, 34.570576],
                            [116.509585, 34.557494],
                            [116.526124, 34.553354],
                            [116.520643, 34.543184],
                            [116.529175, 34.540679],
                            [116.54805, 34.542928],
                            [116.570548, 34.523401],
                            [116.587707, 34.51251],
                            [116.59519, 34.511539],
                            [116.598956, 34.500187],
                            [116.592473, 34.493845],
                            [116.576792, 34.497681],
                            [116.568689, 34.492515],
                            [116.575123, 34.488935],
                            [116.623407, 34.488628],
                            [116.662588, 34.473027],
                            [116.722883, 34.472669],
                            [116.745095, 34.46827],
                            [116.760681, 34.462591],
                            [116.773693, 34.453483],
                            [116.782702, 34.438285],
                            [116.782654, 34.430199],
                            [116.804723, 34.412744],
                            [116.828078, 34.389243],
                            [116.848526, 34.389038],
                            [116.86702, 34.392162],
                            [116.883512, 34.403068],
                            [116.909203, 34.40829],
                            [116.920547, 34.40701],
                            [116.945667, 34.395541],
                            [116.969308, 34.388833],
                            [116.960967, 34.371985],
                            [116.961253, 34.363277],
                            [116.980223, 34.358359],
                            [116.983178, 34.352468],
                            [116.979651, 34.338533],
                            [116.96926, 34.323109],
                            [116.976648, 34.310911],
                            [116.968974, 34.28369],
                            [116.98437, 34.269845],
                            [117.007249, 34.256973],
                            [117.018879, 34.255537],
                            [117.020786, 34.243329],
                            [117.031081, 34.242765],
                            [117.042092, 34.248664],
                            [117.049575, 34.242406],
                            [117.044904, 34.224758],
                            [117.051005, 34.221577],
                            [117.047239, 34.205772],
                            [117.040328, 34.201513],
                            [117.030795, 34.18632],
                            [117.025314, 34.167633],
                            [117.031558, 34.166709],
                            [117.038374, 34.167428],
                            [117.047049, 34.151408],
                            [117.054913, 34.155105],
                            [117.072311, 34.146683],
                            [117.089994, 34.145707],
                            [117.106439, 34.130402],
                            [117.123836, 34.128193],
                            [117.129985, 34.117457],
                            [117.130318, 34.101787],
                            [117.146572, 34.09783],
                            [117.157916, 34.098755],
                            [117.151434, 34.083698],
                            [117.1613, 34.084315],
                            [117.182082, 34.07604],
                            [117.192711, 34.068742],
                            [117.207058, 34.068639],
                            [117.212158, 34.074704],
                            [117.224742, 34.064167],
                            [117.25763, 34.065914],
                            [117.277029, 34.078919],
                            [117.287754, 34.078662],
                            [117.293807, 34.071055],
                            [117.311491, 34.068073],
                            [117.319498, 34.084366],
                            [117.343426, 34.080563],
                            [117.357153, 34.088221],
                            [117.377792, 34.071466],
                            [117.371119, 34.060671],
                            [117.38823, 34.055582],
                            [117.40029, 34.041545],
                            [117.405723, 34.030078],
                            [117.415638, 34.025913],
                            [117.435466, 34.02833],
                            [117.460251, 34.03738],
                            [117.476791, 34.047613],
                            [117.500432, 34.05224],
                            [117.504913, 34.061648],
                            [117.514779, 34.060877],
                            [117.537468, 34.04463],
                            [117.545332, 34.035169],
                            [117.54252, 34.021644],
                            [117.544665, 34.01362],
                            [117.556438, 34.007345],
                            [117.568926, 33.985223],
                            [117.575742, 33.982908],
                            [117.588183, 33.987847],
                            [117.597859, 33.997005],
                            [117.610299, 33.999217],
                            [117.616638, 34.004927],
                            [117.618116, 34.017118],
                            [117.610251, 34.029307],
                            [117.6164, 34.032289],
                            [117.629746, 34.02869],
                            [117.64252, 34.01542],
                            [117.666305, 33.998703],
                            [117.671309, 33.986715],
                            [117.662968, 33.968705],
                            [117.672501, 33.95239],
                            [117.672596, 33.934938],
                            [117.690089, 33.915372],
                            [117.703626, 33.887818],
                            [117.715399, 33.879267],
                            [117.740852, 33.89199],
                            [117.753769, 33.891424],
                            [117.758631, 33.885655],
                            [117.759203, 33.874527],
                            [117.752434, 33.863243],
                            [117.752959, 33.847165],
                            [117.750099, 33.827167],
                            [117.746142, 33.823765],
                            [117.752482, 33.812835],
                            [117.749002, 33.791643],
                            [117.741853, 33.762759],
                            [117.734036, 33.75177],
                            [117.724694, 33.749551],
                            [117.722739, 33.740831],
                            [117.731939, 33.734742],
                            [117.735275, 33.722717],
                            [117.752673, 33.711517],
                            [117.767067, 33.72184],
                            [117.777935, 33.722511],
                            [117.791757, 33.7334],
                            [117.825504, 33.737322],
                            [117.835847, 33.734123],
                            [117.858964, 33.734329],
                            [117.879936, 33.727775],
                            [117.887706, 33.722614],
                            [117.901671, 33.720137],
                            [117.897572, 33.729324],
                            [117.90048, 33.735671],
                            [117.915828, 33.738354],
                            [117.920547, 33.733349],
                            [117.936705, 33.729375],
                            [117.949431, 33.734071],
                            [117.954293, 33.751047],
                            [117.964922, 33.763429],
                            [117.972358, 33.750274],
                            [117.982796, 33.747333],
                            [117.994426, 33.750067],
                            [117.996714, 33.746146],
                            [118.018783, 33.745836],
                            [118.019974, 33.738716],
                            [118.03089, 33.74047],
                            [118.028316, 33.746662],
                            [118.045761, 33.750016],
                            [118.062443, 33.758374],
                            [118.065589, 33.765802],
                            [118.105961, 33.764616],
                            [118.117973, 33.766524],
                            [118.129746, 33.754195],
                            [118.148859, 33.746404],
                            [118.16292, 33.750738],
                            [118.185322, 33.744959],
                            [118.177458, 33.735826],
                            [118.160823, 33.73531],
                            [118.153339, 33.720137],
                            [118.167734, 33.714975],
                            [118.163969, 33.692623],
                            [118.168258, 33.664015],
                            [118.120117, 33.621655],
                            [118.112443, 33.617262],
                            [118.117782, 33.594419],
                            [118.108392, 33.529991],
                            [118.099145, 33.529371],
                            [118.107963, 33.520163],
                            [118.106819, 33.503917],
                            [118.108106, 33.475091],
                            [118.061681, 33.490773],
                            [118.05067, 33.492067],
                            [118.043568, 33.473694],
                            [118.028649, 33.458423],
                            [118.023597, 33.440923],
                            [118.021881, 33.421193],
                            [118.016924, 33.407001],
                            [118.028268, 33.390578],
                            [118.02598, 33.381459],
                            [118.029269, 33.372236],
                            [118.005913, 33.352075],
                            [117.995475, 33.347099],
                            [117.971595, 33.349328],
                            [117.969546, 33.34404],
                            [117.978983, 33.334139],
                            [117.992996, 33.332946],
                            [117.985894, 33.320243],
                            [117.98313, 33.296388],
                            [117.970404, 33.277195],
                            [117.939469, 33.262617],
                            [117.948049, 33.252135],
                            [117.938993, 33.234282],
                            [117.942377, 33.225043],
                            [117.953816, 33.223953],
                            [117.977458, 33.226237],
                            [117.993473, 33.211286],
                            [117.993616, 33.205627],
                            [117.981509, 33.201006],
                            [117.989183, 33.179663],
                            [118.001528, 33.178624],
                            [118.005866, 33.170314],
                            [118.017448, 33.1646],
                            [118.025694, 33.155977],
                            [118.037086, 33.15234],
                            [118.03823, 33.135195],
                            [118.046905, 33.138416],
                            [118.070451, 33.140391],
                            [118.088278, 33.149691],
                            [118.118878, 33.160548],
                            [118.14905, 33.169483],
                            [118.159965, 33.181065],
                            [118.156342, 33.19545],
                            [118.168354, 33.213466],
                            [118.178173, 33.217983],
                            [118.194379, 33.211701],
                            [118.211633, 33.199085],
                            [118.221261, 33.182208],
                            [118.22374, 33.155457],
                            [118.219593, 33.114096],
                            [118.210441, 33.111861],
                            [118.209679, 33.104324],
                            [118.22088, 33.105883],
                            [118.221309, 33.087637],
                            [118.206485, 33.091276],
                            [118.202863, 33.088104],
                            [118.223692, 33.083477],
                            [118.227648, 33.06949],
                            [118.21516, 33.070946],
                            [118.212396, 33.06195],
                            [118.233368, 33.060025],
                            [118.239612, 33.046451],
                            [118.243473, 33.027776],
                            [118.244807, 32.998324],
                            [118.252434, 32.982137],
                            [118.269355, 32.969175],
                            [118.303816, 32.968655],
                            [118.309631, 32.958971],
                            [118.293378, 32.947151],
                            [118.247906, 32.934757],
                            [118.235418, 32.926528],
                            [118.233034, 32.916267],
                            [118.240041, 32.882349],
                            [118.244426, 32.87448],
                            [118.250575, 32.848366],
                            [118.263206, 32.856185],
                            [118.284607, 32.85728],
                            [118.289517, 32.845499],
                            [118.301719, 32.846228],
                            [118.297858, 32.832047],
                            [118.306628, 32.810563],
                            [118.294426, 32.800131],
                            [118.298764, 32.785578],
                            [118.307153, 32.778691],
                            [118.320785, 32.778274],
                            [118.326409, 32.763456],
                            [118.334035, 32.761577],
                            [118.348811, 32.773004],
                            [118.366209, 32.768309],
                            [118.371166, 32.757716],
                            [118.37231, 32.741746],
                            [118.366256, 32.73496],
                            [118.368163, 32.724781],
                            [118.375313, 32.718987],
                            [118.398668, 32.721388],
                            [118.410966, 32.716063],
                            [118.422882, 32.718099],
                            [118.450479, 32.743364],
                            [118.45925, 32.726086],
                            [118.483511, 32.721388],
                            [118.489755, 32.72452],
                            [118.520451, 32.723215],
                            [118.545284, 32.72948],
                            [118.559726, 32.729897],
                            [118.576599, 32.719091],
                            [118.590803, 32.724834],
                            [118.607534, 32.726661],
                            [118.617019, 32.73898],
                            [118.632319, 32.739971],
                            [118.639421, 32.744825],
                            [118.654054, 32.740702],
                            [118.657581, 32.736109],
                            [118.69414, 32.726608],
                            [118.707248, 32.720292],
                            [118.724454, 32.72191],
                            [118.736704, 32.732351],
                            [118.756294, 32.737048],
                            [118.757438, 32.743834],
                            [118.751528, 32.757142],
                            [118.746332, 32.759281],
                            [118.737943, 32.773265],
                            [118.736847, 32.79335],
                            [118.746809, 32.800392],
                            [118.741804, 32.85337],
                            [118.747858, 32.858687],
                            [118.768163, 32.851494],
                            [118.791042, 32.848418],
                            [118.811728, 32.854986],
                            [118.812538, 32.865203],
                            [118.806199, 32.870258],
                            [118.811251, 32.87547],
                            [118.814588, 32.902722],
                            [118.809345, 32.90788],
                            [118.812205, 32.916892],
                            [118.819021, 32.920642],
                            [118.836942, 32.911422],
                            [118.839516, 32.922517],
                            [118.848954, 32.927205],
                            [118.842519, 32.943662],
                            [118.849383, 32.945902],
                            [118.849335, 32.956628],
                            [118.865255, 32.955014],
                            [118.884654, 32.960585],
                            [118.896237, 32.957774],
                            [118.891232, 32.951734],
                            [118.893568, 32.940798],
                            [118.90577, 32.945068],
                            [118.921451, 32.939548],
                            [118.933796, 32.938663],
                            [118.941613, 32.94611],
                            [118.961203, 32.945797],
                            [118.993663, 32.958242],
                            [119.008916, 32.959388],
                            [119.020832, 32.955795],
                            [119.026313, 32.947255],
                            [119.023549, 32.935382],
                            [119.029602, 32.92632],
                            [119.019831, 32.925695],
                            [119.015064, 32.911683],
                            [119.019497, 32.905118],
                            [119.044997, 32.911422],
                            [119.045712, 32.892458],
                            [119.054912, 32.875053],
                            [119.071308, 32.864733],
                            [119.104292, 32.826729],
                            [119.113062, 32.822922],
                            [119.18494, 32.825634],
                            [119.188896, 32.810876],
                            [119.19128, 32.788812],
                            [119.200908, 32.750984],
                            [119.2082, 32.740493],
                            [119.208963, 32.71528],
                            [119.211632, 32.708179],
                            [119.208677, 32.642784],
                            [119.220212, 32.629616],
                            [119.216923, 32.617282],
                            [119.220498, 32.60986],
                            [119.230984, 32.607141],
                            [119.220069, 32.592452],
                            [119.220212, 32.576609],
                            [119.209297, 32.573576],
                            [119.19433, 32.578596],
                            [119.187133, 32.59998],
                            [119.176933, 32.593811],
                            [119.175169, 32.571066],
                            [119.153863, 32.561862],
                            [119.154483, 32.554958],
                            [119.166685, 32.546014],
                            [119.167781, 32.536337],
                            [119.155579, 32.528071],
                            [119.150098, 32.50981],
                            [119.142281, 32.499396],
                            [119.147762, 32.492644],
                            [119.134511, 32.491545],
                            [119.12045, 32.480082],
                            [119.095998, 32.466052],
                            [119.085131, 32.452701],
                            [119.073691, 32.455371],
                            [119.067447, 32.462439],
                            [119.064445, 32.482385],
                            [119.045522, 32.498454],
                            [119.041375, 32.514781],
                            [119.021737, 32.517868],
                            [119.007533, 32.514048],
                            [118.997428, 32.503896],
                            [118.97984, 32.503844],
                            [118.967924, 32.514572],
                            [118.964778, 32.52671],
                            [118.940565, 32.547793],
                            [118.936561, 32.557521],
                            [118.916351, 32.556057],
                            [118.91597, 32.549519],
                            [118.888325, 32.557207],
                            [118.898668, 32.56045],
                            [118.89638, 32.577289],
                            [118.909345, 32.586857],
                            [118.907867, 32.592295],
                            [118.887896, 32.587119],
                            [118.872405, 32.576034],
                            [118.85596, 32.574361],
                            [118.848525, 32.56819],
                            [118.827028, 32.572687],
                            [118.827791, 32.579694],
                            [118.819259, 32.58623],
                            [118.824645, 32.589628],
                            [118.824931, 32.601914],
                            [118.81373, 32.600816],
                            [118.801766, 32.584348],
                            [118.784369, 32.58257],
                            [118.774693, 32.588112],
                            [118.775789, 32.597732],
                            [118.757533, 32.603953],
                            [118.74433, 32.598882],
                            [118.740708, 32.589367],
                            [118.726027, 32.59632],
                            [118.725312, 32.608239],
                            [118.698001, 32.60641],
                            [118.700861, 32.588531],
                            [118.696666, 32.588269],
                            [118.68904, 32.604737],
                            [118.689564, 32.588531],
                            [118.668782, 32.594909],
                            [118.65229, 32.593079],
                            [118.633034, 32.578962],
                            [118.623406, 32.592609],
                            [118.601814, 32.597366],
                            [118.598096, 32.601339],
                            [118.581271, 32.594543],
                            [118.569497, 32.586439],
                            [118.56373, 32.564372],
                            [118.584655, 32.548996],
                            [118.599002, 32.544654],
                            [118.608821, 32.537069],
                            [118.604864, 32.522839],
                            [118.614445, 32.520432],
                            [118.617448, 32.512426],
                            [118.60801, 32.501751],
                            [118.592376, 32.499867],
                            [118.59333, 32.478826],
                            [118.608058, 32.475842],
                            [118.608582, 32.470554],
                            [118.628077, 32.467675],
                            [118.643425, 32.470502],
                            [118.647715, 32.476522],
                            [118.675217, 32.470136],
                            [118.689278, 32.473486],
                            [118.692615, 32.46511],
                            [118.686895, 32.429815],
                            [118.68904, 32.420649],
                            [118.685751, 32.404986],
                            [118.678697, 32.393931],
                            [118.690184, 32.378263],
                            [118.698763, 32.383189],
                            [118.696094, 32.367991],
                            [118.702052, 32.357927],
                            [118.692901, 32.35169],
                            [118.69986, 32.34975],
                            [118.697524, 32.34262],
                            [118.707915, 32.338426],
                            [118.703244, 32.328988],
                            [118.687657, 32.329985],
                            [118.683463, 32.325003],
                            [118.694855, 32.317243],
                            [118.678458, 32.316561],
                            [118.66025, 32.305443],
                            [118.659964, 32.296369],
                            [118.667305, 32.296369],
                            [118.670784, 32.285615],
                            [118.659249, 32.266098],
                            [118.667448, 32.257545],
                            [118.675741, 32.255131],
                            [118.667495, 32.235923],
                            [118.64414, 32.20999],
                            [118.626599, 32.202534],
                            [118.61964, 32.205475],
                            [118.598334, 32.199489],
                            [118.580889, 32.198649],
                            [118.574931, 32.202587],
                            [118.561728, 32.196863],
                            [118.551719, 32.199646],
                            [118.539612, 32.192452],
                            [118.532367, 32.195813],
                            [118.524645, 32.189039],
                            [118.509822, 32.19429],
                            [118.506485, 32.182107],
                            [118.496809, 32.178588],
                            [118.495618, 32.165194],
                            [118.507438, 32.137875],
                            [118.500622, 32.141711],
                            [118.495046, 32.132883],
                            [118.499097, 32.120376],
                            [118.489469, 32.120744],
                            [118.472977, 32.114858],
                            [118.463349, 32.100666],
                            [118.44109, 32.092045],
                            [118.433511, 32.086682],
                            [118.415112, 32.087418],
                            [118.405198, 32.075799],
                            [118.39476, 32.075589],
                            [118.393282, 32.062705],
                            [118.385084, 32.05813],
                            [118.394378, 32.0484],
                            [118.385989, 32.033146],
                            [118.401528, 32.018679],
                            [118.38966, 32.012049],
                            [118.390994, 31.989527],
                            [118.387181, 31.983264],
                            [118.376695, 31.981737],
                            [118.379221, 31.967262],
                            [118.369021, 31.956153],
                            [118.369498, 31.944201],
                            [118.36435, 31.930141],
                            [118.375313, 31.925349],
                            [118.386037, 31.914815],
                            [118.402958, 31.914025],
                            [118.415923, 31.901435],
                            [118.440136, 31.892689],
                            [118.452291, 31.884628],
                            [118.47231, 31.879623],
                            [118.467114, 31.868873],
                            [118.466781, 31.858016],
                            [118.475456, 31.850321],
                            [118.490613, 31.843152],
                            [118.504721, 31.841729],
                            [118.486132, 31.795434],
                            [118.482176, 31.778344],
                            [118.503196, 31.778028],
                            [118.510775, 31.765631],
                            [118.523597, 31.76199],
                            [118.533844, 31.767266],
                            [118.539659, 31.761568],
                            [118.538706, 31.74938],
                            [118.522119, 31.743047],
                            [118.530031, 31.742309],
                            [118.545093, 31.732071],
                            [118.550003, 31.735976],
                            [118.5572, 31.729643],
                            [118.57169, 31.746214],
                            [118.575312, 31.740937],
                            [118.593091, 31.74442],
                            [118.600718, 31.75397],
                            [118.609345, 31.757189],
                            [118.619021, 31.750066],
                            [118.627076, 31.759458],
                            [118.641661, 31.758244],
                            [118.648382, 31.748799],
                            [118.64209, 31.744314],
                            [118.6521, 31.739776],
                            [118.653959, 31.730118],
                            [118.677267, 31.728587],
                            [118.684893, 31.724893],
                            [118.687324, 31.716183],
                            [118.697715, 31.709426],
                            [118.680746, 31.696598],
                            [118.673406, 31.696334],
                            [118.671404, 31.688467],
                            [118.654912, 31.675635],
                            [118.647, 31.679859],
                            [118.643234, 31.671357],
                            [118.647953, 31.659368],
                            [118.643616, 31.650019],
                            [118.657867, 31.641091],
                            [118.673835, 31.640563],
                            [118.684798, 31.636231],
                            [118.694998, 31.639718],
                            [118.716923, 31.639454],
                            [118.719402, 31.62746],
                            [118.728649, 31.634276],
                            [118.734226, 31.632216],
                            [118.745141, 31.656516],
                            [118.744378, 31.668347],
                            [118.751146, 31.677694],
                            [118.768306, 31.677483],
                            [118.774121, 31.682605],
                            [118.799049, 31.666393],
                            [118.783082, 31.656516],
                            [118.789564, 31.646532],
                            [118.796046, 31.628306],
                            [118.802767, 31.619482],
                            [118.81454, 31.619218],
                            [118.819545, 31.628517],
                            [118.833844, 31.630314],
                            [118.858534, 31.623973],
                            [118.868735, 31.611397],
                            [118.870784, 31.599347],
                            [118.865303, 31.591789],
                            [118.877314, 31.589675],
                            [118.873358, 31.573922],
                            [118.881985, 31.564775],
                            [118.875122, 31.551979],
                            [118.873739, 31.531936],
                            [118.883939, 31.53146],
                            [118.885846, 31.518871],
                            [118.868163, 31.520511],
                            [118.870498, 31.526012],
                            [118.857819, 31.523791],
                            [118.846237, 31.509137],
                            [118.846714, 31.503053],
                            [118.856771, 31.506492],
                            [118.883701, 31.500143],
                            [118.877791, 31.478766],
                            [118.870498, 31.463047],
                            [118.866065, 31.44489],
                            [118.86964, 31.421594],
                            [118.851146, 31.392518],
                            [118.847381, 31.393948],
                            [118.829507, 31.377527],
                            [118.800241, 31.368997],
                            [118.784559, 31.368573],
                            [118.771261, 31.363116],
                            [118.7674, 31.365871],
                            [118.770355, 31.379328],
                            [118.765398, 31.387963],
                            [118.754626, 31.385049],
                            [118.74576, 31.372706],
                            [118.735036, 31.344781],
                            [118.72107, 31.322679],
                            [118.719593, 31.294792],
                            [118.704435, 31.302798],
                            [118.707915, 31.296807],
                            [118.726599, 31.282224],
                            [118.761394, 31.277663],
                            [118.779983, 31.259524],
                            [118.781413, 31.239843],
                            [118.795331, 31.229443],
                            [118.802672, 31.228223],
                            [118.819116, 31.236022],
                            [118.824073, 31.230451],
                            [118.851051, 31.23963],
                            [118.869688, 31.24223],
                            [118.891232, 31.237986],
                            [118.915207, 31.244193],
                            [118.924979, 31.239683],
                            [118.953053, 31.237773],
                            [118.983939, 31.237773],
                            [118.986466, 31.231141],
                            [119.003291, 31.233741],
                            [119.015017, 31.241646],
                            [119.022881, 31.238145],
                            [119.039516, 31.23841],
                            [119.048858, 31.233529],
                            [119.062347, 31.238463],
                            [119.073787, 31.232892],
                            [119.085465, 31.240267],
                            [119.105293, 31.23528],
                            [119.107009, 31.250612],
                            [119.120021, 31.261699],
                            [119.131747, 31.262548],
                            [119.14066, 31.276019],
                            [119.150098, 31.277133],
                            [119.158153, 31.294792],
                            [119.176218, 31.293944],
                            [119.181127, 31.300465],
                            [119.199478, 31.293625],
                            [119.197142, 31.273527],
                            [119.204244, 31.26573],
                            [119.215255, 31.27411],
                            [119.218544, 31.264563],
                            [119.236275, 31.259312],
                            [119.238563, 31.254644],
                            [119.250193, 31.257243],
                            [119.249764, 31.262017],
                            [119.261394, 31.261328],
                            [119.266971, 31.250453],
                            [119.294473, 31.263131],
                            [119.314873, 31.26573],
                            [119.333224, 31.264139],
                            [119.337562, 31.258888],
                            [119.345951, 31.268965],
                            [119.350288, 31.281641],
                            [119.350145, 31.301049],
                            [119.356627, 31.303275],
                            [119.367876, 31.289224],
                            [119.371594, 31.271617],
                            [119.379697, 31.26939],
                            [119.365207, 31.232627],
                            [119.360059, 31.212144],
                            [119.365779, 31.195956],
                            [119.371403, 31.197707],
                            [119.379173, 31.189214],
                            [119.394902, 31.199618],
                            [119.405674, 31.194416],
                            [119.389325, 31.188365],
                            [119.39147, 31.174243],
                            [119.400622, 31.178756],
                            [119.415398, 31.172969],
                            [119.423167, 31.181835],
                            [119.438801, 31.177057],
                            [119.454768, 31.164899],
                            [119.460583, 31.156403],
                            [119.475836, 31.158898],
                            [119.482509, 31.152526],
                            [119.48556, 31.161394],
                            [119.494473, 31.163996],
                            [119.51392, 31.156031],
                            [119.5235, 31.159748],
                            [119.534511, 31.158102],
                            [119.545855, 31.147853],
                            [119.56025, 31.140736],
                            [119.571308, 31.128998],
                            [119.57412, 31.113965],
                            [119.581985, 31.108652],
                            [119.599763, 31.109183],
                            [119.613729, 31.129157],
                            [119.623786, 31.130273],
                            [119.624168, 31.115983],
                            [119.649144, 31.105092],
                            [119.634702, 31.093775],
                            [119.629554, 31.085538],
                            [119.634987, 31.064172],
                            [119.631317, 31.046311],
                            [119.634034, 31.01946],
                            [119.624025, 31.005313],
                            [119.616255, 31.002388],
                            [119.607437, 30.991856],
                            [119.588372, 30.979142],
                            [119.580412, 30.967117],
                            [119.582175, 30.947428],
                            [119.580364, 30.929173],
                            [119.563825, 30.919218],
                            [119.556341, 30.896697],
                            [119.559058, 30.891745],
                            [119.558963, 30.871189],
                            [119.573739, 30.853344],
                            [119.575741, 30.829742],
                            [119.561203, 30.829476],
                            [119.55453, 30.825639],
                            [119.524501, 30.776017],
                            [119.507104, 30.769619],
                            [119.491518, 30.777243],
                            [119.480126, 30.773298],
                            [119.478791, 30.753089],
                            [119.484606, 30.744609],
                            [119.479697, 30.736823],
                            [119.482747, 30.704442],
                            [119.466017, 30.683899],
                            [119.452909, 30.671624],
                            [119.448286, 30.655825],
                            [119.433653, 30.644454],
                            [119.412681, 30.642959],
                            [119.400002, 30.658868],
                            [119.395665, 30.678722],
                            [119.391518, 30.685233],
                            [119.379411, 30.679363],
                            [119.372357, 30.680377],
                            [119.35453, 30.666927],
                            [119.343138, 30.664205],
                            [119.333653, 30.652195],
                            [119.323119, 30.630306],
                            [119.311966, 30.621228],
                            [119.291232, 30.616048],
                            [119.275741, 30.617597],
                            [119.258772, 30.614393],
                            [119.25005, 30.620267],
                            [119.239135, 30.609319],
                            [119.253672, 30.596447],
                            [119.254149, 30.588649],
                            [119.264778, 30.582025],
                            [119.264778, 30.573424],
                            [119.245522, 30.561402],
                            [119.236942, 30.546707],
                            [119.242566, 30.530032],
                            [119.261918, 30.525542],
                            [119.261632, 30.517738],
                            [119.272118, 30.510521],
                            [119.287943, 30.512606],
                            [119.313634, 30.531208],
                            [119.326551, 30.533025],
                            [119.328696, 30.52164],
                            [119.336322, 30.507153],
                            [119.330317, 30.488225],
                            [119.334463, 30.478118],
                            [119.336132, 30.445544],
                            [119.349716, 30.438803],
                            [119.352957, 30.424839],
                            [119.349525, 30.408625],
                            [119.363205, 30.409481],
                            [119.368925, 30.39974],
                            [119.366589, 30.388393],
                            [119.371451, 30.38395],
                            [119.393806, 30.38304],
                            [119.403052, 30.374368],
                            [119.399954, 30.367783],
                            [119.386132, 30.363928],
                            [119.375598, 30.354826],
                            [119.34943, 30.34915],
                            [119.342662, 30.363178],
                            [119.329077, 30.371531],
                            [119.300669, 30.36366],
                            [119.289468, 30.349632],
                            [119.278124, 30.341599],
                            [119.265064, 30.338064],
                            [119.247142, 30.340796],
                            [119.239993, 30.327031],
                            [119.245903, 30.321621],
                            [119.236227, 30.2973],
                            [119.229173, 30.289692],
                            [119.222595, 30.299604],
                            [119.205674, 30.301586],
                            [119.201051, 30.291031],
                            [119.188181, 30.291674],
                            [119.156723, 30.29955],
                            [119.151289, 30.304586],
                            [119.128506, 30.304694],
                            [119.111013, 30.311283],
                            [119.090231, 30.324032],
                            [119.073405, 30.31589],
                            [119.063015, 30.304961],
                            [119.05086, 30.306729],
                            [119.048334, 30.312676],
                            [119.028792, 30.312569],
                            [119.004435, 30.328959],
                            [118.988039, 30.333458],
                            [118.988086, 30.348668],
                            [118.975741, 30.347168],
                            [118.96902, 30.351345],
                            [118.959964, 30.347275],
                            [118.955388, 30.359216],
                            [118.936418, 30.35081],
                            [118.936323, 30.34508],
                            [118.917877, 30.332441],
                            [118.908391, 30.330888],
                            [118.899764, 30.322586],
                            [118.879888, 30.314872],
                            [118.881795, 30.298532],
                            [118.878077, 30.282726],
                            [118.889707, 30.254268],
                            [118.882414, 30.24746],
                            [118.893043, 30.242689],
                            [118.903196, 30.21792],
                            [118.924979, 30.213844],
                            [118.929888, 30.203387],
                            [118.920641, 30.199043],
                            [118.910822, 30.187512],
                            [118.864397, 30.169005],
                            [118.852862, 30.166537],
                            [118.845713, 30.156129],
                            [118.856389, 30.148188],
                            [118.865732, 30.151515],
                            [118.881032, 30.146793],
                            [118.896809, 30.148081],
                            [118.895951, 30.138797],
                            [118.888134, 30.127259],
                            [118.887228, 30.117437],
                            [118.871642, 30.113035],
                            [118.868878, 30.10144],
                            [118.872929, 30.094622],
                            [118.875455, 30.072017],
                            [118.878839, 30.064659],
                            [118.888134, 30.06235],
                            [118.897333, 30.051877],
                            [118.890565, 30.041242],
                            [118.902576, 30.029047],
                            [118.898048, 30.017227],
                            [118.890327, 30.012015],
                            [118.895093, 30.001214],
                            [118.89209, 29.994819],
                            [118.899478, 29.981437],
                            [118.891566, 29.959881],
                            [118.894664, 29.938051],
                            [118.884702, 29.938912],
                            [118.871976, 29.94687],
                            [118.86392, 29.936976],
                            [118.848287, 29.941278],
                            [118.838706, 29.934502],
                            [118.844902, 29.915249],
                            [118.845522, 29.899112],
                            [118.841328, 29.891312],
                            [118.807724, 29.867638],
                            [118.802624, 29.860642],
                            [118.778744, 29.841913],
                            [118.766923, 29.848964],
                            [118.755627, 29.845412],
                            [118.750956, 29.831632],
                            [118.765922, 29.823073],
                            [118.75944, 29.817151],
                            [118.745999, 29.818173],
                            [118.739945, 29.813274],
                            [118.736513, 29.788451],
                            [118.74433, 29.779618],
                            [118.749049, 29.761143],
                            [118.744712, 29.738786],
                            [118.724645, 29.72262],
                            [118.718687, 29.709201],
                            [118.700813, 29.706452],
                            [118.682319, 29.686454],
                            [118.67393, 29.669094],
                            [118.647333, 29.643372],
                            [118.640946, 29.641916],
                            [118.633511, 29.648765],
                            [118.619974, 29.654104],
                            [118.602052, 29.643696],
                            [118.573883, 29.638357],
                            [118.555055, 29.613382],
                            [118.549907, 29.613382],
                            [118.535227, 29.590614],
                            [118.500575, 29.575666],
                            [118.494903, 29.553698],
                            [118.497858, 29.543982],
                            [118.495904, 29.519578],
                            [118.47903, 29.510938],
                            [118.458249, 29.506348],
                            [118.448954, 29.513422],
                            [118.429507, 29.503647],
                            [118.414969, 29.50975],
                            [118.393044, 29.50732],
                            [118.38394, 29.510398],
                            [118.379793, 29.502567],
                            [118.358725, 29.477073],
                            [118.34762, 29.473994],
                            [118.324407, 29.49695],
                            [118.310537, 29.496032],
                            [118.306581, 29.47945],
                            [118.316018, 29.450545],
                            [118.316113, 29.422606],
                            [118.291376, 29.419957],
                            [118.28618, 29.426713],
                            [118.276266, 29.423417],
                            [118.267782, 29.427848],
                            [118.255723, 29.426173],
                            [118.248525, 29.431307],
                            [118.232939, 29.423903],
                            [118.218115, 29.42039],
                            [118.204245, 29.395415],
                            [118.193044, 29.395253],
                            [118.188135, 29.406119],
                            [118.1766, 29.404714],
                            [118.163635, 29.412066],
                            [118.136085, 29.418876],
                            [118.12946, 29.432604],
                            [118.138611, 29.437684],
                            [118.137992, 29.454868],
                            [118.127648, 29.472049],
                            [118.143807, 29.489767],
                            [118.142996, 29.499867],
                            [118.13456, 29.508778],
                            [118.109536, 29.521954],
                            [118.103435, 29.530647],
                            [118.082653, 29.533778],
                            [118.050718, 29.543172],
                            [118.042949, 29.566275],
                            [118.014112, 29.577285],
                            [118.003864, 29.578094],
                            [117.994665, 29.573183],
                            [117.984703, 29.561633],
                            [117.964874, 29.569999],
                            [117.954913, 29.565087],
                            [117.938707, 29.549596],
                            [117.920785, 29.554508],
                            [117.889851, 29.545817],
                            [117.876505, 29.546195],
                            [117.863588, 29.55413],
                            [117.852005, 29.554994],
                            [117.829889, 29.563846],
                            [117.822787, 29.571834],
                            [117.807296, 29.573561],
                            [117.794951, 29.570323],
                            [117.770928, 29.557099],
                            [117.753054, 29.560392],
                            [117.736038, 29.551539],
                            [117.707677, 29.549002],
                            [117.69047, 29.555912],
                            [117.682987, 29.568002],
                            [117.682225, 29.587268],
                            [117.678983, 29.59547],
                            [117.668974, 29.596981],
                            [117.661443, 29.611818],
                            [117.647954, 29.614893],
                            [117.628316, 29.606207],
                            [117.608726, 29.591585],
                            [117.586467, 29.584732],
                            [117.574074, 29.591099],
                            [117.557963, 29.590128],
                            [117.546238, 29.594337],
                            [117.54333, 29.588563],
                            [117.534274, 29.598545],
                            [117.523454, 29.629619],
                            [117.530556, 29.65405],
                            [117.516543, 29.663379],
                            [117.493759, 29.65955],
                            [117.474217, 29.668339],
                            [117.451862, 29.695942],
                            [117.457249, 29.725315],
                            [117.455104, 29.749184],
                            [117.44314, 29.758935],
                            [117.434703, 29.761143],
                            [117.413588, 29.78802],
                            [117.409155, 29.802613],
                            [117.424789, 29.834646],
                            [117.418783, 29.850417],
                            [117.403292, 29.84891],
                            [117.384084, 29.843635],
                            [117.375981, 29.818066],
                            [117.356248, 29.813705],
                            [117.347906, 29.822319],
                            [117.338612, 29.847887],
                            [117.333273, 29.850578],
                            [117.325695, 29.843851],
                            [117.303007, 29.840352],
                            [117.297239, 29.836853],
                            [117.292425, 29.822803],
                            [117.278173, 29.825118],
                            [117.271214, 29.830071],
                            [117.257392, 29.831255],
                            [117.249336, 29.846111],
                            [117.25682, 29.859512],
                            [117.261777, 29.880659],
                            [117.253722, 29.90901],
                            [117.246238, 29.915088],
                            [117.21702, 29.92692],
                            [117.206248, 29.927511],
                            [117.188946, 29.921864],
                            [117.177601, 29.921972],
                            [117.148812, 29.911323],
                            [117.134704, 29.903846],
                            [117.127983, 29.895508],
                            [117.133035, 29.874256],
                            [117.127697, 29.861611],
                            [117.110395, 29.855422],
                            [117.092807, 29.836853],
                            [117.073312, 29.832224],
                            [117.0756, 29.822642],
                            [117.092711, 29.809559],
                            [117.127983, 29.795775],
                            [117.135609, 29.780965],
                            [117.135466, 29.772024],
                            [117.108679, 29.751985],
                            [117.10825, 29.745089],
                            [117.122454, 29.728548],
                            [117.113016, 29.712165],
                            [117.085848, 29.696912],
                            [117.070881, 29.693732],
                            [117.051243, 29.682896],
                            [117.042044, 29.680902],
                            [117.015304, 29.685753],
                            [116.996048, 29.683381],
                            [116.984561, 29.674702],
                            [116.971167, 29.655668],
                            [116.939613, 29.64828],
                            [116.918545, 29.634473],
                            [116.873455, 29.609282],
                            [116.848955, 29.576421],
                            [116.838088, 29.569837],
                            [116.818403, 29.564764],
                            [116.795762, 29.566545],
                            [116.780652, 29.570539],
                            [116.779651, 29.57804],
                            [116.786944, 29.591315],
                            [116.774933, 29.595254],
                            [116.770166, 29.592232],
                            [116.760443, 29.599085],
                            [116.740185, 29.585919],
                            [116.729985, 29.568542],
                            [116.721596, 29.56498],
                            [116.716544, 29.590775],
                            [116.688946, 29.604103],
                            [116.685657, 29.611602],
                            [116.670595, 29.625088],
                            [116.651911, 29.63717],
                            [116.652244, 29.645422],
                            [116.663589, 29.659173],
                            [116.677078, 29.66904],
                            [116.680509, 29.681495],
                            [116.705057, 29.688664],
                            [116.717163, 29.690767],
                            [116.715876, 29.697289],
                            [116.706534, 29.696588],
                            [116.705819, 29.697128],
                            [116.703388, 29.710063],
                            [116.698956, 29.7078],
                            [116.673836, 29.709848],
                            [116.687087, 29.734798],
                            [116.703055, 29.741264],
                            [116.720548, 29.763352],
                            [116.739327, 29.774179],
                            [116.745857, 29.790336],
                            [116.762492, 29.802506],
                            [116.780891, 29.79249],
                            [116.789804, 29.795128],
                            [116.812349, 29.811713],
                            [116.830748, 29.841482],
                            [116.861301, 29.867369],
                            [116.882702, 29.893518],
                            [116.891996, 29.919337],
                            [116.891853, 29.92735],
                            [116.900147, 29.949504],
                            [116.887897, 29.968805],
                            [116.868688, 29.980469],
                            [116.845381, 29.969611],
                            [116.835943, 29.970686],
                            [116.835276, 29.95773],
                            [116.828746, 29.963106],
                            [116.829556, 30.006534],
                            [116.802816, 29.996539],
                            [116.787325, 30.020343],
                            [116.783512, 30.030712],
                            [116.770309, 30.035655],
                            [116.764542, 30.048923],
                            [116.753627, 30.048976],
                            [116.747335, 30.057248],
                            [116.720309, 30.053918],
                            [116.685705, 30.07062],
                            [116.666877, 30.076742],
                            [116.642616, 30.076366],
                            [116.611015, 30.070728],
                            [116.596572, 30.059718],
                            [116.586039, 30.046291],
                            [116.57131, 30.014433],
                            [116.571215, 29.98923],
                            [116.564542, 29.949343],
                            [116.558727, 29.924338],
                            [116.551959, 29.90987],
                            [116.54152, 29.901641],
                            [116.525552, 29.897498],
                            [116.479842, 29.897875],
                            [116.467736, 29.896154],
                            [116.441758, 29.879852],
                            [116.392521, 29.855745],
                            [116.35968, 29.843635],
                            [116.343093, 29.835669],
                            [116.322788, 29.820004],
                            [116.312302, 29.808967],
                            [116.280796, 29.788882],
                            [116.261444, 29.782042],
                            [116.253627, 29.783119],
                            [116.227364, 29.816881],
                            [116.208108, 29.827487],
                            [116.187326, 29.829048],
                            [116.167354, 29.827379],
                            [116.135181, 29.819412],
                            [116.131987, 29.844281],
                            [116.134561, 29.877431],
                            [116.125791, 29.901372],
                            [116.104056, 29.926866],
                            [116.085705, 29.950795],
                            [116.077936, 29.956117],
                            [116.073837, 29.969987],
                            [116.081463, 29.981759],
                            [116.078317, 30.010242],
                            [116.088994, 30.026952],
                            [116.091663, 30.036192],
                            [116.079986, 30.057248],
                            [116.079223, 30.066217],
                            [116.0848, 30.075937],
                            [116.083751, 30.095642],
                            [116.088375, 30.11019],
                            [116.085038, 30.126185],
                            [116.075029, 30.133538],
                            [116.06316, 30.151622],
                            [116.056725, 30.169917],
                            [116.05601, 30.181022],
                            [116.063923, 30.193573],
                            [116.064352, 30.206873],
                            [116.046096, 30.223925],
                            [116.031702, 30.227035],
                            [116.026601, 30.239741],
                            [116.012254, 30.249497],
                            [115.994809, 30.255018],
                            [115.988899, 30.267078],
                            [115.985324, 30.291031],
                            [115.980939, 30.295746],
                            [115.958394, 30.305336],
                            [115.938708, 30.306944],
                            [115.921883, 30.301265],
                            [115.904438, 30.310051],
                            [115.903723, 30.315783],
                            [115.914352, 30.3243],
                            [115.916687, 30.334422],
                            [115.896478, 30.3567],
                            [115.884895, 30.379561],
                            [115.90091, 30.397867],
                            [115.909252, 30.398831],
                            [115.921501, 30.416384],
                            [115.930987, 30.420505],
                            [115.938184, 30.417776],
                            [115.946144, 30.425213],
                            [115.920786, 30.429868],
                            [115.915543, 30.443993],
                            [115.894809, 30.452712],
                            [115.894047, 30.459559],
                            [115.900815, 30.469722],
                            [115.898098, 30.482236],
                            [115.909728, 30.506725],
                            [115.919881, 30.515011],
                            [115.905153, 30.52458],
                            [115.899481, 30.537889],
                            [115.887803, 30.542485],
                            [115.883132, 30.559425],
                            [115.875553, 30.569363],
                            [115.87908, 30.578285],
                            [115.866211, 30.587901],
                            [115.857298, 30.589503],
                            [115.84848, 30.601895],
                            [115.828079, 30.606168],
                            [115.824123, 30.596127],
                            [115.819166, 30.59789],
                            [115.807822, 30.615568],
                            [115.814924, 30.624806],
                            [115.809919, 30.642586],
                            [115.798766, 30.65006],
                            [115.797002, 30.658601],
                            [115.775362, 30.668849],
                            [115.77236, 30.677869],
                            [115.762541, 30.685607],
                            [115.767402, 30.694358],
                            [115.765544, 30.707537],
                            [115.776363, 30.728875],
                            [115.782893, 30.751702],
                            [115.79276, 30.759275],
                            [115.810491, 30.759434],
                            [115.820119, 30.750689],
                            [115.834657, 30.756395],
                            [115.85153, 30.756715],
                            [115.854342, 30.767433],
                            [115.868356, 30.774257],
                            [115.8695, 30.782467],
                            [115.85868, 30.784813],
                            [115.865877, 30.798246],
                            [115.86378, 30.815781],
                            [115.848813, 30.82857],
                            [115.849481, 30.841251],
                            [115.863875, 30.855262],
                            [115.865686, 30.864264],
                            [115.876935, 30.869005],
                            [115.885705, 30.877846],
                            [115.912779, 30.887592],
                            [115.932369, 30.889402],
                            [115.936134, 30.902874],
                            [115.970548, 30.920017],
                            [115.976268, 30.931461],
                            [115.993427, 30.936731],
                            [116.009871, 30.949717],
                            [116.024743, 30.953602],
                            [116.034514, 30.951154],
                            [116.039519, 30.957859],
                            [116.07174, 30.956688],
                            [116.06969, 30.969139],
                            [116.0603, 30.994941],
                            [116.058918, 31.012759],
                            [116.046144, 31.014514],
                            [116.015019, 31.011908],
                            [116.010062, 31.017332],
                            [116.00663, 31.034668],
                            [115.994047, 31.034614],
                            [115.983704, 31.041898],
                            [115.961063, 31.046896],
                            [115.946192, 31.04243],
                            [115.938565, 31.047321],
                            [115.942235, 31.060664],
                            [115.939805, 31.071667],
                            [115.925744, 31.076822],
                            [115.909585, 31.090693],
                            [115.902769, 31.089205],
                            [115.887421, 31.109289],
                            [115.886373, 31.127351],
                            [115.880081, 31.141905],
                            [115.869261, 31.14764],
                            [115.857107, 31.143286],
                            [115.841282, 31.128998],
                            [115.829128, 31.126448],
                            [115.813256, 31.13091],
                            [115.797908, 31.127883],
                            [115.781511, 31.11354],
                            [115.770072, 31.113061],
                            [115.764066, 31.118215],
                            [115.75582, 31.142542],
                            [115.740567, 31.152951],
                            [115.728127, 31.174721],
                            [115.700815, 31.201104],
                            [115.678127, 31.207632],
                            [115.655248, 31.210976],
                            [115.645954, 31.209596],
                            [115.636325, 31.19999],
                            [115.629033, 31.184649],
                            [115.603723, 31.173712],
                            [115.596716, 31.150136],
                            [115.585706, 31.144188],
                            [115.559586, 31.160332],
                            [115.540711, 31.191337],
                            [115.538375, 31.220369],
                            [115.53971, 31.231884],
                            [115.530081, 31.249339],
                            [115.51602, 31.263502],
                            [115.507584, 31.267905],
                            [115.501006, 31.262388],
                            [115.494047, 31.265942],
                            [115.473122, 31.265253],
                            [115.466402, 31.276338],
                            [115.457822, 31.281588],
                            [115.460968, 31.318067],
                            [115.449624, 31.31584],
                            [115.442045, 31.346106],
                            [115.420501, 31.349921],
                            [115.404581, 31.337838],
                            [115.3991, 31.342979],
                            [115.372074, 31.349285],
                            [115.382465, 31.356598],
                            [115.375744, 31.371063],
                            [115.38318, 31.37562],
                            [115.392808, 31.38987],
                            [115.373647, 31.40576],
                            [115.38337, 31.418682],
                            [115.385658, 31.443302],
                            [115.389805, 31.45029],
                            [115.377651, 31.47051],
                            [115.371168, 31.494535],
                            [115.377126, 31.503],
                            [115.389614, 31.507603],
                            [115.396812, 31.515168],
                            [115.415877, 31.525959],
                            [115.428556, 31.54722],
                            [115.431559, 31.559012],
                            [115.428223, 31.563401],
                            [115.438852, 31.579948],
                            [115.440043, 31.588723],
                            [115.488232, 31.612242],
                            [115.489662, 31.62577],
                            [115.476983, 31.64294],
                            [115.484276, 31.649068],
                            [115.48542, 31.659791],
                            [115.495382, 31.672942],
                            [115.515067, 31.682869],
                            [115.531845, 31.698551],
                            [115.553485, 31.695278],
                            [115.564924, 31.709004],
                            [115.582655, 31.713913],
                            [115.586945, 31.721726],
                            [115.601435, 31.731701],
                            [115.619166, 31.738351],
                            [115.636564, 31.755078],
                            [115.659633, 31.760196],
                            [115.677793, 31.778872],
                            [115.689805, 31.776551],
                            [115.697145, 31.768638],
                            [115.710825, 31.770906],
                            [115.729843, 31.763309],
                            [115.734276, 31.776023],
                            [115.741997, 31.78209],
                            [115.763065, 31.782353],
                            [115.767927, 31.787839],
                            [115.788327, 31.779821],
                            [115.815353, 31.76236],
                            [115.831034, 31.777606],
                            [115.836468, 31.77386],
                            [115.850243, 31.786731],
                            [115.858298, 31.773702],
                            [115.868689, 31.776551],
                            [115.885229, 31.776076],
                            [115.900815, 31.792006],
                            [115.910253, 31.792322],
                            [115.915019, 31.811888],
                            [115.91316, 31.820113],
                            [115.904056, 31.829393],
                            [115.89295, 31.833294],
                            [115.895715, 31.867503],
                            [115.898337, 31.880255],
                            [115.90377, 31.883522],
                            [115.917259, 31.909969],
                            [115.920167, 31.92045],
                            [115.916115, 31.935987],
                            [115.909013, 31.943253],
                            [115.911349, 31.957996],
                            [115.92317, 31.985474],
                            [115.924552, 31.995579],
                            [115.933799, 32.001631],
                            [115.927603, 32.007524],
                            [115.927841, 32.023572],
                            [115.919547, 32.027886],
                            [115.927745, 32.036303],
                            [115.922216, 32.049663],
                            [115.927793, 32.058761],
                            [115.939614, 32.065861],
                            [115.942569, 32.077692],
                            [115.932512, 32.084264],
                            [115.926554, 32.105239],
                            [115.931368, 32.109286],
                            [115.940329, 32.146755],
                            [115.941949, 32.165141],
                            [115.933656, 32.180426],
                            [115.925267, 32.187831],
                            [115.922884, 32.203637],
                            [115.912731, 32.227629],
                            [115.914733, 32.254869],
                            [115.920072, 32.273181],
                            [115.911063, 32.284199],
                            [115.908251, 32.299253],
                            [115.900291, 32.301404],
                            [115.906964, 32.311579],
                            [115.904581, 32.340995],
                            [115.899242, 32.344979],
                            [115.897908, 32.372289],
                            [115.899099, 32.390106],
                            [115.88928, 32.413473],
                            [115.889423, 32.424263],
                            [115.879223, 32.432591],
                            [115.883275, 32.438614],
                            [115.882703, 32.456104],
                            [115.864257, 32.458932],
                            [115.872359, 32.469769],
                            [115.881273, 32.472491],
                            [115.883561, 32.489242],
                            [115.874457, 32.497773],
                            [115.87317, 32.504734],
                            [115.853055, 32.504472],
                            [115.845763, 32.501803],
                            [115.847336, 32.509548],
                            [115.856964, 32.517973],
                            [115.873027, 32.525821],
                            [115.87765, 32.54387],
                            [115.899433, 32.556214],
                            [115.910205, 32.566987],
                            [115.928365, 32.567563],
                            [115.915448, 32.576871],
                            [115.891568, 32.576243],
                            [115.887564, 32.567667],
                            [115.861397, 32.537383],
                            [115.845953, 32.531628],
                            [115.839948, 32.524775],
                            [115.841473, 32.501227],
                            [115.823837, 32.502222],
                            [115.804104, 32.485473],
                            [115.788756, 32.468931],
                            [115.780987, 32.46757],
                            [115.78704, 32.485788],
                            [115.771502, 32.505309],
                            [115.766783, 32.492435],
                            [115.757202, 32.480187],
                            [115.74195, 32.476365],
                            [115.701197, 32.495313],
                            [115.692093, 32.487515],
                            [115.692188, 32.480605],
                            [115.701244, 32.470869],
                            [115.696716, 32.467466],
                            [115.675887, 32.466419],
                            [115.681559, 32.451182],
                            [115.680606, 32.439976],
                            [115.674933, 32.431963],
                            [115.66745, 32.40991],
                            [115.656297, 32.408758],
                            [115.657965, 32.427406],
                            [115.654152, 32.428925],
                            [115.645572, 32.417559],
                            [115.627126, 32.405457],
                            [115.604533, 32.42594],
                            [115.586087, 32.419235],
                            [115.563875, 32.402995],
                            [115.553628, 32.407501],
                            [115.569119, 32.414625],
                            [115.567593, 32.421644],
                            [115.547288, 32.424735],
                            [115.537469, 32.438928],
                            [115.523218, 32.442018],
                            [115.524123, 32.447831],
                            [115.515591, 32.450606],
                            [115.509347, 32.466733],
                            [115.510682, 32.467832],
                            [115.510587, 32.468827],
                            [115.508632, 32.468565],
                            [115.496716, 32.493377],
                            [115.490377, 32.496308],
                            [115.486993, 32.510542],
                            [115.477651, 32.511798],
                            [115.47665, 32.520955],
                            [115.465734, 32.520118],
                            [115.438947, 32.53257],
                            [115.443713, 32.543294],
                            [115.434657, 32.545177],
                            [115.431082, 32.552448],
                            [115.408871, 32.54999],
                            [115.412779, 32.559822],
                            [115.411588, 32.574779],
                            [115.403246, 32.576661],
                            [115.38766, 32.570909],
                            [115.328985, 32.561182],
                            [115.324695, 32.555952],
                            [115.305105, 32.55318],
                            [115.297145, 32.560555],
                            [115.300387, 32.568399],
                            [115.310873, 32.570543],
                            [115.29848, 32.573263],
                            [115.305534, 32.583197],
                            [115.299386, 32.588112],
                            [115.294858, 32.581054],
                            [115.289185, 32.58989],
                            [115.267212, 32.578073],
                            [115.254724, 32.584975],
                            [115.261302, 32.591667],
                            [115.254772, 32.595223],
                            [115.241998, 32.592609],
                            [115.229796, 32.579067],
                            [115.223647, 32.581472],
                            [115.22951, 32.59057],
                            [115.21216, 32.588478],
                            [115.201102, 32.591824],
                            [115.192236, 32.602332],
                            [115.209634, 32.611689],
                            [115.199386, 32.619686],
                            [115.201054, 32.633378],
                            [115.194572, 32.631288],
                            [115.194905, 32.642366],
                            [115.202722, 32.645501],
                            [115.209538, 32.636723],
                            [115.208919, 32.64989],
                            [115.219405, 32.65919],
                            [115.204009, 32.653913],
                            [115.205153, 32.672928],
                            [115.193666, 32.682852],
                            [115.189472, 32.678778],
                            [115.196907, 32.672719],
                            [115.182989, 32.666764],
                            [115.18461, 32.678308],
                            [115.178461, 32.682904],
                            [115.182703, 32.694498],
                            [115.179081, 32.701965],
                            [115.184324, 32.720396],
                            [115.179367, 32.726347],
                            [115.189615, 32.770917],
                            [115.183561, 32.776917],
                            [115.182084, 32.787299],
                            [115.191092, 32.790064],
                            [115.209491, 32.785421],
                            [115.206345, 32.79768],
                            [115.196907, 32.802114],
                            [115.189948, 32.812545],
                            [115.195573, 32.828867],
                            [115.1889, 32.840389],
                            [115.202675, 32.843518],
                            [115.198575, 32.854361],
                            [115.19114, 32.857488],
                            [115.176269, 32.856289],
                            [115.159777, 32.862284],
                            [115.154915, 32.877294],
                            [115.141998, 32.885423],
                            [115.14052, 32.897512],
                            [115.116164, 32.900221],
                            [115.098099, 32.894802],
                            [115.08623, 32.903243],
                            [115.067355, 32.903243],
                            [115.029748, 32.906838],
                            [115.02746, 32.914339],
                            [115.036755, 32.916319],
                            [115.03542, 32.932361],
                            [115.023981, 32.933715],
                            [115.009252, 32.940173],
                            [114.978795, 32.941319],
                            [114.959967, 32.939496],
                            [114.951817, 32.934393],
                            [114.942236, 32.937569],
                            [114.93604, 32.95215],
                            [114.924124, 32.958971],
                            [114.914543, 32.971622],
                            [114.893857, 32.972663],
                            [114.883371, 32.983751],
                            [114.884944, 32.992703],
                            [114.901579, 33.000354],
                            [114.891903, 33.020492],
                            [114.915401, 33.016069],
                            [114.924934, 33.016746],
                            [114.936993, 33.025486],
                            [114.92298, 33.036099],
                            [114.922456, 33.048323],
                            [114.914972, 33.059765],
                            [114.919548, 33.068814],
                            [114.914019, 33.082801],
                            [114.897289, 33.086597],
                            [114.898242, 33.096942],
                            [114.906297, 33.11659],
                            [114.902913, 33.129583],
                            [114.910253, 33.136598],
                            [114.92665, 33.13852],
                            [114.933085, 33.144911],
                            [114.932656, 33.154003],
                            [114.958061, 33.150003],
                            [114.966354, 33.146366],
                            [114.968881, 33.133688],
                            [114.981464, 33.129063],
                            [114.992332, 33.120956],
                            [114.990473, 33.102868],
                            [115.012017, 33.09767],
                            [115.023361, 33.090756],
                            [115.041235, 33.086649],
                            [115.051578, 33.092472],
                            [115.057441, 33.083737],
                            [115.069548, 33.086753],
                            [115.111111, 33.082905],
                            [115.153247, 33.084413],
                            [115.167927, 33.088728],
                            [115.172408, 33.108066],
                            [115.197146, 33.121424],
                            [115.209824, 33.113472],
                            [115.224362, 33.126257],
                            [115.236993, 33.126724],
                            [115.246288, 33.13639],
                            [115.266497, 33.1327],
                            [115.269595, 33.137845],
                            [115.290329, 33.132441],
                            [115.292856, 33.143404],
                            [115.301483, 33.141638],
                            [115.300148, 33.16299],
                            [115.294381, 33.177897],
                            [115.296764, 33.201317],
                            [115.326411, 33.211338],
                            [115.316259, 33.218398],
                            [115.316307, 33.223797],
                            [115.33175, 33.235631],
                            [115.329748, 33.250578],
                            [115.340139, 33.261164],
                            [115.340282, 33.286325],
                            [115.333799, 33.284717],
                            [115.335039, 33.2981],
                            [115.347002, 33.301004],
                            [115.360205, 33.2981],
                            [115.358776, 33.311428],
                            [115.36502, 33.336005],
                            [115.348337, 33.33896],
                            [115.346812, 33.358709],
                            [115.338566, 33.363011],
                            [115.341664, 33.371199],
                            [115.316116, 33.370992],
                            [115.313256, 33.377107],
                            [115.329414, 33.401665],
                            [115.317355, 33.418241],
                            [115.315639, 33.431447],
                            [115.319023, 33.441493],
                            [115.316354, 33.448897],
                            [115.323313, 33.448638],
                            [115.324552, 33.457595],
                            [115.335944, 33.447292],
                            [115.345811, 33.449777],
                            [115.348861, 33.478973],
                            [115.343809, 33.480837],
                            [115.351245, 33.490411],
                            [115.345429, 33.502934],
                            [115.366592, 33.523473],
                            [115.395096, 33.506504],
                            [115.396812, 33.502002],
                            [115.405344, 33.516696],
                            [115.401721, 33.524353],
                            [115.414638, 33.541629],
                            [115.421979, 33.556782],
                            [115.463685, 33.567227],
                            [115.474314, 33.55735],
                            [115.501864, 33.564383],
                            [115.511302, 33.553369],
                            [115.528556, 33.562728],
                            [115.552722, 33.56552],
                            [115.559347, 33.561953],
                            [115.565019, 33.576378],
                            [115.601149, 33.578187],
                            [115.639757, 33.585115],
                        ],
                    ],
                    [
                        [
                            [118.868163, 31.520511],
                            [118.885846, 31.518871],
                            [118.883701, 31.500143],
                            [118.856771, 31.506492],
                            [118.868163, 31.520511],
                        ],
                    ],
                    [
                        [
                            [116.698956, 29.7078],
                            [116.705819, 29.697128],
                            [116.706534, 29.696588],
                            [116.705057, 29.688664],
                            [116.680509, 29.681495],
                            [116.673026, 29.687532],
                            [116.656677, 29.686346],
                            [116.654151, 29.694756],
                            [116.668021, 29.700308],
                            [116.673836, 29.709848],
                            [116.698956, 29.7078],
                        ],
                    ],
                    [
                        [
                            [115.508632, 32.468565],
                            [115.510587, 32.468827],
                            [115.510682, 32.467832],
                            [115.509347, 32.466733],
                            [115.508632, 32.468565],
                        ],
                    ],
                ],
            },
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 340100,
                "name": "合肥市",
                "center": [117.283042, 31.86119],
                "centroid": [117.360392, 31.762556],
                "childrenNum": 9,
                "level": "city",
                "parent": {
                    "adcode": 340000
                },
                "subFeatureIndex": 0,
                "acroutes": [100000, 340000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [117.2011, 32.534035],
                            [117.211205, 32.516194],
                            [117.209632, 32.493953],
                            [117.211586, 32.476261],
                            [117.209012, 32.472544],
                            [117.219546, 32.463015],
                            [117.244951, 32.460136],
                            [117.266877, 32.451444],
                            [117.28294, 32.442751],
                            [117.293045, 32.443799],
                            [117.30844, 32.451234],
                            [117.32722, 32.441704],
                            [117.365113, 32.455895],
                            [117.380938, 32.464377],
                            [117.394046, 32.478302],
                            [117.408297, 32.468565],
                            [117.39376, 32.452805],
                            [117.38232, 32.43102],
                            [117.382415, 32.409177],
                            [117.377315, 32.398385],
                            [117.359251, 32.384971],
                            [117.369546, 32.382508],
                            [117.392568, 32.388115],
                            [117.405342, 32.375119],
                            [117.44171, 32.366524],
                            [117.444903, 32.343512],
                            [117.423359, 32.334546],
                            [117.412587, 32.319602],
                            [117.395761, 32.283727],
                            [117.40825, 32.26762],
                            [117.425218, 32.259539],
                            [117.427268, 32.242536],
                            [117.435371, 32.236762],
                            [117.449098, 32.233928],
                            [117.46864, 32.223482],
                            [117.48232, 32.212405],
                            [117.498145, 32.203532],
                            [117.553864, 32.215975],
                            [117.576076, 32.230726],
                            [117.59395, 32.239124],
                            [117.605437, 32.238914],
                            [117.613921, 32.250198],
                            [117.622549, 32.249988],
                            [117.631986, 32.256915],
                            [117.631748, 32.248886],
                            [117.652434, 32.260799],
                            [117.672215, 32.261061],
                            [117.673216, 32.250985],
                            [117.697239, 32.248781],
                            [117.707487, 32.243901],
                            [117.712015, 32.236553],
                            [117.729126, 32.245632],
                            [117.741281, 32.247154],
                            [117.757439, 32.240646],
                            [117.770928, 32.239177],
                            [117.781605, 32.231986],
                            [117.791471, 32.219755],
                            [117.807391, 32.221225],
                            [117.819879, 32.230516],
                            [117.833225, 32.221697],
                            [117.847191, 32.217445],
                            [117.863921, 32.195498],
                            [117.872739, 32.141028],
                            [117.855342, 32.123319],
                            [117.851624, 32.105975],
                            [117.867019, 32.106553],
                            [117.868163, 32.097354],
                            [117.858059, 32.093832],
                            [117.866495, 32.085841],
                            [117.868259, 32.075957],
                            [117.885084, 32.064125],
                            [117.864207, 32.047086],
                            [117.842377, 32.041773],
                            [117.833416, 32.03383],
                            [117.832987, 32.015259],
                            [117.810918, 32.002262],
                            [117.82946, 31.994789],
                            [117.836085, 31.979053],
                            [117.844665, 31.974526],
                            [117.846428, 31.962576],
                            [117.865637, 31.954311],
                            [117.868592, 31.945307],
                            [117.868116, 31.928982],
                            [117.886562, 31.926771],
                            [117.900051, 31.92914],
                            [117.91516, 31.922189],
                            [117.929698, 31.920819],
                            [117.951862, 31.906229],
                            [117.94171, 31.868873],
                            [117.935751, 31.855433],
                            [117.913874, 31.840885],
                            [117.908011, 31.832556],
                            [117.901385, 31.811782],
                            [117.913445, 31.787522],
                            [117.905961, 31.777553],
                            [117.909441, 31.767424],
                            [117.924741, 31.76141],
                            [117.915256, 31.75033],
                            [117.92007, 31.734129],
                            [117.913063, 31.715339],
                            [117.913206, 31.704042],
                            [117.932272, 31.681813],
                            [117.941424, 31.679067],
                            [117.939183, 31.671357],
                            [117.949288, 31.671357],
                            [117.967639, 31.662168],
                            [117.963873, 31.659368],
                            [117.969021, 31.642148],
                            [117.973311, 31.63845],
                            [117.971929, 31.620486],
                            [117.960775, 31.616681],
                            [117.96273, 31.627143],
                            [117.941138, 31.626932],
                            [117.934608, 31.618108],
                            [117.937181, 31.610446],
                            [117.932129, 31.604474],
                            [117.936037, 31.588935],
                            [117.929603, 31.587138],
                            [117.935323, 31.58053],
                            [117.928268, 31.568212],
                            [117.913921, 31.564987],
                            [117.907248, 31.556686],
                            [117.908297, 31.54685],
                            [117.919784, 31.54923],
                            [117.92803, 31.538441],
                            [117.941662, 31.540663],
                            [117.952148, 31.536961],
                            [117.939565, 31.525113],
                            [117.952386, 31.519823],
                            [117.965399, 31.498239],
                            [117.945523, 31.487815],
                            [117.934226, 31.488556],
                            [117.917782, 31.502366],
                            [117.900146, 31.504059],
                            [117.890137, 31.501254],
                            [117.850146, 31.483634],
                            [117.830985, 31.486016],
                            [117.81559, 31.479665],
                            [117.795904, 31.483423],
                            [117.778459, 31.4812],
                            [117.768497, 31.466011],
                            [117.757105, 31.471727],
                            [117.740613, 31.46437],
                            [117.720642, 31.467916],
                            [117.705628, 31.458707],
                            [117.697, 31.431549],
                            [117.692901, 31.407349],
                            [117.677124, 31.391459],
                            [117.656104, 31.34955],
                            [117.647763, 31.32077],
                            [117.633845, 31.297125],
                            [117.6164, 31.294156],
                            [117.602673, 31.275754],
                            [117.57212, 31.271034],
                            [117.575409, 31.255758],
                            [117.573121, 31.248066],
                            [117.561395, 31.233263],
                            [117.555723, 31.215062],
                            [117.540328, 31.205987],
                            [117.525266, 31.200573],
                            [117.532463, 31.19224],
                            [117.555008, 31.177216],
                            [117.558774, 31.159111],
                            [117.552387, 31.145197],
                            [117.530842, 31.137018],
                            [117.527315, 31.118055],
                            [117.517401, 31.114974],
                            [117.512206, 31.10658],
                            [117.524217, 31.095156],
                            [117.528697, 31.079267],
                            [117.524169, 31.066458],
                            [117.51211, 31.047162],
                            [117.494427, 31.046364],
                            [117.485037, 31.041952],
                            [117.483941, 31.035837],
                            [117.493616, 31.029988],
                            [117.507534, 31.003452],
                            [117.494808, 30.996005],
                            [117.45925, 30.988983],
                            [117.44824, 30.982706],
                            [117.441567, 30.967916],
                            [117.412968, 30.97728],
                            [117.385466, 30.964829],
                            [117.383273, 30.951899],
                            [117.371453, 30.950994],
                            [117.365161, 30.959029],
                            [117.369498, 30.963659],
                            [117.356534, 30.987919],
                            [117.348907, 30.992122],
                            [117.337802, 30.987653],
                            [117.324789, 30.989249],
                            [117.314065, 30.999835],
                            [117.306343, 30.999994],
                            [117.298002, 30.985526],
                            [117.28518, 30.98244],
                            [117.277315, 30.984728],
                            [117.247049, 31.011217],
                            [117.229365, 31.022331],
                            [117.225409, 31.03706],
                            [117.212063, 31.057315],
                            [117.190566, 31.0697],
                            [117.178412, 31.083359],
                            [117.17069, 31.085378],
                            [117.156248, 31.072411],
                            [117.13599, 31.073155],
                            [117.117306, 31.08506],
                            [117.122787, 31.101798],
                            [117.117163, 31.12443],
                            [117.121977, 31.129264],
                            [117.12212, 31.148543],
                            [117.109394, 31.169571],
                            [117.100147, 31.190488],
                            [117.079174, 31.221643],
                            [117.071358, 31.236871],
                            [117.055104, 31.235386],
                            [117.042235, 31.252469],
                            [117.032273, 31.256607],
                            [117.045285, 31.269018],
                            [117.045809, 31.282967],
                            [117.063874, 31.289436],
                            [117.070786, 31.301102],
                            [117.070023, 31.321724],
                            [117.073693, 31.335453],
                            [117.081367, 31.345947],
                            [117.074074, 31.360678],
                            [117.074837, 31.374401],
                            [117.094379, 31.408831],
                            [117.11907, 31.446637],
                            [117.142473, 31.472045],
                            [117.149194, 31.483317],
                            [117.166448, 31.490619],
                            [117.184513, 31.492842],
                            [117.237277, 31.490461],
                            [117.250719, 31.49681],
                            [117.251386, 31.502947],
                            [117.242282, 31.508185],
                            [117.228316, 31.544788],
                            [117.220023, 31.540239],
                            [117.198288, 31.551979],
                            [117.187039, 31.552085],
                            [117.153817, 31.545158],
                            [117.144999, 31.554835],
                            [117.13375, 31.551028],
                            [117.132082, 31.542884],
                            [117.124265, 31.54447],
                            [117.112301, 31.540081],
                            [117.065971, 31.553513],
                            [117.055009, 31.544735],
                            [117.039613, 31.538864],
                            [117.003197, 31.549653],
                            [116.990566, 31.545634],
                            [116.987135, 31.533787],
                            [116.975457, 31.540239],
                            [116.966925, 31.539816],
                            [116.95253, 31.532042],
                            [116.934561, 31.537754],
                            [116.902054, 31.528234],
                            [116.879318, 31.531672],
                            [116.845476, 31.526488],
                            [116.829747, 31.519083],
                            [116.815733, 31.531936],
                            [116.806725, 31.532624],
                            [116.804485, 31.539235],
                            [116.792854, 31.543941],
                            [116.789756, 31.550605],
                            [116.767497, 31.571331],
                            [116.763255, 31.58238],
                            [116.766782, 31.589358],
                            [116.765638, 31.618584],
                            [116.754628, 31.636918],
                            [116.75315, 31.647061],
                            [116.757583, 31.659157],
                            [116.767926, 31.672097],
                            [116.763255, 31.685879],
                            [116.762254, 31.711327],
                            [116.752149, 31.728746],
                            [116.759442, 31.7469],
                            [116.758012, 31.762465],
                            [116.752101, 31.765525],
                            [116.731129, 31.76542],
                            [116.734752, 31.77481],
                            [116.728746, 31.782406],
                            [116.719785, 31.779083],
                            [116.714113, 31.791847],
                            [116.694809, 31.809356],
                            [116.692521, 31.820272],
                            [116.702006, 31.832082],
                            [116.732607, 31.848371],
                            [116.740567, 31.857911],
                            [116.724647, 31.85828],
                            [116.721596, 31.87135],
                            [116.714113, 31.878938],
                            [116.716067, 31.884207],
                            [116.764256, 31.904227],
                            [116.771072, 31.911286],
                            [116.790042, 31.922557],
                            [116.810157, 31.921188],
                            [116.831606, 31.935881],
                            [116.841424, 31.94815],
                            [116.859346, 31.960523],
                            [116.865352, 31.96942],
                            [116.879175, 31.974315],
                            [116.921024, 31.980579],
                            [116.937421, 31.989474],
                            [116.929175, 31.998736],
                            [116.923789, 32.013523],
                            [116.940423, 32.027728],
                            [116.957106, 32.022362],
                            [116.96254, 32.013154],
                            [116.971358, 32.016311],
                            [116.985562, 32.013944],
                            [116.996667, 32.006419],
                            [116.996572, 31.993421],
                            [117.020738, 32.001052],
                            [117.029937, 32.006998],
                            [117.040757, 32.024256],
                            [117.046715, 32.041247],
                            [117.047001, 32.051767],
                            [117.030557, 32.064599],
                            [117.02355, 32.074432],
                            [117.020309, 32.095514],
                            [117.010299, 32.115015],
                            [116.997573, 32.117696],
                            [116.985943, 32.128206],
                            [116.978412, 32.152271],
                            [116.983274, 32.161937],
                            [117.007392, 32.16199],
                            [117.019022, 32.168923],
                            [117.024456, 32.177642],
                            [117.025314, 32.190877],
                            [117.004389, 32.202902],
                            [117.003102, 32.212458],
                            [117.013636, 32.2228],
                            [117.047239, 32.225162],
                            [117.059727, 32.23461],
                            [117.072215, 32.266256],
                            [117.067354, 32.280054],
                            [117.05763, 32.284146],
                            [117.046238, 32.276329],
                            [117.038374, 32.281156],
                            [117.035705, 32.29469],
                            [117.047621, 32.320179],
                            [117.057297, 32.32815],
                            [117.052053, 32.33549],
                            [117.043331, 32.332973],
                            [117.037897, 32.342148],
                            [117.043712, 32.347863],
                            [117.045619, 32.381145],
                            [117.042282, 32.38539],
                            [117.017687, 32.383084],
                            [117.00458, 32.386228],
                            [117.009203, 32.404567],
                            [117.026601, 32.413787],
                            [117.039661, 32.415987],
                            [117.048336, 32.430601],
                            [117.047668, 32.438824],
                            [117.06702, 32.461445],
                            [117.070786, 32.469141],
                            [117.068116, 32.482804],
                            [117.074694, 32.491754],
                            [117.079603, 32.511589],
                            [117.07355, 32.51656],
                            [117.084847, 32.530477],
                            [117.09457, 32.531995],
                            [117.110681, 32.527862],
                            [117.115828, 32.521949],
                            [117.127649, 32.524618],
                            [117.139613, 32.520432],
                            [117.150766, 32.526606],
                            [117.157773, 32.535866],
                            [117.167115, 32.534296],
                            [117.2011, 32.534035]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 340200,
                "name": "芜湖市",
                "center": [118.376451, 31.326319],
                "centroid": [118.139967, 31.160841],
                "childrenNum": 7,
                "level": "city",
                "parent": {
                    "adcode": 340000
                },
                "subFeatureIndex": 1,
                "acroutes": [100000, 340000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [118.656866, 31.304654],
                            [118.661442, 31.290762],
                            [118.66006, 31.269761],
                            [118.651861, 31.261009],
                            [118.647286, 31.245519],
                            [118.663587, 31.236871],
                            [118.66821, 31.22488],
                            [118.682986, 31.214054],
                            [118.695045, 31.189108],
                            [118.708963, 31.177004],
                            [118.718401, 31.173978],
                            [118.733558, 31.149446],
                            [118.717305, 31.144188],
                            [118.702004, 31.135797],
                            [118.690327, 31.124961],
                            [118.683082, 31.111893],
                            [118.685513, 31.096272],
                            [118.676838, 31.08963],
                            [118.676123, 31.081393],
                            [118.682653, 31.074909],
                            [118.663396, 31.054445],
                            [118.650003, 31.036848],
                            [118.627314, 31.020576],
                            [118.606819, 31.020204],
                            [118.600956, 31.028021],
                            [118.603768, 31.044238],
                            [118.596142, 31.047853],
                            [118.584273, 31.026107],
                            [118.572262, 31.016269],
                            [118.581223, 30.994728],
                            [118.582462, 30.981855],
                            [118.570975, 30.972278],
                            [118.550956, 30.970682],
                            [118.510251, 30.9511],
                            [118.515255, 30.937582],
                            [118.495713, 30.941042],
                            [118.509154, 30.928694],
                            [118.511537, 30.914054],
                            [118.489707, 30.900052],
                            [118.492948, 30.883491],
                            [118.485846, 30.87726],
                            [118.475742, 30.88184],
                            [118.472119, 30.875077],
                            [118.483987, 30.870762],
                            [118.47741, 30.857553],
                            [118.485513, 30.864051],
                            [118.498239, 30.859843],
                            [118.490041, 30.848656],
                            [118.490899, 30.842849],
                            [118.477982, 30.833579],
                            [118.482224, 30.822549],
                            [118.495522, 30.819884],
                            [118.503101, 30.810451],
                            [118.502863, 30.801497],
                            [118.48475, 30.79025],
                            [118.480699, 30.780602],
                            [118.48027, 30.76642],
                            [118.451671, 30.779162],
                            [118.455198, 30.790144],
                            [118.446476, 30.800911],
                            [118.4317, 30.796434],
                            [118.419498, 30.813649],
                            [118.429841, 30.813916],
                            [118.4368, 30.824733],
                            [118.424502, 30.841091],
                            [118.409536, 30.84871],
                            [118.376409, 30.845513],
                            [118.358916, 30.84578],
                            [118.34762, 30.824414],
                            [118.33823, 30.826812],
                            [118.318687, 30.821749],
                            [118.306724, 30.806934],
                            [118.312872, 30.795101],
                            [118.305008, 30.800964],
                            [118.302577, 30.793822],
                            [118.307582, 30.77639],
                            [118.297906, 30.772391],
                            [118.294569, 30.757088],
                            [118.276647, 30.743169],
                            [118.275694, 30.736449],
                            [118.294712, 30.722421],
                            [118.297191, 30.715966],
                            [118.314445, 30.705083],
                            [118.30496, 30.698146],
                            [118.293282, 30.699961],
                            [118.278745, 30.712659],
                            [118.267591, 30.714206],
                            [118.242901, 30.703482],
                            [118.229221, 30.709244],
                            [118.218354, 30.709458],
                            [118.205437, 30.702148],
                            [118.171214, 30.691637],
                            [118.153578, 30.666554],
                            [118.1368, 30.652195],
                            [118.100956, 30.641251],
                            [118.099574, 30.651341],
                            [118.105723, 30.662978],
                            [118.126075, 30.690783],
                            [118.126695, 30.704549],
                            [118.109727, 30.727809],
                            [118.095952, 30.738849],
                            [118.071357, 30.746849],
                            [118.051671, 30.758635],
                            [118.030461, 30.774097],
                            [117.997477, 30.778949],
                            [117.983702, 30.794035],
                            [117.968783, 30.794941],
                            [117.966781, 30.799099],
                            [117.989612, 30.828836],
                            [117.980413, 30.843808],
                            [117.993473, 30.854623],
                            [118.013397, 30.862347],
                            [118.024217, 30.845673],
                            [118.041566, 30.843276],
                            [118.048144, 30.855156],
                            [118.039612, 30.857553],
                            [118.056914, 30.872254],
                            [118.079412, 30.866608],
                            [118.099097, 30.885515],
                            [118.134369, 30.902075],
                            [118.1572, 30.901383],
                            [118.164779, 30.907186],
                            [118.154579, 30.923211],
                            [118.152911, 30.932207],
                            [118.160346, 30.952697],
                            [118.159059, 30.963925],
                            [118.143807, 30.970682],
                            [118.124836, 30.967862],
                            [118.105198, 30.970948],
                            [118.097572, 30.985579],
                            [118.083654, 30.993824],
                            [118.070975, 31.011376],
                            [118.03251, 31.017173],
                            [118.025933, 31.030414],
                            [118.013778, 31.034508],
                            [118.009679, 31.045407],
                            [118.021881, 31.064704],
                            [118.005818, 31.078204],
                            [117.985513, 31.079745],
                            [117.973311, 31.084316],
                            [117.95863, 31.074643],
                            [117.935466, 31.067681],
                            [117.923788, 31.068318],
                            [117.897954, 31.07831],
                            [117.890423, 31.086016],
                            [117.88027, 31.122039],
                            [117.869879, 31.133141],
                            [117.850718, 31.140205],
                            [117.831938, 31.139143],
                            [117.807391, 31.129742],
                            [117.781319, 31.111468],
                            [117.767496, 31.096113],
                            [117.752339, 31.057688],
                            [117.731414, 31.00994],
                            [117.721023, 31.0101],
                            [117.718306, 31.019087],
                            [117.70763, 31.01127],
                            [117.697525, 31.0101],
                            [117.700432, 31.002494],
                            [117.693759, 30.98893],
                            [117.686181, 30.98526],
                            [117.683082, 30.968767],
                            [117.665828, 30.966639],
                            [117.66721, 30.956049],
                            [117.66049, 30.940031],
                            [117.65129, 30.950409],
                            [117.650671, 30.957646],
                            [117.62641, 30.972119],
                            [117.592568, 30.978131],
                            [117.583512, 30.970735],
                            [117.568926, 30.968607],
                            [117.560966, 30.974194],
                            [117.54905, 30.967596],
                            [117.532892, 30.973662],
                            [117.536943, 30.992015],
                            [117.523168, 30.994569],
                            [117.507534, 31.003452],
                            [117.493616, 31.029988],
                            [117.483941, 31.035837],
                            [117.485037, 31.041952],
                            [117.494427, 31.046364],
                            [117.51211, 31.047162],
                            [117.524169, 31.066458],
                            [117.528697, 31.079267],
                            [117.524217, 31.095156],
                            [117.512206, 31.10658],
                            [117.517401, 31.114974],
                            [117.527315, 31.118055],
                            [117.530842, 31.137018],
                            [117.552387, 31.145197],
                            [117.558774, 31.159111],
                            [117.555008, 31.177216],
                            [117.532463, 31.19224],
                            [117.525266, 31.200573],
                            [117.540328, 31.205987],
                            [117.555723, 31.215062],
                            [117.561395, 31.233263],
                            [117.573121, 31.248066],
                            [117.575409, 31.255758],
                            [117.57212, 31.271034],
                            [117.602673, 31.275754],
                            [117.6164, 31.294156],
                            [117.633845, 31.297125],
                            [117.647763, 31.32077],
                            [117.656104, 31.34955],
                            [117.677124, 31.391459],
                            [117.692901, 31.407349],
                            [117.697, 31.431549],
                            [117.705628, 31.458707],
                            [117.720642, 31.467916],
                            [117.740613, 31.46437],
                            [117.757105, 31.471727],
                            [117.768497, 31.466011],
                            [117.778459, 31.4812],
                            [117.795904, 31.483423],
                            [117.81559, 31.479665],
                            [117.830985, 31.486016],
                            [117.850146, 31.483634],
                            [117.890137, 31.501254],
                            [117.900146, 31.504059],
                            [117.917782, 31.502366],
                            [117.934226, 31.488556],
                            [117.945523, 31.487815],
                            [117.965399, 31.498239],
                            [117.963016, 31.486545],
                            [117.986895, 31.474479],
                            [117.98027, 31.466805],
                            [117.968354, 31.465641],
                            [117.969355, 31.45569],
                            [117.976076, 31.448226],
                            [117.974646, 31.437584],
                            [117.97965, 31.432872],
                            [117.991233, 31.438537],
                            [118.16516, 31.399139],
                            [118.168592, 31.403376],
                            [118.162682, 31.413757],
                            [118.171214, 31.429484],
                            [118.148096, 31.437002],
                            [118.131652, 31.437267],
                            [118.127696, 31.461353],
                            [118.14109, 31.471568],
                            [118.15067, 31.468287],
                            [118.144903, 31.477337],
                            [118.136657, 31.499244],
                            [118.135084, 31.51702],
                            [118.157153, 31.522098],
                            [118.167877, 31.531724],
                            [118.18537, 31.538071],
                            [118.198144, 31.535004],
                            [118.202434, 31.526541],
                            [118.219593, 31.525483],
                            [118.248239, 31.533576],
                            [118.249955, 31.529291],
                            [118.269831, 31.515327],
                            [118.267686, 31.510195],
                            [118.291948, 31.499403],
                            [118.303149, 31.497233],
                            [118.304054, 31.507815],
                            [118.309965, 31.506598],
                            [118.311204, 31.496757],
                            [118.321976, 31.485487],
                            [118.316781, 31.474267],
                            [118.314636, 31.45336],
                            [118.317305, 31.44399],
                            [118.326171, 31.444149],
                            [118.340089, 31.453519],
                            [118.347953, 31.465058],
                            [118.376552, 31.532518],
                            [118.392853, 31.507868],
                            [118.415255, 31.49771],
                            [118.420355, 31.481465],
                            [118.431747, 31.472997],
                            [118.431795, 31.461512],
                            [118.424598, 31.456166],
                            [118.430031, 31.436155],
                            [118.436371, 31.425777],
                            [118.44352, 31.405389],
                            [118.444998, 31.393472],
                            [118.461347, 31.399722],
                            [118.470403, 31.393737],
                            [118.484512, 31.392465],
                            [118.490946, 31.403588],
                            [118.510775, 31.406289],
                            [118.524979, 31.401788],
                            [118.522929, 31.381924],
                            [118.543663, 31.365606],
                            [118.557724, 31.346371],
                            [118.55129, 31.331955],
                            [118.55515, 31.318862],
                            [118.572548, 31.300306],
                            [118.575122, 31.291345],
                            [118.598001, 31.295004],
                            [118.617543, 31.294103],
                            [118.656866, 31.304654]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 340300,
                "name": "蚌埠市",
                "center": [117.363228, 32.939667],
                "centroid": [117.330324, 33.107951],
                "childrenNum": 7,
                "level": "city",
                "parent": {
                    "adcode": 340000
                },
                "subFeatureIndex": 2,
                "acroutes": [100000, 340000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [116.735657, 32.928663],
                            [116.742711, 32.94736],
                            [116.740424, 32.959752],
                            [116.747526, 32.978962],
                            [116.754628, 32.98906],
                            [116.755152, 33.002696],
                            [116.76826, 33.006078],
                            [116.768784, 33.000406],
                            [116.778174, 33.00332],
                            [116.777459, 32.996607],
                            [116.79886, 32.994161],
                            [116.802483, 33.000042],
                            [116.810586, 32.99541],
                            [116.816162, 33.013051],
                            [116.814923, 33.021532],
                            [116.802197, 33.032666],
                            [116.781558, 33.040105],
                            [116.752483, 33.053108],
                            [116.748622, 33.060858],
                            [116.749098, 33.075522],
                            [116.764637, 33.090704],
                            [116.764589, 33.114823],
                            [116.754723, 33.13109],
                            [116.756868, 33.141222],
                            [116.77131, 33.15525],
                            [116.777078, 33.151821],
                            [116.791853, 33.169015],
                            [116.805247, 33.156081],
                            [116.815304, 33.155405],
                            [116.821405, 33.202771],
                            [116.826553, 33.210819],
                            [116.825981, 33.230804],
                            [116.813159, 33.250319],
                            [116.805485, 33.275587],
                            [116.800481, 33.27595],
                            [116.801911, 33.303908],
                            [116.807344, 33.30702],
                            [116.820452, 33.302197],
                            [116.841186, 33.284977],
                            [116.849909, 33.281553],
                            [116.869832, 33.286118],
                            [116.878841, 33.299656],
                            [116.904532, 33.299656],
                            [116.923407, 33.30702],
                            [116.937897, 33.301315],
                            [116.953531, 33.286637],
                            [116.974599, 33.278389],
                            [116.986658, 33.281657],
                            [117.002578, 33.278025],
                            [117.012444, 33.279219],
                            [117.025409, 33.29644],
                            [117.034132, 33.293276],
                            [117.095523, 33.284873],
                            [117.099289, 33.307746],
                            [117.092092, 33.316147],
                            [117.065018, 33.321591],
                            [117.064303, 33.332842],
                            [117.074932, 33.333931],
                            [117.080795, 33.344507],
                            [117.093521, 33.346788],
                            [117.096572, 33.353941],
                            [117.084894, 33.365498],
                            [117.062873, 33.373946],
                            [117.051243, 33.371406],
                            [117.060728, 33.392288],
                            [117.08232, 33.406638],
                            [117.094808, 33.398246],
                            [117.108774, 33.398194],
                            [117.107344, 33.392702],
                            [117.125504, 33.380993],
                            [117.133417, 33.387366],
                            [117.14376, 33.409694],
                            [117.134656, 33.419743],
                            [117.126839, 33.422384],
                            [117.128793, 33.434554],
                            [117.139708, 33.442011],
                            [117.154818, 33.439059],
                            [117.15968, 33.457543],
                            [117.202721, 33.423472],
                            [117.208011, 33.453091],
                            [117.231367, 33.47328],
                            [117.241996, 33.489945],
                            [117.24314, 33.501537],
                            [117.261967, 33.497035],
                            [117.309632, 33.490877],
                            [117.320404, 33.476127],
                            [117.34519, 33.475661],
                            [117.365399, 33.470951],
                            [117.391519, 33.456249],
                            [117.40172, 33.424766],
                            [117.424169, 33.399955],
                            [117.433607, 33.379024],
                            [117.477077, 33.347772],
                            [117.484274, 33.345544],
                            [117.507344, 33.346062],
                            [117.528793, 33.339686],
                            [117.539756, 33.327813],
                            [117.56416, 33.333257],
                            [117.577982, 33.32548],
                            [117.58966, 33.323303],
                            [117.609393, 33.339789],
                            [117.62374, 33.345336],
                            [117.631939, 33.343677],
                            [117.642997, 33.333465],
                            [117.66783, 33.327917],
                            [117.677124, 33.309924],
                            [117.690184, 33.304997],
                            [117.692663, 33.291668],
                            [117.710585, 33.282954],
                            [117.728125, 33.284821],
                            [117.737801, 33.275068],
                            [117.775408, 33.282383],
                            [117.793283, 33.277559],
                            [117.808345, 33.283161],
                            [117.809536, 33.296232],
                            [117.824836, 33.299085],
                            [117.846619, 33.295247],
                            [117.85353, 33.304323],
                            [117.859202, 33.324962],
                            [117.870976, 33.329213],
                            [117.894379, 33.330613],
                            [117.897954, 33.340308],
                            [117.909155, 33.344455],
                            [117.916018, 33.330095],
                            [117.952148, 33.32885],
                            [117.972691, 33.330095],
                            [117.978983, 33.334139],
                            [117.992996, 33.332946],
                            [117.985894, 33.320243],
                            [117.98313, 33.296388],
                            [117.970404, 33.277195],
                            [117.939469, 33.262617],
                            [117.948049, 33.252135],
                            [117.938993, 33.234282],
                            [117.942377, 33.225043],
                            [117.953816, 33.223953],
                            [117.977458, 33.226237],
                            [117.993473, 33.211286],
                            [117.993616, 33.205627],
                            [117.981509, 33.201006],
                            [117.989183, 33.179663],
                            [118.001528, 33.178624],
                            [118.005866, 33.170314],
                            [118.017448, 33.1646],
                            [118.025694, 33.155977],
                            [118.037086, 33.15234],
                            [118.03823, 33.135195],
                            [118.046905, 33.138416],
                            [118.070451, 33.140391],
                            [118.067925, 33.135143],
                            [118.050337, 33.133792],
                            [118.044617, 33.127192],
                            [118.05129, 33.124854],
                            [118.073835, 33.135143],
                            [118.07455, 33.117318],
                            [118.065017, 33.09741],
                            [118.072691, 33.081034],
                            [118.061681, 33.07469],
                            [118.032749, 33.073962],
                            [118.018116, 33.06143],
                            [118.004341, 33.055293],
                            [117.99843, 33.040625],
                            [118.005151, 33.031417],
                            [118.018306, 33.034539],
                            [118.0368, 33.027099],
                            [118.031462, 33.014716],
                            [118.011347, 33.001759],
                            [118.003721, 33.002227],
                            [117.982796, 33.01175],
                            [117.970642, 33.001967],
                            [117.947858, 33.014508],
                            [117.937706, 33.008576],
                            [117.913492, 32.987655],
                            [117.899384, 32.990257],
                            [117.879698, 33.002748],
                            [117.895237, 33.013884],
                            [117.89762, 33.019607],
                            [117.890613, 33.031781],
                            [117.893711, 33.035059],
                            [117.886752, 33.046607],
                            [117.880222, 33.041977],
                            [117.860346, 33.035995],
                            [117.822406, 33.02814],
                            [117.800146, 33.031209],
                            [117.787515, 33.045202],
                            [117.773359, 33.047335],
                            [117.762587, 33.040833],
                            [117.746333, 33.009825],
                            [117.737039, 33.001083],
                            [117.718545, 33.006391],
                            [117.707963, 33.00254],
                            [117.698287, 32.985],
                            [117.694665, 32.96928],
                            [117.679174, 32.943871],
                            [117.671834, 32.918819],
                            [117.657534, 32.910745],
                            [117.64619, 32.912308],
                            [117.626886, 32.924809],
                            [117.603483, 32.922257],
                            [117.589994, 32.933924],
                            [117.576839, 32.941059],
                            [117.56864, 32.951369],
                            [117.548526, 32.969592],
                            [117.531224, 32.980576],
                            [117.528173, 32.967041],
                            [117.528602, 32.938976],
                            [117.512396, 32.93283],
                            [117.505151, 32.908557],
                            [117.49967, 32.897408],
                            [117.512253, 32.886153],
                            [117.513588, 32.875261],
                            [117.508249, 32.868747],
                            [117.491281, 32.864681],
                            [117.479222, 32.842944],
                            [117.471167, 32.837157],
                            [117.457773, 32.841484],
                            [117.432272, 32.842266],
                            [117.422168, 32.846593],
                            [117.415113, 32.831995],
                            [117.395857, 32.836427],
                            [117.368354, 32.837783],
                            [117.361729, 32.840129],
                            [117.350814, 32.829232],
                            [117.325218, 32.825894],
                            [117.314017, 32.828241],
                            [117.307678, 32.818959],
                            [117.284942, 32.817447],
                            [117.280366, 32.808842],
                            [117.265542, 32.800862],
                            [117.255819, 32.80566],
                            [117.244665, 32.794602],
                            [117.231796, 32.77217],
                            [117.214112, 32.752027],
                            [117.202673, 32.745399],
                            [117.195905, 32.734699],
                            [117.182034, 32.735952],
                            [117.179365, 32.74112],
                            [117.160395, 32.739919],
                            [117.15906, 32.749888],
                            [117.146143, 32.751349],
                            [117.125266, 32.75782],
                            [117.084561, 32.744095],
                            [117.081701, 32.735117],
                            [117.0909, 32.727757],
                            [117.074837, 32.717525],
                            [117.066448, 32.723946],
                            [117.046334, 32.716167],
                            [117.04376, 32.721388],
                            [117.054437, 32.729688],
                            [117.04009, 32.732873],
                            [117.033607, 32.747435],
                            [117.028698, 32.747696],
                            [117.029318, 32.758081],
                            [117.018736, 32.757403],
                            [117.001958, 32.779161],
                            [116.991901, 32.783752],
                            [116.960919, 32.791786],
                            [116.935037, 32.808737],
                            [116.921072, 32.80952],
                            [116.923312, 32.816508],
                            [116.897239, 32.834289],
                            [116.898336, 32.842996],
                            [116.889232, 32.847271],
                            [116.882225, 32.8443],
                            [116.834179, 32.877607],
                            [116.840614, 32.88657],
                            [116.836467, 32.890843],
                            [116.817831, 32.894021],
                            [116.804866, 32.902566],
                            [116.790996, 32.905014],
                            [116.78499, 32.917204],
                            [116.768403, 32.921476],
                            [116.761301, 32.916371],
                            [116.757869, 32.923767],
                            [116.735657, 32.928663]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 340400,
                "name": "淮南市",
                "center": [117.018329, 32.647574],
                "centroid": [116.773319, 32.471683],
                "childrenNum": 7,
                "level": "city",
                "parent": {
                    "adcode": 340000
                },
                "subFeatureIndex": 3,
                "acroutes": [100000, 340000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [116.771072, 31.911286],
                            [116.748479, 31.919028],
                            [116.723169, 31.916711],
                            [116.70234, 31.905122],
                            [116.687754, 31.903437],
                            [116.680509, 31.915552],
                            [116.680462, 31.957259],
                            [116.681939, 31.967999],
                            [116.677936, 31.976263],
                            [116.667735, 31.977947],
                            [116.612635, 32.000947],
                            [116.586801, 32.018784],
                            [116.571167, 32.020468],
                            [116.546858, 32.028149],
                            [116.551911, 32.042036],
                            [116.544046, 32.067701],
                            [116.549385, 32.078848],
                            [116.533131, 32.097932],
                            [116.524694, 32.116434],
                            [116.530224, 32.134249],
                            [116.526601, 32.151746],
                            [116.515495, 32.163461],
                            [116.509299, 32.18468],
                            [116.517068, 32.194395],
                            [116.515638, 32.202692],
                            [116.501101, 32.215345],
                            [116.515305, 32.223377],
                            [116.527554, 32.240594],
                            [116.521835, 32.261113],
                            [116.52641, 32.270716],
                            [116.521501, 32.292539],
                            [116.519261, 32.314411],
                            [116.509537, 32.324479],
                            [116.501911, 32.343879],
                            [116.48418, 32.360286],
                            [116.481129, 32.375276],
                            [116.485371, 32.388062],
                            [116.492187, 32.395817],
                            [116.480176, 32.406767],
                            [116.484799, 32.439347],
                            [116.490471, 32.448407],
                            [116.494714, 32.465319],
                            [116.509966, 32.460607],
                            [116.522597, 32.486468],
                            [116.523741, 32.509234],
                            [116.566591, 32.544183],
                            [116.613827, 32.544811],
                            [116.635085, 32.55386],
                            [116.628984, 32.575197],
                            [116.620119, 32.583354],
                            [116.601863, 32.588949],
                            [116.554771, 32.585864],
                            [116.555867, 32.600032],
                            [116.540138, 32.60296],
                            [116.537898, 32.615452],
                            [116.541711, 32.622874],
                            [116.535276, 32.628466],
                            [116.526267, 32.657779],
                            [116.506439, 32.662899],
                            [116.502197, 32.681024],
                            [116.489327, 32.681807],
                            [116.487135, 32.677942],
                            [116.460252, 32.680972],
                            [116.44519, 32.697997],
                            [116.444142, 32.70656],
                            [116.45315, 32.71481],
                            [116.45539, 32.729845],
                            [116.445238, 32.732977],
                            [116.442998, 32.748583],
                            [116.44743, 32.760951],
                            [116.448765, 32.789073],
                            [116.441377, 32.800184],
                            [116.442473, 32.809207],
                            [116.449194, 32.8139],
                            [116.439614, 32.821619],
                            [116.445572, 32.843518],
                            [116.421882, 32.857853],
                            [116.406058, 32.85337],
                            [116.389995, 32.857071],
                            [116.386563, 32.86833],
                            [116.394428, 32.884121],
                            [116.394618, 32.891311],
                            [116.393856, 32.910745],
                            [116.385705, 32.921632],
                            [116.365877, 32.940694],
                            [116.365162, 32.946891],
                            [116.371739, 32.964906],
                            [116.376458, 32.969019],
                            [116.376649, 32.993744],
                            [116.382416, 33.004777],
                            [116.446382, 32.984896],
                            [116.627888, 32.941475],
                            [116.684323, 32.93934],
                            [116.705676, 32.936944],
                            [116.735657, 32.928663],
                            [116.757869, 32.923767],
                            [116.761301, 32.916371],
                            [116.768403, 32.921476],
                            [116.78499, 32.917204],
                            [116.790996, 32.905014],
                            [116.804866, 32.902566],
                            [116.817831, 32.894021],
                            [116.836467, 32.890843],
                            [116.840614, 32.88657],
                            [116.834179, 32.877607],
                            [116.882225, 32.8443],
                            [116.889232, 32.847271],
                            [116.898336, 32.842996],
                            [116.897239, 32.834289],
                            [116.923312, 32.816508],
                            [116.921072, 32.80952],
                            [116.935037, 32.808737],
                            [116.960919, 32.791786],
                            [116.991901, 32.783752],
                            [117.001958, 32.779161],
                            [117.018736, 32.757403],
                            [117.029318, 32.758081],
                            [117.028698, 32.747696],
                            [117.033607, 32.747435],
                            [117.04009, 32.732873],
                            [117.054437, 32.729688],
                            [117.04376, 32.721388],
                            [117.046334, 32.716167],
                            [117.066448, 32.723946],
                            [117.074837, 32.717525],
                            [117.0909, 32.727757],
                            [117.081701, 32.735117],
                            [117.084561, 32.744095],
                            [117.125266, 32.75782],
                            [117.146143, 32.751349],
                            [117.15906, 32.749888],
                            [117.160395, 32.739919],
                            [117.179365, 32.74112],
                            [117.182034, 32.735952],
                            [117.195905, 32.734699],
                            [117.205152, 32.728279],
                            [117.189804, 32.716846],
                            [117.184322, 32.696691],
                            [117.162349, 32.686874],
                            [117.1613, 32.679562],
                            [117.172406, 32.664675],
                            [117.17498, 32.653495],
                            [117.195952, 32.60871],
                            [117.199146, 32.579851],
                            [117.214637, 32.560345],
                            [117.211396, 32.54659],
                            [117.203245, 32.542457],
                            [117.2011, 32.534035],
                            [117.167115, 32.534296],
                            [117.157773, 32.535866],
                            [117.150766, 32.526606],
                            [117.139613, 32.520432],
                            [117.127649, 32.524618],
                            [117.115828, 32.521949],
                            [117.110681, 32.527862],
                            [117.09457, 32.531995],
                            [117.084847, 32.530477],
                            [117.07355, 32.51656],
                            [117.079603, 32.511589],
                            [117.074694, 32.491754],
                            [117.068116, 32.482804],
                            [117.070786, 32.469141],
                            [117.06702, 32.461445],
                            [117.047668, 32.438824],
                            [117.048336, 32.430601],
                            [117.039661, 32.415987],
                            [117.026601, 32.413787],
                            [117.009203, 32.404567],
                            [117.00458, 32.386228],
                            [117.017687, 32.383084],
                            [117.042282, 32.38539],
                            [117.045619, 32.381145],
                            [117.043712, 32.347863],
                            [117.037897, 32.342148],
                            [117.043331, 32.332973],
                            [117.052053, 32.33549],
                            [117.057297, 32.32815],
                            [117.047621, 32.320179],
                            [117.035705, 32.29469],
                            [117.038374, 32.281156],
                            [117.046238, 32.276329],
                            [117.05763, 32.284146],
                            [117.067354, 32.280054],
                            [117.072215, 32.266256],
                            [117.059727, 32.23461],
                            [117.047239, 32.225162],
                            [117.013636, 32.2228],
                            [117.003102, 32.212458],
                            [117.004389, 32.202902],
                            [117.025314, 32.190877],
                            [117.024456, 32.177642],
                            [117.019022, 32.168923],
                            [117.007392, 32.16199],
                            [116.983274, 32.161937],
                            [116.978412, 32.152271],
                            [116.985943, 32.128206],
                            [116.997573, 32.117696],
                            [117.010299, 32.115015],
                            [117.020309, 32.095514],
                            [117.02355, 32.074432],
                            [117.030557, 32.064599],
                            [117.047001, 32.051767],
                            [117.046715, 32.041247],
                            [117.040757, 32.024256],
                            [117.029937, 32.006998],
                            [117.020738, 32.001052],
                            [116.996572, 31.993421],
                            [116.996667, 32.006419],
                            [116.985562, 32.013944],
                            [116.971358, 32.016311],
                            [116.96254, 32.013154],
                            [116.957106, 32.022362],
                            [116.940423, 32.027728],
                            [116.923789, 32.013523],
                            [116.929175, 31.998736],
                            [116.937421, 31.989474],
                            [116.921024, 31.980579],
                            [116.879175, 31.974315],
                            [116.865352, 31.96942],
                            [116.859346, 31.960523],
                            [116.841424, 31.94815],
                            [116.831606, 31.935881],
                            [116.810157, 31.921188],
                            [116.790042, 31.922557],
                            [116.771072, 31.911286]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 340500,
                "name": "马鞍山市",
                "center": [118.507906, 31.689362],
                "centroid": [118.369656, 31.637161],
                "childrenNum": 6,
                "level": "city",
                "parent": {
                    "adcode": 340000
                },
                "subFeatureIndex": 4,
                "acroutes": [100000, 340000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [117.951862, 31.906229],
                            [117.96435, 31.90154],
                            [117.988373, 31.881836],
                            [118.044808, 31.859545],
                            [118.061776, 31.858543],
                            [118.072834, 31.850901],
                            [118.083988, 31.8538],
                            [118.085942, 31.877462],
                            [118.109107, 31.891425],
                            [118.120832, 31.906123],
                            [118.132034, 31.903331],
                            [118.147763, 31.907967],
                            [118.171118, 31.900118],
                            [118.181843, 31.907651],
                            [118.187277, 31.919186],
                            [118.203959, 31.927719],
                            [118.219736, 31.925296],
                            [118.239421, 31.944096],
                            [118.256724, 31.954469],
                            [118.290136, 31.979895],
                            [118.304865, 31.985527],
                            [118.305341, 31.998],
                            [118.31721, 32.019836],
                            [118.334464, 32.031253],
                            [118.348716, 32.035461],
                            [118.358344, 32.045297],
                            [118.385084, 32.05813],
                            [118.394378, 32.0484],
                            [118.385989, 32.033146],
                            [118.401528, 32.018679],
                            [118.38966, 32.012049],
                            [118.390994, 31.989527],
                            [118.387181, 31.983264],
                            [118.376695, 31.981737],
                            [118.379221, 31.967262],
                            [118.369021, 31.956153],
                            [118.369498, 31.944201],
                            [118.36435, 31.930141],
                            [118.375313, 31.925349],
                            [118.386037, 31.914815],
                            [118.402958, 31.914025],
                            [118.415923, 31.901435],
                            [118.440136, 31.892689],
                            [118.452291, 31.884628],
                            [118.47231, 31.879623],
                            [118.467114, 31.868873],
                            [118.466781, 31.858016],
                            [118.475456, 31.850321],
                            [118.490613, 31.843152],
                            [118.504721, 31.841729],
                            [118.486132, 31.795434],
                            [118.482176, 31.778344],
                            [118.503196, 31.778028],
                            [118.510775, 31.765631],
                            [118.523597, 31.76199],
                            [118.533844, 31.767266],
                            [118.539659, 31.761568],
                            [118.538706, 31.74938],
                            [118.522119, 31.743047],
                            [118.530031, 31.742309],
                            [118.545093, 31.732071],
                            [118.550003, 31.735976],
                            [118.5572, 31.729643],
                            [118.57169, 31.746214],
                            [118.575312, 31.740937],
                            [118.593091, 31.74442],
                            [118.600718, 31.75397],
                            [118.609345, 31.757189],
                            [118.619021, 31.750066],
                            [118.627076, 31.759458],
                            [118.641661, 31.758244],
                            [118.648382, 31.748799],
                            [118.64209, 31.744314],
                            [118.6521, 31.739776],
                            [118.653959, 31.730118],
                            [118.677267, 31.728587],
                            [118.684893, 31.724893],
                            [118.687324, 31.716183],
                            [118.697715, 31.709426],
                            [118.680746, 31.696598],
                            [118.673406, 31.696334],
                            [118.671404, 31.688467],
                            [118.654912, 31.675635],
                            [118.647, 31.679859],
                            [118.643234, 31.671357],
                            [118.647953, 31.659368],
                            [118.643616, 31.650019],
                            [118.657867, 31.641091],
                            [118.673835, 31.640563],
                            [118.684798, 31.636231],
                            [118.694998, 31.639718],
                            [118.716923, 31.639454],
                            [118.719402, 31.62746],
                            [118.728649, 31.634276],
                            [118.734226, 31.632216],
                            [118.745141, 31.656516],
                            [118.744378, 31.668347],
                            [118.751146, 31.677694],
                            [118.768306, 31.677483],
                            [118.774121, 31.682605],
                            [118.799049, 31.666393],
                            [118.783082, 31.656516],
                            [118.789564, 31.646532],
                            [118.796046, 31.628306],
                            [118.802767, 31.619482],
                            [118.81454, 31.619218],
                            [118.819545, 31.628517],
                            [118.833844, 31.630314],
                            [118.858534, 31.623973],
                            [118.868735, 31.611397],
                            [118.870784, 31.599347],
                            [118.865303, 31.591789],
                            [118.877314, 31.589675],
                            [118.873358, 31.573922],
                            [118.881985, 31.564775],
                            [118.875122, 31.551979],
                            [118.873739, 31.531936],
                            [118.883939, 31.53146],
                            [118.885846, 31.518871],
                            [118.868163, 31.520511],
                            [118.870498, 31.526012],
                            [118.857819, 31.523791],
                            [118.846237, 31.509137],
                            [118.846714, 31.503053],
                            [118.856771, 31.506492],
                            [118.883701, 31.500143],
                            [118.877791, 31.478766],
                            [118.870498, 31.463047],
                            [118.866065, 31.44489],
                            [118.86964, 31.421594],
                            [118.851146, 31.392518],
                            [118.847381, 31.393948],
                            [118.829507, 31.377527],
                            [118.800241, 31.368997],
                            [118.784559, 31.368573],
                            [118.771261, 31.363116],
                            [118.7674, 31.365871],
                            [118.770355, 31.379328],
                            [118.765398, 31.387963],
                            [118.754626, 31.385049],
                            [118.74576, 31.372706],
                            [118.735036, 31.344781],
                            [118.72107, 31.322679],
                            [118.714731, 31.321671],
                            [118.704102, 31.307782],
                            [118.692186, 31.309001],
                            [118.681747, 31.304336],
                            [118.656866, 31.304654],
                            [118.617543, 31.294103],
                            [118.598001, 31.295004],
                            [118.575122, 31.291345],
                            [118.572548, 31.300306],
                            [118.55515, 31.318862],
                            [118.55129, 31.331955],
                            [118.557724, 31.346371],
                            [118.543663, 31.365606],
                            [118.522929, 31.381924],
                            [118.524979, 31.401788],
                            [118.510775, 31.406289],
                            [118.490946, 31.403588],
                            [118.484512, 31.392465],
                            [118.470403, 31.393737],
                            [118.461347, 31.399722],
                            [118.444998, 31.393472],
                            [118.44352, 31.405389],
                            [118.436371, 31.425777],
                            [118.430031, 31.436155],
                            [118.424598, 31.456166],
                            [118.431795, 31.461512],
                            [118.431747, 31.472997],
                            [118.420355, 31.481465],
                            [118.415255, 31.49771],
                            [118.392853, 31.507868],
                            [118.376552, 31.532518],
                            [118.347953, 31.465058],
                            [118.340089, 31.453519],
                            [118.326171, 31.444149],
                            [118.317305, 31.44399],
                            [118.314636, 31.45336],
                            [118.316781, 31.474267],
                            [118.321976, 31.485487],
                            [118.311204, 31.496757],
                            [118.309965, 31.506598],
                            [118.304054, 31.507815],
                            [118.303149, 31.497233],
                            [118.291948, 31.499403],
                            [118.267686, 31.510195],
                            [118.269831, 31.515327],
                            [118.249955, 31.529291],
                            [118.248239, 31.533576],
                            [118.219593, 31.525483],
                            [118.202434, 31.526541],
                            [118.198144, 31.535004],
                            [118.18537, 31.538071],
                            [118.167877, 31.531724],
                            [118.157153, 31.522098],
                            [118.135084, 31.51702],
                            [118.136657, 31.499244],
                            [118.144903, 31.477337],
                            [118.15067, 31.468287],
                            [118.14109, 31.471568],
                            [118.127696, 31.461353],
                            [118.131652, 31.437267],
                            [118.148096, 31.437002],
                            [118.171214, 31.429484],
                            [118.162682, 31.413757],
                            [118.168592, 31.403376],
                            [118.16516, 31.399139],
                            [117.991233, 31.438537],
                            [117.97965, 31.432872],
                            [117.974646, 31.437584],
                            [117.976076, 31.448226],
                            [117.969355, 31.45569],
                            [117.968354, 31.465641],
                            [117.98027, 31.466805],
                            [117.986895, 31.474479],
                            [117.963016, 31.486545],
                            [117.965399, 31.498239],
                            [117.952386, 31.519823],
                            [117.939565, 31.525113],
                            [117.952148, 31.536961],
                            [117.941662, 31.540663],
                            [117.92803, 31.538441],
                            [117.919784, 31.54923],
                            [117.908297, 31.54685],
                            [117.907248, 31.556686],
                            [117.913921, 31.564987],
                            [117.928268, 31.568212],
                            [117.935323, 31.58053],
                            [117.929603, 31.587138],
                            [117.936037, 31.588935],
                            [117.932129, 31.604474],
                            [117.937181, 31.610446],
                            [117.934608, 31.618108],
                            [117.941138, 31.626932],
                            [117.96273, 31.627143],
                            [117.960775, 31.616681],
                            [117.971929, 31.620486],
                            [117.973311, 31.63845],
                            [117.969021, 31.642148],
                            [117.963873, 31.659368],
                            [117.967639, 31.662168],
                            [117.949288, 31.671357],
                            [117.939183, 31.671357],
                            [117.941424, 31.679067],
                            [117.932272, 31.681813],
                            [117.913206, 31.704042],
                            [117.913063, 31.715339],
                            [117.92007, 31.734129],
                            [117.915256, 31.75033],
                            [117.924741, 31.76141],
                            [117.909441, 31.767424],
                            [117.905961, 31.777553],
                            [117.913445, 31.787522],
                            [117.901385, 31.811782],
                            [117.908011, 31.832556],
                            [117.913874, 31.840885],
                            [117.935751, 31.855433],
                            [117.94171, 31.868873],
                            [117.951862, 31.906229]
                        ]
                    ],
                    [
                        [
                            [118.885846, 31.518871],
                            [118.883701, 31.500143],
                            [118.856771, 31.506492],
                            [118.868163, 31.520511],
                            [118.885846, 31.518871]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 340600,
                "name": "淮北市",
                "center": [116.794664, 33.971707],
                "centroid": [116.74441, 33.720047],
                "childrenNum": 4,
                "level": "city",
                "parent": {
                    "adcode": 340000
                },
                "subFeatureIndex": 5,
                "acroutes": [100000, 340000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [116.393713, 33.783082],
                            [116.40825, 33.805514],
                            [116.420929, 33.796696],
                            [116.432607, 33.795304],
                            [116.436944, 33.80309],
                            [116.432988, 33.814846],
                            [116.437326, 33.846547],
                            [116.453007, 33.846959],
                            [116.460157, 33.859946],
                            [116.47398, 33.861337],
                            [116.484895, 33.869787],
                            [116.501911, 33.864686],
                            [116.505295, 33.872363],
                            [116.521215, 33.871075],
                            [116.525219, 33.880503],
                            [116.536897, 33.882255],
                            [116.53928, 33.874218],
                            [116.546668, 33.882512],
                            [116.558393, 33.881482],
                            [116.555104, 33.888282],
                            [116.558346, 33.901674],
                            [116.567068, 33.908214],
                            [116.581606, 33.908317],
                            [116.597097, 33.904146],
                            [116.611825, 33.894617],
                            [116.627316, 33.888591],
                            [116.642712, 33.892454],
                            [116.638517, 33.917175],
                            [116.645762, 33.929893],
                            [116.639995, 33.948889],
                            [116.650338, 33.959081],
                            [116.64805, 33.973336],
                            [116.633512, 33.977093],
                            [116.629937, 33.984039],
                            [116.607249, 33.999886],
                            [116.60315, 34.007911],
                            [116.604199, 34.021335],
                            [116.626887, 34.017581],
                            [116.648765, 34.021438],
                            [116.662445, 34.018198],
                            [116.678984, 34.010174],
                            [116.689899, 34.016141],
                            [116.703913, 34.009454],
                            [116.711158, 34.014186],
                            [116.730652, 34.016192],
                            [116.734275, 34.012077],
                            [116.745762, 34.017015],
                            [116.752435, 34.013003],
                            [116.784418, 34.011357],
                            [116.784084, 34.007293],
                            [116.796239, 34.003384],
                            [116.803055, 33.993712],
                            [116.807678, 34.012386],
                            [116.801911, 34.032392],
                            [116.808345, 34.063961],
                            [116.811682, 34.067919],
                            [116.806248, 34.077017],
                            [116.818689, 34.086114],
                            [116.816639, 34.072854],
                            [116.828555, 34.058923],
                            [116.833512, 34.066223],
                            [116.845905, 34.06977],
                            [116.850719, 34.082516],
                            [116.874122, 34.073984],
                            [116.888898, 34.082722],
                            [116.902435, 34.098241],
                            [116.908965, 34.098961],
                            [116.92865, 34.091201],
                            [116.929556, 34.080615],
                            [116.955628, 34.077788],
                            [116.973074, 34.07897],
                            [116.961634, 34.064218],
                            [116.94805, 34.05224],
                            [116.950195, 34.037072],
                            [116.947668, 34.031004],
                            [116.967163, 34.028895],
                            [116.971596, 34.025604],
                            [116.969451, 34.013672],
                            [116.978603, 34.007191],
                            [116.974027, 33.998703],
                            [116.977459, 33.993609],
                            [116.95763, 33.967676],
                            [116.970929, 33.961809],
                            [116.98375, 33.964948],
                            [116.991281, 33.961757],
                            [116.991234, 33.952801],
                            [116.99948, 33.938336],
                            [116.990471, 33.92495],
                            [116.997096, 33.914188],
                            [116.986038, 33.899047],
                            [116.962826, 33.892918],
                            [116.959108, 33.880245],
                            [116.958155, 33.847732],
                            [116.951386, 33.832476],
                            [116.949575, 33.808814],
                            [116.95029, 33.790096],
                            [116.942235, 33.773746],
                            [116.943951, 33.756465],
                            [116.950767, 33.746146],
                            [116.93437, 33.748158],
                            [116.932082, 33.739335],
                            [116.939279, 33.705116],
                            [116.928221, 33.702948],
                            [116.929365, 33.673156],
                            [116.917116, 33.674137],
                            [116.906343, 33.670884],
                            [116.880795, 33.676874],
                            [116.873693, 33.675945],
                            [116.869594, 33.661949],
                            [116.871787, 33.650483],
                            [116.867926, 33.637361],
                            [116.859728, 33.62429],
                            [116.865209, 33.603878],
                            [116.873741, 33.589612],
                            [116.899527, 33.572035],
                            [116.915209, 33.578291],
                            [116.937039, 33.580307],
                            [116.928269, 33.554403],
                            [116.927888, 33.543905],
                            [116.915257, 33.53894],
                            [116.90458, 33.505987],
                            [116.919594, 33.492895],
                            [116.905771, 33.482338],
                            [116.904961, 33.47711],
                            [116.928793, 33.470795],
                            [116.929461, 33.462151],
                            [116.940042, 33.453608],
                            [116.958822, 33.452314],
                            [116.966734, 33.443305],
                            [116.96621, 33.433052],
                            [116.971358, 33.42834],
                            [116.965209, 33.419069],
                            [116.969403, 33.412336],
                            [116.964351, 33.399334],
                            [116.973455, 33.391977],
                            [116.958298, 33.379957],
                            [116.957249, 33.374464],
                            [116.942902, 33.377417],
                            [116.932749, 33.360212],
                            [116.928174, 33.358813],
                            [116.924218, 33.34658],
                            [116.913922, 33.344559],
                            [116.921119, 33.334346],
                            [116.918355, 33.328539],
                            [116.927268, 33.324703],
                            [116.929413, 33.317132],
                            [116.923407, 33.30702],
                            [116.904532, 33.299656],
                            [116.878841, 33.299656],
                            [116.869832, 33.286118],
                            [116.849909, 33.281553],
                            [116.841186, 33.284977],
                            [116.820452, 33.302197],
                            [116.807344, 33.30702],
                            [116.801911, 33.303908],
                            [116.789089, 33.319777],
                            [116.790424, 33.334553],
                            [116.787421, 33.347254],
                            [116.794141, 33.354822],
                            [116.790948, 33.360005],
                            [116.800862, 33.386122],
                            [116.796572, 33.403012],
                            [116.804628, 33.422902],
                            [116.7705, 33.431861],
                            [116.756725, 33.438438],
                            [116.745905, 33.449104],
                            [116.722597, 33.450709],
                            [116.700004, 33.474056],
                            [116.687182, 33.47799],
                            [116.665733, 33.474626],
                            [116.642378, 33.477628],
                            [116.63642, 33.484977],
                            [116.623503, 33.485495],
                            [116.612778, 33.481872],
                            [116.593617, 33.480112],
                            [116.58213, 33.471209],
                            [116.56826, 33.466292],
                            [116.547478, 33.467897],
                            [116.535562, 33.481302],
                            [116.533989, 33.498018],
                            [116.539089, 33.513178],
                            [116.534656, 33.525077],
                            [116.524742, 33.53056],
                            [116.52846, 33.544008],
                            [116.525505, 33.551455],
                            [116.531939, 33.565624],
                            [116.548002, 33.57007],
                            [116.540662, 33.587596],
                            [116.55153, 33.588578],
                            [116.551101, 33.596642],
                            [116.543808, 33.59783],
                            [116.533751, 33.614575],
                            [116.505486, 33.618968],
                            [116.503817, 33.631265],
                            [116.481129, 33.654253],
                            [116.485848, 33.666081],
                            [116.49214, 33.668405],
                            [116.492426, 33.681315],
                            [116.484227, 33.697889],
                            [116.478603, 33.697992],
                            [116.479413, 33.708678],
                            [116.463589, 33.719724],
                            [116.460014, 33.734123],
                            [116.433226, 33.739696],
                            [116.435753, 33.762191],
                            [116.406439, 33.762552],
                            [116.408155, 33.770393],
                            [116.393713, 33.783082]
                        ]
                    ],
                    [
                        [
                            [117.031558, 34.166709],
                            [117.031748, 34.155721],
                            [117.023312, 34.161678],
                            [117.012921, 34.149508],
                            [117.004913, 34.151408],
                            [117.001768, 34.142318],
                            [116.982177, 34.137285],
                            [116.971501, 34.154643],
                            [116.975457, 34.169071],
                            [116.982416, 34.167274],
                            [116.980176, 34.155978],
                            [116.993522, 34.168352],
                            [116.982416, 34.172357],
                            [116.980271, 34.195867],
                            [116.99538, 34.206337],
                            [116.988803, 34.205208],
                            [116.994666, 34.222808],
                            [117.007821, 34.232967],
                            [117.009584, 34.219679],
                            [117.021691, 34.213675],
                            [117.030175, 34.221372],
                            [117.035085, 34.23189],
                            [117.031081, 34.242765],
                            [117.042092, 34.248664],
                            [117.049575, 34.242406],
                            [117.044904, 34.224758],
                            [117.051005, 34.221577],
                            [117.047239, 34.205772],
                            [117.040328, 34.201513],
                            [117.030795, 34.18632],
                            [117.025314, 34.167633],
                            [117.031558, 34.166709]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 340700,
                "name": "铜陵市",
                "center": [117.816576, 30.929935],
                "centroid": [117.566997, 30.888236],
                "childrenNum": 4,
                "level": "city",
                "parent": {
                    "adcode": 340000
                },
                "subFeatureIndex": 6,
                "acroutes": [100000, 340000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [117.980413, 30.843808],
                            [117.953626, 30.817593],
                            [117.94333, 30.833099],
                            [117.934608, 30.835763],
                            [117.915828, 30.819564],
                            [117.903197, 30.814022],
                            [117.884036, 30.812317],
                            [117.872787, 30.807893],
                            [117.846333, 30.788438],
                            [117.842282, 30.773617],
                            [117.815733, 30.759914],
                            [117.803101, 30.757462],
                            [117.796238, 30.748449],
                            [117.78375, 30.749729],
                            [117.781938, 30.764127],
                            [117.758202, 30.761674],
                            [117.759918, 30.769832],
                            [117.748478, 30.778522],
                            [117.755961, 30.792223],
                            [117.751529, 30.802936],
                            [117.742568, 30.8072],
                            [117.72088, 30.791103],
                            [117.698526, 30.789931],
                            [117.701815, 30.806614],
                            [117.670594, 30.781508],
                            [117.645523, 30.776603],
                            [117.576934, 30.756662],
                            [117.507249, 30.726688],
                            [117.493616, 30.696706],
                            [117.485418, 30.686514],
                            [117.470404, 30.678989],
                            [117.4511, 30.679043],
                            [117.422358, 30.682885],
                            [117.399384, 30.690676],
                            [117.394379, 30.694998],
                            [117.366829, 30.694251],
                            [117.343426, 30.688969],
                            [117.309489, 30.676801],
                            [117.272644, 30.656626],
                            [117.217068, 30.630626],
                            [117.211872, 30.635111],
                            [117.205485, 30.654384],
                            [117.207296, 30.669543],
                            [117.212968, 30.678616],
                            [117.223979, 30.686514],
                            [117.241376, 30.690356],
                            [117.205009, 30.69201],
                            [117.200337, 30.701881],
                            [117.190566, 30.698467],
                            [117.187277, 30.70663],
                            [117.178078, 30.702148],
                            [117.162969, 30.708604],
                            [117.124694, 30.740343],
                            [117.117211, 30.755968],
                            [117.101005, 30.767379],
                            [117.105009, 30.790677],
                            [117.106248, 30.827558],
                            [117.096477, 30.885728],
                            [117.086419, 30.92864],
                            [117.080366, 30.961743],
                            [117.082654, 30.974885],
                            [117.095142, 30.988558],
                            [117.093903, 31.0101],
                            [117.111348, 31.01345],
                            [117.124599, 31.006749],
                            [117.134799, 31.007281],
                            [117.141186, 31.014514],
                            [117.137611, 31.028925],
                            [117.14395, 31.039293],
                            [117.144141, 31.054179],
                            [117.149908, 31.058272],
                            [117.156248, 31.072411],
                            [117.17069, 31.085378],
                            [117.178412, 31.083359],
                            [117.190566, 31.0697],
                            [117.212063, 31.057315],
                            [117.225409, 31.03706],
                            [117.229365, 31.022331],
                            [117.247049, 31.011217],
                            [117.277315, 30.984728],
                            [117.28518, 30.98244],
                            [117.298002, 30.985526],
                            [117.306343, 30.999994],
                            [117.314065, 30.999835],
                            [117.324789, 30.989249],
                            [117.337802, 30.987653],
                            [117.348907, 30.992122],
                            [117.356534, 30.987919],
                            [117.369498, 30.963659],
                            [117.365161, 30.959029],
                            [117.371453, 30.950994],
                            [117.383273, 30.951899],
                            [117.385466, 30.964829],
                            [117.412968, 30.97728],
                            [117.441567, 30.967916],
                            [117.44824, 30.982706],
                            [117.45925, 30.988983],
                            [117.494808, 30.996005],
                            [117.507534, 31.003452],
                            [117.523168, 30.994569],
                            [117.536943, 30.992015],
                            [117.532892, 30.973662],
                            [117.54905, 30.967596],
                            [117.560966, 30.974194],
                            [117.568926, 30.968607],
                            [117.583512, 30.970735],
                            [117.592568, 30.978131],
                            [117.62641, 30.972119],
                            [117.650671, 30.957646],
                            [117.65129, 30.950409],
                            [117.66049, 30.940031],
                            [117.66721, 30.956049],
                            [117.665828, 30.966639],
                            [117.683082, 30.968767],
                            [117.686181, 30.98526],
                            [117.693759, 30.98893],
                            [117.700432, 31.002494],
                            [117.697525, 31.0101],
                            [117.70763, 31.01127],
                            [117.718306, 31.019087],
                            [117.721023, 31.0101],
                            [117.731414, 31.00994],
                            [117.752339, 31.057688],
                            [117.767496, 31.096113],
                            [117.781319, 31.111468],
                            [117.807391, 31.129742],
                            [117.831938, 31.139143],
                            [117.850718, 31.140205],
                            [117.869879, 31.133141],
                            [117.88027, 31.122039],
                            [117.890423, 31.086016],
                            [117.897954, 31.07831],
                            [117.923788, 31.068318],
                            [117.935466, 31.067681],
                            [117.95863, 31.074643],
                            [117.973311, 31.084316],
                            [117.985513, 31.079745],
                            [118.005818, 31.078204],
                            [118.021881, 31.064704],
                            [118.009679, 31.045407],
                            [118.013778, 31.034508],
                            [118.025933, 31.030414],
                            [118.03251, 31.017173],
                            [118.070975, 31.011376],
                            [118.083654, 30.993824],
                            [118.097572, 30.985579],
                            [118.105198, 30.970948],
                            [118.124836, 30.967862],
                            [118.143807, 30.970682],
                            [118.159059, 30.963925],
                            [118.160346, 30.952697],
                            [118.152911, 30.932207],
                            [118.154579, 30.923211],
                            [118.164779, 30.907186],
                            [118.1572, 30.901383],
                            [118.134369, 30.902075],
                            [118.099097, 30.885515],
                            [118.079412, 30.866608],
                            [118.056914, 30.872254],
                            [118.039612, 30.857553],
                            [118.048144, 30.855156],
                            [118.041566, 30.843276],
                            [118.024217, 30.845673],
                            [118.013397, 30.862347],
                            [117.993473, 30.854623],
                            [117.980413, 30.843808]
                        ]
                    ],
                    [
                        [
                            [117.297144, 30.487209],
                            [117.307535, 30.494267],
                            [117.319784, 30.49277],
                            [117.324551, 30.487637],
                            [117.326648, 30.470631],
                            [117.321882, 30.462234],
                            [117.31478, 30.461859],
                            [117.305437, 30.445812],
                            [117.293378, 30.440997],
                            [117.299289, 30.425374],
                            [117.281129, 30.414458],
                            [117.268545, 30.420184],
                            [117.251958, 30.420558],
                            [117.25253, 30.428798],
                            [117.259203, 30.430511],
                            [117.267211, 30.441746],
                            [117.25558, 30.45405],
                            [117.256724, 30.458543],
                            [117.274456, 30.465229],
                            [117.290137, 30.4763],
                            [117.297144, 30.487209]
                        ]
                    ],
                    [
                        [
                            [116.960728, 30.628544],
                            [116.934656, 30.632121],
                            [116.920643, 30.646163],
                            [116.92212, 30.654277],
                            [116.934465, 30.661323],
                            [116.951434, 30.656145],
                            [116.956963, 30.658013],
                            [116.967354, 30.657053],
                            [116.97703, 30.643547],
                            [116.960728, 30.628544]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 340800,
                "name": "安庆市",
                "center": [117.043551, 30.50883],
                "centroid": [116.451502, 30.574825],
                "childrenNum": 10,
                "level": "city",
                "parent": {
                    "adcode": 340000
                },
                "subFeatureIndex": 7,
                "acroutes": [100000, 340000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [116.903341, 30.357289],
                            [116.910347, 30.332869],
                            [116.9205, 30.314283],
                            [116.928793, 30.290978],
                            [116.927173, 30.273455],
                            [116.920547, 30.257966],
                            [116.892711, 30.240492],
                            [116.867497, 30.213576],
                            [116.860061, 30.17732],
                            [116.841901, 30.146739],
                            [116.816925, 30.115075],
                            [116.771787, 30.073681],
                            [116.747335, 30.057248],
                            [116.720309, 30.053918],
                            [116.685705, 30.07062],
                            [116.666877, 30.076742],
                            [116.642616, 30.076366],
                            [116.611015, 30.070728],
                            [116.596572, 30.059718],
                            [116.586039, 30.046291],
                            [116.57131, 30.014433],
                            [116.571215, 29.98923],
                            [116.564542, 29.949343],
                            [116.558727, 29.924338],
                            [116.551959, 29.90987],
                            [116.54152, 29.901641],
                            [116.525552, 29.897498],
                            [116.479842, 29.897875],
                            [116.467736, 29.896154],
                            [116.441758, 29.879852],
                            [116.392521, 29.855745],
                            [116.35968, 29.843635],
                            [116.343093, 29.835669],
                            [116.322788, 29.820004],
                            [116.312302, 29.808967],
                            [116.280796, 29.788882],
                            [116.261444, 29.782042],
                            [116.253627, 29.783119],
                            [116.227364, 29.816881],
                            [116.208108, 29.827487],
                            [116.187326, 29.829048],
                            [116.167354, 29.827379],
                            [116.135181, 29.819412],
                            [116.131987, 29.844281],
                            [116.134561, 29.877431],
                            [116.125791, 29.901372],
                            [116.104056, 29.926866],
                            [116.085705, 29.950795],
                            [116.077936, 29.956117],
                            [116.073837, 29.969987],
                            [116.081463, 29.981759],
                            [116.078317, 30.010242],
                            [116.088994, 30.026952],
                            [116.091663, 30.036192],
                            [116.079986, 30.057248],
                            [116.079223, 30.066217],
                            [116.0848, 30.075937],
                            [116.083751, 30.095642],
                            [116.088375, 30.11019],
                            [116.085038, 30.126185],
                            [116.075029, 30.133538],
                            [116.06316, 30.151622],
                            [116.056725, 30.169917],
                            [116.05601, 30.181022],
                            [116.063923, 30.193573],
                            [116.064352, 30.206873],
                            [116.046096, 30.223925],
                            [116.031702, 30.227035],
                            [116.026601, 30.239741],
                            [116.012254, 30.249497],
                            [115.994809, 30.255018],
                            [115.988899, 30.267078],
                            [115.985324, 30.291031],
                            [115.980939, 30.295746],
                            [115.958394, 30.305336],
                            [115.938708, 30.306944],
                            [115.921883, 30.301265],
                            [115.904438, 30.310051],
                            [115.903723, 30.315783],
                            [115.914352, 30.3243],
                            [115.916687, 30.334422],
                            [115.896478, 30.3567],
                            [115.884895, 30.379561],
                            [115.90091, 30.397867],
                            [115.909252, 30.398831],
                            [115.921501, 30.416384],
                            [115.930987, 30.420505],
                            [115.938184, 30.417776],
                            [115.946144, 30.425213],
                            [115.920786, 30.429868],
                            [115.915543, 30.443993],
                            [115.894809, 30.452712],
                            [115.894047, 30.459559],
                            [115.900815, 30.469722],
                            [115.898098, 30.482236],
                            [115.909728, 30.506725],
                            [115.919881, 30.515011],
                            [115.905153, 30.52458],
                            [115.899481, 30.537889],
                            [115.887803, 30.542485],
                            [115.883132, 30.559425],
                            [115.875553, 30.569363],
                            [115.87908, 30.578285],
                            [115.866211, 30.587901],
                            [115.857298, 30.589503],
                            [115.84848, 30.601895],
                            [115.828079, 30.606168],
                            [115.824123, 30.596127],
                            [115.819166, 30.59789],
                            [115.807822, 30.615568],
                            [115.814924, 30.624806],
                            [115.809919, 30.642586],
                            [115.798766, 30.65006],
                            [115.797002, 30.658601],
                            [115.775362, 30.668849],
                            [115.77236, 30.677869],
                            [115.762541, 30.685607],
                            [115.767402, 30.694358],
                            [115.765544, 30.707537],
                            [115.776363, 30.728875],
                            [115.782893, 30.751702],
                            [115.79276, 30.759275],
                            [115.810491, 30.759434],
                            [115.820119, 30.750689],
                            [115.834657, 30.756395],
                            [115.85153, 30.756715],
                            [115.854342, 30.767433],
                            [115.868356, 30.774257],
                            [115.8695, 30.782467],
                            [115.85868, 30.784813],
                            [115.865877, 30.798246],
                            [115.86378, 30.815781],
                            [115.848813, 30.82857],
                            [115.849481, 30.841251],
                            [115.863875, 30.855262],
                            [115.865686, 30.864264],
                            [115.876935, 30.869005],
                            [115.885705, 30.877846],
                            [115.912779, 30.887592],
                            [115.932369, 30.889402],
                            [115.936134, 30.902874],
                            [115.970548, 30.920017],
                            [115.976268, 30.931461],
                            [115.993427, 30.936731],
                            [116.009871, 30.949717],
                            [116.024743, 30.953602],
                            [116.034514, 30.951154],
                            [116.039519, 30.957859],
                            [116.07174, 30.956688],
                            [116.06969, 30.969139],
                            [116.0603, 30.994941],
                            [116.058918, 31.012759],
                            [116.046144, 31.014514],
                            [116.051578, 31.042217],
                            [116.050958, 31.049554],
                            [116.066354, 31.070072],
                            [116.092664, 31.082668],
                            [116.093379, 31.090108],
                            [116.10458, 31.094465],
                            [116.11888, 31.086866],
                            [116.157679, 31.099301],
                            [116.166258, 31.0976],
                            [116.18132, 31.083359],
                            [116.183751, 31.064917],
                            [116.203293, 31.0579],
                            [116.222455, 31.061781],
                            [116.243427, 31.0756],
                            [116.261396, 31.082403],
                            [116.268498, 31.100098],
                            [116.293045, 31.114761],
                            [116.303532, 31.123155],
                            [116.309776, 31.140418],
                            [116.3307, 31.145622],
                            [116.342712, 31.15242],
                            [116.344952, 31.163624],
                            [116.359537, 31.173978],
                            [116.378984, 31.165377],
                            [116.395572, 31.162084],
                            [116.415305, 31.162191],
                            [116.431892, 31.144135],
                            [116.437707, 31.128414],
                            [116.4603, 31.125917],
                            [116.470071, 31.135637],
                            [116.481844, 31.136965],
                            [116.496715, 31.148756],
                            [116.501911, 31.141427],
                            [116.508298, 31.142489],
                            [116.519547, 31.160173],
                            [116.538469, 31.174456],
                            [116.543474, 31.181941],
                            [116.552816, 31.179712],
                            [116.556582, 31.172173],
                            [116.552816, 31.165908],
                            [116.558346, 31.147587],
                            [116.555867, 31.123314],
                            [116.562683, 31.111096],
                            [116.549385, 31.093243],
                            [116.538708, 31.072145],
                            [116.533512, 31.056624],
                            [116.534799, 31.044185],
                            [116.530939, 31.035306],
                            [116.530605, 31.021002],
                            [116.543617, 31.020311],
                            [116.560347, 31.034614],
                            [116.563779, 31.045567],
                            [116.571072, 31.051787],
                            [116.591711, 31.04764],
                            [116.594571, 31.054126],
                            [116.611539, 31.067309],
                            [116.614018, 31.073899],
                            [116.622502, 31.074112],
                            [116.647049, 31.05891],
                            [116.65396, 31.052212],
                            [116.665495, 31.059123],
                            [116.68356, 31.055774],
                            [116.68866, 31.048703],
                            [116.70968, 31.043228],
                            [116.722883, 31.059601],
                            [116.736753, 31.063907],
                            [116.752721, 31.060877],
                            [116.761301, 31.068372],
                            [116.777602, 31.070019],
                            [116.78866, 31.065289],
                            [116.805962, 31.08219],
                            [116.815638, 31.085378],
                            [116.829365, 31.101213],
                            [116.843331, 31.104455],
                            [116.842187, 31.11338],
                            [116.847144, 31.124642],
                            [116.862254, 31.129901],
                            [116.875981, 31.127458],
                            [116.894952, 31.133407],
                            [116.919356, 31.151305],
                            [116.92274, 31.160067],
                            [116.943903, 31.161766],
                            [116.946906, 31.182738],
                            [116.954008, 31.189161],
                            [116.963255, 31.214532],
                            [116.981415, 31.244564],
                            [116.998193, 31.2565],
                            [117.006725, 31.267693],
                            [117.016257, 31.266844],
                            [117.032273, 31.256607],
                            [117.042235, 31.252469],
                            [117.055104, 31.235386],
                            [117.071358, 31.236871],
                            [117.079174, 31.221643],
                            [117.100147, 31.190488],
                            [117.109394, 31.169571],
                            [117.12212, 31.148543],
                            [117.121977, 31.129264],
                            [117.117163, 31.12443],
                            [117.122787, 31.101798],
                            [117.117306, 31.08506],
                            [117.13599, 31.073155],
                            [117.156248, 31.072411],
                            [117.149908, 31.058272],
                            [117.144141, 31.054179],
                            [117.14395, 31.039293],
                            [117.137611, 31.028925],
                            [117.141186, 31.014514],
                            [117.134799, 31.007281],
                            [117.124599, 31.006749],
                            [117.111348, 31.01345],
                            [117.093903, 31.0101],
                            [117.095142, 30.988558],
                            [117.082654, 30.974885],
                            [117.080366, 30.961743],
                            [117.086419, 30.92864],
                            [117.096477, 30.885728],
                            [117.106248, 30.827558],
                            [117.105009, 30.790677],
                            [117.101005, 30.767379],
                            [117.059537, 30.773191],
                            [117.053674, 30.772071],
                            [117.043665, 30.754742],
                            [117.017878, 30.751809],
                            [117.006248, 30.759115],
                            [117.006582, 30.744236],
                            [116.989422, 30.733249],
                            [116.984847, 30.722741],
                            [116.998145, 30.7165],
                            [116.995619, 30.70695],
                            [116.987992, 30.705189],
                            [116.980414, 30.692704],
                            [116.971405, 30.691583],
                            [116.961968, 30.672532],
                            [116.953483, 30.664365],
                            [116.956963, 30.658013],
                            [116.951434, 30.656145],
                            [116.934465, 30.661323],
                            [116.92212, 30.654277],
                            [116.920643, 30.646163],
                            [116.934656, 30.632121],
                            [116.960728, 30.628544],
                            [116.961157, 30.617116],
                            [116.967258, 30.611776],
                            [116.96907, 30.595112],
                            [116.973503, 30.586565],
                            [116.972645, 30.573103],
                            [116.964113, 30.566371],
                            [116.955342, 30.575293],
                            [116.949146, 30.571928],
                            [116.937325, 30.580102],
                            [116.924122, 30.580636],
                            [116.92193, 30.568348],
                            [116.911968, 30.56776],
                            [116.903865, 30.553066],
                            [116.896525, 30.554455],
                            [116.890852, 30.531796],
                            [116.879175, 30.518914],
                            [116.885323, 30.506885],
                            [116.873979, 30.505174],
                            [116.867497, 30.498598],
                            [116.873503, 30.489508],
                            [116.863302, 30.487369],
                            [116.834656, 30.476139],
                            [116.814494, 30.46325],
                            [116.797526, 30.458971],
                            [116.775219, 30.456457],
                            [116.767306, 30.453194],
                            [116.750147, 30.436182],
                            [116.756677, 30.420986],
                            [116.776982, 30.407982],
                            [116.780366, 30.412959],
                            [116.795142, 30.417401],
                            [116.806486, 30.426819],
                            [116.818975, 30.425588],
                            [116.831796, 30.417829],
                            [116.850719, 30.430511],
                            [116.854199, 30.415903],
                            [116.849766, 30.414939],
                            [116.867354, 30.380792],
                            [116.876648, 30.368104],
                            [116.877935, 30.357128],
                            [116.8909, 30.354826],
                            [116.903341, 30.357289]
                        ]
                    ],
                    [
                        [
                            [117.217068, 30.630626],
                            [117.21783, 30.620641],
                            [117.247906, 30.58929],
                            [117.252244, 30.563967],
                            [117.243807, 30.538156],
                            [117.241281, 30.523083],
                            [117.236372, 30.504747],
                            [117.226315, 30.489027],
                            [117.213397, 30.476941],
                            [117.192187, 30.465871],
                            [117.164017, 30.474802],
                            [117.135133, 30.492075],
                            [117.111586, 30.495337],
                            [117.025457, 30.494267],
                            [117.01049, 30.489294],
                            [116.986372, 30.470791],
                            [116.975552, 30.458062],
                            [116.950433, 30.442816],
                            [116.935609, 30.440301],
                            [116.914446, 30.425481],
                            [116.9011, 30.436503],
                            [116.892425, 30.431099],
                            [116.891949, 30.414725],
                            [116.888279, 30.407019],
                            [116.893855, 30.381595],
                            [116.903341, 30.357289],
                            [116.8909, 30.354826],
                            [116.877935, 30.357128],
                            [116.876648, 30.368104],
                            [116.867354, 30.380792],
                            [116.849766, 30.414939],
                            [116.854199, 30.415903],
                            [116.850719, 30.430511],
                            [116.831796, 30.417829],
                            [116.818975, 30.425588],
                            [116.806486, 30.426819],
                            [116.795142, 30.417401],
                            [116.780366, 30.412959],
                            [116.776982, 30.407982],
                            [116.756677, 30.420986],
                            [116.750147, 30.436182],
                            [116.767306, 30.453194],
                            [116.775219, 30.456457],
                            [116.797526, 30.458971],
                            [116.814494, 30.46325],
                            [116.834656, 30.476139],
                            [116.863302, 30.487369],
                            [116.873503, 30.489508],
                            [116.867497, 30.498598],
                            [116.873979, 30.505174],
                            [116.885323, 30.506885],
                            [116.879175, 30.518914],
                            [116.890852, 30.531796],
                            [116.896525, 30.554455],
                            [116.903865, 30.553066],
                            [116.911968, 30.56776],
                            [116.92193, 30.568348],
                            [116.924122, 30.580636],
                            [116.937325, 30.580102],
                            [116.949146, 30.571928],
                            [116.955342, 30.575293],
                            [116.964113, 30.566371],
                            [116.972645, 30.573103],
                            [116.973503, 30.586565],
                            [116.96907, 30.595112],
                            [116.967258, 30.611776],
                            [116.961157, 30.617116],
                            [116.960728, 30.628544],
                            [116.97703, 30.643547],
                            [116.967354, 30.657053],
                            [116.956963, 30.658013],
                            [116.953483, 30.664365],
                            [116.961968, 30.672532],
                            [116.971405, 30.691583],
                            [116.980414, 30.692704],
                            [116.987992, 30.705189],
                            [116.995619, 30.70695],
                            [116.998145, 30.7165],
                            [116.984847, 30.722741],
                            [116.989422, 30.733249],
                            [117.006582, 30.744236],
                            [117.006248, 30.759115],
                            [117.017878, 30.751809],
                            [117.043665, 30.754742],
                            [117.053674, 30.772071],
                            [117.059537, 30.773191],
                            [117.101005, 30.767379],
                            [117.117211, 30.755968],
                            [117.124694, 30.740343],
                            [117.162969, 30.708604],
                            [117.178078, 30.702148],
                            [117.187277, 30.70663],
                            [117.190566, 30.698467],
                            [117.200337, 30.701881],
                            [117.205009, 30.69201],
                            [117.241376, 30.690356],
                            [117.223979, 30.686514],
                            [117.212968, 30.678616],
                            [117.207296, 30.669543],
                            [117.205485, 30.654384],
                            [117.211872, 30.635111],
                            [117.217068, 30.630626]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 341000,
                "name": "黄山市",
                "center": [118.317325, 29.709239],
                "centroid": [118.076088, 29.904836],
                "childrenNum": 7,
                "level": "city",
                "parent": {
                    "adcode": 340000
                },
                "subFeatureIndex": 8,
                "acroutes": [100000, 340000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [118.868878, 30.10144],
                            [118.872929, 30.094622],
                            [118.875455, 30.072017],
                            [118.878839, 30.064659],
                            [118.888134, 30.06235],
                            [118.897333, 30.051877],
                            [118.890565, 30.041242],
                            [118.902576, 30.029047],
                            [118.898048, 30.017227],
                            [118.890327, 30.012015],
                            [118.895093, 30.001214],
                            [118.89209, 29.994819],
                            [118.899478, 29.981437],
                            [118.891566, 29.959881],
                            [118.894664, 29.938051],
                            [118.884702, 29.938912],
                            [118.871976, 29.94687],
                            [118.86392, 29.936976],
                            [118.848287, 29.941278],
                            [118.838706, 29.934502],
                            [118.844902, 29.915249],
                            [118.845522, 29.899112],
                            [118.841328, 29.891312],
                            [118.807724, 29.867638],
                            [118.802624, 29.860642],
                            [118.778744, 29.841913],
                            [118.766923, 29.848964],
                            [118.755627, 29.845412],
                            [118.750956, 29.831632],
                            [118.765922, 29.823073],
                            [118.75944, 29.817151],
                            [118.745999, 29.818173],
                            [118.739945, 29.813274],
                            [118.736513, 29.788451],
                            [118.74433, 29.779618],
                            [118.749049, 29.761143],
                            [118.744712, 29.738786],
                            [118.724645, 29.72262],
                            [118.718687, 29.709201],
                            [118.700813, 29.706452],
                            [118.682319, 29.686454],
                            [118.67393, 29.669094],
                            [118.647333, 29.643372],
                            [118.640946, 29.641916],
                            [118.633511, 29.648765],
                            [118.619974, 29.654104],
                            [118.602052, 29.643696],
                            [118.573883, 29.638357],
                            [118.555055, 29.613382],
                            [118.549907, 29.613382],
                            [118.535227, 29.590614],
                            [118.500575, 29.575666],
                            [118.494903, 29.553698],
                            [118.497858, 29.543982],
                            [118.495904, 29.519578],
                            [118.47903, 29.510938],
                            [118.458249, 29.506348],
                            [118.448954, 29.513422],
                            [118.429507, 29.503647],
                            [118.414969, 29.50975],
                            [118.393044, 29.50732],
                            [118.38394, 29.510398],
                            [118.379793, 29.502567],
                            [118.358725, 29.477073],
                            [118.34762, 29.473994],
                            [118.324407, 29.49695],
                            [118.310537, 29.496032],
                            [118.306581, 29.47945],
                            [118.316018, 29.450545],
                            [118.316113, 29.422606],
                            [118.291376, 29.419957],
                            [118.28618, 29.426713],
                            [118.276266, 29.423417],
                            [118.267782, 29.427848],
                            [118.255723, 29.426173],
                            [118.248525, 29.431307],
                            [118.232939, 29.423903],
                            [118.218115, 29.42039],
                            [118.204245, 29.395415],
                            [118.193044, 29.395253],
                            [118.188135, 29.406119],
                            [118.1766, 29.404714],
                            [118.163635, 29.412066],
                            [118.136085, 29.418876],
                            [118.12946, 29.432604],
                            [118.138611, 29.437684],
                            [118.137992, 29.454868],
                            [118.127648, 29.472049],
                            [118.143807, 29.489767],
                            [118.142996, 29.499867],
                            [118.13456, 29.508778],
                            [118.109536, 29.521954],
                            [118.103435, 29.530647],
                            [118.082653, 29.533778],
                            [118.050718, 29.543172],
                            [118.042949, 29.566275],
                            [118.014112, 29.577285],
                            [118.003864, 29.578094],
                            [117.994665, 29.573183],
                            [117.984703, 29.561633],
                            [117.964874, 29.569999],
                            [117.954913, 29.565087],
                            [117.938707, 29.549596],
                            [117.920785, 29.554508],
                            [117.889851, 29.545817],
                            [117.876505, 29.546195],
                            [117.863588, 29.55413],
                            [117.852005, 29.554994],
                            [117.829889, 29.563846],
                            [117.822787, 29.571834],
                            [117.807296, 29.573561],
                            [117.794951, 29.570323],
                            [117.770928, 29.557099],
                            [117.753054, 29.560392],
                            [117.736038, 29.551539],
                            [117.707677, 29.549002],
                            [117.69047, 29.555912],
                            [117.682987, 29.568002],
                            [117.682225, 29.587268],
                            [117.678983, 29.59547],
                            [117.668974, 29.596981],
                            [117.661443, 29.611818],
                            [117.647954, 29.614893],
                            [117.628316, 29.606207],
                            [117.608726, 29.591585],
                            [117.586467, 29.584732],
                            [117.574074, 29.591099],
                            [117.557963, 29.590128],
                            [117.546238, 29.594337],
                            [117.54333, 29.588563],
                            [117.534274, 29.598545],
                            [117.523454, 29.629619],
                            [117.530556, 29.65405],
                            [117.516543, 29.663379],
                            [117.493759, 29.65955],
                            [117.474217, 29.668339],
                            [117.451862, 29.695942],
                            [117.457249, 29.725315],
                            [117.455104, 29.749184],
                            [117.44314, 29.758935],
                            [117.434703, 29.761143],
                            [117.413588, 29.78802],
                            [117.409155, 29.802613],
                            [117.424789, 29.834646],
                            [117.418783, 29.850417],
                            [117.403292, 29.84891],
                            [117.384084, 29.843635],
                            [117.375981, 29.818066],
                            [117.356248, 29.813705],
                            [117.347906, 29.822319],
                            [117.338612, 29.847887],
                            [117.333273, 29.850578],
                            [117.325695, 29.843851],
                            [117.303007, 29.840352],
                            [117.297239, 29.836853],
                            [117.292425, 29.822803],
                            [117.278173, 29.825118],
                            [117.271214, 29.830071],
                            [117.257392, 29.831255],
                            [117.249336, 29.846111],
                            [117.25682, 29.859512],
                            [117.261777, 29.880659],
                            [117.253722, 29.90901],
                            [117.246238, 29.915088],
                            [117.21702, 29.92692],
                            [117.206248, 29.927511],
                            [117.203102, 29.965149],
                            [117.206152, 29.974288],
                            [117.260156, 29.985253],
                            [117.267401, 29.98321],
                            [117.297668, 29.992777],
                            [117.309155, 29.999065],
                            [117.324217, 29.99799],
                            [117.349813, 30.008254],
                            [117.386372, 30.011048],
                            [117.394093, 30.029745],
                            [117.411538, 30.030444],
                            [117.433273, 30.02072],
                            [117.446476, 30.02303],
                            [117.461777, 30.037965],
                            [117.492806, 30.034903],
                            [117.511491, 30.037105],
                            [117.542091, 30.052844],
                            [117.53599, 30.076581],
                            [117.544093, 30.086783],
                            [117.535371, 30.083776],
                            [117.528983, 30.099561],
                            [117.541043, 30.11062],
                            [117.545618, 30.101601],
                            [117.554293, 30.101601],
                            [117.559965, 30.0834],
                            [117.56845, 30.088233],
                            [117.571071, 30.101762],
                            [117.560299, 30.103748],
                            [117.568736, 30.107399],
                            [117.572739, 30.115719],
                            [117.584846, 30.118027],
                            [117.599765, 30.129781],
                            [117.61049, 30.131499],
                            [117.615351, 30.111693],
                            [117.631176, 30.099293],
                            [117.642901, 30.105627],
                            [117.646143, 30.114484],
                            [117.655866, 30.115451],
                            [117.662491, 30.108902],
                            [117.676219, 30.107936],
                            [117.673264, 30.122106],
                            [117.68661, 30.126132],
                            [117.682606, 30.132733],
                            [117.698955, 30.143466],
                            [117.743187, 30.154037],
                            [117.778125, 30.156719],
                            [117.797811, 30.163694],
                            [117.820404, 30.182577],
                            [117.831366, 30.182202],
                            [117.846953, 30.192286],
                            [117.852863, 30.191749],
                            [117.8613, 30.209072],
                            [117.858345, 30.21733],
                            [117.829317, 30.225212],
                            [117.824932, 30.241617],
                            [117.842997, 30.260378],
                            [117.863206, 30.266435],
                            [117.888516, 30.269597],
                            [117.886419, 30.293228],
                            [117.902196, 30.294246],
                            [117.91292, 30.299283],
                            [117.907677, 30.309783],
                            [117.920356, 30.320014],
                            [117.928507, 30.319747],
                            [117.932034, 30.326335],
                            [117.925361, 30.33078],
                            [117.940137, 30.33469],
                            [117.928125, 30.357289],
                            [117.91659, 30.366552],
                            [117.938278, 30.378115],
                            [117.953197, 30.392568],
                            [117.952911, 30.403594],
                            [117.941233, 30.413602],
                            [117.938564, 30.425106],
                            [117.945904, 30.455066],
                            [117.945904, 30.466726],
                            [117.951481, 30.489134],
                            [117.963635, 30.508436],
                            [117.970118, 30.512231],
                            [117.985751, 30.498705],
                            [118.016924, 30.500576],
                            [118.034941, 30.498438],
                            [118.053721, 30.503677],
                            [118.075218, 30.515011],
                            [118.089612, 30.51731],
                            [118.117591, 30.509238],
                            [118.130747, 30.49817],
                            [118.121118, 30.493091],
                            [118.118211, 30.483252],
                            [118.103435, 30.465229],
                            [118.109774, 30.452712],
                            [118.107582, 30.42928],
                            [118.125027, 30.423662],
                            [118.130175, 30.429601],
                            [118.142901, 30.433828],
                            [118.15782, 30.434309],
                            [118.163254, 30.446775],
                            [118.181128, 30.447844],
                            [118.16864, 30.453033],
                            [118.188039, 30.474481],
                            [118.185847, 30.46448],
                            [118.196571, 30.468652],
                            [118.21373, 30.466833],
                            [118.213873, 30.461271],
                            [118.225217, 30.455013],
                            [118.231604, 30.445651],
                            [118.228077, 30.439713],
                            [118.215399, 30.438322],
                            [118.222977, 30.423929],
                            [118.221452, 30.414351],
                            [118.237801, 30.40049],
                            [118.250337, 30.394816],
                            [118.255913, 30.378437],
                            [118.265684, 30.376402],
                            [118.278173, 30.38031],
                            [118.280365, 30.372387],
                            [118.300289, 30.370139],
                            [118.295141, 30.358306],
                            [118.305532, 30.351399],
                            [118.299765, 30.340796],
                            [118.302052, 30.329709],
                            [118.310203, 30.32055],
                            [118.307629, 30.309301],
                            [118.294903, 30.302122],
                            [118.31211, 30.292907],
                            [118.320546, 30.293764],
                            [118.304912, 30.284387],
                            [118.292472, 30.283691],
                            [118.271404, 30.269865],
                            [118.266638, 30.259842],
                            [118.267782, 30.243333],
                            [118.271881, 30.238186],
                            [118.286562, 30.232879],
                            [118.289946, 30.219046],
                            [118.290708, 30.199526],
                            [118.31149, 30.193197],
                            [118.326647, 30.175282],
                            [118.339326, 30.16584],
                            [118.347477, 30.134289],
                            [118.356962, 30.121945],
                            [118.355103, 30.111908],
                            [118.370642, 30.099722],
                            [118.384607, 30.097145],
                            [118.394807, 30.106271],
                            [118.404483, 30.099615],
                            [118.417734, 30.097306],
                            [118.449955, 30.102621],
                            [118.468926, 30.082434],
                            [118.477696, 30.076527],
                            [118.494474, 30.072124],
                            [118.514016, 30.038932],
                            [118.513492, 30.030659],
                            [118.498096, 30.018141],
                            [118.498716, 30.005997],
                            [118.50577, 29.99138],
                            [118.509297, 29.998312],
                            [118.520403, 29.99885],
                            [118.524502, 29.992508],
                            [118.520784, 29.975201],
                            [118.524741, 29.967407],
                            [118.548668, 29.945203],
                            [118.564588, 29.947569],
                            [118.574931, 29.963751],
                            [118.583463, 29.968321],
                            [118.605818, 29.971654],
                            [118.614016, 29.980469],
                            [118.618592, 29.997399],
                            [118.614493, 30.001805],
                            [118.628029, 30.016529],
                            [118.651004, 30.024534],
                            [118.669021, 30.023675],
                            [118.688754, 30.028993],
                            [118.694807, 30.036675],
                            [118.69781, 30.056818],
                            [118.730365, 30.070298],
                            [118.743139, 30.092743],
                            [118.754626, 30.080608],
                            [118.767972, 30.076796],
                            [118.789945, 30.078299],
                            [118.82107, 30.102728],
                            [118.85005, 30.110458],
                            [118.868878, 30.10144]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 341100,
                "name": "滁州市",
                "center": [118.316264, 32.303627],
                "centroid": [118.107896, 32.543514],
                "childrenNum": 8,
                "level": "city",
                "parent": {
                    "adcode": 340000
                },
                "subFeatureIndex": 9,
                "acroutes": [100000, 340000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [117.951862, 31.906229],
                            [117.929698, 31.920819],
                            [117.91516, 31.922189],
                            [117.900051, 31.92914],
                            [117.886562, 31.926771],
                            [117.868116, 31.928982],
                            [117.868592, 31.945307],
                            [117.865637, 31.954311],
                            [117.846428, 31.962576],
                            [117.844665, 31.974526],
                            [117.836085, 31.979053],
                            [117.82946, 31.994789],
                            [117.810918, 32.002262],
                            [117.832987, 32.015259],
                            [117.833416, 32.03383],
                            [117.842377, 32.041773],
                            [117.864207, 32.047086],
                            [117.885084, 32.064125],
                            [117.868259, 32.075957],
                            [117.866495, 32.085841],
                            [117.858059, 32.093832],
                            [117.868163, 32.097354],
                            [117.867019, 32.106553],
                            [117.851624, 32.105975],
                            [117.855342, 32.123319],
                            [117.872739, 32.141028],
                            [117.863921, 32.195498],
                            [117.847191, 32.217445],
                            [117.833225, 32.221697],
                            [117.819879, 32.230516],
                            [117.807391, 32.221225],
                            [117.791471, 32.219755],
                            [117.781605, 32.231986],
                            [117.770928, 32.239177],
                            [117.757439, 32.240646],
                            [117.741281, 32.247154],
                            [117.729126, 32.245632],
                            [117.712015, 32.236553],
                            [117.707487, 32.243901],
                            [117.697239, 32.248781],
                            [117.673216, 32.250985],
                            [117.672215, 32.261061],
                            [117.652434, 32.260799],
                            [117.631748, 32.248886],
                            [117.631986, 32.256915],
                            [117.622549, 32.249988],
                            [117.613921, 32.250198],
                            [117.605437, 32.238914],
                            [117.59395, 32.239124],
                            [117.576076, 32.230726],
                            [117.553864, 32.215975],
                            [117.498145, 32.203532],
                            [117.48232, 32.212405],
                            [117.46864, 32.223482],
                            [117.449098, 32.233928],
                            [117.435371, 32.236762],
                            [117.427268, 32.242536],
                            [117.425218, 32.259539],
                            [117.40825, 32.26762],
                            [117.395761, 32.283727],
                            [117.412587, 32.319602],
                            [117.423359, 32.334546],
                            [117.444903, 32.343512],
                            [117.44171, 32.366524],
                            [117.405342, 32.375119],
                            [117.392568, 32.388115],
                            [117.369546, 32.382508],
                            [117.359251, 32.384971],
                            [117.377315, 32.398385],
                            [117.382415, 32.409177],
                            [117.38232, 32.43102],
                            [117.39376, 32.452805],
                            [117.408297, 32.468565],
                            [117.394046, 32.478302],
                            [117.380938, 32.464377],
                            [117.365113, 32.455895],
                            [117.32722, 32.441704],
                            [117.30844, 32.451234],
                            [117.293045, 32.443799],
                            [117.28294, 32.442751],
                            [117.266877, 32.451444],
                            [117.244951, 32.460136],
                            [117.219546, 32.463015],
                            [117.209012, 32.472544],
                            [117.211586, 32.476261],
                            [117.209632, 32.493953],
                            [117.211205, 32.516194],
                            [117.2011, 32.534035],
                            [117.203245, 32.542457],
                            [117.211396, 32.54659],
                            [117.214637, 32.560345],
                            [117.199146, 32.579851],
                            [117.195952, 32.60871],
                            [117.17498, 32.653495],
                            [117.172406, 32.664675],
                            [117.1613, 32.679562],
                            [117.162349, 32.686874],
                            [117.184322, 32.696691],
                            [117.189804, 32.716846],
                            [117.205152, 32.728279],
                            [117.195905, 32.734699],
                            [117.202673, 32.745399],
                            [117.214112, 32.752027],
                            [117.231796, 32.77217],
                            [117.244665, 32.794602],
                            [117.255819, 32.80566],
                            [117.265542, 32.800862],
                            [117.280366, 32.808842],
                            [117.284942, 32.817447],
                            [117.307678, 32.818959],
                            [117.314017, 32.828241],
                            [117.325218, 32.825894],
                            [117.350814, 32.829232],
                            [117.361729, 32.840129],
                            [117.368354, 32.837783],
                            [117.395857, 32.836427],
                            [117.415113, 32.831995],
                            [117.422168, 32.846593],
                            [117.432272, 32.842266],
                            [117.457773, 32.841484],
                            [117.471167, 32.837157],
                            [117.479222, 32.842944],
                            [117.491281, 32.864681],
                            [117.508249, 32.868747],
                            [117.513588, 32.875261],
                            [117.512253, 32.886153],
                            [117.49967, 32.897408],
                            [117.505151, 32.908557],
                            [117.512396, 32.93283],
                            [117.528602, 32.938976],
                            [117.528173, 32.967041],
                            [117.531224, 32.980576],
                            [117.548526, 32.969592],
                            [117.56864, 32.951369],
                            [117.576839, 32.941059],
                            [117.589994, 32.933924],
                            [117.603483, 32.922257],
                            [117.626886, 32.924809],
                            [117.64619, 32.912308],
                            [117.657534, 32.910745],
                            [117.671834, 32.918819],
                            [117.679174, 32.943871],
                            [117.694665, 32.96928],
                            [117.698287, 32.985],
                            [117.707963, 33.00254],
                            [117.718545, 33.006391],
                            [117.737039, 33.001083],
                            [117.746333, 33.009825],
                            [117.762587, 33.040833],
                            [117.773359, 33.047335],
                            [117.787515, 33.045202],
                            [117.800146, 33.031209],
                            [117.822406, 33.02814],
                            [117.860346, 33.035995],
                            [117.880222, 33.041977],
                            [117.886752, 33.046607],
                            [117.893711, 33.035059],
                            [117.890613, 33.031781],
                            [117.89762, 33.019607],
                            [117.895237, 33.013884],
                            [117.879698, 33.002748],
                            [117.899384, 32.990257],
                            [117.913492, 32.987655],
                            [117.937706, 33.008576],
                            [117.947858, 33.014508],
                            [117.970642, 33.001967],
                            [117.982796, 33.01175],
                            [118.003721, 33.002227],
                            [118.011347, 33.001759],
                            [118.031462, 33.014716],
                            [118.0368, 33.027099],
                            [118.018306, 33.034539],
                            [118.005151, 33.031417],
                            [117.99843, 33.040625],
                            [118.004341, 33.055293],
                            [118.018116, 33.06143],
                            [118.032749, 33.073962],
                            [118.061681, 33.07469],
                            [118.072691, 33.081034],
                            [118.065017, 33.09741],
                            [118.07455, 33.117318],
                            [118.073835, 33.135143],
                            [118.05129, 33.124854],
                            [118.044617, 33.127192],
                            [118.050337, 33.133792],
                            [118.067925, 33.135143],
                            [118.070451, 33.140391],
                            [118.088278, 33.149691],
                            [118.118878, 33.160548],
                            [118.14905, 33.169483],
                            [118.159965, 33.181065],
                            [118.156342, 33.19545],
                            [118.168354, 33.213466],
                            [118.178173, 33.217983],
                            [118.194379, 33.211701],
                            [118.211633, 33.199085],
                            [118.221261, 33.182208],
                            [118.22374, 33.155457],
                            [118.219593, 33.114096],
                            [118.210441, 33.111861],
                            [118.209679, 33.104324],
                            [118.22088, 33.105883],
                            [118.221309, 33.087637],
                            [118.206485, 33.091276],
                            [118.202863, 33.088104],
                            [118.223692, 33.083477],
                            [118.227648, 33.06949],
                            [118.21516, 33.070946],
                            [118.212396, 33.06195],
                            [118.233368, 33.060025],
                            [118.239612, 33.046451],
                            [118.243473, 33.027776],
                            [118.244807, 32.998324],
                            [118.252434, 32.982137],
                            [118.269355, 32.969175],
                            [118.303816, 32.968655],
                            [118.309631, 32.958971],
                            [118.293378, 32.947151],
                            [118.247906, 32.934757],
                            [118.235418, 32.926528],
                            [118.233034, 32.916267],
                            [118.240041, 32.882349],
                            [118.244426, 32.87448],
                            [118.250575, 32.848366],
                            [118.263206, 32.856185],
                            [118.284607, 32.85728],
                            [118.289517, 32.845499],
                            [118.301719, 32.846228],
                            [118.297858, 32.832047],
                            [118.306628, 32.810563],
                            [118.294426, 32.800131],
                            [118.298764, 32.785578],
                            [118.307153, 32.778691],
                            [118.320785, 32.778274],
                            [118.326409, 32.763456],
                            [118.334035, 32.761577],
                            [118.348811, 32.773004],
                            [118.366209, 32.768309],
                            [118.371166, 32.757716],
                            [118.37231, 32.741746],
                            [118.366256, 32.73496],
                            [118.368163, 32.724781],
                            [118.375313, 32.718987],
                            [118.398668, 32.721388],
                            [118.410966, 32.716063],
                            [118.422882, 32.718099],
                            [118.450479, 32.743364],
                            [118.45925, 32.726086],
                            [118.483511, 32.721388],
                            [118.489755, 32.72452],
                            [118.520451, 32.723215],
                            [118.545284, 32.72948],
                            [118.559726, 32.729897],
                            [118.576599, 32.719091],
                            [118.590803, 32.724834],
                            [118.607534, 32.726661],
                            [118.617019, 32.73898],
                            [118.632319, 32.739971],
                            [118.639421, 32.744825],
                            [118.654054, 32.740702],
                            [118.657581, 32.736109],
                            [118.69414, 32.726608],
                            [118.707248, 32.720292],
                            [118.724454, 32.72191],
                            [118.736704, 32.732351],
                            [118.756294, 32.737048],
                            [118.757438, 32.743834],
                            [118.751528, 32.757142],
                            [118.746332, 32.759281],
                            [118.737943, 32.773265],
                            [118.736847, 32.79335],
                            [118.746809, 32.800392],
                            [118.741804, 32.85337],
                            [118.747858, 32.858687],
                            [118.768163, 32.851494],
                            [118.791042, 32.848418],
                            [118.811728, 32.854986],
                            [118.812538, 32.865203],
                            [118.806199, 32.870258],
                            [118.811251, 32.87547],
                            [118.814588, 32.902722],
                            [118.809345, 32.90788],
                            [118.812205, 32.916892],
                            [118.819021, 32.920642],
                            [118.836942, 32.911422],
                            [118.839516, 32.922517],
                            [118.848954, 32.927205],
                            [118.842519, 32.943662],
                            [118.849383, 32.945902],
                            [118.849335, 32.956628],
                            [118.865255, 32.955014],
                            [118.884654, 32.960585],
                            [118.896237, 32.957774],
                            [118.891232, 32.951734],
                            [118.893568, 32.940798],
                            [118.90577, 32.945068],
                            [118.921451, 32.939548],
                            [118.933796, 32.938663],
                            [118.941613, 32.94611],
                            [118.961203, 32.945797],
                            [118.993663, 32.958242],
                            [119.008916, 32.959388],
                            [119.020832, 32.955795],
                            [119.026313, 32.947255],
                            [119.023549, 32.935382],
                            [119.029602, 32.92632],
                            [119.019831, 32.925695],
                            [119.015064, 32.911683],
                            [119.019497, 32.905118],
                            [119.044997, 32.911422],
                            [119.045712, 32.892458],
                            [119.054912, 32.875053],
                            [119.071308, 32.864733],
                            [119.104292, 32.826729],
                            [119.113062, 32.822922],
                            [119.18494, 32.825634],
                            [119.188896, 32.810876],
                            [119.19128, 32.788812],
                            [119.200908, 32.750984],
                            [119.2082, 32.740493],
                            [119.208963, 32.71528],
                            [119.211632, 32.708179],
                            [119.208677, 32.642784],
                            [119.220212, 32.629616],
                            [119.216923, 32.617282],
                            [119.220498, 32.60986],
                            [119.230984, 32.607141],
                            [119.220069, 32.592452],
                            [119.220212, 32.576609],
                            [119.209297, 32.573576],
                            [119.19433, 32.578596],
                            [119.187133, 32.59998],
                            [119.176933, 32.593811],
                            [119.175169, 32.571066],
                            [119.153863, 32.561862],
                            [119.154483, 32.554958],
                            [119.166685, 32.546014],
                            [119.167781, 32.536337],
                            [119.155579, 32.528071],
                            [119.150098, 32.50981],
                            [119.142281, 32.499396],
                            [119.147762, 32.492644],
                            [119.134511, 32.491545],
                            [119.12045, 32.480082],
                            [119.095998, 32.466052],
                            [119.085131, 32.452701],
                            [119.073691, 32.455371],
                            [119.067447, 32.462439],
                            [119.064445, 32.482385],
                            [119.045522, 32.498454],
                            [119.041375, 32.514781],
                            [119.021737, 32.517868],
                            [119.007533, 32.514048],
                            [118.997428, 32.503896],
                            [118.97984, 32.503844],
                            [118.967924, 32.514572],
                            [118.964778, 32.52671],
                            [118.940565, 32.547793],
                            [118.936561, 32.557521],
                            [118.916351, 32.556057],
                            [118.91597, 32.549519],
                            [118.888325, 32.557207],
                            [118.898668, 32.56045],
                            [118.89638, 32.577289],
                            [118.909345, 32.586857],
                            [118.907867, 32.592295],
                            [118.887896, 32.587119],
                            [118.872405, 32.576034],
                            [118.85596, 32.574361],
                            [118.848525, 32.56819],
                            [118.827028, 32.572687],
                            [118.827791, 32.579694],
                            [118.819259, 32.58623],
                            [118.824645, 32.589628],
                            [118.824931, 32.601914],
                            [118.81373, 32.600816],
                            [118.801766, 32.584348],
                            [118.784369, 32.58257],
                            [118.774693, 32.588112],
                            [118.775789, 32.597732],
                            [118.757533, 32.603953],
                            [118.74433, 32.598882],
                            [118.740708, 32.589367],
                            [118.726027, 32.59632],
                            [118.725312, 32.608239],
                            [118.698001, 32.60641],
                            [118.700861, 32.588531],
                            [118.696666, 32.588269],
                            [118.68904, 32.604737],
                            [118.689564, 32.588531],
                            [118.668782, 32.594909],
                            [118.65229, 32.593079],
                            [118.633034, 32.578962],
                            [118.623406, 32.592609],
                            [118.601814, 32.597366],
                            [118.598096, 32.601339],
                            [118.581271, 32.594543],
                            [118.569497, 32.586439],
                            [118.56373, 32.564372],
                            [118.584655, 32.548996],
                            [118.599002, 32.544654],
                            [118.608821, 32.537069],
                            [118.604864, 32.522839],
                            [118.614445, 32.520432],
                            [118.617448, 32.512426],
                            [118.60801, 32.501751],
                            [118.592376, 32.499867],
                            [118.59333, 32.478826],
                            [118.608058, 32.475842],
                            [118.608582, 32.470554],
                            [118.628077, 32.467675],
                            [118.643425, 32.470502],
                            [118.647715, 32.476522],
                            [118.675217, 32.470136],
                            [118.689278, 32.473486],
                            [118.692615, 32.46511],
                            [118.686895, 32.429815],
                            [118.68904, 32.420649],
                            [118.685751, 32.404986],
                            [118.678697, 32.393931],
                            [118.690184, 32.378263],
                            [118.698763, 32.383189],
                            [118.696094, 32.367991],
                            [118.702052, 32.357927],
                            [118.692901, 32.35169],
                            [118.69986, 32.34975],
                            [118.697524, 32.34262],
                            [118.707915, 32.338426],
                            [118.703244, 32.328988],
                            [118.687657, 32.329985],
                            [118.683463, 32.325003],
                            [118.694855, 32.317243],
                            [118.678458, 32.316561],
                            [118.66025, 32.305443],
                            [118.659964, 32.296369],
                            [118.667305, 32.296369],
                            [118.670784, 32.285615],
                            [118.659249, 32.266098],
                            [118.667448, 32.257545],
                            [118.675741, 32.255131],
                            [118.667495, 32.235923],
                            [118.64414, 32.20999],
                            [118.626599, 32.202534],
                            [118.61964, 32.205475],
                            [118.598334, 32.199489],
                            [118.580889, 32.198649],
                            [118.574931, 32.202587],
                            [118.561728, 32.196863],
                            [118.551719, 32.199646],
                            [118.539612, 32.192452],
                            [118.532367, 32.195813],
                            [118.524645, 32.189039],
                            [118.509822, 32.19429],
                            [118.506485, 32.182107],
                            [118.496809, 32.178588],
                            [118.495618, 32.165194],
                            [118.507438, 32.137875],
                            [118.500622, 32.141711],
                            [118.495046, 32.132883],
                            [118.499097, 32.120376],
                            [118.489469, 32.120744],
                            [118.472977, 32.114858],
                            [118.463349, 32.100666],
                            [118.44109, 32.092045],
                            [118.433511, 32.086682],
                            [118.415112, 32.087418],
                            [118.405198, 32.075799],
                            [118.39476, 32.075589],
                            [118.393282, 32.062705],
                            [118.385084, 32.05813],
                            [118.358344, 32.045297],
                            [118.348716, 32.035461],
                            [118.334464, 32.031253],
                            [118.31721, 32.019836],
                            [118.305341, 31.998],
                            [118.304865, 31.985527],
                            [118.290136, 31.979895],
                            [118.256724, 31.954469],
                            [118.239421, 31.944096],
                            [118.219736, 31.925296],
                            [118.203959, 31.927719],
                            [118.187277, 31.919186],
                            [118.181843, 31.907651],
                            [118.171118, 31.900118],
                            [118.147763, 31.907967],
                            [118.132034, 31.903331],
                            [118.120832, 31.906123],
                            [118.109107, 31.891425],
                            [118.085942, 31.877462],
                            [118.083988, 31.8538],
                            [118.072834, 31.850901],
                            [118.061776, 31.858543],
                            [118.044808, 31.859545],
                            [117.988373, 31.881836],
                            [117.96435, 31.90154],
                            [117.951862, 31.906229]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 341200,
                "name": "阜阳市",
                "center": [115.819729, 32.896969],
                "centroid": [115.709057, 32.916529],
                "childrenNum": 8,
                "level": "city",
                "parent": {
                    "adcode": 340000
                },
                "subFeatureIndex": 10,
                "acroutes": [100000, 340000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [116.484799, 32.439347],
                            [116.472359, 32.438247],
                            [116.437564, 32.45092],
                            [116.404819, 32.442804],
                            [116.392235, 32.447621],
                            [116.358489, 32.464743],
                            [116.332798, 32.510385],
                            [116.320071, 32.521164],
                            [116.271692, 32.520955],
                            [116.26397, 32.494738],
                            [116.246334, 32.48406],
                            [116.251244, 32.464429],
                            [116.244523, 32.4549],
                            [116.23561, 32.465843],
                            [116.222979, 32.459193],
                            [116.213065, 32.463748],
                            [116.203722, 32.447621],
                            [116.191187, 32.454271],
                            [116.176411, 32.425363],
                            [116.167879, 32.439766],
                            [116.148146, 32.439923],
                            [116.141854, 32.46045],
                            [116.124552, 32.47113],
                            [116.113398, 32.490812],
                            [116.101435, 32.523833],
                            [116.090948, 32.539162],
                            [116.076411, 32.543974],
                            [116.05663, 32.546328],
                            [116.036849, 32.555011],
                            [116.03113, 32.573524],
                            [116.022026, 32.591563],
                            [115.996954, 32.602907],
                            [115.967355, 32.605103],
                            [115.95234, 32.59104],
                            [115.936992, 32.571955],
                            [115.928365, 32.567563],
                            [115.915448, 32.576871],
                            [115.891568, 32.576243],
                            [115.887564, 32.567667],
                            [115.861397, 32.537383],
                            [115.845953, 32.531628],
                            [115.839948, 32.524775],
                            [115.841473, 32.501227],
                            [115.823837, 32.502222],
                            [115.804104, 32.485473],
                            [115.788756, 32.468931],
                            [115.780987, 32.46757],
                            [115.78704, 32.485788],
                            [115.771502, 32.505309],
                            [115.766783, 32.492435],
                            [115.757202, 32.480187],
                            [115.74195, 32.476365],
                            [115.701197, 32.495313],
                            [115.692093, 32.487515],
                            [115.692188, 32.480605],
                            [115.701244, 32.470869],
                            [115.696716, 32.467466],
                            [115.675887, 32.466419],
                            [115.681559, 32.451182],
                            [115.680606, 32.439976],
                            [115.674933, 32.431963],
                            [115.66745, 32.40991],
                            [115.656297, 32.408758],
                            [115.657965, 32.427406],
                            [115.654152, 32.428925],
                            [115.645572, 32.417559],
                            [115.627126, 32.405457],
                            [115.604533, 32.42594],
                            [115.586087, 32.419235],
                            [115.563875, 32.402995],
                            [115.553628, 32.407501],
                            [115.569119, 32.414625],
                            [115.567593, 32.421644],
                            [115.547288, 32.424735],
                            [115.537469, 32.438928],
                            [115.523218, 32.442018],
                            [115.524123, 32.447831],
                            [115.515591, 32.450606],
                            [115.509347, 32.466733],
                            [115.510682, 32.467832],
                            [115.510587, 32.468827],
                            [115.508632, 32.468565],
                            [115.496716, 32.493377],
                            [115.490377, 32.496308],
                            [115.486993, 32.510542],
                            [115.477651, 32.511798],
                            [115.47665, 32.520955],
                            [115.465734, 32.520118],
                            [115.438947, 32.53257],
                            [115.443713, 32.543294],
                            [115.434657, 32.545177],
                            [115.431082, 32.552448],
                            [115.408871, 32.54999],
                            [115.412779, 32.559822],
                            [115.411588, 32.574779],
                            [115.403246, 32.576661],
                            [115.38766, 32.570909],
                            [115.328985, 32.561182],
                            [115.324695, 32.555952],
                            [115.305105, 32.55318],
                            [115.297145, 32.560555],
                            [115.300387, 32.568399],
                            [115.310873, 32.570543],
                            [115.29848, 32.573263],
                            [115.305534, 32.583197],
                            [115.299386, 32.588112],
                            [115.294858, 32.581054],
                            [115.289185, 32.58989],
                            [115.267212, 32.578073],
                            [115.254724, 32.584975],
                            [115.261302, 32.591667],
                            [115.254772, 32.595223],
                            [115.241998, 32.592609],
                            [115.229796, 32.579067],
                            [115.223647, 32.581472],
                            [115.22951, 32.59057],
                            [115.21216, 32.588478],
                            [115.201102, 32.591824],
                            [115.192236, 32.602332],
                            [115.209634, 32.611689],
                            [115.199386, 32.619686],
                            [115.201054, 32.633378],
                            [115.194572, 32.631288],
                            [115.194905, 32.642366],
                            [115.202722, 32.645501],
                            [115.209538, 32.636723],
                            [115.208919, 32.64989],
                            [115.219405, 32.65919],
                            [115.204009, 32.653913],
                            [115.205153, 32.672928],
                            [115.193666, 32.682852],
                            [115.189472, 32.678778],
                            [115.196907, 32.672719],
                            [115.182989, 32.666764],
                            [115.18461, 32.678308],
                            [115.178461, 32.682904],
                            [115.182703, 32.694498],
                            [115.179081, 32.701965],
                            [115.184324, 32.720396],
                            [115.179367, 32.726347],
                            [115.189615, 32.770917],
                            [115.183561, 32.776917],
                            [115.182084, 32.787299],
                            [115.191092, 32.790064],
                            [115.209491, 32.785421],
                            [115.206345, 32.79768],
                            [115.196907, 32.802114],
                            [115.189948, 32.812545],
                            [115.195573, 32.828867],
                            [115.1889, 32.840389],
                            [115.202675, 32.843518],
                            [115.198575, 32.854361],
                            [115.19114, 32.857488],
                            [115.176269, 32.856289],
                            [115.159777, 32.862284],
                            [115.154915, 32.877294],
                            [115.141998, 32.885423],
                            [115.14052, 32.897512],
                            [115.116164, 32.900221],
                            [115.098099, 32.894802],
                            [115.08623, 32.903243],
                            [115.067355, 32.903243],
                            [115.029748, 32.906838],
                            [115.02746, 32.914339],
                            [115.036755, 32.916319],
                            [115.03542, 32.932361],
                            [115.023981, 32.933715],
                            [115.009252, 32.940173],
                            [114.978795, 32.941319],
                            [114.959967, 32.939496],
                            [114.951817, 32.934393],
                            [114.942236, 32.937569],
                            [114.93604, 32.95215],
                            [114.924124, 32.958971],
                            [114.914543, 32.971622],
                            [114.893857, 32.972663],
                            [114.883371, 32.983751],
                            [114.884944, 32.992703],
                            [114.901579, 33.000354],
                            [114.891903, 33.020492],
                            [114.915401, 33.016069],
                            [114.924934, 33.016746],
                            [114.936993, 33.025486],
                            [114.92298, 33.036099],
                            [114.922456, 33.048323],
                            [114.914972, 33.059765],
                            [114.919548, 33.068814],
                            [114.914019, 33.082801],
                            [114.897289, 33.086597],
                            [114.898242, 33.096942],
                            [114.906297, 33.11659],
                            [114.902913, 33.129583],
                            [114.910253, 33.136598],
                            [114.92665, 33.13852],
                            [114.933085, 33.144911],
                            [114.932656, 33.154003],
                            [114.958061, 33.150003],
                            [114.966354, 33.146366],
                            [114.968881, 33.133688],
                            [114.981464, 33.129063],
                            [114.992332, 33.120956],
                            [114.990473, 33.102868],
                            [115.012017, 33.09767],
                            [115.023361, 33.090756],
                            [115.041235, 33.086649],
                            [115.051578, 33.092472],
                            [115.057441, 33.083737],
                            [115.069548, 33.086753],
                            [115.111111, 33.082905],
                            [115.153247, 33.084413],
                            [115.167927, 33.088728],
                            [115.172408, 33.108066],
                            [115.197146, 33.121424],
                            [115.209824, 33.113472],
                            [115.224362, 33.126257],
                            [115.236993, 33.126724],
                            [115.246288, 33.13639],
                            [115.266497, 33.1327],
                            [115.269595, 33.137845],
                            [115.290329, 33.132441],
                            [115.292856, 33.143404],
                            [115.301483, 33.141638],
                            [115.300148, 33.16299],
                            [115.294381, 33.177897],
                            [115.296764, 33.201317],
                            [115.326411, 33.211338],
                            [115.316259, 33.218398],
                            [115.316307, 33.223797],
                            [115.33175, 33.235631],
                            [115.329748, 33.250578],
                            [115.340139, 33.261164],
                            [115.340282, 33.286325],
                            [115.333799, 33.284717],
                            [115.335039, 33.2981],
                            [115.347002, 33.301004],
                            [115.360205, 33.2981],
                            [115.358776, 33.311428],
                            [115.36502, 33.336005],
                            [115.348337, 33.33896],
                            [115.346812, 33.358709],
                            [115.338566, 33.363011],
                            [115.341664, 33.371199],
                            [115.316116, 33.370992],
                            [115.313256, 33.377107],
                            [115.329414, 33.401665],
                            [115.317355, 33.418241],
                            [115.315639, 33.431447],
                            [115.319023, 33.441493],
                            [115.316354, 33.448897],
                            [115.323313, 33.448638],
                            [115.324552, 33.457595],
                            [115.335944, 33.447292],
                            [115.345811, 33.449777],
                            [115.348861, 33.478973],
                            [115.343809, 33.480837],
                            [115.351245, 33.490411],
                            [115.345429, 33.502934],
                            [115.366592, 33.523473],
                            [115.395096, 33.506504],
                            [115.396812, 33.502002],
                            [115.405344, 33.516696],
                            [115.401721, 33.524353],
                            [115.414638, 33.541629],
                            [115.421979, 33.556782],
                            [115.463685, 33.567227],
                            [115.474314, 33.55735],
                            [115.501864, 33.564383],
                            [115.511302, 33.553369],
                            [115.528556, 33.562728],
                            [115.552722, 33.56552],
                            [115.559347, 33.561953],
                            [115.565019, 33.576378],
                            [115.601149, 33.578187],
                            [115.639757, 33.585115],
                            [115.651244, 33.544629],
                            [115.676697, 33.508729],
                            [115.681273, 33.505831],
                            [115.698337, 33.509557],
                            [115.720834, 33.51085],
                            [115.749481, 33.499881],
                            [115.751387, 33.495896],
                            [115.769404, 33.490515],
                            [115.773217, 33.484718],
                            [115.786135, 33.481044],
                            [115.796049, 33.468569],
                            [115.807441, 33.466861],
                            [115.831606, 33.451227],
                            [115.848861, 33.450864],
                            [115.854962, 33.442321],
                            [115.897383, 33.400525],
                            [115.895334, 33.384724],
                            [115.898432, 33.356999],
                            [115.911111, 33.340567],
                            [115.914399, 33.328902],
                            [115.921406, 33.323303],
                            [115.919833, 33.313606],
                            [115.92603, 33.309769],
                            [115.927841, 33.298722],
                            [115.914828, 33.295506],
                            [115.915972, 33.279478],
                            [115.906725, 33.255975],
                            [115.909204, 33.246634],
                            [115.917498, 33.24269],
                            [115.925696, 33.229195],
                            [115.916497, 33.215491],
                            [115.876983, 33.248295],
                            [115.839423, 33.262824],
                            [115.832083, 33.256753],
                            [115.8297, 33.231635],
                            [115.835277, 33.21383],
                            [115.845238, 33.193528],
                            [115.841378, 33.180234],
                            [115.825505, 33.162678],
                            [115.824361, 33.150938],
                            [115.831034, 33.157172],
                            [115.850196, 33.153535],
                            [115.850196, 33.136078],
                            [115.839709, 33.135454],
                            [115.844333, 33.125321],
                            [115.865925, 33.125581],
                            [115.877126, 33.122151],
                            [115.872026, 33.103128],
                            [115.866735, 33.094343],
                            [115.89848, 33.093667],
                            [115.914876, 33.088],
                            [115.948098, 33.080774],
                            [115.980796, 33.07079],
                            [116.002483, 33.060077],
                            [116.018213, 33.056125],
                            [116.010157, 33.043954],
                            [116.01602, 33.041925],
                            [116.04214, 33.048843],
                            [116.051053, 33.044266],
                            [116.0552, 33.034227],
                            [116.051768, 33.021428],
                            [116.059013, 33.016954],
                            [116.060062, 33.003737],
                            [116.052531, 32.99515],
                            [116.054914, 32.99057],
                            [116.083084, 32.986458],
                            [116.125743, 32.976047],
                            [116.155581, 32.973757],
                            [116.167926, 32.967145],
                            [116.165305, 32.959492],
                            [116.168165, 32.940642],
                            [116.178889, 32.922882],
                            [116.191711, 32.91387],
                            [116.198432, 32.893396],
                            [116.212636, 32.888706],
                            [116.232988, 32.889852],
                            [116.245333, 32.884954],
                            [116.248527, 32.872812],
                            [116.280319, 32.859052],
                            [116.292569, 32.858948],
                            [116.30825, 32.86562],
                            [116.348098, 32.878128],
                            [116.370881, 32.900221],
                            [116.386992, 32.89772],
                            [116.394618, 32.891311],
                            [116.394428, 32.884121],
                            [116.386563, 32.86833],
                            [116.389995, 32.857071],
                            [116.406058, 32.85337],
                            [116.421882, 32.857853],
                            [116.445572, 32.843518],
                            [116.439614, 32.821619],
                            [116.449194, 32.8139],
                            [116.442473, 32.809207],
                            [116.441377, 32.800184],
                            [116.448765, 32.789073],
                            [116.44743, 32.760951],
                            [116.442998, 32.748583],
                            [116.445238, 32.732977],
                            [116.45539, 32.729845],
                            [116.45315, 32.71481],
                            [116.444142, 32.70656],
                            [116.44519, 32.697997],
                            [116.460252, 32.680972],
                            [116.487135, 32.677942],
                            [116.489327, 32.681807],
                            [116.502197, 32.681024],
                            [116.506439, 32.662899],
                            [116.526267, 32.657779],
                            [116.535276, 32.628466],
                            [116.541711, 32.622874],
                            [116.537898, 32.615452],
                            [116.540138, 32.60296],
                            [116.555867, 32.600032],
                            [116.554771, 32.585864],
                            [116.601863, 32.588949],
                            [116.620119, 32.583354],
                            [116.628984, 32.575197],
                            [116.635085, 32.55386],
                            [116.613827, 32.544811],
                            [116.566591, 32.544183],
                            [116.523741, 32.509234],
                            [116.522597, 32.486468],
                            [116.509966, 32.460607],
                            [116.494714, 32.465319],
                            [116.490471, 32.448407],
                            [116.484799, 32.439347]
                        ]
                    ],
                    [
                        [
                            [115.510587, 32.468827],
                            [115.510682, 32.467832],
                            [115.509347, 32.466733],
                            [115.508632, 32.468565],
                            [115.510587, 32.468827]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 341300,
                "name": "宿州市",
                "center": [116.984084, 33.633891],
                "centroid": [117.213969, 33.860247],
                "childrenNum": 5,
                "level": "city",
                "parent": {
                    "adcode": 340000
                },
                "subFeatureIndex": 11,
                "acroutes": [100000, 340000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [117.031081, 34.242765],
                            [117.035085, 34.23189],
                            [117.030175, 34.221372],
                            [117.021691, 34.213675],
                            [117.009584, 34.219679],
                            [117.007821, 34.232967],
                            [116.994666, 34.222808],
                            [116.988803, 34.205208],
                            [116.99538, 34.206337],
                            [116.980271, 34.195867],
                            [116.982416, 34.172357],
                            [116.993522, 34.168352],
                            [116.980176, 34.155978],
                            [116.982416, 34.167274],
                            [116.975457, 34.169071],
                            [116.971501, 34.154643],
                            [116.982177, 34.137285],
                            [117.001768, 34.142318],
                            [117.004913, 34.151408],
                            [117.012921, 34.149508],
                            [117.023312, 34.161678],
                            [117.031748, 34.155721],
                            [117.031558, 34.166709],
                            [117.038374, 34.167428],
                            [117.047049, 34.151408],
                            [117.054913, 34.155105],
                            [117.072311, 34.146683],
                            [117.089994, 34.145707],
                            [117.106439, 34.130402],
                            [117.123836, 34.128193],
                            [117.129985, 34.117457],
                            [117.130318, 34.101787],
                            [117.146572, 34.09783],
                            [117.157916, 34.098755],
                            [117.151434, 34.083698],
                            [117.1613, 34.084315],
                            [117.182082, 34.07604],
                            [117.192711, 34.068742],
                            [117.207058, 34.068639],
                            [117.212158, 34.074704],
                            [117.224742, 34.064167],
                            [117.25763, 34.065914],
                            [117.277029, 34.078919],
                            [117.287754, 34.078662],
                            [117.293807, 34.071055],
                            [117.311491, 34.068073],
                            [117.319498, 34.084366],
                            [117.343426, 34.080563],
                            [117.357153, 34.088221],
                            [117.377792, 34.071466],
                            [117.371119, 34.060671],
                            [117.38823, 34.055582],
                            [117.40029, 34.041545],
                            [117.405723, 34.030078],
                            [117.415638, 34.025913],
                            [117.435466, 34.02833],
                            [117.460251, 34.03738],
                            [117.476791, 34.047613],
                            [117.500432, 34.05224],
                            [117.504913, 34.061648],
                            [117.514779, 34.060877],
                            [117.537468, 34.04463],
                            [117.545332, 34.035169],
                            [117.54252, 34.021644],
                            [117.544665, 34.01362],
                            [117.556438, 34.007345],
                            [117.568926, 33.985223],
                            [117.575742, 33.982908],
                            [117.588183, 33.987847],
                            [117.597859, 33.997005],
                            [117.610299, 33.999217],
                            [117.616638, 34.004927],
                            [117.618116, 34.017118],
                            [117.610251, 34.029307],
                            [117.6164, 34.032289],
                            [117.629746, 34.02869],
                            [117.64252, 34.01542],
                            [117.666305, 33.998703],
                            [117.671309, 33.986715],
                            [117.662968, 33.968705],
                            [117.672501, 33.95239],
                            [117.672596, 33.934938],
                            [117.690089, 33.915372],
                            [117.703626, 33.887818],
                            [117.715399, 33.879267],
                            [117.740852, 33.89199],
                            [117.753769, 33.891424],
                            [117.758631, 33.885655],
                            [117.759203, 33.874527],
                            [117.752434, 33.863243],
                            [117.752959, 33.847165],
                            [117.750099, 33.827167],
                            [117.746142, 33.823765],
                            [117.752482, 33.812835],
                            [117.749002, 33.791643],
                            [117.741853, 33.762759],
                            [117.734036, 33.75177],
                            [117.724694, 33.749551],
                            [117.722739, 33.740831],
                            [117.731939, 33.734742],
                            [117.735275, 33.722717],
                            [117.752673, 33.711517],
                            [117.767067, 33.72184],
                            [117.777935, 33.722511],
                            [117.791757, 33.7334],
                            [117.825504, 33.737322],
                            [117.835847, 33.734123],
                            [117.858964, 33.734329],
                            [117.879936, 33.727775],
                            [117.887706, 33.722614],
                            [117.901671, 33.720137],
                            [117.897572, 33.729324],
                            [117.90048, 33.735671],
                            [117.915828, 33.738354],
                            [117.920547, 33.733349],
                            [117.936705, 33.729375],
                            [117.949431, 33.734071],
                            [117.954293, 33.751047],
                            [117.964922, 33.763429],
                            [117.972358, 33.750274],
                            [117.982796, 33.747333],
                            [117.994426, 33.750067],
                            [117.996714, 33.746146],
                            [118.018783, 33.745836],
                            [118.019974, 33.738716],
                            [118.03089, 33.74047],
                            [118.028316, 33.746662],
                            [118.045761, 33.750016],
                            [118.062443, 33.758374],
                            [118.065589, 33.765802],
                            [118.105961, 33.764616],
                            [118.117973, 33.766524],
                            [118.129746, 33.754195],
                            [118.148859, 33.746404],
                            [118.16292, 33.750738],
                            [118.185322, 33.744959],
                            [118.177458, 33.735826],
                            [118.160823, 33.73531],
                            [118.153339, 33.720137],
                            [118.167734, 33.714975],
                            [118.163969, 33.692623],
                            [118.168258, 33.664015],
                            [118.120117, 33.621655],
                            [118.112443, 33.617262],
                            [118.117782, 33.594419],
                            [118.108392, 33.529991],
                            [118.099145, 33.529371],
                            [118.107963, 33.520163],
                            [118.106819, 33.503917],
                            [118.108106, 33.475091],
                            [118.061681, 33.490773],
                            [118.05067, 33.492067],
                            [118.043568, 33.473694],
                            [118.028649, 33.458423],
                            [118.023597, 33.440923],
                            [118.021881, 33.421193],
                            [118.016924, 33.407001],
                            [118.028268, 33.390578],
                            [118.02598, 33.381459],
                            [118.029269, 33.372236],
                            [118.005913, 33.352075],
                            [117.995475, 33.347099],
                            [117.971595, 33.349328],
                            [117.969546, 33.34404],
                            [117.978983, 33.334139],
                            [117.972691, 33.330095],
                            [117.952148, 33.32885],
                            [117.916018, 33.330095],
                            [117.909155, 33.344455],
                            [117.897954, 33.340308],
                            [117.894379, 33.330613],
                            [117.870976, 33.329213],
                            [117.859202, 33.324962],
                            [117.85353, 33.304323],
                            [117.846619, 33.295247],
                            [117.824836, 33.299085],
                            [117.809536, 33.296232],
                            [117.808345, 33.283161],
                            [117.793283, 33.277559],
                            [117.775408, 33.282383],
                            [117.737801, 33.275068],
                            [117.728125, 33.284821],
                            [117.710585, 33.282954],
                            [117.692663, 33.291668],
                            [117.690184, 33.304997],
                            [117.677124, 33.309924],
                            [117.66783, 33.327917],
                            [117.642997, 33.333465],
                            [117.631939, 33.343677],
                            [117.62374, 33.345336],
                            [117.609393, 33.339789],
                            [117.58966, 33.323303],
                            [117.577982, 33.32548],
                            [117.56416, 33.333257],
                            [117.539756, 33.327813],
                            [117.528793, 33.339686],
                            [117.507344, 33.346062],
                            [117.484274, 33.345544],
                            [117.477077, 33.347772],
                            [117.433607, 33.379024],
                            [117.424169, 33.399955],
                            [117.40172, 33.424766],
                            [117.391519, 33.456249],
                            [117.365399, 33.470951],
                            [117.34519, 33.475661],
                            [117.320404, 33.476127],
                            [117.309632, 33.490877],
                            [117.261967, 33.497035],
                            [117.24314, 33.501537],
                            [117.241996, 33.489945],
                            [117.231367, 33.47328],
                            [117.208011, 33.453091],
                            [117.202721, 33.423472],
                            [117.15968, 33.457543],
                            [117.154818, 33.439059],
                            [117.139708, 33.442011],
                            [117.128793, 33.434554],
                            [117.126839, 33.422384],
                            [117.134656, 33.419743],
                            [117.14376, 33.409694],
                            [117.133417, 33.387366],
                            [117.125504, 33.380993],
                            [117.107344, 33.392702],
                            [117.108774, 33.398194],
                            [117.094808, 33.398246],
                            [117.08232, 33.406638],
                            [117.060728, 33.392288],
                            [117.051243, 33.371406],
                            [117.062873, 33.373946],
                            [117.084894, 33.365498],
                            [117.096572, 33.353941],
                            [117.093521, 33.346788],
                            [117.080795, 33.344507],
                            [117.074932, 33.333931],
                            [117.064303, 33.332842],
                            [117.065018, 33.321591],
                            [117.092092, 33.316147],
                            [117.099289, 33.307746],
                            [117.095523, 33.284873],
                            [117.034132, 33.293276],
                            [117.025409, 33.29644],
                            [117.012444, 33.279219],
                            [117.002578, 33.278025],
                            [116.986658, 33.281657],
                            [116.974599, 33.278389],
                            [116.953531, 33.286637],
                            [116.937897, 33.301315],
                            [116.923407, 33.30702],
                            [116.929413, 33.317132],
                            [116.927268, 33.324703],
                            [116.918355, 33.328539],
                            [116.921119, 33.334346],
                            [116.913922, 33.344559],
                            [116.924218, 33.34658],
                            [116.928174, 33.358813],
                            [116.932749, 33.360212],
                            [116.942902, 33.377417],
                            [116.957249, 33.374464],
                            [116.958298, 33.379957],
                            [116.973455, 33.391977],
                            [116.964351, 33.399334],
                            [116.969403, 33.412336],
                            [116.965209, 33.419069],
                            [116.971358, 33.42834],
                            [116.96621, 33.433052],
                            [116.966734, 33.443305],
                            [116.958822, 33.452314],
                            [116.940042, 33.453608],
                            [116.929461, 33.462151],
                            [116.928793, 33.470795],
                            [116.904961, 33.47711],
                            [116.905771, 33.482338],
                            [116.919594, 33.492895],
                            [116.90458, 33.505987],
                            [116.915257, 33.53894],
                            [116.927888, 33.543905],
                            [116.928269, 33.554403],
                            [116.937039, 33.580307],
                            [116.915209, 33.578291],
                            [116.899527, 33.572035],
                            [116.873741, 33.589612],
                            [116.865209, 33.603878],
                            [116.859728, 33.62429],
                            [116.867926, 33.637361],
                            [116.871787, 33.650483],
                            [116.869594, 33.661949],
                            [116.873693, 33.675945],
                            [116.880795, 33.676874],
                            [116.906343, 33.670884],
                            [116.917116, 33.674137],
                            [116.929365, 33.673156],
                            [116.928221, 33.702948],
                            [116.939279, 33.705116],
                            [116.932082, 33.739335],
                            [116.93437, 33.748158],
                            [116.950767, 33.746146],
                            [116.943951, 33.756465],
                            [116.942235, 33.773746],
                            [116.95029, 33.790096],
                            [116.949575, 33.808814],
                            [116.951386, 33.832476],
                            [116.958155, 33.847732],
                            [116.959108, 33.880245],
                            [116.962826, 33.892918],
                            [116.986038, 33.899047],
                            [116.997096, 33.914188],
                            [116.990471, 33.92495],
                            [116.99948, 33.938336],
                            [116.991234, 33.952801],
                            [116.991281, 33.961757],
                            [116.98375, 33.964948],
                            [116.970929, 33.961809],
                            [116.95763, 33.967676],
                            [116.977459, 33.993609],
                            [116.974027, 33.998703],
                            [116.978603, 34.007191],
                            [116.969451, 34.013672],
                            [116.971596, 34.025604],
                            [116.967163, 34.028895],
                            [116.947668, 34.031004],
                            [116.950195, 34.037072],
                            [116.94805, 34.05224],
                            [116.961634, 34.064218],
                            [116.973074, 34.07897],
                            [116.955628, 34.077788],
                            [116.929556, 34.080615],
                            [116.92865, 34.091201],
                            [116.908965, 34.098961],
                            [116.902435, 34.098241],
                            [116.888898, 34.082722],
                            [116.874122, 34.073984],
                            [116.850719, 34.082516],
                            [116.845905, 34.06977],
                            [116.833512, 34.066223],
                            [116.828555, 34.058923],
                            [116.816639, 34.072854],
                            [116.818689, 34.086114],
                            [116.806248, 34.077017],
                            [116.811682, 34.067919],
                            [116.808345, 34.063961],
                            [116.801911, 34.032392],
                            [116.807678, 34.012386],
                            [116.803055, 33.993712],
                            [116.796239, 34.003384],
                            [116.784084, 34.007293],
                            [116.784418, 34.011357],
                            [116.752435, 34.013003],
                            [116.745762, 34.017015],
                            [116.734275, 34.012077],
                            [116.730652, 34.016192],
                            [116.711158, 34.014186],
                            [116.703913, 34.009454],
                            [116.689899, 34.016141],
                            [116.678984, 34.010174],
                            [116.662445, 34.018198],
                            [116.648765, 34.021438],
                            [116.626887, 34.017581],
                            [116.604199, 34.021335],
                            [116.595619, 34.040106],
                            [116.587421, 34.04571],
                            [116.576887, 34.064064],
                            [116.580319, 34.065555],
                            [116.567735, 34.075938],
                            [116.566877, 34.083801],
                            [116.557964, 34.097779],
                            [116.539613, 34.103482],
                            [116.541472, 34.109956],
                            [116.528031, 34.122851],
                            [116.534656, 34.126601],
                            [116.535991, 34.150997],
                            [116.545857, 34.161061],
                            [116.565495, 34.169533],
                            [116.559966, 34.186166],
                            [116.546143, 34.195508],
                            [116.542712, 34.218858],
                            [116.547144, 34.228196],
                            [116.543617, 34.239533],
                            [116.55396, 34.241893],
                            [116.56764, 34.251229],
                            [116.582321, 34.266512],
                            [116.582416, 34.27523],
                            [116.568975, 34.283434],
                            [116.511873, 34.296456],
                            [116.490138, 34.290919],
                            [116.466306, 34.271179],
                            [116.456868, 34.269127],
                            [116.44581, 34.28815],
                            [116.4307, 34.27805],
                            [116.433226, 34.270153],
                            [116.416258, 34.268256],
                            [116.406105, 34.276512],
                            [116.393951, 34.276101],
                            [116.375934, 34.271281],
                            [116.372216, 34.266102],
                            [116.363255, 34.276255],
                            [116.37336, 34.293944],
                            [116.368832, 34.310244],
                            [116.363541, 34.316856],
                            [116.329652, 34.329719],
                            [116.301577, 34.342119],
                            [116.288803, 34.358923],
                            [116.276792, 34.360409],
                            [116.270834, 34.370704],
                            [116.255629, 34.376492],
                            [116.2399, 34.374545],
                            [116.213589, 34.382227],
                            [116.209919, 34.390216],
                            [116.217068, 34.395541],
                            [116.215877, 34.403324],
                            [116.205295, 34.415662],
                            [116.179223, 34.430506],
                            [116.174933, 34.444682],
                            [116.162064, 34.459419],
                            [116.178842, 34.483565],
                            [116.178603, 34.496044],
                            [116.189471, 34.497067],
                            [116.203913, 34.508675],
                            [116.203818, 34.518748],
                            [116.190948, 34.53567],
                            [116.196334, 34.555654],
                            [116.197002, 34.57594],
                            [116.206296, 34.578086],
                            [116.216925, 34.575123],
                            [116.233417, 34.555143],
                            [116.247717, 34.55177],
                            [116.25296, 34.565721],
                            [116.259156, 34.567612],
                            [116.266067, 34.583757],
                            [116.274885, 34.584626],
                            [116.278651, 34.602096],
                            [116.286086, 34.608838],
                            [116.301101, 34.607765],
                            [116.310872, 34.601432],
                            [116.324981, 34.601125],
                            [116.333989, 34.62089],
                            [116.350958, 34.621145],
                            [116.372121, 34.633451],
                            [116.374218, 34.639986],
                            [116.382559, 34.638659],
                            [116.393379, 34.643049],
                            [116.43051, 34.650809],
                            [116.432845, 34.630132],
                            [116.447573, 34.620532],
                            [116.477221, 34.615119],
                            [116.478365, 34.603832],
                            [116.491425, 34.588968],
                            [116.492378, 34.570576],
                            [116.509585, 34.557494],
                            [116.526124, 34.553354],
                            [116.520643, 34.543184],
                            [116.529175, 34.540679],
                            [116.54805, 34.542928],
                            [116.570548, 34.523401],
                            [116.587707, 34.51251],
                            [116.59519, 34.511539],
                            [116.598956, 34.500187],
                            [116.592473, 34.493845],
                            [116.576792, 34.497681],
                            [116.568689, 34.492515],
                            [116.575123, 34.488935],
                            [116.623407, 34.488628],
                            [116.662588, 34.473027],
                            [116.722883, 34.472669],
                            [116.745095, 34.46827],
                            [116.760681, 34.462591],
                            [116.773693, 34.453483],
                            [116.782702, 34.438285],
                            [116.782654, 34.430199],
                            [116.804723, 34.412744],
                            [116.828078, 34.389243],
                            [116.848526, 34.389038],
                            [116.86702, 34.392162],
                            [116.883512, 34.403068],
                            [116.909203, 34.40829],
                            [116.920547, 34.40701],
                            [116.945667, 34.395541],
                            [116.969308, 34.388833],
                            [116.960967, 34.371985],
                            [116.961253, 34.363277],
                            [116.980223, 34.358359],
                            [116.983178, 34.352468],
                            [116.979651, 34.338533],
                            [116.96926, 34.323109],
                            [116.976648, 34.310911],
                            [116.968974, 34.28369],
                            [116.98437, 34.269845],
                            [117.007249, 34.256973],
                            [117.018879, 34.255537],
                            [117.020786, 34.243329],
                            [117.031081, 34.242765]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 341500,
                "name": "六安市",
                "center": [116.507676, 31.752889],
                "centroid": [116.233982, 31.65917],
                "childrenNum": 7,
                "level": "city",
                "parent": {
                    "adcode": 340000
                },
                "subFeatureIndex": 12,
                "acroutes": [100000, 340000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [115.928365, 32.567563],
                            [115.936992, 32.571955],
                            [115.95234, 32.59104],
                            [115.967355, 32.605103],
                            [115.996954, 32.602907],
                            [116.022026, 32.591563],
                            [116.03113, 32.573524],
                            [116.036849, 32.555011],
                            [116.05663, 32.546328],
                            [116.076411, 32.543974],
                            [116.090948, 32.539162],
                            [116.101435, 32.523833],
                            [116.113398, 32.490812],
                            [116.124552, 32.47113],
                            [116.141854, 32.46045],
                            [116.148146, 32.439923],
                            [116.167879, 32.439766],
                            [116.176411, 32.425363],
                            [116.191187, 32.454271],
                            [116.203722, 32.447621],
                            [116.213065, 32.463748],
                            [116.222979, 32.459193],
                            [116.23561, 32.465843],
                            [116.244523, 32.4549],
                            [116.251244, 32.464429],
                            [116.246334, 32.48406],
                            [116.26397, 32.494738],
                            [116.271692, 32.520955],
                            [116.320071, 32.521164],
                            [116.332798, 32.510385],
                            [116.358489, 32.464743],
                            [116.392235, 32.447621],
                            [116.404819, 32.442804],
                            [116.437564, 32.45092],
                            [116.472359, 32.438247],
                            [116.484799, 32.439347],
                            [116.480176, 32.406767],
                            [116.492187, 32.395817],
                            [116.485371, 32.388062],
                            [116.481129, 32.375276],
                            [116.48418, 32.360286],
                            [116.501911, 32.343879],
                            [116.509537, 32.324479],
                            [116.519261, 32.314411],
                            [116.521501, 32.292539],
                            [116.52641, 32.270716],
                            [116.521835, 32.261113],
                            [116.527554, 32.240594],
                            [116.515305, 32.223377],
                            [116.501101, 32.215345],
                            [116.515638, 32.202692],
                            [116.517068, 32.194395],
                            [116.509299, 32.18468],
                            [116.515495, 32.163461],
                            [116.526601, 32.151746],
                            [116.530224, 32.134249],
                            [116.524694, 32.116434],
                            [116.533131, 32.097932],
                            [116.549385, 32.078848],
                            [116.544046, 32.067701],
                            [116.551911, 32.042036],
                            [116.546858, 32.028149],
                            [116.571167, 32.020468],
                            [116.586801, 32.018784],
                            [116.612635, 32.000947],
                            [116.667735, 31.977947],
                            [116.677936, 31.976263],
                            [116.681939, 31.967999],
                            [116.680462, 31.957259],
                            [116.680509, 31.915552],
                            [116.687754, 31.903437],
                            [116.70234, 31.905122],
                            [116.723169, 31.916711],
                            [116.748479, 31.919028],
                            [116.771072, 31.911286],
                            [116.764256, 31.904227],
                            [116.716067, 31.884207],
                            [116.714113, 31.878938],
                            [116.721596, 31.87135],
                            [116.724647, 31.85828],
                            [116.740567, 31.857911],
                            [116.732607, 31.848371],
                            [116.702006, 31.832082],
                            [116.692521, 31.820272],
                            [116.694809, 31.809356],
                            [116.714113, 31.791847],
                            [116.719785, 31.779083],
                            [116.728746, 31.782406],
                            [116.734752, 31.77481],
                            [116.731129, 31.76542],
                            [116.752101, 31.765525],
                            [116.758012, 31.762465],
                            [116.759442, 31.7469],
                            [116.752149, 31.728746],
                            [116.762254, 31.711327],
                            [116.763255, 31.685879],
                            [116.767926, 31.672097],
                            [116.757583, 31.659157],
                            [116.75315, 31.647061],
                            [116.754628, 31.636918],
                            [116.765638, 31.618584],
                            [116.766782, 31.589358],
                            [116.763255, 31.58238],
                            [116.767497, 31.571331],
                            [116.789756, 31.550605],
                            [116.792854, 31.543941],
                            [116.804485, 31.539235],
                            [116.806725, 31.532624],
                            [116.815733, 31.531936],
                            [116.829747, 31.519083],
                            [116.845476, 31.526488],
                            [116.879318, 31.531672],
                            [116.902054, 31.528234],
                            [116.934561, 31.537754],
                            [116.95253, 31.532042],
                            [116.966925, 31.539816],
                            [116.975457, 31.540239],
                            [116.987135, 31.533787],
                            [116.990566, 31.545634],
                            [117.003197, 31.549653],
                            [117.039613, 31.538864],
                            [117.055009, 31.544735],
                            [117.065971, 31.553513],
                            [117.112301, 31.540081],
                            [117.124265, 31.54447],
                            [117.132082, 31.542884],
                            [117.13375, 31.551028],
                            [117.144999, 31.554835],
                            [117.153817, 31.545158],
                            [117.187039, 31.552085],
                            [117.198288, 31.551979],
                            [117.220023, 31.540239],
                            [117.228316, 31.544788],
                            [117.242282, 31.508185],
                            [117.251386, 31.502947],
                            [117.250719, 31.49681],
                            [117.237277, 31.490461],
                            [117.184513, 31.492842],
                            [117.166448, 31.490619],
                            [117.149194, 31.483317],
                            [117.142473, 31.472045],
                            [117.11907, 31.446637],
                            [117.094379, 31.408831],
                            [117.074837, 31.374401],
                            [117.074074, 31.360678],
                            [117.081367, 31.345947],
                            [117.073693, 31.335453],
                            [117.070023, 31.321724],
                            [117.070786, 31.301102],
                            [117.063874, 31.289436],
                            [117.045809, 31.282967],
                            [117.045285, 31.269018],
                            [117.032273, 31.256607],
                            [117.016257, 31.266844],
                            [117.006725, 31.267693],
                            [116.998193, 31.2565],
                            [116.981415, 31.244564],
                            [116.963255, 31.214532],
                            [116.954008, 31.189161],
                            [116.946906, 31.182738],
                            [116.943903, 31.161766],
                            [116.92274, 31.160067],
                            [116.919356, 31.151305],
                            [116.894952, 31.133407],
                            [116.875981, 31.127458],
                            [116.862254, 31.129901],
                            [116.847144, 31.124642],
                            [116.842187, 31.11338],
                            [116.843331, 31.104455],
                            [116.829365, 31.101213],
                            [116.815638, 31.085378],
                            [116.805962, 31.08219],
                            [116.78866, 31.065289],
                            [116.777602, 31.070019],
                            [116.761301, 31.068372],
                            [116.752721, 31.060877],
                            [116.736753, 31.063907],
                            [116.722883, 31.059601],
                            [116.70968, 31.043228],
                            [116.68866, 31.048703],
                            [116.68356, 31.055774],
                            [116.665495, 31.059123],
                            [116.65396, 31.052212],
                            [116.647049, 31.05891],
                            [116.622502, 31.074112],
                            [116.614018, 31.073899],
                            [116.611539, 31.067309],
                            [116.594571, 31.054126],
                            [116.591711, 31.04764],
                            [116.571072, 31.051787],
                            [116.563779, 31.045567],
                            [116.560347, 31.034614],
                            [116.543617, 31.020311],
                            [116.530605, 31.021002],
                            [116.530939, 31.035306],
                            [116.534799, 31.044185],
                            [116.533512, 31.056624],
                            [116.538708, 31.072145],
                            [116.549385, 31.093243],
                            [116.562683, 31.111096],
                            [116.555867, 31.123314],
                            [116.558346, 31.147587],
                            [116.552816, 31.165908],
                            [116.556582, 31.172173],
                            [116.552816, 31.179712],
                            [116.543474, 31.181941],
                            [116.538469, 31.174456],
                            [116.519547, 31.160173],
                            [116.508298, 31.142489],
                            [116.501911, 31.141427],
                            [116.496715, 31.148756],
                            [116.481844, 31.136965],
                            [116.470071, 31.135637],
                            [116.4603, 31.125917],
                            [116.437707, 31.128414],
                            [116.431892, 31.144135],
                            [116.415305, 31.162191],
                            [116.395572, 31.162084],
                            [116.378984, 31.165377],
                            [116.359537, 31.173978],
                            [116.344952, 31.163624],
                            [116.342712, 31.15242],
                            [116.3307, 31.145622],
                            [116.309776, 31.140418],
                            [116.303532, 31.123155],
                            [116.293045, 31.114761],
                            [116.268498, 31.100098],
                            [116.261396, 31.082403],
                            [116.243427, 31.0756],
                            [116.222455, 31.061781],
                            [116.203293, 31.0579],
                            [116.183751, 31.064917],
                            [116.18132, 31.083359],
                            [116.166258, 31.0976],
                            [116.157679, 31.099301],
                            [116.11888, 31.086866],
                            [116.10458, 31.094465],
                            [116.093379, 31.090108],
                            [116.092664, 31.082668],
                            [116.066354, 31.070072],
                            [116.050958, 31.049554],
                            [116.051578, 31.042217],
                            [116.046144, 31.014514],
                            [116.015019, 31.011908],
                            [116.010062, 31.017332],
                            [116.00663, 31.034668],
                            [115.994047, 31.034614],
                            [115.983704, 31.041898],
                            [115.961063, 31.046896],
                            [115.946192, 31.04243],
                            [115.938565, 31.047321],
                            [115.942235, 31.060664],
                            [115.939805, 31.071667],
                            [115.925744, 31.076822],
                            [115.909585, 31.090693],
                            [115.902769, 31.089205],
                            [115.887421, 31.109289],
                            [115.886373, 31.127351],
                            [115.880081, 31.141905],
                            [115.869261, 31.14764],
                            [115.857107, 31.143286],
                            [115.841282, 31.128998],
                            [115.829128, 31.126448],
                            [115.813256, 31.13091],
                            [115.797908, 31.127883],
                            [115.781511, 31.11354],
                            [115.770072, 31.113061],
                            [115.764066, 31.118215],
                            [115.75582, 31.142542],
                            [115.740567, 31.152951],
                            [115.728127, 31.174721],
                            [115.700815, 31.201104],
                            [115.678127, 31.207632],
                            [115.655248, 31.210976],
                            [115.645954, 31.209596],
                            [115.636325, 31.19999],
                            [115.629033, 31.184649],
                            [115.603723, 31.173712],
                            [115.596716, 31.150136],
                            [115.585706, 31.144188],
                            [115.559586, 31.160332],
                            [115.540711, 31.191337],
                            [115.538375, 31.220369],
                            [115.53971, 31.231884],
                            [115.530081, 31.249339],
                            [115.51602, 31.263502],
                            [115.507584, 31.267905],
                            [115.501006, 31.262388],
                            [115.494047, 31.265942],
                            [115.473122, 31.265253],
                            [115.466402, 31.276338],
                            [115.457822, 31.281588],
                            [115.460968, 31.318067],
                            [115.449624, 31.31584],
                            [115.442045, 31.346106],
                            [115.420501, 31.349921],
                            [115.404581, 31.337838],
                            [115.3991, 31.342979],
                            [115.372074, 31.349285],
                            [115.382465, 31.356598],
                            [115.375744, 31.371063],
                            [115.38318, 31.37562],
                            [115.392808, 31.38987],
                            [115.373647, 31.40576],
                            [115.38337, 31.418682],
                            [115.385658, 31.443302],
                            [115.389805, 31.45029],
                            [115.377651, 31.47051],
                            [115.371168, 31.494535],
                            [115.377126, 31.503],
                            [115.389614, 31.507603],
                            [115.396812, 31.515168],
                            [115.415877, 31.525959],
                            [115.428556, 31.54722],
                            [115.431559, 31.559012],
                            [115.428223, 31.563401],
                            [115.438852, 31.579948],
                            [115.440043, 31.588723],
                            [115.488232, 31.612242],
                            [115.489662, 31.62577],
                            [115.476983, 31.64294],
                            [115.484276, 31.649068],
                            [115.48542, 31.659791],
                            [115.495382, 31.672942],
                            [115.515067, 31.682869],
                            [115.531845, 31.698551],
                            [115.553485, 31.695278],
                            [115.564924, 31.709004],
                            [115.582655, 31.713913],
                            [115.586945, 31.721726],
                            [115.601435, 31.731701],
                            [115.619166, 31.738351],
                            [115.636564, 31.755078],
                            [115.659633, 31.760196],
                            [115.677793, 31.778872],
                            [115.689805, 31.776551],
                            [115.697145, 31.768638],
                            [115.710825, 31.770906],
                            [115.729843, 31.763309],
                            [115.734276, 31.776023],
                            [115.741997, 31.78209],
                            [115.763065, 31.782353],
                            [115.767927, 31.787839],
                            [115.788327, 31.779821],
                            [115.815353, 31.76236],
                            [115.831034, 31.777606],
                            [115.836468, 31.77386],
                            [115.850243, 31.786731],
                            [115.858298, 31.773702],
                            [115.868689, 31.776551],
                            [115.885229, 31.776076],
                            [115.900815, 31.792006],
                            [115.910253, 31.792322],
                            [115.915019, 31.811888],
                            [115.91316, 31.820113],
                            [115.904056, 31.829393],
                            [115.89295, 31.833294],
                            [115.895715, 31.867503],
                            [115.898337, 31.880255],
                            [115.90377, 31.883522],
                            [115.917259, 31.909969],
                            [115.920167, 31.92045],
                            [115.916115, 31.935987],
                            [115.909013, 31.943253],
                            [115.911349, 31.957996],
                            [115.92317, 31.985474],
                            [115.924552, 31.995579],
                            [115.933799, 32.001631],
                            [115.927603, 32.007524],
                            [115.927841, 32.023572],
                            [115.919547, 32.027886],
                            [115.927745, 32.036303],
                            [115.922216, 32.049663],
                            [115.927793, 32.058761],
                            [115.939614, 32.065861],
                            [115.942569, 32.077692],
                            [115.932512, 32.084264],
                            [115.926554, 32.105239],
                            [115.931368, 32.109286],
                            [115.940329, 32.146755],
                            [115.941949, 32.165141],
                            [115.933656, 32.180426],
                            [115.925267, 32.187831],
                            [115.922884, 32.203637],
                            [115.912731, 32.227629],
                            [115.914733, 32.254869],
                            [115.920072, 32.273181],
                            [115.911063, 32.284199],
                            [115.908251, 32.299253],
                            [115.900291, 32.301404],
                            [115.906964, 32.311579],
                            [115.904581, 32.340995],
                            [115.899242, 32.344979],
                            [115.897908, 32.372289],
                            [115.899099, 32.390106],
                            [115.88928, 32.413473],
                            [115.889423, 32.424263],
                            [115.879223, 32.432591],
                            [115.883275, 32.438614],
                            [115.882703, 32.456104],
                            [115.864257, 32.458932],
                            [115.872359, 32.469769],
                            [115.881273, 32.472491],
                            [115.883561, 32.489242],
                            [115.874457, 32.497773],
                            [115.87317, 32.504734],
                            [115.853055, 32.504472],
                            [115.845763, 32.501803],
                            [115.847336, 32.509548],
                            [115.856964, 32.517973],
                            [115.873027, 32.525821],
                            [115.87765, 32.54387],
                            [115.899433, 32.556214],
                            [115.910205, 32.566987],
                            [115.928365, 32.567563]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 341600,
                "name": "亳州市",
                "center": [115.782939, 33.869338],
                "centroid": [116.184956, 33.435373],
                "childrenNum": 4,
                "level": "city",
                "parent": {
                    "adcode": 340000
                },
                "subFeatureIndex": 13,
                "acroutes": [100000, 340000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [116.393713, 33.783082],
                            [116.408155, 33.770393],
                            [116.406439, 33.762552],
                            [116.435753, 33.762191],
                            [116.433226, 33.739696],
                            [116.460014, 33.734123],
                            [116.463589, 33.719724],
                            [116.479413, 33.708678],
                            [116.478603, 33.697992],
                            [116.484227, 33.697889],
                            [116.492426, 33.681315],
                            [116.49214, 33.668405],
                            [116.485848, 33.666081],
                            [116.481129, 33.654253],
                            [116.503817, 33.631265],
                            [116.505486, 33.618968],
                            [116.533751, 33.614575],
                            [116.543808, 33.59783],
                            [116.551101, 33.596642],
                            [116.55153, 33.588578],
                            [116.540662, 33.587596],
                            [116.548002, 33.57007],
                            [116.531939, 33.565624],
                            [116.525505, 33.551455],
                            [116.52846, 33.544008],
                            [116.524742, 33.53056],
                            [116.534656, 33.525077],
                            [116.539089, 33.513178],
                            [116.533989, 33.498018],
                            [116.535562, 33.481302],
                            [116.547478, 33.467897],
                            [116.56826, 33.466292],
                            [116.58213, 33.471209],
                            [116.593617, 33.480112],
                            [116.612778, 33.481872],
                            [116.623503, 33.485495],
                            [116.63642, 33.484977],
                            [116.642378, 33.477628],
                            [116.665733, 33.474626],
                            [116.687182, 33.47799],
                            [116.700004, 33.474056],
                            [116.722597, 33.450709],
                            [116.745905, 33.449104],
                            [116.756725, 33.438438],
                            [116.7705, 33.431861],
                            [116.804628, 33.422902],
                            [116.796572, 33.403012],
                            [116.800862, 33.386122],
                            [116.790948, 33.360005],
                            [116.794141, 33.354822],
                            [116.787421, 33.347254],
                            [116.790424, 33.334553],
                            [116.789089, 33.319777],
                            [116.801911, 33.303908],
                            [116.800481, 33.27595],
                            [116.805485, 33.275587],
                            [116.813159, 33.250319],
                            [116.825981, 33.230804],
                            [116.826553, 33.210819],
                            [116.821405, 33.202771],
                            [116.815304, 33.155405],
                            [116.805247, 33.156081],
                            [116.791853, 33.169015],
                            [116.777078, 33.151821],
                            [116.77131, 33.15525],
                            [116.756868, 33.141222],
                            [116.754723, 33.13109],
                            [116.764589, 33.114823],
                            [116.764637, 33.090704],
                            [116.749098, 33.075522],
                            [116.748622, 33.060858],
                            [116.752483, 33.053108],
                            [116.781558, 33.040105],
                            [116.802197, 33.032666],
                            [116.814923, 33.021532],
                            [116.816162, 33.013051],
                            [116.810586, 32.99541],
                            [116.802483, 33.000042],
                            [116.79886, 32.994161],
                            [116.777459, 32.996607],
                            [116.778174, 33.00332],
                            [116.768784, 33.000406],
                            [116.76826, 33.006078],
                            [116.755152, 33.002696],
                            [116.754628, 32.98906],
                            [116.747526, 32.978962],
                            [116.740424, 32.959752],
                            [116.742711, 32.94736],
                            [116.735657, 32.928663],
                            [116.705676, 32.936944],
                            [116.684323, 32.93934],
                            [116.627888, 32.941475],
                            [116.446382, 32.984896],
                            [116.382416, 33.004777],
                            [116.376649, 32.993744],
                            [116.376458, 32.969019],
                            [116.371739, 32.964906],
                            [116.365162, 32.946891],
                            [116.365877, 32.940694],
                            [116.385705, 32.921632],
                            [116.393856, 32.910745],
                            [116.394618, 32.891311],
                            [116.386992, 32.89772],
                            [116.370881, 32.900221],
                            [116.348098, 32.878128],
                            [116.30825, 32.86562],
                            [116.292569, 32.858948],
                            [116.280319, 32.859052],
                            [116.248527, 32.872812],
                            [116.245333, 32.884954],
                            [116.232988, 32.889852],
                            [116.212636, 32.888706],
                            [116.198432, 32.893396],
                            [116.191711, 32.91387],
                            [116.178889, 32.922882],
                            [116.168165, 32.940642],
                            [116.165305, 32.959492],
                            [116.167926, 32.967145],
                            [116.155581, 32.973757],
                            [116.125743, 32.976047],
                            [116.083084, 32.986458],
                            [116.054914, 32.99057],
                            [116.052531, 32.99515],
                            [116.060062, 33.003737],
                            [116.059013, 33.016954],
                            [116.051768, 33.021428],
                            [116.0552, 33.034227],
                            [116.051053, 33.044266],
                            [116.04214, 33.048843],
                            [116.01602, 33.041925],
                            [116.010157, 33.043954],
                            [116.018213, 33.056125],
                            [116.002483, 33.060077],
                            [115.980796, 33.07079],
                            [115.948098, 33.080774],
                            [115.914876, 33.088],
                            [115.89848, 33.093667],
                            [115.866735, 33.094343],
                            [115.872026, 33.103128],
                            [115.877126, 33.122151],
                            [115.865925, 33.125581],
                            [115.844333, 33.125321],
                            [115.839709, 33.135454],
                            [115.850196, 33.136078],
                            [115.850196, 33.153535],
                            [115.831034, 33.157172],
                            [115.824361, 33.150938],
                            [115.825505, 33.162678],
                            [115.841378, 33.180234],
                            [115.845238, 33.193528],
                            [115.835277, 33.21383],
                            [115.8297, 33.231635],
                            [115.832083, 33.256753],
                            [115.839423, 33.262824],
                            [115.876983, 33.248295],
                            [115.916497, 33.215491],
                            [115.925696, 33.229195],
                            [115.917498, 33.24269],
                            [115.909204, 33.246634],
                            [115.906725, 33.255975],
                            [115.915972, 33.279478],
                            [115.914828, 33.295506],
                            [115.927841, 33.298722],
                            [115.92603, 33.309769],
                            [115.919833, 33.313606],
                            [115.921406, 33.323303],
                            [115.914399, 33.328902],
                            [115.911111, 33.340567],
                            [115.898432, 33.356999],
                            [115.895334, 33.384724],
                            [115.897383, 33.400525],
                            [115.854962, 33.442321],
                            [115.848861, 33.450864],
                            [115.831606, 33.451227],
                            [115.807441, 33.466861],
                            [115.796049, 33.468569],
                            [115.786135, 33.481044],
                            [115.773217, 33.484718],
                            [115.769404, 33.490515],
                            [115.751387, 33.495896],
                            [115.749481, 33.499881],
                            [115.720834, 33.51085],
                            [115.698337, 33.509557],
                            [115.681273, 33.505831],
                            [115.676697, 33.508729],
                            [115.651244, 33.544629],
                            [115.639757, 33.585115],
                            [115.625029, 33.625633],
                            [115.617784, 33.632608],
                            [115.601626, 33.657662],
                            [115.602531, 33.67264],
                            [115.599624, 33.688286],
                            [115.607155, 33.68906],
                            [115.596287, 33.700315],
                            [115.601578, 33.718537],
                            [115.59624, 33.731233],
                            [115.583561, 33.747229],
                            [115.574838, 33.752234],
                            [115.570024, 33.765286],
                            [115.56316, 33.771683],
                            [115.56521, 33.780193],
                            [115.582226, 33.788703],
                            [115.59052, 33.783701],
                            [115.614257, 33.775654],
                            [115.621168, 33.796799],
                            [115.623313, 33.811959],
                            [115.616592, 33.820001],
                            [115.625601, 33.823662],
                            [115.626268, 33.836187],
                            [115.636135, 33.841187],
                            [115.633513, 33.867314],
                            [115.620882, 33.876124],
                            [115.605725, 33.867417],
                            [115.592331, 33.868241],
                            [115.579509, 33.877],
                            [115.564209, 33.871333],
                            [115.556678, 33.876897],
                            [115.546192, 33.875506],
                            [115.546573, 33.888436],
                            [115.555296, 33.888591],
                            [115.556821, 33.903682],
                            [115.568308, 33.906927],
                            [115.559776, 33.914549],
                            [115.562588, 33.927164],
                            [115.569976, 33.932828],
                            [115.569166, 33.945492],
                            [115.577555, 33.950125],
                            [115.579033, 33.973954],
                            [115.588375, 33.97699],
                            [115.591044, 33.986201],
                            [115.584085, 33.988619],
                            [115.592665, 34.009865],
                            [115.606583, 34.013209],
                            [115.601054, 34.022981],
                            [115.615067, 34.033369],
                            [115.621359, 34.03013],
                            [115.642236, 34.032289],
                            [115.649576, 34.035632],
                            [115.648003, 34.046327],
                            [115.65358, 34.060106],
                            [115.669166, 34.056713],
                            [115.681845, 34.065503],
                            [115.699814, 34.066017],
                            [115.705963, 34.059797],
                            [115.735849, 34.076811],
                            [115.753437, 34.067714],
                            [115.769118, 34.067405],
                            [115.777603, 34.073727],
                            [115.793427, 34.063653],
                            [115.809109, 34.06247],
                            [115.815543, 34.052908],
                            [115.832226, 34.038563],
                            [115.845238, 34.03085],
                            [115.845477, 34.012026],
                            [115.852722, 34.003847],
                            [115.877078, 34.003178],
                            [115.877555, 34.029872],
                            [115.887278, 34.032804],
                            [115.895334, 34.028741],
                            [115.899338, 34.014752],
                            [115.904342, 34.009968],
                            [115.919738, 34.010791],
                            [115.926697, 34.007911],
                            [115.957583, 34.007756],
                            [115.984037, 33.987847],
                            [115.994952, 33.975086],
                            [116.000338, 33.963198],
                            [115.995524, 33.947551],
                            [115.982703, 33.917175],
                            [115.98704, 33.901159],
                            [115.999147, 33.901931],
                            [116.012493, 33.897399],
                            [116.013446, 33.885706],
                            [116.034561, 33.880039],
                            [116.034752, 33.873754],
                            [116.043475, 33.874888],
                            [116.054914, 33.860873],
                            [116.056725, 33.850928],
                            [116.065067, 33.847475],
                            [116.063494, 33.826188],
                            [116.045953, 33.829023],
                            [116.045429, 33.822991],
                            [116.05806, 33.821393],
                            [116.06235, 33.814485],
                            [116.055438, 33.804792],
                            [116.073313, 33.794066],
                            [116.074457, 33.781534],
                            [116.099099, 33.783133],
                            [116.098908, 33.774881],
                            [116.109299, 33.758219],
                            [116.131654, 33.752234],
                            [116.14276, 33.738458],
                            [116.14214, 33.734432],
                            [116.155391, 33.709917],
                            [116.174027, 33.708988],
                            [116.197288, 33.72535],
                            [116.230367, 33.730562],
                            [116.246048, 33.728704],
                            [116.263589, 33.730098],
                            [116.284657, 33.750119],
                            [116.308155, 33.757548],
                            [116.31683, 33.77127],
                            [116.328746, 33.76637],
                            [116.3307, 33.773849],
                            [116.348718, 33.778749],
                            [116.361063, 33.776273],
                            [116.372502, 33.780245],
                            [116.393713, 33.783082]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 341700,
                "name": "池州市",
                "center": [117.489157, 30.656037],
                "centroid": [117.371349, 30.282017],
                "childrenNum": 4,
                "level": "city",
                "parent": {
                    "adcode": 340000
                },
                "subFeatureIndex": 14,
                "acroutes": [100000, 340000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [117.970118, 30.512231],
                            [117.963635, 30.508436],
                            [117.951481, 30.489134],
                            [117.945904, 30.466726],
                            [117.945904, 30.455066],
                            [117.938564, 30.425106],
                            [117.941233, 30.413602],
                            [117.952911, 30.403594],
                            [117.953197, 30.392568],
                            [117.938278, 30.378115],
                            [117.91659, 30.366552],
                            [117.928125, 30.357289],
                            [117.940137, 30.33469],
                            [117.925361, 30.33078],
                            [117.932034, 30.326335],
                            [117.928507, 30.319747],
                            [117.920356, 30.320014],
                            [117.907677, 30.309783],
                            [117.91292, 30.299283],
                            [117.902196, 30.294246],
                            [117.886419, 30.293228],
                            [117.888516, 30.269597],
                            [117.863206, 30.266435],
                            [117.842997, 30.260378],
                            [117.824932, 30.241617],
                            [117.829317, 30.225212],
                            [117.858345, 30.21733],
                            [117.8613, 30.209072],
                            [117.852863, 30.191749],
                            [117.846953, 30.192286],
                            [117.831366, 30.182202],
                            [117.820404, 30.182577],
                            [117.797811, 30.163694],
                            [117.778125, 30.156719],
                            [117.743187, 30.154037],
                            [117.698955, 30.143466],
                            [117.682606, 30.132733],
                            [117.68661, 30.126132],
                            [117.673264, 30.122106],
                            [117.676219, 30.107936],
                            [117.662491, 30.108902],
                            [117.655866, 30.115451],
                            [117.646143, 30.114484],
                            [117.642901, 30.105627],
                            [117.631176, 30.099293],
                            [117.615351, 30.111693],
                            [117.61049, 30.131499],
                            [117.599765, 30.129781],
                            [117.584846, 30.118027],
                            [117.572739, 30.115719],
                            [117.568736, 30.107399],
                            [117.560299, 30.103748],
                            [117.571071, 30.101762],
                            [117.56845, 30.088233],
                            [117.559965, 30.0834],
                            [117.554293, 30.101601],
                            [117.545618, 30.101601],
                            [117.541043, 30.11062],
                            [117.528983, 30.099561],
                            [117.535371, 30.083776],
                            [117.544093, 30.086783],
                            [117.53599, 30.076581],
                            [117.542091, 30.052844],
                            [117.511491, 30.037105],
                            [117.492806, 30.034903],
                            [117.461777, 30.037965],
                            [117.446476, 30.02303],
                            [117.433273, 30.02072],
                            [117.411538, 30.030444],
                            [117.394093, 30.029745],
                            [117.386372, 30.011048],
                            [117.349813, 30.008254],
                            [117.324217, 29.99799],
                            [117.309155, 29.999065],
                            [117.297668, 29.992777],
                            [117.267401, 29.98321],
                            [117.260156, 29.985253],
                            [117.206152, 29.974288],
                            [117.203102, 29.965149],
                            [117.206248, 29.927511],
                            [117.188946, 29.921864],
                            [117.177601, 29.921972],
                            [117.148812, 29.911323],
                            [117.134704, 29.903846],
                            [117.127983, 29.895508],
                            [117.133035, 29.874256],
                            [117.127697, 29.861611],
                            [117.110395, 29.855422],
                            [117.092807, 29.836853],
                            [117.073312, 29.832224],
                            [117.0756, 29.822642],
                            [117.092711, 29.809559],
                            [117.127983, 29.795775],
                            [117.135609, 29.780965],
                            [117.135466, 29.772024],
                            [117.108679, 29.751985],
                            [117.10825, 29.745089],
                            [117.122454, 29.728548],
                            [117.113016, 29.712165],
                            [117.085848, 29.696912],
                            [117.070881, 29.693732],
                            [117.051243, 29.682896],
                            [117.042044, 29.680902],
                            [117.015304, 29.685753],
                            [116.996048, 29.683381],
                            [116.984561, 29.674702],
                            [116.971167, 29.655668],
                            [116.939613, 29.64828],
                            [116.918545, 29.634473],
                            [116.873455, 29.609282],
                            [116.848955, 29.576421],
                            [116.838088, 29.569837],
                            [116.818403, 29.564764],
                            [116.795762, 29.566545],
                            [116.780652, 29.570539],
                            [116.779651, 29.57804],
                            [116.786944, 29.591315],
                            [116.774933, 29.595254],
                            [116.770166, 29.592232],
                            [116.760443, 29.599085],
                            [116.740185, 29.585919],
                            [116.729985, 29.568542],
                            [116.721596, 29.56498],
                            [116.716544, 29.590775],
                            [116.688946, 29.604103],
                            [116.685657, 29.611602],
                            [116.670595, 29.625088],
                            [116.651911, 29.63717],
                            [116.652244, 29.645422],
                            [116.663589, 29.659173],
                            [116.677078, 29.66904],
                            [116.680509, 29.681495],
                            [116.705057, 29.688664],
                            [116.717163, 29.690767],
                            [116.715876, 29.697289],
                            [116.706534, 29.696588],
                            [116.705819, 29.697128],
                            [116.703388, 29.710063],
                            [116.698956, 29.7078],
                            [116.673836, 29.709848],
                            [116.687087, 29.734798],
                            [116.703055, 29.741264],
                            [116.720548, 29.763352],
                            [116.739327, 29.774179],
                            [116.745857, 29.790336],
                            [116.762492, 29.802506],
                            [116.780891, 29.79249],
                            [116.789804, 29.795128],
                            [116.812349, 29.811713],
                            [116.830748, 29.841482],
                            [116.861301, 29.867369],
                            [116.882702, 29.893518],
                            [116.891996, 29.919337],
                            [116.891853, 29.92735],
                            [116.900147, 29.949504],
                            [116.887897, 29.968805],
                            [116.868688, 29.980469],
                            [116.845381, 29.969611],
                            [116.835943, 29.970686],
                            [116.835276, 29.95773],
                            [116.828746, 29.963106],
                            [116.829556, 30.006534],
                            [116.802816, 29.996539],
                            [116.787325, 30.020343],
                            [116.783512, 30.030712],
                            [116.770309, 30.035655],
                            [116.764542, 30.048923],
                            [116.753627, 30.048976],
                            [116.747335, 30.057248],
                            [116.771787, 30.073681],
                            [116.816925, 30.115075],
                            [116.841901, 30.146739],
                            [116.860061, 30.17732],
                            [116.867497, 30.213576],
                            [116.892711, 30.240492],
                            [116.920547, 30.257966],
                            [116.927173, 30.273455],
                            [116.928793, 30.290978],
                            [116.9205, 30.314283],
                            [116.910347, 30.332869],
                            [116.903341, 30.357289],
                            [116.893855, 30.381595],
                            [116.888279, 30.407019],
                            [116.891949, 30.414725],
                            [116.892425, 30.431099],
                            [116.9011, 30.436503],
                            [116.914446, 30.425481],
                            [116.935609, 30.440301],
                            [116.950433, 30.442816],
                            [116.975552, 30.458062],
                            [116.986372, 30.470791],
                            [117.01049, 30.489294],
                            [117.025457, 30.494267],
                            [117.111586, 30.495337],
                            [117.135133, 30.492075],
                            [117.164017, 30.474802],
                            [117.192187, 30.465871],
                            [117.213397, 30.476941],
                            [117.25558, 30.45405],
                            [117.267211, 30.441746],
                            [117.259203, 30.430511],
                            [117.25253, 30.428798],
                            [117.251958, 30.420558],
                            [117.268545, 30.420184],
                            [117.281129, 30.414458],
                            [117.299289, 30.425374],
                            [117.293378, 30.440997],
                            [117.305437, 30.445812],
                            [117.31478, 30.461859],
                            [117.321882, 30.462234],
                            [117.326648, 30.470631],
                            [117.324551, 30.487637],
                            [117.319784, 30.49277],
                            [117.307535, 30.494267],
                            [117.297144, 30.487209],
                            [117.241281, 30.523083],
                            [117.243807, 30.538156],
                            [117.252244, 30.563967],
                            [117.247906, 30.58929],
                            [117.21783, 30.620641],
                            [117.217068, 30.630626],
                            [117.272644, 30.656626],
                            [117.309489, 30.676801],
                            [117.343426, 30.688969],
                            [117.366829, 30.694251],
                            [117.394379, 30.694998],
                            [117.399384, 30.690676],
                            [117.422358, 30.682885],
                            [117.4511, 30.679043],
                            [117.470404, 30.678989],
                            [117.485418, 30.686514],
                            [117.493616, 30.696706],
                            [117.507249, 30.726688],
                            [117.576934, 30.756662],
                            [117.645523, 30.776603],
                            [117.670594, 30.781508],
                            [117.701815, 30.806614],
                            [117.698526, 30.789931],
                            [117.72088, 30.791103],
                            [117.742568, 30.8072],
                            [117.751529, 30.802936],
                            [117.755961, 30.792223],
                            [117.748478, 30.778522],
                            [117.759918, 30.769832],
                            [117.758202, 30.761674],
                            [117.781938, 30.764127],
                            [117.78375, 30.749729],
                            [117.796238, 30.748449],
                            [117.803101, 30.757462],
                            [117.815733, 30.759914],
                            [117.842282, 30.773617],
                            [117.846333, 30.788438],
                            [117.872787, 30.807893],
                            [117.884036, 30.812317],
                            [117.903197, 30.814022],
                            [117.915828, 30.819564],
                            [117.934608, 30.835763],
                            [117.94333, 30.833099],
                            [117.953626, 30.817593],
                            [117.980413, 30.843808],
                            [117.989612, 30.828836],
                            [117.966781, 30.799099],
                            [117.968783, 30.794941],
                            [117.983702, 30.794035],
                            [117.997477, 30.778949],
                            [118.030461, 30.774097],
                            [118.051671, 30.758635],
                            [118.071357, 30.746849],
                            [118.095952, 30.738849],
                            [118.109727, 30.727809],
                            [118.126695, 30.704549],
                            [118.126075, 30.690783],
                            [118.105723, 30.662978],
                            [118.099574, 30.651341],
                            [118.100956, 30.641251],
                            [118.077934, 30.623684],
                            [118.073073, 30.609533],
                            [118.065923, 30.600026],
                            [118.046142, 30.597142],
                            [118.022977, 30.575454],
                            [117.997048, 30.570806],
                            [117.985132, 30.561348],
                            [117.987229, 30.537675],
                            [117.98108, 30.525382],
                            [117.970118, 30.512231]
                        ]
                    ],
                    [
                        [
                            [116.698956, 29.7078],
                            [116.705819, 29.697128],
                            [116.706534, 29.696588],
                            [116.705057, 29.688664],
                            [116.680509, 29.681495],
                            [116.673026, 29.687532],
                            [116.656677, 29.686346],
                            [116.654151, 29.694756],
                            [116.668021, 29.700308],
                            [116.673836, 29.709848],
                            [116.698956, 29.7078]
                        ]
                    ],
                    [
                        [
                            [117.297144, 30.487209],
                            [117.290137, 30.4763],
                            [117.274456, 30.465229],
                            [117.256724, 30.458543],
                            [117.25558, 30.45405],
                            [117.213397, 30.476941],
                            [117.226315, 30.489027],
                            [117.236372, 30.504747],
                            [117.241281, 30.523083],
                            [117.297144, 30.487209]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 341800,
                "name": "宣城市",
                "center": [118.757995, 30.945667],
                "centroid": [118.857477, 30.684955],
                "childrenNum": 7,
                "level": "city",
                "parent": {
                    "adcode": 340000
                },
                "subFeatureIndex": 15,
                "acroutes": [100000, 340000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [118.868878, 30.10144],
                            [118.85005, 30.110458],
                            [118.82107, 30.102728],
                            [118.789945, 30.078299],
                            [118.767972, 30.076796],
                            [118.754626, 30.080608],
                            [118.743139, 30.092743],
                            [118.730365, 30.070298],
                            [118.69781, 30.056818],
                            [118.694807, 30.036675],
                            [118.688754, 30.028993],
                            [118.669021, 30.023675],
                            [118.651004, 30.024534],
                            [118.628029, 30.016529],
                            [118.614493, 30.001805],
                            [118.618592, 29.997399],
                            [118.614016, 29.980469],
                            [118.605818, 29.971654],
                            [118.583463, 29.968321],
                            [118.574931, 29.963751],
                            [118.564588, 29.947569],
                            [118.548668, 29.945203],
                            [118.524741, 29.967407],
                            [118.520784, 29.975201],
                            [118.524502, 29.992508],
                            [118.520403, 29.99885],
                            [118.509297, 29.998312],
                            [118.50577, 29.99138],
                            [118.498716, 30.005997],
                            [118.498096, 30.018141],
                            [118.513492, 30.030659],
                            [118.514016, 30.038932],
                            [118.494474, 30.072124],
                            [118.477696, 30.076527],
                            [118.468926, 30.082434],
                            [118.449955, 30.102621],
                            [118.417734, 30.097306],
                            [118.404483, 30.099615],
                            [118.394807, 30.106271],
                            [118.384607, 30.097145],
                            [118.370642, 30.099722],
                            [118.355103, 30.111908],
                            [118.356962, 30.121945],
                            [118.347477, 30.134289],
                            [118.339326, 30.16584],
                            [118.326647, 30.175282],
                            [118.31149, 30.193197],
                            [118.290708, 30.199526],
                            [118.289946, 30.219046],
                            [118.286562, 30.232879],
                            [118.271881, 30.238186],
                            [118.267782, 30.243333],
                            [118.266638, 30.259842],
                            [118.271404, 30.269865],
                            [118.292472, 30.283691],
                            [118.304912, 30.284387],
                            [118.320546, 30.293764],
                            [118.31211, 30.292907],
                            [118.294903, 30.302122],
                            [118.307629, 30.309301],
                            [118.310203, 30.32055],
                            [118.302052, 30.329709],
                            [118.299765, 30.340796],
                            [118.305532, 30.351399],
                            [118.295141, 30.358306],
                            [118.300289, 30.370139],
                            [118.280365, 30.372387],
                            [118.278173, 30.38031],
                            [118.265684, 30.376402],
                            [118.255913, 30.378437],
                            [118.250337, 30.394816],
                            [118.237801, 30.40049],
                            [118.221452, 30.414351],
                            [118.222977, 30.423929],
                            [118.215399, 30.438322],
                            [118.228077, 30.439713],
                            [118.231604, 30.445651],
                            [118.225217, 30.455013],
                            [118.213873, 30.461271],
                            [118.21373, 30.466833],
                            [118.196571, 30.468652],
                            [118.185847, 30.46448],
                            [118.188039, 30.474481],
                            [118.16864, 30.453033],
                            [118.181128, 30.447844],
                            [118.163254, 30.446775],
                            [118.15782, 30.434309],
                            [118.142901, 30.433828],
                            [118.130175, 30.429601],
                            [118.125027, 30.423662],
                            [118.107582, 30.42928],
                            [118.109774, 30.452712],
                            [118.103435, 30.465229],
                            [118.118211, 30.483252],
                            [118.121118, 30.493091],
                            [118.130747, 30.49817],
                            [118.117591, 30.509238],
                            [118.089612, 30.51731],
                            [118.075218, 30.515011],
                            [118.053721, 30.503677],
                            [118.034941, 30.498438],
                            [118.016924, 30.500576],
                            [117.985751, 30.498705],
                            [117.970118, 30.512231],
                            [117.98108, 30.525382],
                            [117.987229, 30.537675],
                            [117.985132, 30.561348],
                            [117.997048, 30.570806],
                            [118.022977, 30.575454],
                            [118.046142, 30.597142],
                            [118.065923, 30.600026],
                            [118.073073, 30.609533],
                            [118.077934, 30.623684],
                            [118.100956, 30.641251],
                            [118.1368, 30.652195],
                            [118.153578, 30.666554],
                            [118.171214, 30.691637],
                            [118.205437, 30.702148],
                            [118.218354, 30.709458],
                            [118.229221, 30.709244],
                            [118.242901, 30.703482],
                            [118.267591, 30.714206],
                            [118.278745, 30.712659],
                            [118.293282, 30.699961],
                            [118.30496, 30.698146],
                            [118.314445, 30.705083],
                            [118.297191, 30.715966],
                            [118.294712, 30.722421],
                            [118.275694, 30.736449],
                            [118.276647, 30.743169],
                            [118.294569, 30.757088],
                            [118.297906, 30.772391],
                            [118.307582, 30.77639],
                            [118.302577, 30.793822],
                            [118.305008, 30.800964],
                            [118.312872, 30.795101],
                            [118.306724, 30.806934],
                            [118.318687, 30.821749],
                            [118.33823, 30.826812],
                            [118.34762, 30.824414],
                            [118.358916, 30.84578],
                            [118.376409, 30.845513],
                            [118.409536, 30.84871],
                            [118.424502, 30.841091],
                            [118.4368, 30.824733],
                            [118.429841, 30.813916],
                            [118.419498, 30.813649],
                            [118.4317, 30.796434],
                            [118.446476, 30.800911],
                            [118.455198, 30.790144],
                            [118.451671, 30.779162],
                            [118.48027, 30.76642],
                            [118.480699, 30.780602],
                            [118.48475, 30.79025],
                            [118.502863, 30.801497],
                            [118.503101, 30.810451],
                            [118.495522, 30.819884],
                            [118.482224, 30.822549],
                            [118.477982, 30.833579],
                            [118.490899, 30.842849],
                            [118.490041, 30.848656],
                            [118.498239, 30.859843],
                            [118.485513, 30.864051],
                            [118.47741, 30.857553],
                            [118.483987, 30.870762],
                            [118.472119, 30.875077],
                            [118.475742, 30.88184],
                            [118.485846, 30.87726],
                            [118.492948, 30.883491],
                            [118.489707, 30.900052],
                            [118.511537, 30.914054],
                            [118.509154, 30.928694],
                            [118.495713, 30.941042],
                            [118.515255, 30.937582],
                            [118.510251, 30.9511],
                            [118.550956, 30.970682],
                            [118.570975, 30.972278],
                            [118.582462, 30.981855],
                            [118.581223, 30.994728],
                            [118.572262, 31.016269],
                            [118.584273, 31.026107],
                            [118.596142, 31.047853],
                            [118.603768, 31.044238],
                            [118.600956, 31.028021],
                            [118.606819, 31.020204],
                            [118.627314, 31.020576],
                            [118.650003, 31.036848],
                            [118.663396, 31.054445],
                            [118.682653, 31.074909],
                            [118.676123, 31.081393],
                            [118.676838, 31.08963],
                            [118.685513, 31.096272],
                            [118.683082, 31.111893],
                            [118.690327, 31.124961],
                            [118.702004, 31.135797],
                            [118.717305, 31.144188],
                            [118.733558, 31.149446],
                            [118.718401, 31.173978],
                            [118.708963, 31.177004],
                            [118.695045, 31.189108],
                            [118.682986, 31.214054],
                            [118.66821, 31.22488],
                            [118.663587, 31.236871],
                            [118.647286, 31.245519],
                            [118.651861, 31.261009],
                            [118.66006, 31.269761],
                            [118.661442, 31.290762],
                            [118.656866, 31.304654],
                            [118.681747, 31.304336],
                            [118.692186, 31.309001],
                            [118.704102, 31.307782],
                            [118.714731, 31.321671],
                            [118.72107, 31.322679],
                            [118.719593, 31.294792],
                            [118.704435, 31.302798],
                            [118.707915, 31.296807],
                            [118.726599, 31.282224],
                            [118.761394, 31.277663],
                            [118.779983, 31.259524],
                            [118.781413, 31.239843],
                            [118.795331, 31.229443],
                            [118.802672, 31.228223],
                            [118.819116, 31.236022],
                            [118.824073, 31.230451],
                            [118.851051, 31.23963],
                            [118.869688, 31.24223],
                            [118.891232, 31.237986],
                            [118.915207, 31.244193],
                            [118.924979, 31.239683],
                            [118.953053, 31.237773],
                            [118.983939, 31.237773],
                            [118.986466, 31.231141],
                            [119.003291, 31.233741],
                            [119.015017, 31.241646],
                            [119.022881, 31.238145],
                            [119.039516, 31.23841],
                            [119.048858, 31.233529],
                            [119.062347, 31.238463],
                            [119.073787, 31.232892],
                            [119.085465, 31.240267],
                            [119.105293, 31.23528],
                            [119.107009, 31.250612],
                            [119.120021, 31.261699],
                            [119.131747, 31.262548],
                            [119.14066, 31.276019],
                            [119.150098, 31.277133],
                            [119.158153, 31.294792],
                            [119.176218, 31.293944],
                            [119.181127, 31.300465],
                            [119.199478, 31.293625],
                            [119.197142, 31.273527],
                            [119.204244, 31.26573],
                            [119.215255, 31.27411],
                            [119.218544, 31.264563],
                            [119.236275, 31.259312],
                            [119.238563, 31.254644],
                            [119.250193, 31.257243],
                            [119.249764, 31.262017],
                            [119.261394, 31.261328],
                            [119.266971, 31.250453],
                            [119.294473, 31.263131],
                            [119.314873, 31.26573],
                            [119.333224, 31.264139],
                            [119.337562, 31.258888],
                            [119.345951, 31.268965],
                            [119.350288, 31.281641],
                            [119.350145, 31.301049],
                            [119.356627, 31.303275],
                            [119.367876, 31.289224],
                            [119.371594, 31.271617],
                            [119.379697, 31.26939],
                            [119.365207, 31.232627],
                            [119.360059, 31.212144],
                            [119.365779, 31.195956],
                            [119.371403, 31.197707],
                            [119.379173, 31.189214],
                            [119.394902, 31.199618],
                            [119.405674, 31.194416],
                            [119.389325, 31.188365],
                            [119.39147, 31.174243],
                            [119.400622, 31.178756],
                            [119.415398, 31.172969],
                            [119.423167, 31.181835],
                            [119.438801, 31.177057],
                            [119.454768, 31.164899],
                            [119.460583, 31.156403],
                            [119.475836, 31.158898],
                            [119.482509, 31.152526],
                            [119.48556, 31.161394],
                            [119.494473, 31.163996],
                            [119.51392, 31.156031],
                            [119.5235, 31.159748],
                            [119.534511, 31.158102],
                            [119.545855, 31.147853],
                            [119.56025, 31.140736],
                            [119.571308, 31.128998],
                            [119.57412, 31.113965],
                            [119.581985, 31.108652],
                            [119.599763, 31.109183],
                            [119.613729, 31.129157],
                            [119.623786, 31.130273],
                            [119.624168, 31.115983],
                            [119.649144, 31.105092],
                            [119.634702, 31.093775],
                            [119.629554, 31.085538],
                            [119.634987, 31.064172],
                            [119.631317, 31.046311],
                            [119.634034, 31.01946],
                            [119.624025, 31.005313],
                            [119.616255, 31.002388],
                            [119.607437, 30.991856],
                            [119.588372, 30.979142],
                            [119.580412, 30.967117],
                            [119.582175, 30.947428],
                            [119.580364, 30.929173],
                            [119.563825, 30.919218],
                            [119.556341, 30.896697],
                            [119.559058, 30.891745],
                            [119.558963, 30.871189],
                            [119.573739, 30.853344],
                            [119.575741, 30.829742],
                            [119.561203, 30.829476],
                            [119.55453, 30.825639],
                            [119.524501, 30.776017],
                            [119.507104, 30.769619],
                            [119.491518, 30.777243],
                            [119.480126, 30.773298],
                            [119.478791, 30.753089],
                            [119.484606, 30.744609],
                            [119.479697, 30.736823],
                            [119.482747, 30.704442],
                            [119.466017, 30.683899],
                            [119.452909, 30.671624],
                            [119.448286, 30.655825],
                            [119.433653, 30.644454],
                            [119.412681, 30.642959],
                            [119.400002, 30.658868],
                            [119.395665, 30.678722],
                            [119.391518, 30.685233],
                            [119.379411, 30.679363],
                            [119.372357, 30.680377],
                            [119.35453, 30.666927],
                            [119.343138, 30.664205],
                            [119.333653, 30.652195],
                            [119.323119, 30.630306],
                            [119.311966, 30.621228],
                            [119.291232, 30.616048],
                            [119.275741, 30.617597],
                            [119.258772, 30.614393],
                            [119.25005, 30.620267],
                            [119.239135, 30.609319],
                            [119.253672, 30.596447],
                            [119.254149, 30.588649],
                            [119.264778, 30.582025],
                            [119.264778, 30.573424],
                            [119.245522, 30.561402],
                            [119.236942, 30.546707],
                            [119.242566, 30.530032],
                            [119.261918, 30.525542],
                            [119.261632, 30.517738],
                            [119.272118, 30.510521],
                            [119.287943, 30.512606],
                            [119.313634, 30.531208],
                            [119.326551, 30.533025],
                            [119.328696, 30.52164],
                            [119.336322, 30.507153],
                            [119.330317, 30.488225],
                            [119.334463, 30.478118],
                            [119.336132, 30.445544],
                            [119.349716, 30.438803],
                            [119.352957, 30.424839],
                            [119.349525, 30.408625],
                            [119.363205, 30.409481],
                            [119.368925, 30.39974],
                            [119.366589, 30.388393],
                            [119.371451, 30.38395],
                            [119.393806, 30.38304],
                            [119.403052, 30.374368],
                            [119.399954, 30.367783],
                            [119.386132, 30.363928],
                            [119.375598, 30.354826],
                            [119.34943, 30.34915],
                            [119.342662, 30.363178],
                            [119.329077, 30.371531],
                            [119.300669, 30.36366],
                            [119.289468, 30.349632],
                            [119.278124, 30.341599],
                            [119.265064, 30.338064],
                            [119.247142, 30.340796],
                            [119.239993, 30.327031],
                            [119.245903, 30.321621],
                            [119.236227, 30.2973],
                            [119.229173, 30.289692],
                            [119.222595, 30.299604],
                            [119.205674, 30.301586],
                            [119.201051, 30.291031],
                            [119.188181, 30.291674],
                            [119.156723, 30.29955],
                            [119.151289, 30.304586],
                            [119.128506, 30.304694],
                            [119.111013, 30.311283],
                            [119.090231, 30.324032],
                            [119.073405, 30.31589],
                            [119.063015, 30.304961],
                            [119.05086, 30.306729],
                            [119.048334, 30.312676],
                            [119.028792, 30.312569],
                            [119.004435, 30.328959],
                            [118.988039, 30.333458],
                            [118.988086, 30.348668],
                            [118.975741, 30.347168],
                            [118.96902, 30.351345],
                            [118.959964, 30.347275],
                            [118.955388, 30.359216],
                            [118.936418, 30.35081],
                            [118.936323, 30.34508],
                            [118.917877, 30.332441],
                            [118.908391, 30.330888],
                            [118.899764, 30.322586],
                            [118.879888, 30.314872],
                            [118.881795, 30.298532],
                            [118.878077, 30.282726],
                            [118.889707, 30.254268],
                            [118.882414, 30.24746],
                            [118.893043, 30.242689],
                            [118.903196, 30.21792],
                            [118.924979, 30.213844],
                            [118.929888, 30.203387],
                            [118.920641, 30.199043],
                            [118.910822, 30.187512],
                            [118.864397, 30.169005],
                            [118.852862, 30.166537],
                            [118.845713, 30.156129],
                            [118.856389, 30.148188],
                            [118.865732, 30.151515],
                            [118.881032, 30.146793],
                            [118.896809, 30.148081],
                            [118.895951, 30.138797],
                            [118.888134, 30.127259],
                            [118.887228, 30.117437],
                            [118.871642, 30.113035],
                            [118.868878, 30.10144]
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                adcode: 330000,
                name: '浙江省',
                center: [120.153576, 30.287459],
                centroid: [120.109921, 29.181449],
                childrenNum: 11,
                level: 'province',
                acroutes: [100000],
                parent: { adcode: 100000 },
            },
            geometry: {
                type: 'MultiPolygon',
                coordinates: [
                    [
                        [
                            [118.344964, 29.475681],
                            [118.358694, 29.477083],
                            [118.379806, 29.502567],
                            [118.383005, 29.510153],
                            [118.393045, 29.507308],
                            [118.414994, 29.509741],
                            [118.430594, 29.503721],
                            [118.44895, 29.51341],
                            [118.459826, 29.505577],
                            [118.470407, 29.507473],
                            [118.495899, 29.519553],
                            [118.497868, 29.543995],
                            [118.494915, 29.553721],
                            [118.499689, 29.573623],
                            [118.515486, 29.583305],
                            [118.53522, 29.590638],
                            [118.549886, 29.613416],
                            [118.555053, 29.613416],
                            [118.573902, 29.638371],
                            [118.602051, 29.643683],
                            [118.620014, 29.654099],
                            [118.633498, 29.648788],
                            [118.640929, 29.641912],
                            [118.647327, 29.643394],
                            [118.673902, 29.669083],
                            [118.682367, 29.681061],
                            [118.682908, 29.688345],
                            [118.691668, 29.693942],
                            [118.700821, 29.706452],
                            [118.718686, 29.709167],
                            [118.72464, 29.722621],
                            [118.744719, 29.738788],
                            [118.74905, 29.761121],
                            [118.744325, 29.779626],
                            [118.736501, 29.788465],
                            [118.739946, 29.813295],
                            [118.745999, 29.818186],
                            [118.75781, 29.816747],
                            [118.76593, 29.823077],
                            [118.750969, 29.831625],
                            [118.755595, 29.845432],
                            [118.766963, 29.848925],
                            [118.778725, 29.841899],
                            [118.802593, 29.860676],
                            [118.807712, 29.86766],
                            [118.841324, 29.891319],
                            [118.845507, 29.899082],
                            [118.844916, 29.915261],
                            [118.838716, 29.934476],
                            [118.848263, 29.941249],
                            [118.863913, 29.93698],
                            [118.871983, 29.946873],
                            [118.88468, 29.93891],
                            [118.894867, 29.939197],
                            [118.891521, 29.959885],
                            [118.899493, 29.98143],
                            [118.892062, 29.994806],
                            [118.895015, 30.000386],
                            [118.89034, 30.012037],
                            [118.898017, 30.017246],
                            [118.902594, 30.029059],
                            [118.890586, 30.04128],
                            [118.897328, 30.049646],
                            [118.888125, 30.062357],
                            [118.878824, 30.064653],
                            [118.875478, 30.072033],
                            [118.872918, 30.094619],
                            [118.868883, 30.101464],
                            [118.871639, 30.113021],
                            [118.887239, 30.117446],
                            [118.888125, 30.127239],
                            [118.89595, 30.138793],
                            [118.896787, 30.148093],
                            [118.877348, 30.147396],
                            [118.865733, 30.151493],
                            [118.856383, 30.148216],
                            [118.845704, 30.156122],
                            [118.85284, 30.166566],
                            [118.864405, 30.168983],
                            [118.910812, 30.187493],
                            [118.920655, 30.198999],
                            [118.929858, 30.20338],
                            [118.924986, 30.213861],
                            [118.903184, 30.217913],
                            [118.892554, 30.243249],
                            [118.882417, 30.247465],
                            [118.8897, 30.254258],
                            [118.878086, 30.282734],
                            [118.881826, 30.298524],
                            [118.879857, 30.314884],
                            [118.899789, 30.322572],
                            [118.908401, 30.330872],
                            [118.917899, 30.332467],
                            [118.936354, 30.34506],
                            [118.936452, 30.350824],
                            [118.955399, 30.359204],
                            [118.959385, 30.347267],
                            [118.969031, 30.351356],
                            [118.975724, 30.347145],
                            [118.988126, 30.348698],
                            [118.988027, 30.333489],
                            [119.004464, 30.328951],
                            [119.028775, 30.312593],
                            [119.048313, 30.312675],
                            [119.050823, 30.306745],
                            [119.062978, 30.304945],
                            [119.073411, 30.315865],
                            [119.090242, 30.324003],
                            [119.11101, 30.311285],
                            [119.12853, 30.3047],
                            [119.151266, 30.304577],
                            [119.156729, 30.299547],
                            [119.188225, 30.291652],
                            [119.201069, 30.291039],
                            [119.205695, 30.301551],
                            [119.222624, 30.299628],
                            [119.225479, 30.288789],
                            [119.233747, 30.293411],
                            [119.245902, 30.321631],
                            [119.239997, 30.327029],
                            [119.247132, 30.340808],
                            [119.265046, 30.338069],
                            [119.278136, 30.341585],
                            [119.289455, 30.349639],
                            [119.300676, 30.363701],
                            [119.326562, 30.371753],
                            [119.342654, 30.363169],
                            [119.349446, 30.349148],
                            [119.375627, 30.354789],
                            [119.386159, 30.363905],
                            [119.399987, 30.367788],
                            [119.403038, 30.373347],
                            [119.393836, 30.383033],
                            [119.371444, 30.383932],
                            [119.366572, 30.388386],
                            [119.368934, 30.399746],
                            [119.360912, 30.410737],
                            [119.349544, 30.408612],
                            [119.352989, 30.424831],
                            [119.349692, 30.438841],
                            [119.336158, 30.44558],
                            [119.334485, 30.478084],
                            [119.330351, 30.488249],
                            [119.336355, 30.507149],
                            [119.328678, 30.521637],
                            [119.326562, 30.532981],
                            [119.313619, 30.531186],
                            [119.28793, 30.512618],
                            [119.272133, 30.510495],
                            [119.26165, 30.51776],
                            [119.261896, 30.525554],
                            [119.242556, 30.530043],
                            [119.236945, 30.546731],
                            [119.245508, 30.561417],
                            [119.264751, 30.57345],
                            [119.264751, 30.582056],
                            [119.254121, 30.588663],
                            [119.253678, 30.596452],
                            [119.240095, 30.604933],
                            [119.245853, 30.618877],
                            [119.255006, 30.615126],
                            [119.278383, 30.617613],
                            [119.291227, 30.616023],
                            [119.311946, 30.621241],
                            [119.323117, 30.630291],
                            [119.333648, 30.652219],
                            [119.343147, 30.6642],
                            [119.354564, 30.66693],
                            [119.372379, 30.680376],
                            [119.379367, 30.679358],
                            [119.391523, 30.685224],
                            [119.395657, 30.678706],
                            [119.400037, 30.658862],
                            [119.412684, 30.642968],
                            [119.433649, 30.644476],
                            [119.448314, 30.655846],
                            [119.45294, 30.671616],
                            [119.465982, 30.683921],
                            [119.482763, 30.704452],
                            [119.480303, 30.738091],
                            [119.484584, 30.744605],
                            [119.478777, 30.753074],
                            [119.479564, 30.771229],
                            [119.491523, 30.777253],
                            [119.507124, 30.769642],
                            [119.524496, 30.776032],
                            [119.554515, 30.825635],
                            [119.561208, 30.829459],
                            [119.575726, 30.829743],
                            [119.573758, 30.853334],
                            [119.558945, 30.871186],
                            [119.559092, 30.891718],
                            [119.556336, 30.896718],
                            [119.563817, 30.919236],
                            [119.580352, 30.929152],
                            [119.582173, 30.947437],
                            [119.579565, 30.962671],
                            [119.585864, 30.976401],
                            [119.607468, 30.991875],
                            [119.616277, 31.002392],
                            [119.624004, 31.005316],
                            [119.634043, 31.019485],
                            [119.631337, 31.046317],
                            [119.634978, 31.064174],
                            [119.629516, 31.082311],
                            [119.634683, 31.093751],
                            [119.649152, 31.105109],
                            [119.624152, 31.11602],
                            [119.623807, 31.130254],
                            [119.638128, 31.135526],
                            [119.641573, 31.148136],
                            [119.662537, 31.159852],
                            [119.663719, 31.165973],
                            [119.678039, 31.168203],
                            [119.682764, 31.160501],
                            [119.703876, 31.151906],
                            [119.713128, 31.167635],
                            [119.740491, 31.173432],
                            [119.755353, 31.170756],
                            [119.779319, 31.178782],
                            [119.793394, 31.168041],
                            [119.791278, 31.156609],
                            [119.800973, 31.156325],
                            [119.809881, 31.148501],
                            [119.823316, 31.154136],
                            [119.829762, 31.161393],
                            [119.823463, 31.165811],
                            [119.826465, 31.173188],
                            [119.837587, 31.173675],
                            [119.842164, 31.16877],
                            [119.866623, 31.168324],
                            [119.878729, 31.160785],
                            [119.900235, 31.169176],
                            [119.920954, 31.170392],
                            [119.921052, 31.16119],
                            [119.936751, 31.146555],
                            [119.946249, 31.106245],
                            [119.969773, 31.074277],
                            [119.988523, 31.059223],
                            [120.001712, 31.027118],
                            [120.017017, 31.017821],
                            [120.05245, 31.005722],
                            [120.09438, 30.973233],
                            [120.111014, 30.955928],
                            [120.135128, 30.941911],
                            [120.149646, 30.937482],
                            [120.221791, 30.926876],
                            [120.250778, 30.926226],
                            [120.308061, 30.932281],
                            [120.343347, 30.939961],
                            [120.371103, 30.948777],
                            [120.35944, 30.931915],
                            [120.362688, 30.921674],
                            [120.35693, 30.908872],
                            [120.360129, 30.892775],
                            [120.358012, 30.887084],
                            [120.364656, 30.880457],
                            [120.372432, 30.882164],
                            [120.37942, 30.890783],
                            [120.394676, 30.890783],
                            [120.423515, 30.90306],
                            [120.418003, 30.925576],
                            [120.423416, 30.927445],
                            [120.434981, 30.920821],
                            [120.442265, 30.90058],
                            [120.434489, 30.887978],
                            [120.439558, 30.885213],
                            [120.452353, 30.867893],
                            [120.44128, 30.856303],
                            [120.454469, 30.849633],
                            [120.460375, 30.839872],
                            [120.461015, 30.828279],
                            [120.455257, 30.816847],
                            [120.477255, 30.800002],
                            [120.477009, 30.785596],
                            [120.489066, 30.763861],
                            [120.50442, 30.757959],
                            [120.517462, 30.772287],
                            [120.56382, 30.83552],
                            [120.580897, 30.845688],
                            [120.588968, 30.854432],
                            [120.602994, 30.848901],
                            [120.616872, 30.849999],
                            [120.625681, 30.855896],
                            [120.644726, 30.854839],
                            [120.655405, 30.847518],
                            [120.658703, 30.86529],
                            [120.663082, 30.861346],
                            [120.673073, 30.874927],
                            [120.682817, 30.88253],
                            [120.699943, 30.867811],
                            [120.704274, 30.872935],
                            [120.702551, 30.884034],
                            [120.713279, 30.885051],
                            [120.709835, 30.907531],
                            [120.712689, 30.919683],
                            [120.709441, 30.933175],
                            [120.697581, 30.950321],
                            [120.684441, 30.955156],
                            [120.69822, 30.970796],
                            [120.705504, 30.966449],
                            [120.710081, 30.971892],
                            [120.725583, 30.971527],
                            [120.736114, 30.963728],
                            [120.745957, 30.962509],
                            [120.758457, 30.974532],
                            [120.769677, 30.977294],
                            [120.769923, 30.996626],
                            [120.802896, 31.005397],
                            [120.820908, 31.006371],
                            [120.840052, 30.997803],
                            [120.847335, 30.9896],
                            [120.853241, 30.992971],
                            [120.865642, 30.989803],
                            [120.868054, 30.995367],
                            [120.891331, 31.003732],
                            [120.895121, 31.017374],
                            [120.910081, 31.016928],
                            [120.918103, 31.012786],
                            [120.940101, 31.010026],
                            [120.936312, 31.017131],
                            [120.949993, 31.017618],
                            [120.949107, 31.029959],
                            [120.95831, 31.028579],
                            [120.963182, 31.016603],
                            [120.989511, 31.01441],
                            [121.000534, 30.973923],
                            [120.99143, 30.968358],
                            [121.000042, 30.934719],
                            [120.99896, 30.909522],
                            [121.002552, 30.904848],
                            [120.99266, 30.90184],
                            [120.993842, 30.889645],
                            [121.008507, 30.888141],
                            [121.021893, 30.875171],
                            [121.014806, 30.871024],
                            [121.016283, 30.86285],
                            [121.003979, 30.846095],
                            [120.997779, 30.844061],
                            [120.989117, 30.832306],
                            [120.994629, 30.821485],
                            [121.010918, 30.834625],
                            [121.030062, 30.828564],
                            [121.037936, 30.813877],
                            [121.039954, 30.827221],
                            [121.06205, 30.837797],
                            [121.060525, 30.8452],
                            [121.080456, 30.848739],
                            [121.09773, 30.857116],
                            [121.104816, 30.849349],
                            [121.114757, 30.851463],
                            [121.123566, 30.847274],
                            [121.120614, 30.836333],
                            [121.134639, 30.833038],
                            [121.137641, 30.826245],
                            [121.128143, 30.809971],
                            [121.126273, 30.788567],
                            [121.117267, 30.785474],
                            [121.122976, 30.779003],
                            [121.140643, 30.776927],
                            [121.1527, 30.778962],
                            [121.174649, 30.772002],
                            [121.191825, 30.77884],
                            [121.200338, 30.773631],
                            [121.200092, 30.783277],
                            [121.218006, 30.784945],
                            [121.226224, 30.775096],
                            [121.232277, 30.755801],
                            [121.256392, 30.743954],
                            [121.269778, 30.73072],
                            [121.272041, 30.723268],
                            [121.265841, 30.709502],
                            [121.270663, 30.70156],
                            [121.27465, 30.677402],
                            [121.257031, 30.673653],
                            [121.244974, 30.654787],
                            [121.231687, 30.644109],
                            [121.221008, 30.63987],
                            [121.188872, 30.633063],
                            [121.172632, 30.625807],
                            [121.15088, 30.611783],
                            [121.149206, 30.60004],
                            [121.11648, 30.585482],
                            [121.085377, 30.575204],
                            [121.058359, 30.564028],
                            [121.071598, 30.542692],
                            [121.093153, 30.515842],
                            [121.119236, 30.48976],
                            [121.183212, 30.434348],
                            [121.225486, 30.404649],
                            [121.278784, 30.405057],
                            [121.328046, 30.397131],
                            [121.371894, 30.370894],
                            [121.395073, 30.338437],
                            [121.452701, 30.298565],
                            [121.476274, 30.279421],
                            [121.49778, 30.258595],
                            [121.527554, 30.224913],
                            [121.561462, 30.184176],
                            [121.591678, 30.143546],
                            [121.61471, 30.108308],
                            [121.619927, 30.088512],
                            [121.626029, 30.07769],
                            [121.63533, 30.069819],
                            [121.653096, 30.071131],
                            [121.667466, 30.048867],
                            [121.69975, 30.008016],
                            [121.724996, 29.992221],
                            [121.771453, 29.99497],
                            [121.784051, 29.993493],
                            [121.814366, 29.974331],
                            [121.835183, 29.957956],
                            [121.859986, 29.944],
                            [121.901817, 29.923678],
                            [121.919534, 29.920804],
                            [121.927113, 29.931151],
                            [121.9529, 29.950732],
                            [121.968008, 29.956519],
                            [121.981739, 29.947037],
                            [121.984396, 29.937637],
                            [121.994534, 29.934599],
                            [122.0029, 29.923186],
                            [122.003442, 29.898999],
                            [122.00979, 29.891114],
                            [122.080115, 29.892634],
                            [122.096257, 29.905036],
                            [122.11673, 29.909964],
                            [122.140155, 29.901751],
                            [122.143058, 29.877724],
                            [122.135922, 29.872261],
                            [122.102212, 29.859649],
                            [122.08479, 29.844528],
                            [122.04857, 29.826036],
                            [122.037595, 29.813747],
                            [122.015991, 29.771936],
                            [122.003146, 29.762273],
                            [121.959199, 29.750017],
                            [121.937595, 29.748536],
                            [121.925538, 29.741256],
                            [121.906443, 29.719247],
                            [121.863234, 29.67925],
                            [121.833559, 29.653111],
                            [121.858953, 29.636601],
                            [121.872486, 29.632483],
                            [121.893845, 29.636559],
                            [121.909593, 29.650105],
                            [121.923422, 29.65167],
                            [121.937595, 29.642571],
                            [121.966089, 29.635859],
                            [121.985381, 29.606291],
                            [121.999751, 29.593686],
                            [122.000292, 29.58244],
                            [121.987201, 29.570616],
                            [121.985774, 29.563776],
                            [121.995076, 29.545108],
                            [121.986414, 29.541193],
                            [121.968993, 29.515595],
                            [121.96668, 29.506566],
                            [121.973127, 29.477991],
                            [121.992074, 29.461411],
                            [121.991729, 29.445942],
                            [121.981493, 29.429934],
                            [121.975538, 29.411159],
                            [121.959642, 29.407156],
                            [121.945814, 29.395311],
                            [121.937693, 29.384125],
                            [121.938579, 29.369512],
                            [121.932231, 29.353451],
                            [121.935971, 29.348124],
                            [121.952064, 29.344119],
                            [121.958363, 29.334373],
                            [121.946552, 29.316695],
                            [121.940892, 29.298271],
                            [121.944829, 29.284182],
                            [121.967566, 29.281414],
                            [121.981099, 29.2841],
                            [122.000243, 29.278811],
                            [121.99852, 29.266124],
                            [122.001965, 29.26009],
                            [121.990991, 29.260793],
                            [121.968304, 29.250006],
                            [121.968008, 29.243888],
                            [121.977457, 29.224087],
                            [121.971896, 29.193364],
                            [121.948619, 29.19324],
                            [121.9373, 29.182859],
                            [121.949111, 29.183314],
                            [121.96043, 29.170575],
                            [121.98666, 29.154855],
                            [121.988284, 29.149269],
                            [121.979278, 29.144842],
                            [121.985381, 29.137601],
                            [121.98853, 29.110992],
                            [121.983363, 29.101224],
                            [121.968747, 29.093028],
                            [121.983314, 29.091454],
                            [121.984396, 29.086942],
                            [121.969829, 29.075888],
                            [121.966138, 29.052866],
                            [121.951621, 29.04744],
                            [121.935085, 29.05183],
                            [121.931591, 29.070713],
                            [121.903835, 29.069056],
                            [121.899406, 29.076426],
                            [121.909642, 29.085866],
                            [121.898077, 29.103956],
                            [121.884494, 29.105446],
                            [121.860036, 29.086404],
                            [121.842368, 29.08835],
                            [121.827014, 29.101845],
                            [121.811167, 29.109916],
                            [121.794238, 29.105197],
                            [121.780557, 29.109626],
                            [121.769386, 29.148277],
                            [121.768008, 29.166686],
                            [121.749947, 29.136691],
                            [121.715596, 29.12498],
                            [121.648814, 29.150924],
                            [121.60846, 29.169127],
                            [121.616531, 29.143518],
                            [121.659936, 29.118359],
                            [121.661511, 29.106108],
                            [121.65536, 29.092738],
                            [121.651915, 29.075888],
                            [121.658952, 29.058497],
                            [121.699454, 29.039985],
                            [121.712643, 29.028926],
                            [121.71535, 29.012274],
                            [121.711265, 28.986005],
                            [121.718352, 28.970422],
                            [121.743352, 28.954257],
                            [121.772043, 28.898365],
                            [121.776423, 28.879783],
                            [121.774602, 28.863895],
                            [121.759051, 28.85597],
                            [121.738677, 28.856592],
                            [121.704228, 28.863646],
                            [121.668352, 28.872939],
                            [121.660084, 28.869661],
                            [121.687348, 28.863355],
                            [121.69222, 28.855265],
                            [121.702899, 28.825262],
                            [121.70472, 28.804633],
                            [121.694582, 28.772872],
                            [121.689415, 28.719167],
                            [121.679129, 28.698891],
                            [121.646305, 28.682809],
                            [121.587397, 28.67221],
                            [121.540842, 28.655583],
                            [121.557082, 28.644982],
                            [121.568844, 28.626563],
                            [121.586216, 28.586553],
                            [121.596157, 28.575238],
                            [121.615054, 28.571743],
                            [121.634247, 28.562715],
                            [121.63907, 28.549108],
                            [121.64222, 28.520808],
                            [121.652653, 28.502616],
                            [121.667811, 28.485713],
                            [121.671108, 28.472596],
                            [121.664513, 28.444858],
                            [121.681935, 28.440318],
                            [121.691826, 28.418446],
                            [121.692761, 28.407321],
                            [121.687151, 28.400904],
                            [121.658903, 28.392403],
                            [121.658854, 28.378441],
                            [121.646403, 28.365102],
                            [121.63656, 28.359558],
                            [121.635871, 28.347468],
                            [121.66033, 28.355639],
                            [121.666433, 28.344091],
                            [121.672633, 28.347801],
                            [121.669336, 28.333375],
                            [121.656935, 28.318613],
                            [121.645665, 28.296674],
                            [121.649011, 28.278319],
                            [121.637053, 28.269767],
                            [121.634297, 28.259461],
                            [121.624208, 28.250489],
                            [121.579523, 28.24185],
                            [121.571944, 28.258709],
                            [121.571452, 28.279404],
                            [121.564365, 28.28804],
                            [121.525979, 28.303598],
                            [121.499306, 28.305934],
                            [121.488774, 28.301429],
                            [121.477652, 28.284327],
                            [121.459739, 28.271853],
                            [121.456048, 28.250322],
                            [121.446402, 28.238595],
                            [121.419581, 28.218018],
                            [121.402357, 28.197311],
                            [121.391333, 28.159102],
                            [121.3778, 28.150289],
                            [121.37214, 28.131282],
                            [121.361215, 28.126144],
                            [121.343154, 28.127397],
                            [121.33774, 28.135961],
                            [121.328144, 28.134165],
                            [121.310083, 28.110726],
                            [121.307425, 28.088494],
                            [121.297829, 28.06446],
                            [121.282278, 28.054636],
                            [121.261165, 28.034442],
                            [121.238675, 28.028838],
                            [121.176175, 28.022315],
                            [121.149797, 28.025284],
                            [121.140988, 28.031389],
                            [121.13587, 28.050581],
                            [121.135279, 28.070522],
                            [121.121106, 28.125266],
                            [121.108409, 28.139011],
                            [121.0902, 28.127146],
                            [121.07086, 28.110517],
                            [121.059098, 28.096351],
                            [121.039413, 28.055849],
                            [121.030948, 28.033647],
                            [121.02455, 28.003745],
                            [121.015249, 27.981617],
                            [120.991824, 27.949734],
                            [121.055899, 27.900133],
                            [121.075584, 27.894439],
                            [121.099452, 27.895067],
                            [121.116726, 27.899798],
                            [121.137395, 27.908841],
                            [121.157917, 27.910306],
                            [121.16274, 27.902519],
                            [121.160378, 27.884641],
                            [121.166775, 27.876895],
                            [121.185181, 27.874801],
                            [121.19586, 27.869817],
                            [121.200535, 27.855159],
                            [121.196647, 27.833964],
                            [121.184344, 27.814105],
                            [121.167169, 27.811675],
                            [121.15772, 27.813895],
                            [121.143842, 27.791728],
                            [121.13149, 27.788836],
                            [121.13144, 27.797595],
                            [121.152504, 27.815362],
                            [121.133015, 27.813183],
                            [121.107671, 27.813686],
                            [121.089856, 27.817541],
                            [121.069875, 27.834215],
                            [121.027798, 27.832623],
                            [121.020072, 27.835891],
                            [121.012149, 27.846237],
                            [120.974255, 27.887196],
                            [120.951469, 27.895905],
                            [120.941774, 27.896784],
                            [120.910869, 27.864708],
                            [120.883703, 27.820934],
                            [120.840642, 27.758741],
                            [120.809638, 27.77555],
                            [120.797729, 27.779574],
                            [120.761114, 27.717692],
                            [120.739658, 27.702175],
                            [120.708949, 27.682585],
                            [120.700681, 27.669412],
                            [120.685376, 27.622999],
                            [120.674992, 27.609105],
                            [120.652059, 27.586854],
                            [120.634884, 27.577281],
                            [120.637049, 27.561449],
                            [120.642807, 27.556577],
                            [120.662295, 27.519612],
                            [120.678191, 27.516419],
                            [120.686311, 27.4923],
                            [120.702797, 27.478726],
                            [120.699648, 27.465654],
                            [120.676813, 27.431055],
                            [120.673614, 27.419954],
                            [120.675041, 27.382312],
                            [120.670071, 27.362834],
                            [120.657079, 27.352316],
                            [120.612246, 27.336915],
                            [120.580307, 27.321385],
                            [120.571645, 27.309978],
                            [120.57573, 27.293645],
                            [120.574057, 27.286699],
                            [120.563427, 27.277941],
                            [120.552944, 27.257771],
                            [120.554765, 27.252044],
                            [120.576173, 27.241135],
                            [120.571497, 27.228204],
                            [120.564116, 27.220243],
                            [120.556143, 27.204065],
                            [120.55324, 27.17343],
                            [120.545956, 27.156824],
                            [120.522285, 27.142154],
                            [120.492462, 27.136168],
                            [120.467757, 27.143166],
                            [120.461655, 27.142576],
                            [120.445267, 27.16087],
                            [120.43759, 27.161039],
                            [120.426172, 27.173472],
                            [120.42568, 27.183333],
                            [120.404371, 27.20398],
                            [120.400926, 27.211564],
                            [120.413918, 27.230942],
                            [120.398515, 27.242483],
                            [120.401763, 27.250864],
                            [120.415395, 27.256381],
                            [120.422383, 27.250822],
                            [120.43006, 27.258866],
                            [120.4088, 27.276636],
                            [120.401369, 27.298571],
                            [120.383406, 27.312714],
                            [120.374794, 27.329255],
                            [120.358357, 27.337546],
                            [120.351467, 27.346761],
                            [120.355257, 27.353873],
                            [120.343249, 27.366242],
                            [120.351566, 27.383574],
                            [120.340739, 27.399642],
                            [120.331733, 27.396025],
                            [120.319823, 27.399684],
                            [120.315985, 27.406708],
                            [120.315148, 27.393165],
                            [120.302697, 27.392197],
                            [120.289508, 27.395941],
                            [120.273366, 27.389421],
                            [120.258209, 27.412679],
                            [120.26377, 27.41802],
                            [120.262441, 27.432905],
                            [120.249006, 27.439885],
                            [120.24689, 27.434587],
                            [120.221595, 27.420291],
                            [120.213228, 27.420291],
                            [120.202402, 27.428364],
                            [120.176909, 27.419954],
                            [120.163376, 27.424874],
                            [120.141821, 27.422183],
                            [120.131437, 27.416716],
                            [120.137195, 27.402334],
                            [120.128878, 27.391608],
                            [120.121594, 27.397413],
                            [120.107175, 27.395562],
                            [120.09625, 27.390347],
                            [120.09684, 27.37962],
                            [120.077007, 27.369187],
                            [120.052303, 27.338682],
                            [120.027549, 27.342259],
                            [120.026614, 27.350801],
                            [120.015984, 27.36477],
                            [120.009586, 27.363928],
                            [120.005206, 27.376675],
                            [119.994232, 27.379199],
                            [119.988326, 27.371375],
                            [119.960275, 27.366116],
                            [119.964015, 27.360478],
                            [119.960176, 27.351853],
                            [119.937932, 27.3346],
                            [119.944035, 27.314146],
                            [119.933503, 27.316545],
                            [119.903286, 27.317597],
                            [119.899054, 27.311494],
                            [119.887637, 27.313304],
                            [119.865589, 27.306232],
                            [119.871298, 27.315408],
                            [119.856731, 27.314819],
                            [119.8462, 27.324037],
                            [119.835077, 27.312967],
                            [119.844822, 27.306653],
                            [119.840146, 27.298908],
                            [119.822331, 27.301433],
                            [119.819526, 27.296045],
                            [119.795756, 27.310441],
                            [119.790491, 27.302612],
                            [119.77056, 27.305685],
                            [119.769772, 27.324373],
                            [119.777991, 27.320164],
                            [119.784979, 27.323574],
                            [119.781485, 27.330476],
                            [119.768394, 27.335736],
                            [119.769132, 27.345415],
                            [119.751022, 27.350086],
                            [119.74743, 27.359973],
                            [119.740491, 27.362203],
                            [119.750481, 27.373226],
                            [119.740294, 27.375708],
                            [119.739555, 27.386813],
                            [119.733847, 27.388706],
                            [119.724349, 27.401703],
                            [119.71303, 27.402838],
                            [119.704319, 27.416927],
                            [119.704713, 27.424706],
                            [119.689506, 27.430845],
                            [119.685471, 27.438413],
                            [119.693886, 27.438665],
                            [119.703433, 27.447284],
                            [119.704024, 27.458508],
                            [119.709929, 27.46246],
                            [119.706681, 27.470656],
                            [119.710717, 27.482508],
                            [119.709634, 27.496797],
                            [119.702892, 27.500285],
                            [119.708551, 27.514276],
                            [119.689506, 27.534064],
                            [119.690589, 27.537256],
                            [119.670559, 27.536584],
                            [119.659339, 27.539693],
                            [119.668837, 27.556493],
                            [119.672036, 27.556409],
                            [119.675038, 27.574383],
                            [119.645461, 27.578205],
                            [119.630894, 27.582698],
                            [119.626465, 27.620481],
                            [119.64113, 27.625392],
                            [119.647528, 27.640543],
                            [119.639654, 27.652671],
                            [119.644033, 27.663496],
                            [119.635569, 27.668405],
                            [119.606238, 27.67474],
                            [119.595018, 27.666895],
                            [119.583945, 27.665175],
                            [119.578925, 27.669832],
                            [119.566523, 27.663748],
                            [119.550135, 27.663832],
                            [119.549299, 27.670167],
                            [119.539161, 27.67537],
                            [119.541917, 27.663916],
                            [119.537094, 27.658923],
                            [119.525923, 27.660307],
                            [119.52046, 27.650069],
                            [119.511503, 27.653468],
                            [119.501169, 27.649901],
                            [119.49797, 27.625896],
                            [119.500923, 27.608224],
                            [119.488718, 27.59882],
                            [119.481877, 27.585679],
                            [119.48483, 27.570394],
                            [119.477497, 27.553847],
                            [119.474643, 27.539314],
                            [119.466523, 27.52646],
                            [119.45171, 27.51352],
                            [119.438472, 27.508772],
                            [119.432861, 27.513016],
                            [119.422674, 27.536584],
                            [119.41667, 27.539651],
                            [119.394968, 27.539272],
                            [119.376808, 27.534988],
                            [119.360027, 27.524402],
                            [119.341867, 27.506797],
                            [119.347674, 27.492763],
                            [119.334682, 27.480029],
                            [119.285026, 27.457626],
                            [119.276463, 27.435512],
                            [119.267851, 27.421468],
                            [119.251069, 27.420753],
                            [119.24728, 27.4295],
                            [119.243441, 27.419828],
                            [119.222674, 27.417053],
                            [119.209485, 27.422099],
                            [119.19477, 27.418735],
                            [119.180252, 27.428238],
                            [119.16849, 27.424874],
                            [119.153973, 27.428532],
                            [119.147526, 27.424832],
                            [119.138766, 27.434419],
                            [119.12853, 27.43177],
                            [119.121394, 27.438329],
                            [119.125921, 27.452203],
                            [119.118884, 27.461451],
                            [119.131286, 27.46309],
                            [119.130744, 27.4728],
                            [119.115095, 27.482845],
                            [119.088126, 27.464099],
                            [119.072525, 27.472253],
                            [119.066423, 27.466957],
                            [119.055301, 27.477591],
                            [119.037191, 27.480617],
                            [119.020803, 27.497931],
                            [118.998903, 27.496335],
                            [118.990734, 27.503352],
                            [118.982761, 27.49604],
                            [118.990439, 27.48856],
                            [118.988322, 27.477255],
                            [118.966029, 27.473346],
                            [118.955448, 27.449849],
                            [118.949198, 27.456364],
                            [118.933352, 27.463595],
                            [118.910763, 27.460862],
                            [118.901462, 27.464688],
                            [118.897722, 27.478978],
                            [118.889454, 27.481332],
                            [118.89034, 27.494107],
                            [118.886501, 27.501251],
                            [118.879907, 27.49957],
                            [118.873607, 27.517764],
                            [118.857859, 27.516671],
                            [118.859631, 27.527594],
                            [118.869178, 27.539903],
                            [118.889011, 27.547505],
                            [118.896048, 27.563129],
                            [118.910222, 27.570352],
                            [118.90407, 27.575979],
                            [118.902741, 27.592313],
                            [118.913913, 27.619138],
                            [118.902643, 27.623671],
                            [118.903726, 27.638864],
                            [118.89531, 27.655566],
                            [118.879907, 27.667944],
                            [118.874641, 27.682795],
                            [118.880546, 27.689297],
                            [118.875035, 27.700958],
                            [118.878479, 27.70532],
                            [118.900084, 27.704985],
                            [118.897968, 27.718909],
                            [118.890438, 27.718741],
                            [118.880645, 27.731153],
                            [118.87218, 27.734424],
                            [118.853972, 27.774251],
                            [118.839995, 27.779322],
                            [118.839405, 27.788585],
                            [118.851462, 27.796003],
                            [118.847131, 27.812513],
                            [118.838814, 27.820641],
                            [118.835418, 27.838195],
                            [118.826314, 27.846614],
                            [118.835763, 27.866509],
                            [118.82656, 27.874843],
                            [118.831531, 27.886316],
                            [118.820408, 27.89536],
                            [118.81844, 27.916711],
                            [118.803725, 27.918302],
                            [118.804562, 27.927092],
                            [118.767111, 27.941824],
                            [118.754168, 27.942745],
                            [118.753479, 27.948018],
                            [118.729906, 27.97258],
                            [118.732514, 27.990904],
                            [118.72656, 28.000399],
                            [118.726609, 28.014201],
                            [118.733499, 28.026455],
                            [118.732662, 28.035947],
                            [118.720359, 28.045438],
                            [118.718784, 28.063624],
                            [118.73532, 28.074994],
                            [118.743144, 28.088536],
                            [118.763518, 28.094721],
                            [118.765142, 28.102912],
                            [118.773607, 28.107968],
                            [118.785369, 28.106715],
                            [118.802298, 28.117286],
                            [118.800428, 28.13312],
                            [118.805891, 28.153088],
                            [118.798115, 28.168917],
                            [118.782908, 28.172633],
                            [118.775182, 28.167998],
                            [118.760959, 28.167413],
                            [118.769276, 28.185746],
                            [118.782121, 28.193178],
                            [118.794769, 28.205953],
                            [118.804168, 28.207874],
                            [118.812387, 28.225573],
                            [118.802052, 28.240431],
                            [118.781186, 28.243102],
                            [118.754513, 28.253452],
                            [118.740881, 28.267514],
                            [118.739355, 28.27736],
                            [118.727298, 28.281115],
                            [118.730152, 28.2968],
                            [118.722327, 28.31048],
                            [118.713518, 28.312899],
                            [118.700182, 28.310397],
                            [118.689896, 28.291001],
                            [118.674788, 28.271435],
                            [118.666668, 28.269725],
                            [118.651363, 28.27711],
                            [118.64024, 28.27348],
                            [118.632465, 28.261297],
                            [118.623016, 28.256623],
                            [118.595703, 28.256999],
                            [118.598016, 28.270643],
                            [118.584482, 28.284327],
                            [118.568833, 28.285245],
                            [118.558596, 28.282324],
                            [118.547474, 28.28658],
                            [118.546244, 28.275024],
                            [118.530201, 28.270434],
                            [118.514157, 28.269641],
                            [118.505643, 28.279905],
                            [118.495604, 28.273104],
                            [118.492947, 28.262715],
                            [118.502691, 28.246817],
                            [118.490683, 28.238428],
                            [118.481037, 28.245982],
                            [118.463862, 28.243061],
                            [118.445161, 28.254745],
                            [118.448852, 28.261505],
                            [118.438616, 28.261255],
                            [118.430446, 28.280781],
                            [118.433202, 28.28829],
                            [118.459679, 28.30168],
                            [118.47085, 28.316694],
                            [118.481923, 28.32099],
                            [118.48709, 28.328996],
                            [118.469423, 28.328204],
                            [118.473901, 28.339046],
                            [118.469275, 28.355848],
                            [118.455151, 28.383984],
                            [118.431135, 28.398362],
                            [118.44024, 28.411946],
                            [118.456529, 28.415988],
                            [118.450131, 28.418154],
                            [118.459334, 28.42982],
                            [118.465929, 28.448232],
                            [118.463321, 28.455854],
                            [118.482169, 28.47118],
                            [118.472179, 28.479384],
                            [118.461647, 28.482631],
                            [118.454315, 28.476385],
                            [118.438124, 28.492999],
                            [118.421785, 28.492125],
                            [118.415043, 28.497412],
                            [118.421933, 28.502991],
                            [118.430791, 28.500785],
                            [118.445555, 28.513273],
                            [118.437287, 28.521682],
                            [118.433251, 28.516479],
                            [118.425328, 28.525261],
                            [118.428133, 28.534668],
                            [118.420702, 28.544739],
                            [118.428084, 28.54736],
                            [118.41337, 28.555142],
                            [118.409433, 28.569247],
                            [118.417307, 28.572825],
                            [118.415683, 28.583475],
                            [118.421588, 28.596287],
                            [118.414059, 28.595372],
                            [118.417749, 28.607558],
                            [118.425279, 28.611426],
                            [118.433399, 28.627062],
                            [118.427789, 28.63147],
                            [118.422129, 28.646812],
                            [118.432612, 28.651551],
                            [118.432858, 28.676533],
                            [118.414994, 28.686591],
                            [118.418832, 28.692242],
                            [118.402247, 28.703005],
                            [118.39147, 28.700512],
                            [118.392503, 28.710442],
                            [118.401903, 28.714473],
                            [118.399738, 28.727559],
                            [118.392356, 28.738858],
                            [118.396293, 28.754932],
                            [118.386942, 28.754807],
                            [118.383694, 28.774201],
                            [118.378724, 28.784622],
                            [118.38335, 28.787363],
                            [118.371932, 28.801769],
                            [118.368192, 28.811275],
                            [118.331873, 28.814803],
                            [118.320554, 28.821236],
                            [118.310564, 28.821983],
                            [118.295308, 28.835222],
                            [118.304314, 28.840078],
                            [118.297424, 28.847837],
                            [118.293881, 28.860866],
                            [118.287926, 28.864517],
                            [118.28143, 28.891356],
                            [118.276115, 28.89596],
                            [118.269865, 28.918644],
                            [118.256824, 28.92362],
                            [118.237631, 28.91852],
                            [118.224983, 28.911843],
                            [118.199392, 28.902969],
                            [118.193487, 28.908277],
                            [118.196686, 28.915949],
                            [118.206036, 28.919598],
                            [118.227837, 28.942443],
                            [118.223802, 28.947832],
                            [118.199392, 28.954672],
                            [118.195997, 28.965034],
                            [118.186597, 28.97697],
                            [118.16514, 28.986709],
                            [118.147178, 28.984803],
                            [118.147867, 28.977799],
                            [118.133743, 28.983891],
                            [118.125918, 28.994499],
                            [118.132463, 29.008379],
                            [118.127296, 29.016085],
                            [118.113713, 29.009208],
                            [118.110022, 28.991723],
                            [118.099933, 28.990397],
                            [118.110662, 29.003739],
                            [118.10702, 29.011984],
                            [118.097079, 28.998726],
                            [118.090681, 29.010451],
                            [118.088073, 29.029424],
                            [118.072177, 29.038991],
                            [118.066961, 29.053942],
                            [118.076902, 29.062845],
                            [118.07577, 29.074563],
                            [118.045898, 29.088846],
                            [118.037974, 29.101886],
                            [118.053083, 29.116248],
                            [118.03891, 29.126346],
                            [118.045012, 29.149104],
                            [118.04137, 29.160853],
                            [118.028378, 29.169251],
                            [118.033447, 29.177151],
                            [118.042453, 29.210319],
                            [118.05141, 29.217596],
                            [118.057906, 29.214784],
                            [118.07326, 29.217017],
                            [118.081971, 29.234587],
                            [118.075573, 29.24736],
                            [118.080445, 29.266331],
                            [118.077886, 29.278769],
                            [118.071931, 29.287033],
                            [118.078132, 29.290587],
                            [118.105101, 29.284926],
                            [118.115878, 29.293685],
                            [118.136105, 29.283893],
                            [118.152886, 29.28629],
                            [118.169373, 29.29761],
                            [118.176607, 29.297404],
                            [118.176066, 29.305914],
                            [118.166567, 29.313886],
                            [118.179756, 29.321404],
                            [118.1833, 29.332225],
                            [118.207808, 29.347587],
                            [118.208694, 29.360346],
                            [118.204018, 29.36786],
                            [118.208792, 29.377521],
                            [118.194323, 29.388253],
                            [118.193044, 29.39527],
                            [118.204264, 29.395394],
                            [118.218093, 29.420361],
                            [118.232955, 29.42391],
                            [118.248507, 29.431337],
                            [118.255692, 29.42618],
                            [118.267798, 29.427871],
                            [118.277641, 29.423374],
                            [118.286154, 29.426716],
                            [118.291371, 29.41999],
                            [118.316125, 29.42259],
                            [118.315977, 29.450562],
                            [118.306627, 29.479434],
                            [118.310564, 29.496011],
                            [118.324442, 29.496918],
                            [118.344964, 29.475681],
                        ],
                    ],
                    [
                        [
                            [122.256887, 30.065104],
                            [122.269929, 30.062439],
                            [122.291632, 30.065145],
                            [122.31176, 30.038656],
                            [122.32677, 30.031848],
                            [122.334102, 30.021266],
                            [122.343896, 30.020446],
                            [122.346898, 30.011544],
                            [122.340303, 30.006539],
                            [122.344289, 29.995257],
                            [122.341287, 29.976834],
                            [122.331986, 29.962183],
                            [122.324112, 29.941291],
                            [122.308955, 29.943466],
                            [122.279033, 29.937514],
                            [122.239958, 29.962593],
                            [122.192616, 29.978886],
                            [122.168944, 29.989103],
                            [122.139958, 29.987092],
                            [122.120863, 29.98381],
                            [122.108806, 30.00494],
                            [122.092468, 30.006786],
                            [122.073422, 30.005145],
                            [122.038875, 29.989595],
                            [122.026424, 29.992426],
                            [122.012005, 30.021184],
                            [121.99857, 30.037548],
                            [121.981247, 30.048826],
                            [121.978196, 30.059282],
                            [121.992221, 30.074656],
                            [121.983461, 30.100316],
                            [121.948471, 30.147888],
                            [121.935085, 30.16161],
                            [121.936414, 30.167795],
                            [121.949997, 30.176068],
                            [121.955164, 30.184012],
                            [121.977211, 30.174471],
                            [121.996306, 30.161405],
                            [122.036808, 30.148912],
                            [122.048767, 30.147233],
                            [122.072684, 30.154114],
                            [122.095716, 30.158088],
                            [122.110922, 30.154811],
                            [122.119978, 30.14924],
                            [122.121454, 30.141088],
                            [122.133019, 30.136622],
                            [122.144879, 30.118798],
                            [122.156641, 30.112611],
                            [122.169486, 30.117118],
                            [122.182429, 30.117036],
                            [122.191631, 30.108677],
                            [122.240746, 30.108103],
                            [122.258315, 30.098595],
                            [122.279525, 30.102857],
                            [122.293896, 30.100316],
                            [122.304083, 30.086544],
                            [122.290943, 30.074451],
                            [122.281642, 30.077403],
                            [122.265943, 30.076214],
                            [122.256543, 30.071828],
                            [122.256887, 30.065104],
                        ],
                    ],
                    [
                        [
                            [122.625097, 30.817539],
                            [122.615845, 30.82474],
                            [122.622243, 30.826001],
                            [122.636269, 30.819939],
                            [122.637745, 30.814447],
                            [122.625097, 30.817539],
                        ],
                    ],
                    [
                        [
                            [122.150932, 30.190073],
                            [122.166484, 30.198385],
                            [122.176621, 30.199982],
                            [122.178196, 30.191752],
                            [122.196356, 30.193635],
                            [122.218206, 30.188885],
                            [122.204181, 30.18176],
                            [122.208118, 30.175167],
                            [122.197586, 30.175904],
                            [122.184495, 30.163453],
                            [122.190696, 30.161078],
                            [122.176474, 30.155138],
                            [122.170125, 30.139121],
                            [122.162891, 30.137933],
                            [122.150686, 30.146659],
                            [122.1436, 30.166935],
                            [122.150932, 30.190073],
                        ],
                    ],
                    [
                        [
                            [122.207773, 29.70316],
                            [122.208216, 29.715627],
                            [122.217813, 29.711759],
                            [122.226179, 29.714105],
                            [122.232773, 29.706122],
                            [122.229624, 29.701637],
                            [122.262301, 29.688057],
                            [122.281642, 29.688633],
                            [122.277606, 29.677933],
                            [122.270864, 29.685135],
                            [122.250391, 29.688139],
                            [122.24611, 29.67999],
                            [122.229082, 29.693489],
                            [122.207773, 29.70316],
                        ],
                    ],
                    [
                        [
                            [122.427607, 30.738538],
                            [122.432183, 30.742325],
                            [122.450441, 30.743017],
                            [122.460432, 30.730272],
                            [122.467075, 30.730272],
                            [122.473621, 30.715204],
                            [122.486514, 30.711132],
                            [122.504871, 30.713249],
                            [122.50615, 30.720051],
                            [122.528345, 30.724897],
                            [122.536268, 30.717567],
                            [122.526672, 30.713983],
                            [122.539664, 30.703678],
                            [122.535186, 30.698301],
                            [122.513778, 30.702049],
                            [122.510136, 30.69492],
                            [122.499605, 30.70323],
                            [122.490501, 30.695775],
                            [122.487154, 30.701193],
                            [122.4499, 30.691457],
                            [122.444241, 30.697079],
                            [122.437055, 30.691743],
                            [122.427607, 30.69602],
                            [122.430264, 30.706529],
                            [122.442518, 30.716345],
                            [122.441681, 30.733082],
                            [122.427607, 30.738538],
                        ],
                    ],
                    [
                        [
                            [122.163088, 30.329809],
                            [122.173816, 30.337578],
                            [122.178147, 30.350579],
                            [122.18174, 30.340971],
                            [122.191877, 30.337414],
                            [122.191287, 30.329155],
                            [122.209003, 30.32985],
                            [122.213383, 30.33443],
                            [122.228344, 30.329564],
                            [122.221602, 30.324657],
                            [122.231887, 30.305968],
                            [122.248177, 30.304496],
                            [122.239466, 30.296479],
                            [122.224456, 30.290425],
                            [122.231395, 30.277989],
                            [122.237202, 30.277007],
                            [122.229427, 30.260436],
                            [122.230116, 30.23269],
                            [122.208856, 30.229129],
                            [122.208413, 30.235514],
                            [122.199604, 30.234327],
                            [122.194141, 30.24374],
                            [122.146356, 30.246237],
                            [122.134446, 30.251884],
                            [122.101031, 30.275084],
                            [122.057822, 30.291775],
                            [122.051867, 30.300078],
                            [122.058511, 30.304618],
                            [122.06791, 30.301714],
                            [122.092812, 30.299996],
                            [122.124357, 30.319995],
                            [122.133019, 30.314515],
                            [122.137743, 30.32159],
                            [122.144043, 30.315538],
                            [122.163088, 30.329809],
                        ],
                    ],
                    [
                        [
                            [122.317468, 30.249593],
                            [122.318699, 30.26551],
                            [122.322685, 30.26997],
                            [122.349457, 30.267392],
                            [122.358807, 30.271238],
                            [122.385727, 30.270993],
                            [122.400343, 30.275657],
                            [122.407233, 30.27267],
                            [122.409595, 30.25704],
                            [122.429477, 30.250861],
                            [122.418798, 30.246278],
                            [122.417174, 30.23887],
                            [122.407725, 30.236005],
                            [122.408217, 30.227778],
                            [122.397193, 30.225241],
                            [122.391534, 30.239893],
                            [122.381986, 30.238134],
                            [122.380707, 30.253889],
                            [122.363236, 30.254871],
                            [122.362055, 30.239566],
                            [122.34862, 30.233222],
                            [122.336809, 30.23576],
                            [122.32923, 30.230193],
                            [122.318403, 30.236455],
                            [122.309004, 30.23531],
                            [122.305559, 30.228883],
                            [122.298472, 30.234082],
                            [122.29173, 30.226509],
                            [122.284545, 30.226837],
                            [122.275982, 30.23535],
                            [122.278, 30.243004],
                            [122.317468, 30.249593],
                        ],
                    ],
                    [
                        [
                            [122.026375, 29.178351],
                            [122.040843, 29.17955],
                            [122.029771, 29.187367],
                            [122.037005, 29.190552],
                            [122.031247, 29.196342],
                            [122.036217, 29.207383],
                            [122.056198, 29.200518],
                            [122.050095, 29.193488],
                            [122.057576, 29.188939],
                            [122.044534, 29.1841],
                            [122.049013, 29.175083],
                            [122.063235, 29.174008],
                            [122.074505, 29.178144],
                            [122.06791, 29.165611],
                            [122.056739, 29.158454],
                            [122.039859, 29.163253],
                            [122.037645, 29.151959],
                            [122.027605, 29.155806],
                            [122.013383, 29.151504],
                            [122.026375, 29.178351],
                        ],
                    ],
                    [
                        [
                            [122.675245, 30.848779],
                            [122.679133, 30.861102],
                            [122.690108, 30.849105],
                            [122.698523, 30.848128],
                            [122.695472, 30.839018],
                            [122.687991, 30.838082],
                            [122.669192, 30.845566],
                            [122.675245, 30.848779],
                        ],
                    ],
                    [
                        [
                            [121.84911, 28.733666],
                            [121.855557, 28.736075],
                            [121.846994, 28.741433],
                            [121.851177, 28.748868],
                            [121.875833, 28.749034],
                            [121.893008, 28.762532],
                            [121.909544, 28.761867],
                            [121.896109, 28.757341],
                            [121.893008, 28.752108],
                            [121.880508, 28.748702],
                            [121.866089, 28.738027],
                            [121.873077, 28.727518],
                            [121.865547, 28.721992],
                            [121.859642, 28.727891],
                            [121.846797, 28.729055],
                            [121.84911, 28.733666],
                        ],
                    ],
                    [
                        [
                            [122.782824, 30.789748],
                            [122.782135, 30.7823],
                            [122.775689, 30.788038],
                            [122.782824, 30.789748],
                        ],
                    ],
                    [
                        [
                            [121.749651, 28.69058],
                            [121.761856, 28.689333],
                            [121.765252, 28.705124],
                            [121.780508, 28.699182],
                            [121.772732, 28.694195],
                            [121.790006, 28.690913],
                            [121.801571, 28.702423],
                            [121.808559, 28.699431],
                            [121.800045, 28.695317],
                            [121.794041, 28.679608],
                            [121.781689, 28.680066],
                            [121.778687, 28.687629],
                            [121.768254, 28.690746],
                            [121.75226, 28.683349],
                            [121.749651, 28.69058],
                        ],
                    ],
                    [
                        [
                            [122.331002, 29.938089],
                            [122.351868, 29.959105],
                            [122.356691, 29.950321],
                            [122.372734, 29.954139],
                            [122.377164, 29.949008],
                            [122.397882, 29.939648],
                            [122.401573, 29.945806],
                            [122.410235, 29.94478],
                            [122.408955, 29.951429],
                            [122.424309, 29.945765],
                            [122.420618, 29.937309],
                            [122.430215, 29.916904],
                            [122.410923, 29.91793],
                            [122.41363, 29.912551],
                            [122.43489, 29.906227],
                            [122.432085, 29.893989],
                            [122.434053, 29.883557],
                            [122.418601, 29.881462],
                            [122.41929, 29.873082],
                            [122.401819, 29.870042],
                            [122.398079, 29.853609],
                            [122.413236, 29.84835],
                            [122.416189, 29.828995],
                            [122.386366, 29.834009],
                            [122.378345, 29.84309],
                            [122.369978, 29.862031],
                            [122.376819, 29.871151],
                            [122.376327, 29.88676],
                            [122.372341, 29.893209],
                            [122.362744, 29.8944],
                            [122.341337, 29.908198],
                            [122.327213, 29.923103],
                            [122.331002, 29.938089],
                        ],
                    ],
                    [
                        [
                            [122.430412, 30.408653],
                            [122.41112, 30.411268],
                            [122.404821, 30.4176],
                            [122.387695, 30.417477],
                            [122.378295, 30.413556],
                            [122.375441, 30.419357],
                            [122.365156, 30.417151],
                            [122.352409, 30.421971],
                            [122.348079, 30.410696],
                            [122.318305, 30.407182],
                            [122.285923, 30.417028],
                            [122.280411, 30.420337],
                            [122.279378, 30.444477],
                            [122.281838, 30.460118],
                            [122.278689, 30.474369],
                            [122.287596, 30.47739],
                            [122.303984, 30.46657],
                            [122.314959, 30.470245],
                            [122.337006, 30.465794],
                            [122.35615, 30.464651],
                            [122.372734, 30.47886],
                            [122.383414, 30.472858],
                            [122.373817, 30.46167],
                            [122.381445, 30.455953],
                            [122.402459, 30.458281],
                            [122.411268, 30.452686],
                            [122.432282, 30.445376],
                            [122.428542, 30.430549],
                            [122.432725, 30.420092],
                            [122.440796, 30.413556],
                            [122.430412, 30.408653],
                        ],
                    ],
                    [
                        [
                            [122.231297, 28.859829],
                            [122.243797, 28.861322],
                            [122.238679, 28.853315],
                            [122.231297, 28.859829],
                        ],
                    ],
                    [
                        [
                            [122.181936, 29.407693],
                            [122.179771, 29.424694],
                            [122.187497, 29.421806],
                            [122.197242, 29.425478],
                            [122.199358, 29.436247],
                            [122.21112, 29.44095],
                            [122.22485, 29.438392],
                            [122.223866, 29.428366],
                            [122.207921, 29.429645],
                            [122.205362, 29.418092],
                            [122.190204, 29.415905],
                            [122.181936, 29.407693],
                        ],
                    ],
                    [
                        [
                            [121.919928, 28.707285],
                            [121.916581, 28.717215],
                            [121.942664, 28.720663],
                            [121.920617, 28.704916],
                            [121.919928, 28.707285],
                        ],
                    ],
                    [
                        [
                            [121.387347, 28.119292],
                            [121.401323, 28.129862],
                            [121.401569, 28.122968],
                            [121.387347, 28.119292],
                        ],
                    ],
                    [
                        [
                            [121.837349, 28.770505],
                            [121.850538, 28.784747],
                            [121.844386, 28.788816],
                            [121.852949, 28.793092],
                            [121.857034, 28.803637],
                            [121.850734, 28.808286],
                            [121.861561, 28.813765],
                            [121.872388, 28.807871],
                            [121.865498, 28.799361],
                            [121.862693, 28.78209],
                            [121.843254, 28.770629],
                            [121.837349, 28.770505],
                        ],
                    ],
                    [
                        [
                            [122.327163, 30.519474],
                            [122.340008, 30.522371],
                            [122.34611, 30.528044],
                            [122.343699, 30.504006],
                            [122.31924, 30.512781],
                            [122.317518, 30.518046],
                            [122.327163, 30.519474],
                        ],
                    ],
                    [
                        [
                            [122.450737, 30.426097],
                            [122.459693, 30.426424],
                            [122.46427, 30.436799],
                            [122.476081, 30.436023],
                            [122.474211, 30.429528],
                            [122.485727, 30.415762],
                            [122.469634, 30.414413],
                            [122.450737, 30.426097],
                        ],
                    ],
                    [
                        [
                            [121.687397, 28.384526],
                            [121.69532, 28.381317],
                            [121.686118, 28.374648],
                            [121.687397, 28.384526],
                        ],
                    ],
                    [
                        [
                            [122.477361, 30.229784],
                            [122.489516, 30.231298],
                            [122.503493, 30.22565],
                            [122.503197, 30.215907],
                            [122.481445, 30.221147],
                            [122.477361, 30.229784],
                        ],
                    ],
                    [
                        [
                            [122.264762, 29.845391],
                            [122.282527, 29.845515],
                            [122.302065, 29.838488],
                            [122.302951, 29.83368],
                            [122.319289, 29.829447],
                            [122.323768, 29.821844],
                            [122.318354, 29.817857],
                            [122.297882, 29.81798],
                            [122.297045, 29.811486],
                            [122.31614, 29.806389],
                            [122.309447, 29.794098],
                            [122.328443, 29.777693],
                            [122.317222, 29.774198],
                            [122.310136, 29.766796],
                            [122.296799, 29.778968],
                            [122.28484, 29.779667],
                            [122.267862, 29.792782],
                            [122.248571, 29.804334],
                            [122.24109, 29.820323],
                            [122.23046, 29.822707],
                            [122.221257, 29.835817],
                            [122.234446, 29.846542],
                            [122.248374, 29.848761],
                            [122.264762, 29.845391],
                        ],
                    ],
                    [
                        [
                            [122.302951, 30.499108],
                            [122.321848, 30.49425],
                            [122.31427, 30.491066],
                            [122.302951, 30.499108],
                        ],
                    ],
                    [
                        [
                            [122.217222, 29.638577],
                            [122.231002, 29.634748],
                            [122.21983, 29.629971],
                            [122.217222, 29.638577],
                        ],
                    ],
                    [
                        [
                            [120.971745, 27.649859],
                            [120.967759, 27.658042],
                            [120.97957, 27.670419],
                            [120.988281, 27.662783],
                            [120.986509, 27.655104],
                            [120.974747, 27.645033],
                            [120.971745, 27.649859],
                        ],
                    ],
                    [
                        [
                            [122.703247, 30.19732],
                            [122.704724, 30.207065],
                            [122.711564, 30.209357],
                            [122.70807, 30.188476],
                            [122.703247, 30.19732],
                        ],
                    ],
                    [
                        [
                            [122.426918, 30.032094],
                            [122.428197, 30.038656],
                            [122.433463, 30.022004],
                            [122.426918, 30.032094],
                        ],
                    ],
                    [
                        [
                            [121.199945, 27.62493],
                            [121.213577, 27.633324],
                            [121.220811, 27.630303],
                            [121.209, 27.61855],
                            [121.198321, 27.614646],
                            [121.191677, 27.62195],
                            [121.199945, 27.62493],
                        ],
                    ],
                    [
                        [
                            [122.470766, 30.730069],
                            [122.46678, 30.742936],
                            [122.452115, 30.743343],
                            [122.452607, 30.757592],
                            [122.470077, 30.752585],
                            [122.46801, 30.744035],
                            [122.470766, 30.730069],
                        ],
                    ],
                    [
                        [
                            [122.189564, 29.810007],
                            [122.183708, 29.815186],
                            [122.190598, 29.820652],
                            [122.201179, 29.815227],
                            [122.195618, 29.804704],
                            [122.189564, 29.810007],
                        ],
                    ],
                    [
                        [
                            [121.790892, 29.082264],
                            [121.788677, 29.094601],
                            [121.793795, 29.099444],
                            [121.820272, 29.099402],
                            [121.831591, 29.095015],
                            [121.840941, 29.081519],
                            [121.838628, 29.057752],
                            [121.832329, 29.050381],
                            [121.82352, 29.051043],
                            [121.817319, 29.063052],
                            [121.808559, 29.059243],
                            [121.791089, 29.074232],
                            [121.790892, 29.082264],
                        ],
                    ],
                    [
                        [
                            [122.184299, 29.460627],
                            [122.19483, 29.465453],
                            [122.194141, 29.45345],
                            [122.183216, 29.455595],
                            [122.184299, 29.460627],
                        ],
                    ],
                    [
                        [
                            [122.026473, 29.621859],
                            [122.033855, 29.624741],
                            [122.037645, 29.613457],
                            [122.025686, 29.604314],
                            [122.022389, 29.620211],
                            [122.026473, 29.621859],
                        ],
                    ],
                    [
                        [
                            [122.258807, 28.886586],
                            [122.267025, 28.886835],
                            [122.267321, 28.880364],
                            [122.258807, 28.886586],
                        ],
                    ],
                    [
                        [
                            [122.52554, 30.221557],
                            [122.516682, 30.231339],
                            [122.529428, 30.230439],
                            [122.52554, 30.221557],
                        ],
                    ],
                    [
                        [
                            [122.269683, 30.222621],
                            [122.274653, 30.230234],
                            [122.282823, 30.227942],
                            [122.269683, 30.222621],
                        ],
                    ],
                    [
                        [
                            [121.943697, 30.77709],
                            [121.969731, 30.789178],
                            [121.987989, 30.753318],
                            [121.990794, 30.739353],
                            [121.988235, 30.711172],
                            [121.992812, 30.695368],
                            [122.010971, 30.669497],
                            [122.024357, 30.662489],
                            [122.034495, 30.661633],
                            [122.063284, 30.650222],
                            [122.072536, 30.649448],
                            [122.081592, 30.639666],
                            [122.07918, 30.634775],
                            [122.102113, 30.622994],
                            [122.11358, 30.621078],
                            [122.113629, 30.613781],
                            [122.12672, 30.609826],
                            [122.134298, 30.612394],
                            [122.136907, 30.600244],
                            [122.133265, 30.595514],
                            [122.123078, 30.598368],
                            [122.090745, 30.600325],
                            [122.071011, 30.611294],
                            [122.052851, 30.625399],
                            [122.024406, 30.643701],
                            [122.015007, 30.645291],
                            [121.997044, 30.658821],
                            [121.968205, 30.688361],
                            [121.961119, 30.705877],
                            [121.958609, 30.740493],
                            [121.955607, 30.75686],
                            [121.943697, 30.77709],
                        ],
                    ],
                    [
                        [
                            [122.636072, 30.204281],
                            [122.640895, 30.210913],
                            [122.650344, 30.210995],
                            [122.654527, 30.189704],
                            [122.646308, 30.18692],
                            [122.643848, 30.197853],
                            [122.636072, 30.204281],
                        ],
                    ],
                    [
                        [
                            [121.889563, 28.471513],
                            [121.876128, 28.472554],
                            [121.874111, 28.47701],
                            [121.883116, 28.484089],
                            [121.883658, 28.495456],
                            [121.871305, 28.49429],
                            [121.87037, 28.500035],
                            [121.880065, 28.501909],
                            [121.8873, 28.511359],
                            [121.896994, 28.514231],
                            [121.899455, 28.500701],
                            [121.918943, 28.497371],
                            [121.908313, 28.479092],
                            [121.889563, 28.471513],
                        ],
                    ],
                    [
                        [
                            [121.113133, 27.918344],
                            [121.123812, 27.921274],
                            [121.123911, 27.911353],
                            [121.113379, 27.904403],
                            [121.108163, 27.910934],
                            [121.113133, 27.918344],
                        ],
                    ],
                    [
                        [
                            [122.18233, 29.650764],
                            [122.174358, 29.659945],
                            [122.158117, 29.655293],
                            [122.141484, 29.660521],
                            [122.132822, 29.668548],
                            [122.133117, 29.683036],
                            [122.125686, 29.693119],
                            [122.111168, 29.70032],
                            [122.109052, 29.713899],
                            [122.095962, 29.716491],
                            [122.079968, 29.70139],
                            [122.073816, 29.701802],
                            [122.047881, 29.717972],
                            [122.065155, 29.749893],
                            [122.071405, 29.7728],
                            [122.083659, 29.783203],
                            [122.10856, 29.783655],
                            [122.120863, 29.790973],
                            [122.131395, 29.78863],
                            [122.137842, 29.774527],
                            [122.141385, 29.75779],
                            [122.146651, 29.749647],
                            [122.182133, 29.728833],
                            [122.200785, 29.711183],
                            [122.211366, 29.692255],
                            [122.192517, 29.655334],
                            [122.18233, 29.650764],
                        ],
                    ],
                    [
                        [
                            [121.678588, 28.278319],
                            [121.677604, 28.285954],
                            [121.686413, 28.2895],
                            [121.688775, 28.273939],
                            [121.678588, 28.278319],
                        ],
                    ],
                    [
                        [
                            [122.232626, 29.682666],
                            [122.24296, 29.675298],
                            [122.234594, 29.672005],
                            [122.232626, 29.682666],
                        ],
                    ],
                    [
                        [
                            [122.358807, 30.600081],
                            [122.374358, 30.587399],
                            [122.356543, 30.593353],
                            [122.358807, 30.600081],
                        ],
                    ],
                    [
                        [
                            [122.077901, 30.596411],
                            [122.100096, 30.592415],
                            [122.082231, 30.587236],
                            [122.085233, 30.578834],
                            [122.071749, 30.572553],
                            [122.055607, 30.585482],
                            [122.055164, 30.591681],
                            [122.077901, 30.596411],
                        ],
                    ],
                    [
                        [
                            [122.36176, 29.839556],
                            [122.376868, 29.841734],
                            [122.371209, 29.835529],
                            [122.378788, 29.834379],
                            [122.375933, 29.825748],
                            [122.369289, 29.828091],
                            [122.36176, 29.839556],
                        ],
                    ],
                    [
                        [
                            [122.229968, 29.661056],
                            [122.243502, 29.661015],
                            [122.245913, 29.654716],
                            [122.229968, 29.661056],
                        ],
                    ],
                    [
                        [
                            [121.983461, 29.227808],
                            [121.993451, 29.227808],
                            [122.001818, 29.221441],
                            [121.991089, 29.221441],
                            [121.983461, 29.227808],
                        ],
                    ],
                    [
                        [
                            [121.410674, 28.079425],
                            [121.404227, 28.077627],
                            [121.40718, 28.089873],
                            [121.400831, 28.092506],
                            [121.410526, 28.101617],
                            [121.410674, 28.079425],
                        ],
                    ],
                    [
                        [
                            [122.461367, 29.943877],
                            [122.456987, 29.92569],
                            [122.449162, 29.939238],
                            [122.459546, 29.948638],
                            [122.461367, 29.943877],
                        ],
                    ],
                    [
                        [
                            [122.570717, 30.644313],
                            [122.547046, 30.650752],
                            [122.54803, 30.663467],
                            [122.555757, 30.667419],
                            [122.558709, 30.679072],
                            [122.575639, 30.66583],
                            [122.587893, 30.665341],
                            [122.582922, 30.655113],
                            [122.568798, 30.65442],
                            [122.570717, 30.644313],
                        ],
                    ],
                    [
                        [
                            [122.179377, 30.226428],
                            [122.186956, 30.230644],
                            [122.200244, 30.226755],
                            [122.204574, 30.214106],
                            [122.190942, 30.212264],
                            [122.186415, 30.21779],
                            [122.179082, 30.214884],
                            [122.179377, 30.226428],
                        ],
                    ],
                    [
                        [
                            [122.424949, 30.6212],
                            [122.432725, 30.61745],
                            [122.423965, 30.612272],
                            [122.424949, 30.6212],
                        ],
                    ],
                    [
                        [
                            [121.131047, 27.762472],
                            [121.139118, 27.765155],
                            [121.144383, 27.758531],
                            [121.133114, 27.753123],
                            [121.131047, 27.762472],
                        ],
                    ],
                    [
                        [
                            [121.980705, 29.472671],
                            [121.987792, 29.474898],
                            [121.990843, 29.467845],
                            [121.980705, 29.472671],
                        ],
                    ],
                    [
                        [
                            [121.131047, 27.770143],
                            [121.138281, 27.776682],
                            [121.149846, 27.772029],
                            [121.136952, 27.766999],
                            [121.131047, 27.770143],
                        ],
                    ],
                    [
                        [
                            [121.869534, 28.423946],
                            [121.871256, 28.433111],
                            [121.889711, 28.451189],
                            [121.920617, 28.45273],
                            [121.910823, 28.440068],
                            [121.893451, 28.430278],
                            [121.88602, 28.433986],
                            [121.869534, 28.423946],
                        ],
                    ],
                    [
                        [
                            [121.687397, 29.09667],
                            [121.681885, 29.109336],
                            [121.691777, 29.11124],
                            [121.697092, 29.094062],
                            [121.687397, 29.09667],
                        ],
                    ],
                    [
                        [
                            [122.209003, 30.222375],
                            [122.216681, 30.22082],
                            [122.225441, 30.229293],
                            [122.23735, 30.232322],
                            [122.245322, 30.218405],
                            [122.228295, 30.220451],
                            [122.215746, 30.218036],
                            [122.209003, 30.222375],
                        ],
                    ],
                    [
                        [
                            [121.976178, 29.501124],
                            [121.989908, 29.510071],
                            [122.004967, 29.503763],
                            [122.004574, 29.500299],
                            [121.984741, 29.503886],
                            [121.983806, 29.497042],
                            [121.976178, 29.501124],
                        ],
                    ],
                    [
                        [
                            [121.695271, 29.088474],
                            [121.710084, 29.082719],
                            [121.694385, 29.084707],
                            [121.695271, 29.088474],
                        ],
                    ],
                    [
                        [
                            [122.15546, 29.619429],
                            [122.160824, 29.619346],
                            [122.152704, 29.60695],
                            [122.14419, 29.608474],
                            [122.15546, 29.619429],
                        ],
                    ],
                    [
                        [
                            [122.391484, 29.970309],
                            [122.376819, 29.973305],
                            [122.367813, 29.980486],
                            [122.372291, 29.988364],
                            [122.373128, 30.001658],
                            [122.380018, 30.024506],
                            [122.397784, 30.026721],
                            [122.40861, 30.031725],
                            [122.41053, 30.024301],
                            [122.403345, 30.0154],
                            [122.41801, 30.006293],
                            [122.414418, 29.998458],
                            [122.39675, 29.999114],
                            [122.393502, 29.985123],
                            [122.398571, 29.975151],
                            [122.391484, 29.970309],
                        ],
                    ],
                    [
                        [
                            [122.065204, 30.179631],
                            [122.059003, 30.17832],
                            [122.033068, 30.161201],
                            [122.024013, 30.162593],
                            [122.017664, 30.186469],
                            [122.030115, 30.198057],
                            [122.040056, 30.196051],
                            [122.04291, 30.201497],
                            [122.055755, 30.200309],
                            [122.065696, 30.192202],
                            [122.065204, 30.179631],
                        ],
                    ],
                    [
                        [
                            [121.888087, 30.092078],
                            [121.880114, 30.085274],
                            [121.893402, 30.082691],
                            [121.89537, 30.073303],
                            [121.906935, 30.055797],
                            [121.915597, 30.057273],
                            [121.92475, 30.052598],
                            [121.924849, 30.037877],
                            [121.934199, 30.011749],
                            [121.932821, 29.994806],
                            [121.915646, 29.984097],
                            [121.890941, 29.974495],
                            [121.874258, 29.96481],
                            [121.850882, 29.969652],
                            [121.85039, 29.977285],
                            [121.837004, 29.987174],
                            [121.835232, 29.993001],
                            [121.844041, 30.007893],
                            [121.843156, 30.02869],
                            [121.839809, 30.047268],
                            [121.854081, 30.068179],
                            [121.848667, 30.101218],
                            [121.85979, 30.10171],
                            [121.885774, 30.094742],
                            [121.888087, 30.092078],
                        ],
                    ],
                    [
                        [
                            [121.107277, 27.444005],
                            [121.09399, 27.453001],
                            [121.086066, 27.452413],
                            [121.066381, 27.461325],
                            [121.063379, 27.458298],
                            [121.071942, 27.444972],
                            [121.066283, 27.444972],
                            [121.047976, 27.458046],
                            [121.050043, 27.464688],
                            [121.058852, 27.463847],
                            [121.055013, 27.473893],
                            [121.070515, 27.471161],
                            [121.066234, 27.478222],
                            [121.084147, 27.472379],
                            [121.089364, 27.462628],
                            [121.105407, 27.454893],
                            [121.107277, 27.444005],
                        ],
                    ],
                    [
                        [
                            [122.325638, 30.226919],
                            [122.335628, 30.227778],
                            [122.332183, 30.220247],
                            [122.325638, 30.226919],
                        ],
                    ],
                    [
                        [
                            [121.952064, 29.187616],
                            [121.975636, 29.192123],
                            [121.971601, 29.185093],
                            [121.981788, 29.175911],
                            [121.983511, 29.165404],
                            [121.971404, 29.163294],
                            [121.951719, 29.183107],
                            [121.952064, 29.187616],
                        ],
                    ],
                    [
                        [
                            [121.830803, 30.066375],
                            [121.821994, 30.082076],
                            [121.833264, 30.082855],
                            [121.844927, 30.077239],
                            [121.852506, 30.065596],
                            [121.847437, 30.06166],
                            [121.830803, 30.066375],
                        ],
                    ],
                    [
                        [
                            [120.903388, 27.69387],
                            [120.912099, 27.699238],
                            [120.911951, 27.689171],
                            [120.903388, 27.69387],
                        ],
                    ],
                    [
                        [
                            [122.038235, 29.759229],
                            [122.043944, 29.753801],
                            [122.043599, 29.742654],
                            [122.031837, 29.736814],
                            [122.029721, 29.716944],
                            [122.016335, 29.714475],
                            [122.011365, 29.74611],
                            [122.024357, 29.756844],
                            [122.038235, 29.759229],
                        ],
                    ],
                    [
                        [
                            [122.32239, 29.83257],
                            [122.323965, 29.839515],
                            [122.332872, 29.826652],
                            [122.32239, 29.83257],
                        ],
                    ],
                    [
                        [
                            [121.217415, 27.613681],
                            [121.228685, 27.616409],
                            [121.224945, 27.607048],
                            [121.217415, 27.613681],
                        ],
                    ],
                    [
                        [
                            [122.716486, 30.17574],
                            [122.72185, 30.181965],
                            [122.728051, 30.17271],
                            [122.718553, 30.168368],
                            [122.716486, 30.17574],
                        ],
                    ],
                    [
                        [
                            [122.1436, 30.610927],
                            [122.13607, 30.61533],
                            [122.149997, 30.619081],
                            [122.1436, 30.610927],
                        ],
                    ],
                    [
                        [
                            [122.514516, 30.649],
                            [122.522784, 30.643579],
                            [122.514221, 30.641786],
                            [122.514516, 30.649],
                        ],
                    ],
                    [
                        [
                            [121.957428, 30.287684],
                            [121.931542, 30.304414],
                            [121.921502, 30.307563],
                            [121.940252, 30.331731],
                            [121.976079, 30.337619],
                            [121.981001, 30.343384],
                            [121.989121, 30.340031],
                            [121.986168, 30.331036],
                            [121.992763, 30.328092],
                            [122.000883, 30.308504],
                            [121.989022, 30.289525],
                            [121.979869, 30.288502],
                            [121.968304, 30.294556],
                            [121.957428, 30.287684],
                        ],
                    ],
                    [
                        [
                            [121.940351, 30.114537],
                            [121.950341, 30.113594],
                            [121.963481, 30.10339],
                            [121.957674, 30.084659],
                            [121.945961, 30.064448],
                            [121.928638, 30.06658],
                            [121.929623, 30.078469],
                            [121.916483, 30.083265],
                            [121.911266, 30.095685],
                            [121.923323, 30.106628],
                            [121.940351, 30.114537],
                        ],
                    ],
                    [
                        [
                            [122.526278, 30.666767],
                            [122.533365, 30.672268],
                            [122.544881, 30.663344],
                            [122.540894, 30.657884],
                            [122.526278, 30.666767],
                        ],
                    ],
                    [
                        [
                            [121.083655, 27.791896],
                            [121.091037, 27.793237],
                            [121.096893, 27.783053],
                            [121.090545, 27.776221],
                            [121.073566, 27.778023],
                            [121.083655, 27.791896],
                        ],
                    ],
                    [
                        [
                            [121.67908, 28.371063],
                            [121.688431, 28.373064],
                            [121.687348, 28.366269],
                            [121.67908, 28.371063],
                        ],
                    ],
                    [
                        [
                            [121.672633, 29.062224],
                            [121.680507, 29.054688],
                            [121.665842, 29.059615],
                            [121.672633, 29.062224],
                        ],
                    ],
                    [
                        [
                            [122.680856, 30.190523],
                            [122.673178, 30.208334],
                            [122.687007, 30.205345],
                            [122.694094, 30.187698],
                            [122.689222, 30.180982],
                            [122.688434, 30.191301],
                            [122.680856, 30.190523],
                        ],
                    ],
                    [
                        [
                            [122.226572, 29.808856],
                            [122.239023, 29.801867],
                            [122.224702, 29.801867],
                            [122.226572, 29.808856],
                        ],
                    ],
                    [
                        [
                            [121.930459, 29.036051],
                            [121.931, 29.041394],
                            [121.948766, 29.047233],
                            [121.954524, 29.043961],
                            [121.940991, 29.03369],
                            [121.930459, 29.036051],
                        ],
                    ],
                    [
                        [
                            [121.851227, 28.423487],
                            [121.855607, 28.431819],
                            [121.860872, 28.426737],
                            [121.851227, 28.423487],
                        ],
                    ],
                    [
                        [
                            [122.41678, 30.682047],
                            [122.435431, 30.674672],
                            [122.425737, 30.668886],
                            [122.408807, 30.672472],
                            [122.41678, 30.682047],
                        ],
                    ],
                    [
                        [
                            [122.006641, 29.234877],
                            [122.013826, 29.23281],
                            [122.008609, 29.222971],
                            [122.00103, 29.227394],
                            [122.006641, 29.234877],
                        ],
                    ],
                    [
                        [
                            [122.178492, 29.978393],
                            [122.193255, 29.965179],
                            [122.195962, 29.958694],
                            [122.182921, 29.955288],
                            [122.170765, 29.966164],
                            [122.154426, 29.971253],
                            [122.14355, 29.968462],
                            [122.141877, 29.974823],
                            [122.16924, 29.988241],
                            [122.178492, 29.978393],
                        ],
                    ],
                    [
                        [
                            [121.618106, 30.604811],
                            [121.617712, 30.60848],
                            [121.637397, 30.608847],
                            [121.618106, 30.604811],
                        ],
                    ],
                    [
                        [
                            [122.001621, 29.410416],
                            [122.018944, 29.409674],
                            [122.016286, 29.404185],
                            [122.003835, 29.405051],
                            [122.001621, 29.410416],
                        ],
                    ],
                    [
                        [
                            [122.225047, 29.738294],
                            [122.234299, 29.739775],
                            [122.241287, 29.731918],
                            [122.233561, 29.731013],
                            [122.225047, 29.738294],
                        ],
                    ],
                    [
                        [
                            [122.127802, 30.218364],
                            [122.146946, 30.222007],
                            [122.151917, 30.21603],
                            [122.140647, 30.214393],
                            [122.129476, 30.207433],
                            [122.127802, 30.218364],
                        ],
                    ],
                    [
                        [
                            [121.863825, 30.116955],
                            [121.870567, 30.106628],
                            [121.861168, 30.104292],
                            [121.863825, 30.116955],
                        ],
                    ],
                    [
                        [
                            [121.145761, 27.760669],
                            [121.155013, 27.756645],
                            [121.146696, 27.754171],
                            [121.145761, 27.760669],
                        ],
                    ],
                    [
                        [
                            [122.197734, 29.726776],
                            [122.206789, 29.728833],
                            [122.219683, 29.724102],
                            [122.217124, 29.717355],
                            [122.197734, 29.726776],
                        ],
                    ],
                    [
                        [
                            [122.759941, 30.137073],
                            [122.763435, 30.142112],
                            [122.773326, 30.140432],
                            [122.784793, 30.12601],
                            [122.767126, 30.12347],
                            [122.759941, 30.137073],
                        ],
                    ],
                    [
                        [
                            [120.826223, 27.686193],
                            [120.833113, 27.687368],
                            [120.842758, 27.675537],
                            [120.832473, 27.67688],
                            [120.826223, 27.686193],
                        ],
                    ],
                    [
                        [
                            [122.287941, 29.723938],
                            [122.269978, 29.730725],
                            [122.251573, 29.731178],
                            [122.238236, 29.741996],
                            [122.213285, 29.771525],
                            [122.21422, 29.780366],
                            [122.233856, 29.784477],
                            [122.246159, 29.783367],
                            [122.261021, 29.773622],
                            [122.255706, 29.76108],
                            [122.258364, 29.753307],
                            [122.280017, 29.746233],
                            [122.296602, 29.749606],
                            [122.309545, 29.743518],
                            [122.313187, 29.731466],
                            [122.296848, 29.729985],
                            [122.287941, 29.723938],
                        ],
                    ],
                    [
                        [
                            [121.224108, 27.817876],
                            [121.213281, 27.820096],
                            [121.225043, 27.824496],
                            [121.224108, 27.817876],
                        ],
                    ],
                    [
                        [
                            [122.153836, 30.578957],
                            [122.156739, 30.584503],
                            [122.167862, 30.583687],
                            [122.153836, 30.578957],
                        ],
                    ],
                    [
                        [
                            [121.634592, 28.225448],
                            [121.644927, 28.232836],
                            [121.644828, 28.222985],
                            [121.634592, 28.225448],
                        ],
                    ],
                    [
                        [
                            [122.259053, 30.519882],
                            [122.267567, 30.526901],
                            [122.277901, 30.524493],
                            [122.275244, 30.513148],
                            [122.25738, 30.511842],
                            [122.259053, 30.519882],
                        ],
                    ],
                    [
                        [
                            [122.192468, 29.796194],
                            [122.202015, 29.790891],
                            [122.198324, 29.785217],
                            [122.182429, 29.788013],
                            [122.175686, 29.797181],
                            [122.192468, 29.796194],
                        ],
                    ],
                    [
                        [
                            [120.824943, 27.646208],
                            [120.8339, 27.649985],
                            [120.821991, 27.634835],
                            [120.824943, 27.646208],
                        ],
                    ],
                    [
                        [
                            [121.981444, 29.332638],
                            [121.970223, 29.340856],
                            [121.985135, 29.348454],
                            [121.978688, 29.340485],
                            [121.981444, 29.332638],
                        ],
                    ],
                    [
                        [
                            [122.146257, 29.96247],
                            [122.163088, 29.965713],
                            [122.170273, 29.957833],
                            [122.166336, 29.94634],
                            [122.140696, 29.943712],
                            [122.132232, 29.956519],
                            [122.146257, 29.96247],
                        ],
                    ],
                    [
                        [
                            [122.452115, 29.973469],
                            [122.450244, 29.964728],
                            [122.444683, 29.968216],
                            [122.452115, 29.973469],
                        ],
                    ],
                    [
                        [
                            [122.467469, 30.408857],
                            [122.477853, 30.410491],
                            [122.476376, 30.403587],
                            [122.467469, 30.408857],
                        ],
                    ],
                    [
                        [
                            [121.502062, 28.072235],
                            [121.504867, 28.085736],
                            [121.528834, 28.101742],
                            [121.532279, 28.093426],
                            [121.527111, 28.086363],
                            [121.516137, 28.087199],
                            [121.511068, 28.077084],
                            [121.502062, 28.072235],
                        ],
                    ],
                    [
                        [
                            [121.346353, 28.087784],
                            [121.345565, 28.096059],
                            [121.359443, 28.098065],
                            [121.373961, 28.10989],
                            [121.372091, 28.099903],
                            [121.356786, 28.089121],
                            [121.346353, 28.087784],
                        ],
                    ],
                    [
                        [
                            [122.264122, 30.269888],
                            [122.30177, 30.270052],
                            [122.304821, 30.262523],
                            [122.312941, 30.265142],
                            [122.315844, 30.250165],
                            [122.291878, 30.248324],
                            [122.276277, 30.244232],
                            [122.261612, 30.234736],
                            [122.25423, 30.237356],
                            [122.254574, 30.253235],
                            [122.264122, 30.269888],
                        ],
                    ],
                    [
                        [
                            [122.283019, 29.860388],
                            [122.284545, 29.875588],
                            [122.301474, 29.883844],
                            [122.319191, 29.878792],
                            [122.340057, 29.883598],
                            [122.348423, 29.878833],
                            [122.342961, 29.870782],
                            [122.343305, 29.86047],
                            [122.329968, 29.85895],
                            [122.323915, 29.852541],
                            [122.309004, 29.849582],
                            [122.293403, 29.852089],
                            [122.283019, 29.860388],
                        ],
                    ],
                    [
                        [
                            [122.331199, 30.595677],
                            [122.343207, 30.599632],
                            [122.341337, 30.593597],
                            [122.326031, 30.590131],
                            [122.331199, 30.595677],
                        ],
                    ],
                    [
                        [
                            [121.204325, 27.609735],
                            [121.208951, 27.618172],
                            [121.216923, 27.618928],
                            [121.210033, 27.608476],
                            [121.204325, 27.609735],
                        ],
                    ],
                    [
                        [
                            [122.78125, 30.694187],
                            [122.775196, 30.704167],
                            [122.758218, 30.70213],
                            [122.75748, 30.713901],
                            [122.782086, 30.730028],
                            [122.792815, 30.729499],
                            [122.799508, 30.716467],
                            [122.7906, 30.717444],
                            [122.787647, 30.711498],
                            [122.791732, 30.698423],
                            [122.78125, 30.694187],
                        ],
                    ],
                    [
                        [
                            [122.648375, 30.812494],
                            [122.640255, 30.816318],
                            [122.643355, 30.826733],
                            [122.660629, 30.819858],
                            [122.648375, 30.812494],
                        ],
                    ],
                    [
                        [
                            [121.977999, 30.100275],
                            [121.982822, 30.095234],
                            [121.973865, 30.084905],
                            [121.966483, 30.097447],
                            [121.977999, 30.100275],
                        ],
                    ],
                    [
                        [
                            [121.981001, 30.06699],
                            [121.975538, 30.075148],
                            [121.981739, 30.083224],
                            [121.988579, 30.083634],
                            [121.99045, 30.07109],
                            [121.981001, 30.06699],
                        ],
                    ],
                    [
                        [
                            [121.81727, 28.610428],
                            [121.823274, 28.607267],
                            [121.803933, 28.599115],
                            [121.81727, 28.610428],
                        ],
                    ],
                    [
                        [
                            [122.069436, 29.992385],
                            [122.076867, 30.000714],
                            [122.093796, 29.985492],
                            [122.078147, 29.97273],
                            [122.072241, 29.972853],
                            [122.069436, 29.992385],
                        ],
                    ],
                    [
                        [
                            [121.098173, 27.937514],
                            [121.080259, 27.947181],
                            [121.063527, 27.947809],
                            [121.049993, 27.94128],
                            [121.03833, 27.948939],
                            [121.040544, 27.964296],
                            [121.076027, 27.986344],
                            [121.094334, 27.984127],
                            [121.120663, 27.986637],
                            [121.134049, 27.980529],
                            [121.152946, 27.961576],
                            [121.147385, 27.953374],
                            [121.125978, 27.944126],
                            [121.098173, 27.937514],
                        ],
                    ],
                    [
                        [
                            [122.145322, 29.966328],
                            [122.146454, 29.963496],
                            [122.129033, 29.960541],
                            [122.128393, 29.96641],
                            [122.145322, 29.966328],
                        ],
                    ],
                    [
                        [
                            [120.896548, 27.711444],
                            [120.899451, 27.706033],
                            [120.887394, 27.704523],
                            [120.896548, 27.711444],
                        ],
                    ],
                    [
                        [
                            [122.178295, 29.406001],
                            [122.184348, 29.399604],
                            [122.173866, 29.399769],
                            [122.178295, 29.406001],
                        ],
                    ],
                    [
                        [
                            [122.391583, 30.740615],
                            [122.386366, 30.759384],
                            [122.395274, 30.760523],
                            [122.391583, 30.740615],
                        ],
                    ],
                    [
                        [
                            [121.685576, 29.115917],
                            [121.690153, 29.120883],
                            [121.694385, 29.113061],
                            [121.685576, 29.115917],
                        ],
                    ],
                    [
                        [
                            [121.18587, 27.962957],
                            [121.171352, 27.978605],
                            [121.177356, 27.990527],
                            [121.194974, 28.000148],
                            [121.220122, 27.991489],
                            [121.24025, 27.993748],
                            [121.237543, 27.988143],
                            [121.206195, 27.976889],
                            [121.18587, 27.962957],
                        ],
                    ],
                    [
                        [
                            [122.284988, 30.635835],
                            [122.277212, 30.638933],
                            [122.284742, 30.648714],
                            [122.292616, 30.650548],
                            [122.295766, 30.640726],
                            [122.284988, 30.635835],
                        ],
                    ],
                    [
                        [
                            [122.16422, 29.799278],
                            [122.161218, 29.8038],
                            [122.174259, 29.807664],
                            [122.180017, 29.802361],
                            [122.174948, 29.797222],
                            [122.16422, 29.799278],
                        ],
                    ],
                    [
                        [
                            [122.452804, 29.956889],
                            [122.458955, 29.95106],
                            [122.450687, 29.945929],
                            [122.444831, 29.955042],
                            [122.452804, 29.956889],
                        ],
                    ],
                    [
                        [
                            [121.145122, 28.013239],
                            [121.149649, 28.019805],
                            [121.166185, 28.021771],
                            [121.145122, 28.013239],
                        ],
                    ],
                    [
                        [
                            [122.83627, 30.698708],
                            [122.826821, 30.709136],
                            [122.810777, 30.712476],
                            [122.804232, 30.723024],
                            [122.814616, 30.732879],
                            [122.831053, 30.728521],
                            [122.836811, 30.719155],
                            [122.839911, 30.703759],
                            [122.83627, 30.698708],
                        ],
                    ],
                    [
                        [
                            [122.009987, 29.902654],
                            [122.005312, 29.913044],
                            [122.011513, 29.917027],
                            [122.02416, 29.909594],
                            [122.02165, 29.901546],
                            [122.009987, 29.902654],
                        ],
                    ],
                    [
                        [
                            [122.132379, 29.983769],
                            [122.143206, 29.987051],
                            [122.143108, 29.978311],
                            [122.132379, 29.983769],
                        ],
                    ],
                    [
                        [
                            [122.096208, 29.944862],
                            [122.097733, 29.938745],
                            [122.083511, 29.935625],
                            [122.079672, 29.939566],
                            [122.081542, 29.953687],
                            [122.090942, 29.956314],
                            [122.096208, 29.944862],
                        ],
                    ],
                    [
                        [
                            [122.227852, 29.715627],
                            [122.235382, 29.717725],
                            [122.233364, 29.70999],
                            [122.227852, 29.715627],
                        ],
                    ],
                    [
                        [
                            [122.213137, 29.958161],
                            [122.19296, 29.975972],
                            [122.20482, 29.973879],
                            [122.239811, 29.960049],
                            [122.274604, 29.93891],
                            [122.273374, 29.932259],
                            [122.237399, 29.944739],
                            [122.213137, 29.958161],
                        ],
                    ],
                    [
                        [
                            [121.969091, 30.064038],
                            [121.974406, 30.062111],
                            [121.974997, 30.049523],
                            [121.964071, 30.053787],
                            [121.969091, 30.064038],
                        ],
                    ],
                    [
                        [
                            [122.108314, 29.963086],
                            [122.112842, 29.978434],
                            [122.128245, 29.973797],
                            [122.125883, 29.96087],
                            [122.110922, 29.958735],
                            [122.108314, 29.963086],
                        ],
                    ],
                    [
                        [
                            [122.028983, 29.955042],
                            [122.042271, 29.964522],
                            [122.05108, 29.964974],
                            [122.058462, 29.952907],
                            [122.047782, 29.93423],
                            [122.037005, 29.929508],
                            [122.031198, 29.935215],
                            [122.028983, 29.955042],
                        ],
                    ],
                    [
                        [
                            [121.04394, 27.979316],
                            [121.043251, 27.993372],
                            [121.074108, 28.007426],
                            [121.089068, 28.004916],
                            [121.08961, 27.998684],
                            [121.075436, 27.990025],
                            [121.04394, 27.979316],
                        ],
                    ],
                    [
                        [
                            [122.2561, 29.864702],
                            [122.249899, 29.875588],
                            [122.267222, 29.875793],
                            [122.278246, 29.867701],
                            [122.274161, 29.862401],
                            [122.2561, 29.864702],
                        ],
                    ],
                    [
                        [
                            [122.193747, 29.766262],
                            [122.200342, 29.765151],
                            [122.201277, 29.755487],
                            [122.189171, 29.75524],
                            [122.193747, 29.766262],
                        ],
                    ],
                    [
                        [
                            [121.940105, 28.441526],
                            [121.94355, 28.450731],
                            [121.945174, 28.436652],
                            [121.940105, 28.441526],
                        ],
                    ],
                    [
                        [
                            [122.288827, 29.93074],
                            [122.288138, 29.936118],
                            [122.301573, 29.941865],
                            [122.311809, 29.942029],
                            [122.315352, 29.931027],
                            [122.30674, 29.922118],
                            [122.291435, 29.924623],
                            [122.288827, 29.93074],
                        ],
                    ],
                    [
                        [
                            [122.006247, 29.899574],
                            [122.017221, 29.900806],
                            [122.014367, 29.892634],
                            [122.006247, 29.899574],
                        ],
                    ],
                    [
                        [
                            [122.212399, 29.69172],
                            [122.228836, 29.690732],
                            [122.229673, 29.685423],
                            [122.215844, 29.684312],
                            [122.212399, 29.69172],
                        ],
                    ],
                    [
                        [
                            [122.042418, 29.981635],
                            [122.046749, 29.988693],
                            [122.054672, 29.988693],
                            [122.051424, 29.976834],
                            [122.042418, 29.981635],
                        ],
                    ],
                    [
                        [
                            [121.112986, 27.473136],
                            [121.12337, 27.466327],
                            [121.112346, 27.463511],
                            [121.106539, 27.473178],
                            [121.112986, 27.473136],
                        ],
                    ],
                    [
                        [
                            [121.079029, 27.428743],
                            [121.076962, 27.434125],
                            [121.088084, 27.431602],
                            [121.090397, 27.424538],
                            [121.079029, 27.428743],
                        ],
                    ],
                    [
                        [
                            [122.300687, 29.894646],
                            [122.309496, 29.896084],
                            [122.314713, 29.88943],
                            [122.299899, 29.890539],
                            [122.300687, 29.894646],
                        ],
                    ],
                    [
                        [
                            [121.09458, 27.494023],
                            [121.09458, 27.486333],
                            [121.085673, 27.4923],
                            [121.09458, 27.494023],
                        ],
                    ],
                ],
            },
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 330100,
                "name": "杭州市",
                "center": [120.153576, 30.287459],
                "centroid": [119.476522, 29.898925],
                "childrenNum": 13,
                "level": "city",
                "parent": {
                    "adcode": 330000
                },
                "subFeatureIndex": 0,
                "acroutes": [100000, 330000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [119.403038, 30.373347],
                            [119.418147, 30.376085],
                            [119.435716, 30.391492],
                            [119.441031, 30.392472],
                            [119.450234, 30.410818],
                            [119.467015, 30.408122],
                            [119.490391, 30.408203],
                            [119.513127, 30.401666],
                            [119.533452, 30.409429],
                            [119.535273, 30.424055],
                            [119.55176, 30.43978],
                            [119.565933, 30.443375],
                            [119.572823, 30.431326],
                            [119.581779, 30.423646],
                            [119.594968, 30.421644],
                            [119.627941, 30.431775],
                            [119.635569, 30.441782],
                            [119.650579, 30.440352],
                            [119.642951, 30.428507],
                            [119.631829, 30.424667],
                            [119.63739, 30.410369],
                            [119.633256, 30.395292],
                            [119.646691, 30.39378],
                            [119.6555, 30.40518],
                            [119.668099, 30.399501],
                            [119.681091, 30.408735],
                            [119.686012, 30.417559],
                            [119.709191, 30.434062],
                            [119.694919, 30.452727],
                            [119.695362, 30.464488],
                            [119.701711, 30.467999],
                            [119.708896, 30.487964],
                            [119.704713, 30.494577],
                            [119.709191, 30.508822],
                            [119.70486, 30.525963],
                            [119.695018, 30.542325],
                            [119.69241, 30.556155],
                            [119.71175, 30.566516],
                            [119.729073, 30.551749],
                            [119.743246, 30.550158],
                            [119.768936, 30.551341],
                            [119.766376, 30.514087],
                            [119.784044, 30.511026],
                            [119.794182, 30.505638],
                            [119.815884, 30.510659],
                            [119.836013, 30.496577],
                            [119.851121, 30.502006],
                            [119.854123, 30.493964],
                            [119.867115, 30.477757],
                            [119.880796, 30.476206],
                            [119.872578, 30.462487],
                            [119.890048, 30.457056],
                            [119.90304, 30.459424],
                            [119.90934, 30.456321],
                            [119.921544, 30.462528],
                            [119.931436, 30.456443],
                            [119.934979, 30.446764],
                            [119.950728, 30.444232],
                            [119.955895, 30.433654],
                            [119.965048, 30.431571],
                            [119.982962, 30.445294],
                            [120.00368, 30.444273],
                            [120.013818, 30.435614],
                            [120.041525, 30.433368],
                            [120.046102, 30.427445],
                            [120.064754, 30.4301],
                            [120.062145, 30.434634],
                            [120.0681, 30.445948],
                            [120.059242, 30.459016],
                            [120.059488, 30.47343],
                            [120.065836, 30.483595],
                            [120.068297, 30.496618],
                            [120.099252, 30.495801],
                            [120.096742, 30.48678],
                            [120.11121, 30.476206],
                            [120.146004, 30.482697],
                            [120.149793, 30.467509],
                            [120.175039, 30.476818],
                            [120.180551, 30.482534],
                            [120.173809, 30.492046],
                            [120.185915, 30.494618],
                            [120.185079, 30.502618],
                            [120.195659, 30.503598],
                            [120.201762, 30.514413],
                            [120.205404, 30.505843],
                            [120.224597, 30.509761],
                            [120.239262, 30.50523],
                            [120.25191, 30.506536],
                            [120.277451, 30.504822],
                            [120.285817, 30.507802],
                            [120.299892, 30.5198],
                            [120.317707, 30.521596],
                            [120.326123, 30.500414],
                            [120.329174, 30.468407],
                            [120.341379, 30.472286],
                            [120.337245, 30.464324],
                            [120.340345, 30.433899],
                            [120.330749, 30.427282],
                            [120.332963, 30.417314],
                            [120.322038, 30.404731],
                            [120.306388, 30.396232],
                            [120.315689, 30.394311],
                            [120.319282, 30.379314],
                            [120.342953, 30.37163],
                            [120.362835, 30.374695],
                            [120.398318, 30.38479],
                            [120.400926, 30.377025],
                            [120.388524, 30.370118],
                            [120.378091, 30.344937],
                            [120.413771, 30.318319],
                            [120.43882, 30.373388],
                            [120.460227, 30.382665],
                            [120.498761, 30.38904],
                            [120.567856, 30.387855],
                            [120.633899, 30.389449],
                            [120.658998, 30.385607],
                            [120.692955, 30.377965],
                            [120.70388, 30.365867],
                            [120.704126, 30.330791],
                            [120.706045, 30.309444],
                            [120.710868, 30.297542],
                            [120.721941, 30.286334],
                            [120.693939, 30.262032],
                            [120.669037, 30.23314],
                            [120.642708, 30.217258],
                            [120.612787, 30.16628],
                            [120.609145, 30.152845],
                            [120.593496, 30.146782],
                            [120.568348, 30.151329],
                            [120.563427, 30.147929],
                            [120.550927, 30.15563],
                            [120.529371, 30.157514],
                            [120.518495, 30.155384],
                            [120.506143, 30.159767],
                            [120.498072, 30.169187],
                            [120.484096, 30.172218],
                            [120.466182, 30.169556],
                            [120.465001, 30.155466],
                            [120.451172, 30.15096],
                            [120.44694, 30.135434],
                            [120.429617, 30.132443],
                            [120.422875, 30.135884],
                            [120.426074, 30.144283],
                            [120.420956, 30.152763],
                            [120.410867, 30.149527],
                            [120.411359, 30.132607],
                            [120.399007, 30.136335],
                            [120.387835, 30.156163],
                            [120.37317, 30.155507],
                            [120.358751, 30.147847],
                            [120.352008, 30.150674],
                            [120.353386, 30.142194],
                            [120.339607, 30.142112],
                            [120.327993, 30.125191],
                            [120.318002, 30.12601],
                            [120.312245, 30.1374],
                            [120.297825, 30.128182],
                            [120.303731, 30.126666],
                            [120.300286, 30.118348],
                            [120.286851, 30.106791],
                            [120.299302, 30.097365],
                            [120.313327, 30.107078],
                            [120.333701, 30.09548],
                            [120.338623, 30.070229],
                            [120.33818, 30.060881],
                            [120.324941, 30.048621],
                            [120.331831, 30.037918],
                            [120.343593, 30.034924],
                            [120.345808, 30.019707],
                            [120.35693, 30.011708],
                            [120.362835, 29.99776],
                            [120.360473, 29.98857],
                            [120.364312, 29.978516],
                            [120.360473, 29.973674],
                            [120.346447, 29.973797],
                            [120.340493, 29.956068],
                            [120.326073, 29.946216],
                            [120.325188, 29.93854],
                            [120.312048, 29.927702],
                            [120.291034, 29.935666],
                            [120.284144, 29.922159],
                            [120.2744, 29.919531],
                            [120.265296, 29.924499],
                            [120.264754, 29.930986],
                            [120.255207, 29.94363],
                            [120.250729, 29.936693],
                            [120.221004, 29.942235],
                            [120.200433, 29.929467],
                            [120.204813, 29.924048],
                            [120.185079, 29.904502],
                            [120.17627, 29.913578],
                            [120.166329, 29.917273],
                            [120.159734, 29.906227],
                            [120.150039, 29.905036],
                            [120.150285, 29.887582],
                            [120.144773, 29.874109],
                            [120.131289, 29.858827],
                            [120.109931, 29.845967],
                            [120.101122, 29.830269],
                            [120.102746, 29.823981],
                            [120.095807, 29.816583],
                            [120.074252, 29.82731],
                            [120.065639, 29.822049],
                            [120.038425, 29.82283],
                            [120.030059, 29.806307],
                            [120.036604, 29.788548],
                            [120.030059, 29.78275],
                            [120.030059, 29.770538],
                            [120.011505, 29.761491],
                            [120.010915, 29.757214],
                            [119.991968, 29.753143],
                            [119.973119, 29.765809],
                            [119.960275, 29.755158],
                            [119.944576, 29.755528],
                            [119.927204, 29.744423],
                            [119.913572, 29.755857],
                            [119.904369, 29.754582],
                            [119.890343, 29.762931],
                            [119.889064, 29.753102],
                            [119.900481, 29.74467],
                            [119.901367, 29.728627],
                            [119.912489, 29.720399],
                            [119.914655, 29.704682],
                            [119.922529, 29.697769],
                            [119.933454, 29.699415],
                            [119.937735, 29.70748],
                            [119.951269, 29.699292],
                            [119.967411, 29.694889],
                            [119.973464, 29.68995],
                            [119.973119, 29.674804],
                            [119.936161, 29.666531],
                            [119.924792, 29.669906],
                            [119.921249, 29.66402],
                            [119.911702, 29.66649],
                            [119.895708, 29.660644],
                            [119.879271, 29.66793],
                            [119.859536, 29.671347],
                            [119.852499, 29.668877],
                            [119.835422, 29.678138],
                            [119.824448, 29.671841],
                            [119.817607, 29.673076],
                            [119.79118, 29.654963],
                            [119.776514, 29.626841],
                            [119.779319, 29.603984],
                            [119.764949, 29.594675],
                            [119.769182, 29.579556],
                            [119.761652, 29.566536],
                            [119.764211, 29.557347],
                            [119.750678, 29.550713],
                            [119.741081, 29.551908],
                            [119.722626, 29.542759],
                            [119.74492, 29.516419],
                            [119.735422, 29.510936],
                            [119.726908, 29.511555],
                            [119.718837, 29.505288],
                            [119.719575, 29.491146],
                            [119.70678, 29.472382],
                            [119.707124, 29.464215],
                            [119.715835, 29.448995],
                            [119.707272, 29.433235],
                            [119.691179, 29.438763],
                            [119.688916, 29.421764],
                            [119.676317, 29.419206],
                            [119.673413, 29.425024],
                            [119.664408, 29.424075],
                            [119.642508, 29.432946],
                            [119.624939, 29.417762],
                            [119.625529, 29.410499],
                            [119.606238, 29.388088],
                            [119.617606, 29.380369],
                            [119.616277, 29.368273],
                            [119.604565, 29.369636],
                            [119.592901, 29.377686],
                            [119.582075, 29.379131],
                            [119.574594, 29.372773],
                            [119.558551, 29.372154],
                            [119.545411, 29.367365],
                            [119.536061, 29.373145],
                            [119.523905, 29.366003],
                            [119.522724, 29.350024],
                            [119.510421, 29.333464],
                            [119.500037, 29.335735],
                            [119.49231, 29.331069],
                            [119.480204, 29.332968],
                            [119.471493, 29.349033],
                            [119.461454, 29.350932],
                            [119.45481, 29.365259],
                            [119.457566, 29.370379],
                            [119.451858, 29.385611],
                            [119.451365, 29.397292],
                            [119.443147, 29.404556],
                            [119.437143, 29.424116],
                            [119.427793, 29.422177],
                            [119.43232, 29.415162],
                            [119.426759, 29.405547],
                            [119.404761, 29.400677],
                            [119.399938, 29.411242],
                            [119.39354, 29.411242],
                            [119.388521, 29.429728],
                            [119.378137, 29.42981],
                            [119.368294, 29.415699],
                            [119.360223, 29.416276],
                            [119.346395, 29.408724],
                            [119.337093, 29.411159],
                            [119.328629, 29.393413],
                            [119.340145, 29.38235],
                            [119.333058, 29.355061],
                            [119.348462, 29.336231],
                            [119.344278, 29.324378],
                            [119.348806, 29.319504],
                            [119.3242, 29.307979],
                            [119.328629, 29.299263],
                            [119.322625, 29.296164],
                            [119.318294, 29.279885],
                            [119.286011, 29.279348],
                            [119.288077, 29.268852],
                            [119.270656, 29.251659],
                            [119.260912, 29.247815],
                            [119.237782, 29.250708],
                            [119.239308, 29.258933],
                            [119.227103, 29.276827],
                            [119.228727, 29.284182],
                            [119.208156, 29.284389],
                            [119.200282, 29.29038],
                            [119.20038, 29.272158],
                            [119.192211, 29.258479],
                            [119.200922, 29.257487],
                            [119.2148, 29.246947],
                            [119.210272, 29.23066],
                            [119.213668, 29.225203],
                            [119.204465, 29.223549],
                            [119.201709, 29.229379],
                            [119.189504, 29.227105],
                            [119.194918, 29.216314],
                            [119.189504, 29.205191],
                            [119.177693, 29.207259],
                            [119.170459, 29.217596],
                            [119.151758, 29.22789],
                            [119.138126, 29.220242],
                            [119.12912, 29.227063],
                            [119.132565, 29.235456],
                            [119.12351, 29.236737],
                            [119.106384, 29.227518],
                            [119.085222, 29.230578],
                            [119.075675, 29.224004],
                            [119.062929, 29.226278],
                            [119.030596, 29.215074],
                            [119.013076, 29.212386],
                            [119.003234, 29.207714],
                            [118.998903, 29.216355],
                            [118.987141, 29.226071],
                            [118.984828, 29.239465],
                            [118.988224, 29.243558],
                            [118.966816, 29.269348],
                            [118.963322, 29.267653],
                            [118.949641, 29.281744],
                            [118.961895, 29.290215],
                            [118.962092, 29.296164],
                            [118.948017, 29.301122],
                            [118.94408, 29.306286],
                            [118.927053, 29.310375],
                            [118.900428, 29.332638],
                            [118.886354, 29.322354],
                            [118.878332, 29.326567],
                            [118.860664, 29.31496],
                            [118.855743, 29.303311],
                            [118.828775, 29.287446],
                            [118.82656, 29.280298],
                            [118.816865, 29.281703],
                            [118.793637, 29.267943],
                            [118.786402, 29.266744],
                            [118.784778, 29.259099],
                            [118.774985, 29.250998],
                            [118.763912, 29.248311],
                            [118.767259, 29.234133],
                            [118.765438, 29.220614],
                            [118.753036, 29.213875],
                            [118.743735, 29.213668],
                            [118.708843, 29.188774],
                            [118.68463, 29.202545],
                            [118.670162, 29.200518],
                            [118.638321, 29.192165],
                            [118.626855, 29.19568],
                            [118.633646, 29.205605],
                            [118.631825, 29.219622],
                            [118.620112, 29.219291],
                            [118.607612, 29.239713],
                            [118.615437, 29.25075],
                            [118.606677, 29.267116],
                            [118.610614, 29.279472],
                            [118.619177, 29.276786],
                            [118.63276, 29.263149],
                            [118.634138, 29.272984],
                            [118.614404, 29.296577],
                            [118.617209, 29.303146],
                            [118.603478, 29.316447],
                            [118.603823, 29.323552],
                            [118.596047, 29.330821],
                            [118.589059, 29.327888],
                            [118.571687, 29.338337],
                            [118.55151, 29.335694],
                            [118.528577, 29.345275],
                            [118.519079, 29.344366],
                            [118.524344, 29.36142],
                            [118.517504, 29.363484],
                            [118.505742, 29.359273],
                            [118.488813, 29.367241],
                            [118.479167, 29.366539],
                            [118.470112, 29.360098],
                            [118.456234, 29.365879],
                            [118.448754, 29.37525],
                            [118.441224, 29.375911],
                            [118.423655, 29.387345],
                            [118.425771, 29.397623],
                            [118.405397, 29.408147],
                            [118.413173, 29.420568],
                            [118.402051, 29.425189],
                            [118.390289, 29.423951],
                            [118.384137, 29.433276],
                            [118.372917, 29.437815],
                            [118.366371, 29.45015],
                            [118.352543, 29.45279],
                            [118.345751, 29.465123],
                            [118.344964, 29.475681],
                            [118.358694, 29.477083],
                            [118.379806, 29.502567],
                            [118.383005, 29.510153],
                            [118.393045, 29.507308],
                            [118.414994, 29.509741],
                            [118.430594, 29.503721],
                            [118.44895, 29.51341],
                            [118.459826, 29.505577],
                            [118.470407, 29.507473],
                            [118.495899, 29.519553],
                            [118.497868, 29.543995],
                            [118.494915, 29.553721],
                            [118.499689, 29.573623],
                            [118.515486, 29.583305],
                            [118.53522, 29.590638],
                            [118.549886, 29.613416],
                            [118.555053, 29.613416],
                            [118.573902, 29.638371],
                            [118.602051, 29.643683],
                            [118.620014, 29.654099],
                            [118.633498, 29.648788],
                            [118.640929, 29.641912],
                            [118.647327, 29.643394],
                            [118.673902, 29.669083],
                            [118.682367, 29.681061],
                            [118.682908, 29.688345],
                            [118.691668, 29.693942],
                            [118.700821, 29.706452],
                            [118.718686, 29.709167],
                            [118.72464, 29.722621],
                            [118.744719, 29.738788],
                            [118.74905, 29.761121],
                            [118.744325, 29.779626],
                            [118.736501, 29.788465],
                            [118.739946, 29.813295],
                            [118.745999, 29.818186],
                            [118.75781, 29.816747],
                            [118.76593, 29.823077],
                            [118.750969, 29.831625],
                            [118.755595, 29.845432],
                            [118.766963, 29.848925],
                            [118.778725, 29.841899],
                            [118.802593, 29.860676],
                            [118.807712, 29.86766],
                            [118.841324, 29.891319],
                            [118.845507, 29.899082],
                            [118.844916, 29.915261],
                            [118.838716, 29.934476],
                            [118.848263, 29.941249],
                            [118.863913, 29.93698],
                            [118.871983, 29.946873],
                            [118.88468, 29.93891],
                            [118.894867, 29.939197],
                            [118.891521, 29.959885],
                            [118.899493, 29.98143],
                            [118.892062, 29.994806],
                            [118.895015, 30.000386],
                            [118.89034, 30.012037],
                            [118.898017, 30.017246],
                            [118.902594, 30.029059],
                            [118.890586, 30.04128],
                            [118.897328, 30.049646],
                            [118.888125, 30.062357],
                            [118.878824, 30.064653],
                            [118.875478, 30.072033],
                            [118.872918, 30.094619],
                            [118.868883, 30.101464],
                            [118.871639, 30.113021],
                            [118.887239, 30.117446],
                            [118.888125, 30.127239],
                            [118.89595, 30.138793],
                            [118.896787, 30.148093],
                            [118.877348, 30.147396],
                            [118.865733, 30.151493],
                            [118.856383, 30.148216],
                            [118.845704, 30.156122],
                            [118.85284, 30.166566],
                            [118.864405, 30.168983],
                            [118.910812, 30.187493],
                            [118.920655, 30.198999],
                            [118.929858, 30.20338],
                            [118.924986, 30.213861],
                            [118.903184, 30.217913],
                            [118.892554, 30.243249],
                            [118.882417, 30.247465],
                            [118.8897, 30.254258],
                            [118.878086, 30.282734],
                            [118.881826, 30.298524],
                            [118.879857, 30.314884],
                            [118.899789, 30.322572],
                            [118.908401, 30.330872],
                            [118.917899, 30.332467],
                            [118.936354, 30.34506],
                            [118.936452, 30.350824],
                            [118.955399, 30.359204],
                            [118.959385, 30.347267],
                            [118.969031, 30.351356],
                            [118.975724, 30.347145],
                            [118.988126, 30.348698],
                            [118.988027, 30.333489],
                            [119.004464, 30.328951],
                            [119.028775, 30.312593],
                            [119.048313, 30.312675],
                            [119.050823, 30.306745],
                            [119.062978, 30.304945],
                            [119.073411, 30.315865],
                            [119.090242, 30.324003],
                            [119.11101, 30.311285],
                            [119.12853, 30.3047],
                            [119.151266, 30.304577],
                            [119.156729, 30.299547],
                            [119.188225, 30.291652],
                            [119.201069, 30.291039],
                            [119.205695, 30.301551],
                            [119.222624, 30.299628],
                            [119.225479, 30.288789],
                            [119.233747, 30.293411],
                            [119.245902, 30.321631],
                            [119.239997, 30.327029],
                            [119.247132, 30.340808],
                            [119.265046, 30.338069],
                            [119.278136, 30.341585],
                            [119.289455, 30.349639],
                            [119.300676, 30.363701],
                            [119.326562, 30.371753],
                            [119.342654, 30.363169],
                            [119.349446, 30.349148],
                            [119.375627, 30.354789],
                            [119.386159, 30.363905],
                            [119.399987, 30.367788],
                            [119.403038, 30.373347]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 330200,
                "name": "宁波市",
                "center": [121.549792, 29.868388],
                "centroid": [121.479174, 29.733017],
                "childrenNum": 10,
                "level": "city",
                "parent": {
                    "adcode": 330000
                },
                "subFeatureIndex": 1,
                "acroutes": [100000, 330000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [120.86702, 30.271729],
                            [120.916036, 30.285762],
                            [120.954373, 30.306418],
                            [120.99517, 30.319914],
                            [121.01392, 30.323635],
                            [121.032572, 30.337006],
                            [121.040102, 30.352868],
                            [121.06018, 30.376371],
                            [121.086952, 30.397131],
                            [121.099501, 30.443661],
                            [121.119236, 30.48976],
                            [121.183212, 30.434348],
                            [121.225486, 30.404649],
                            [121.278784, 30.405057],
                            [121.328046, 30.397131],
                            [121.371894, 30.370894],
                            [121.395073, 30.338437],
                            [121.452701, 30.298565],
                            [121.476274, 30.279421],
                            [121.49778, 30.258595],
                            [121.527554, 30.224913],
                            [121.561462, 30.184176],
                            [121.591678, 30.143546],
                            [121.61471, 30.108308],
                            [121.619927, 30.088512],
                            [121.626029, 30.07769],
                            [121.63533, 30.069819],
                            [121.653096, 30.071131],
                            [121.667466, 30.048867],
                            [121.69975, 30.008016],
                            [121.724996, 29.992221],
                            [121.771453, 29.99497],
                            [121.784051, 29.993493],
                            [121.814366, 29.974331],
                            [121.835183, 29.957956],
                            [121.859986, 29.944],
                            [121.901817, 29.923678],
                            [121.919534, 29.920804],
                            [121.927113, 29.931151],
                            [121.9529, 29.950732],
                            [121.968008, 29.956519],
                            [121.981739, 29.947037],
                            [121.984396, 29.937637],
                            [121.994534, 29.934599],
                            [122.0029, 29.923186],
                            [122.003442, 29.898999],
                            [122.00979, 29.891114],
                            [122.080115, 29.892634],
                            [122.096257, 29.905036],
                            [122.11673, 29.909964],
                            [122.140155, 29.901751],
                            [122.143058, 29.877724],
                            [122.135922, 29.872261],
                            [122.102212, 29.859649],
                            [122.08479, 29.844528],
                            [122.04857, 29.826036],
                            [122.037595, 29.813747],
                            [122.015991, 29.771936],
                            [122.003146, 29.762273],
                            [121.959199, 29.750017],
                            [121.937595, 29.748536],
                            [121.925538, 29.741256],
                            [121.906443, 29.719247],
                            [121.863234, 29.67925],
                            [121.833559, 29.653111],
                            [121.858953, 29.636601],
                            [121.872486, 29.632483],
                            [121.893845, 29.636559],
                            [121.909593, 29.650105],
                            [121.923422, 29.65167],
                            [121.937595, 29.642571],
                            [121.966089, 29.635859],
                            [121.985381, 29.606291],
                            [121.999751, 29.593686],
                            [122.000292, 29.58244],
                            [121.987201, 29.570616],
                            [121.985774, 29.563776],
                            [121.995076, 29.545108],
                            [121.986414, 29.541193],
                            [121.968993, 29.515595],
                            [121.96668, 29.506566],
                            [121.973127, 29.477991],
                            [121.992074, 29.461411],
                            [121.991729, 29.445942],
                            [121.981493, 29.429934],
                            [121.975538, 29.411159],
                            [121.959642, 29.407156],
                            [121.945814, 29.395311],
                            [121.937693, 29.384125],
                            [121.938579, 29.369512],
                            [121.932231, 29.353451],
                            [121.935971, 29.348124],
                            [121.952064, 29.344119],
                            [121.958363, 29.334373],
                            [121.946552, 29.316695],
                            [121.940892, 29.298271],
                            [121.944829, 29.284182],
                            [121.967566, 29.281414],
                            [121.981099, 29.2841],
                            [122.000243, 29.278811],
                            [121.99852, 29.266124],
                            [122.001965, 29.26009],
                            [121.990991, 29.260793],
                            [121.968304, 29.250006],
                            [121.968008, 29.243888],
                            [121.977457, 29.224087],
                            [121.971896, 29.193364],
                            [121.948619, 29.19324],
                            [121.9373, 29.182859],
                            [121.949111, 29.183314],
                            [121.96043, 29.170575],
                            [121.98666, 29.154855],
                            [121.988284, 29.149269],
                            [121.979278, 29.144842],
                            [121.985381, 29.137601],
                            [121.98853, 29.110992],
                            [121.983363, 29.101224],
                            [121.968747, 29.093028],
                            [121.983314, 29.091454],
                            [121.984396, 29.086942],
                            [121.969829, 29.075888],
                            [121.966138, 29.052866],
                            [121.951621, 29.04744],
                            [121.935085, 29.05183],
                            [121.931591, 29.070713],
                            [121.903835, 29.069056],
                            [121.899406, 29.076426],
                            [121.909642, 29.085866],
                            [121.898077, 29.103956],
                            [121.884494, 29.105446],
                            [121.860036, 29.086404],
                            [121.842368, 29.08835],
                            [121.827014, 29.101845],
                            [121.811167, 29.109916],
                            [121.794238, 29.105197],
                            [121.780557, 29.109626],
                            [121.769386, 29.148277],
                            [121.768008, 29.166686],
                            [121.749947, 29.136691],
                            [121.715596, 29.12498],
                            [121.648814, 29.150924],
                            [121.60846, 29.169127],
                            [121.564267, 29.173056],
                            [121.555802, 29.168961],
                            [121.53592, 29.139795],
                            [121.529719, 29.136277],
                            [121.508361, 29.140622],
                            [121.484542, 29.142856],
                            [121.470517, 29.147615],
                            [121.450044, 29.159612],
                            [121.431048, 29.159778],
                            [121.407032, 29.156882],
                            [121.401225, 29.160978],
                            [121.403833, 29.17864],
                            [121.385378, 29.196921],
                            [121.378784, 29.199236],
                            [121.366924, 29.189146],
                            [121.356343, 29.186044],
                            [121.361904, 29.173305],
                            [121.345418, 29.145173],
                            [121.348715, 29.135574],
                            [121.336609, 29.121959],
                            [121.323813, 29.117159],
                            [121.316973, 29.105653],
                            [121.308213, 29.11451],
                            [121.298616, 29.114593],
                            [121.295221, 29.092696],
                            [121.271746, 29.101803],
                            [121.270713, 29.11033],
                            [121.256096, 29.114055],
                            [121.258754, 29.129243],
                            [121.257622, 29.149311],
                            [121.264364, 29.1544],
                            [121.253045, 29.157172],
                            [121.251028, 29.163542],
                            [121.238872, 29.175745],
                            [121.232966, 29.186623],
                            [121.233705, 29.196797],
                            [121.225338, 29.203868],
                            [121.202701, 29.203578],
                            [121.173517, 29.20639],
                            [121.164708, 29.2116],
                            [121.174403, 29.223095],
                            [121.158852, 29.244756],
                            [121.166824, 29.258892],
                            [121.179325, 29.258727],
                            [121.175289, 29.278274],
                            [121.180899, 29.292033],
                            [121.196992, 29.303229],
                            [121.201077, 29.312482],
                            [121.190742, 29.312358],
                            [121.194187, 29.322189],
                            [121.193399, 29.341434],
                            [121.20024, 29.342384],
                            [121.213134, 29.353575],
                            [121.230063, 29.362658],
                            [121.226421, 29.384662],
                            [121.231441, 29.393825],
                            [121.226815, 29.414749],
                            [121.215102, 29.417267],
                            [121.218252, 29.421146],
                            [121.209197, 29.436742],
                            [121.217514, 29.439217],
                            [121.224059, 29.449242],
                            [121.216972, 29.452666],
                            [121.219827, 29.477785],
                            [121.228488, 29.490733],
                            [121.216726, 29.496795],
                            [121.231539, 29.51308],
                            [121.225585, 29.532908],
                            [121.213183, 29.530311],
                            [121.20585, 29.536947],
                            [121.183557, 29.538802],
                            [121.169334, 29.537112],
                            [121.155702, 29.54177],
                            [121.140348, 29.543006],
                            [121.130948, 29.554174],
                            [121.112986, 29.554834],
                            [121.113478, 29.56596],
                            [121.120417, 29.575601],
                            [121.115643, 29.586724],
                            [121.105702, 29.585447],
                            [121.117562, 29.605508],
                            [121.110181, 29.607444],
                            [121.113281, 29.613745],
                            [121.101716, 29.626265],
                            [121.08774, 29.628077],
                            [121.074206, 29.637259],
                            [121.074895, 29.66085],
                            [121.068399, 29.66686],
                            [121.058802, 29.683859],
                            [121.054226, 29.68567],
                            [121.038428, 29.675751],
                            [121.017759, 29.669742],
                            [120.992414, 29.675833],
                            [120.992956, 29.685259],
                            [121.010229, 29.68674],
                            [121.01397, 29.693119],
                            [121.006785, 29.698592],
                            [121.009639, 29.709003],
                            [121.034787, 29.715997],
                            [121.035869, 29.72114],
                            [121.019727, 29.723403],
                            [121.010722, 29.73525],
                            [121.014954, 29.741667],
                            [121.03518, 29.746439],
                            [121.024796, 29.763918],
                            [121.033999, 29.76877],
                            [121.045515, 29.76729],
                            [121.055111, 29.760669],
                            [121.08208, 29.778433],
                            [121.092612, 29.788959],
                            [121.096007, 29.797839],
                            [121.104964, 29.805485],
                            [121.096499, 29.815966],
                            [121.10649, 29.836228],
                            [121.085771, 29.849295],
                            [121.077011, 29.849007],
                            [121.063133, 29.859032],
                            [121.060574, 29.854143],
                            [121.031096, 29.874602],
                            [121.016578, 29.894934],
                            [121.023172, 29.897357],
                            [121.031637, 29.911073],
                            [121.0308, 29.918792],
                            [121.042021, 29.933203],
                            [121.045072, 29.955616],
                            [121.066135, 29.960829],
                            [121.07647, 29.970391],
                            [121.085869, 29.972648],
                            [121.091627, 29.987257],
                            [121.082621, 29.991072],
                            [121.075781, 30.001986],
                            [121.064413, 30.006827],
                            [121.05142, 30.006786],
                            [121.038133, 29.998704],
                            [121.034737, 30.003955],
                            [121.039511, 30.013923],
                            [121.018202, 30.010765],
                            [120.990151, 30.027787],
                            [120.986509, 30.044274],
                            [120.992562, 30.050425],
                            [120.986656, 30.054402],
                            [120.98144, 30.067359],
                            [120.969924, 30.07027],
                            [120.973861, 30.078305],
                            [120.96766, 30.089987],
                            [120.959737, 30.094537],
                            [120.950141, 30.091012],
                            [120.93828, 30.113021],
                            [120.930455, 30.115192],
                            [120.939461, 30.125723],
                            [120.931194, 30.146618],
                            [120.92765, 30.165215],
                            [120.916233, 30.188394],
                            [120.893447, 30.228843],
                            [120.86702, 30.271729]
                        ]
                    ],
                    [
                        [
                            [122.026375, 29.178351],
                            [122.040843, 29.17955],
                            [122.029771, 29.187367],
                            [122.037005, 29.190552],
                            [122.031247, 29.196342],
                            [122.036217, 29.207383],
                            [122.056198, 29.200518],
                            [122.050095, 29.193488],
                            [122.057576, 29.188939],
                            [122.044534, 29.1841],
                            [122.049013, 29.175083],
                            [122.063235, 29.174008],
                            [122.074505, 29.178144],
                            [122.06791, 29.165611],
                            [122.056739, 29.158454],
                            [122.039859, 29.163253],
                            [122.037645, 29.151959],
                            [122.027605, 29.155806],
                            [122.013383, 29.151504],
                            [122.026375, 29.178351]
                        ]
                    ],
                    [
                        [
                            [122.231297, 28.859829],
                            [122.243797, 28.861322],
                            [122.238679, 28.853315],
                            [122.231297, 28.859829]
                        ]
                    ],
                    [
                        [
                            [122.181936, 29.407693],
                            [122.179771, 29.424694],
                            [122.187497, 29.421806],
                            [122.197242, 29.425478],
                            [122.199358, 29.436247],
                            [122.21112, 29.44095],
                            [122.22485, 29.438392],
                            [122.223866, 29.428366],
                            [122.207921, 29.429645],
                            [122.205362, 29.418092],
                            [122.190204, 29.415905],
                            [122.181936, 29.407693]
                        ]
                    ],
                    [
                        [
                            [121.790892, 29.082264],
                            [121.788677, 29.094601],
                            [121.793795, 29.099444],
                            [121.820272, 29.099402],
                            [121.831591, 29.095015],
                            [121.840941, 29.081519],
                            [121.838628, 29.057752],
                            [121.832329, 29.050381],
                            [121.82352, 29.051043],
                            [121.817319, 29.063052],
                            [121.808559, 29.059243],
                            [121.791089, 29.074232],
                            [121.790892, 29.082264]
                        ]
                    ],
                    [
                        [
                            [122.184299, 29.460627],
                            [122.19483, 29.465453],
                            [122.194141, 29.45345],
                            [122.183216, 29.455595],
                            [122.184299, 29.460627]
                        ]
                    ],
                    [
                        [
                            [122.026473, 29.621859],
                            [122.033855, 29.624741],
                            [122.037645, 29.613457],
                            [122.025686, 29.604314],
                            [122.022389, 29.620211],
                            [122.026473, 29.621859]
                        ]
                    ],
                    [
                        [
                            [122.258807, 28.886586],
                            [122.267025, 28.886835],
                            [122.267321, 28.880364],
                            [122.258807, 28.886586]
                        ]
                    ],
                    [
                        [
                            [121.983461, 29.227808],
                            [121.993451, 29.227808],
                            [122.001818, 29.221441],
                            [121.991089, 29.221441],
                            [121.983461, 29.227808]
                        ]
                    ],
                    [
                        [
                            [121.980705, 29.472671],
                            [121.987792, 29.474898],
                            [121.990843, 29.467845],
                            [121.980705, 29.472671]
                        ]
                    ],
                    [
                        [
                            [121.976178, 29.501124],
                            [121.989908, 29.510071],
                            [122.004967, 29.503763],
                            [122.004574, 29.500299],
                            [121.984741, 29.503886],
                            [121.983806, 29.497042],
                            [121.976178, 29.501124]
                        ]
                    ],
                    [
                        [
                            [121.952064, 29.187616],
                            [121.975636, 29.192123],
                            [121.971601, 29.185093],
                            [121.981788, 29.175911],
                            [121.983511, 29.165404],
                            [121.971404, 29.163294],
                            [121.951719, 29.183107],
                            [121.952064, 29.187616]
                        ]
                    ],
                    [
                        [
                            [121.930459, 29.036051],
                            [121.931, 29.041394],
                            [121.948766, 29.047233],
                            [121.954524, 29.043961],
                            [121.940991, 29.03369],
                            [121.930459, 29.036051]
                        ]
                    ],
                    [
                        [
                            [122.006641, 29.234877],
                            [122.013826, 29.23281],
                            [122.008609, 29.222971],
                            [122.00103, 29.227394],
                            [122.006641, 29.234877]
                        ]
                    ],
                    [
                        [
                            [122.001621, 29.410416],
                            [122.018944, 29.409674],
                            [122.016286, 29.404185],
                            [122.003835, 29.405051],
                            [122.001621, 29.410416]
                        ]
                    ],
                    [
                        [
                            [121.981444, 29.332638],
                            [121.970223, 29.340856],
                            [121.985135, 29.348454],
                            [121.978688, 29.340485],
                            [121.981444, 29.332638]
                        ]
                    ],
                    [
                        [
                            [122.178295, 29.406001],
                            [122.184348, 29.399604],
                            [122.173866, 29.399769],
                            [122.178295, 29.406001]
                        ]
                    ],
                    [
                        [
                            [122.009987, 29.902654],
                            [122.005312, 29.913044],
                            [122.011513, 29.917027],
                            [122.02416, 29.909594],
                            [122.02165, 29.901546],
                            [122.009987, 29.902654]
                        ]
                    ],
                    [
                        [
                            [122.006247, 29.899574],
                            [122.017221, 29.900806],
                            [122.014367, 29.892634],
                            [122.006247, 29.899574]
                        ]
                    ]
                ]
            }
        },
         {
            "type": "Feature",
            "properties": {
                "adcode": 330300,
                "name": "温州市",
                "center": [120.672111, 28.000575],
                "centroid": [120.463943, 27.89471],
                "childrenNum": 12,
                "level": "city",
                "parent": {
                    "adcode": 330000
                },
                "subFeatureIndex": 2,
                "acroutes": [100000, 330000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [121.108409, 28.139011],
                            [121.0902, 28.127146],
                            [121.07086, 28.110517],
                            [121.059098, 28.096351],
                            [121.039413, 28.055849],
                            [121.030948, 28.033647],
                            [121.02455, 28.003745],
                            [121.015249, 27.981617],
                            [120.991824, 27.949734],
                            [121.055899, 27.900133],
                            [121.075584, 27.894439],
                            [121.099452, 27.895067],
                            [121.116726, 27.899798],
                            [121.137395, 27.908841],
                            [121.157917, 27.910306],
                            [121.16274, 27.902519],
                            [121.160378, 27.884641],
                            [121.166775, 27.876895],
                            [121.185181, 27.874801],
                            [121.19586, 27.869817],
                            [121.200535, 27.855159],
                            [121.196647, 27.833964],
                            [121.184344, 27.814105],
                            [121.167169, 27.811675],
                            [121.15772, 27.813895],
                            [121.143842, 27.791728],
                            [121.13149, 27.788836],
                            [121.13144, 27.797595],
                            [121.152504, 27.815362],
                            [121.133015, 27.813183],
                            [121.107671, 27.813686],
                            [121.089856, 27.817541],
                            [121.069875, 27.834215],
                            [121.027798, 27.832623],
                            [121.020072, 27.835891],
                            [121.012149, 27.846237],
                            [120.974255, 27.887196],
                            [120.951469, 27.895905],
                            [120.941774, 27.896784],
                            [120.910869, 27.864708],
                            [120.883703, 27.820934],
                            [120.840642, 27.758741],
                            [120.809638, 27.77555],
                            [120.797729, 27.779574],
                            [120.761114, 27.717692],
                            [120.739658, 27.702175],
                            [120.708949, 27.682585],
                            [120.700681, 27.669412],
                            [120.685376, 27.622999],
                            [120.674992, 27.609105],
                            [120.652059, 27.586854],
                            [120.634884, 27.577281],
                            [120.637049, 27.561449],
                            [120.642807, 27.556577],
                            [120.662295, 27.519612],
                            [120.678191, 27.516419],
                            [120.686311, 27.4923],
                            [120.702797, 27.478726],
                            [120.699648, 27.465654],
                            [120.676813, 27.431055],
                            [120.673614, 27.419954],
                            [120.675041, 27.382312],
                            [120.670071, 27.362834],
                            [120.657079, 27.352316],
                            [120.612246, 27.336915],
                            [120.580307, 27.321385],
                            [120.571645, 27.309978],
                            [120.57573, 27.293645],
                            [120.574057, 27.286699],
                            [120.563427, 27.277941],
                            [120.552944, 27.257771],
                            [120.554765, 27.252044],
                            [120.576173, 27.241135],
                            [120.571497, 27.228204],
                            [120.564116, 27.220243],
                            [120.556143, 27.204065],
                            [120.55324, 27.17343],
                            [120.545956, 27.156824],
                            [120.522285, 27.142154],
                            [120.492462, 27.136168],
                            [120.467757, 27.143166],
                            [120.461655, 27.142576],
                            [120.445267, 27.16087],
                            [120.43759, 27.161039],
                            [120.426172, 27.173472],
                            [120.42568, 27.183333],
                            [120.404371, 27.20398],
                            [120.400926, 27.211564],
                            [120.413918, 27.230942],
                            [120.398515, 27.242483],
                            [120.401763, 27.250864],
                            [120.415395, 27.256381],
                            [120.422383, 27.250822],
                            [120.43006, 27.258866],
                            [120.4088, 27.276636],
                            [120.401369, 27.298571],
                            [120.383406, 27.312714],
                            [120.374794, 27.329255],
                            [120.358357, 27.337546],
                            [120.351467, 27.346761],
                            [120.355257, 27.353873],
                            [120.343249, 27.366242],
                            [120.351566, 27.383574],
                            [120.340739, 27.399642],
                            [120.331733, 27.396025],
                            [120.319823, 27.399684],
                            [120.315985, 27.406708],
                            [120.315148, 27.393165],
                            [120.302697, 27.392197],
                            [120.289508, 27.395941],
                            [120.273366, 27.389421],
                            [120.258209, 27.412679],
                            [120.26377, 27.41802],
                            [120.262441, 27.432905],
                            [120.249006, 27.439885],
                            [120.24689, 27.434587],
                            [120.221595, 27.420291],
                            [120.213228, 27.420291],
                            [120.202402, 27.428364],
                            [120.176909, 27.419954],
                            [120.163376, 27.424874],
                            [120.141821, 27.422183],
                            [120.131437, 27.416716],
                            [120.137195, 27.402334],
                            [120.128878, 27.391608],
                            [120.121594, 27.397413],
                            [120.107175, 27.395562],
                            [120.09625, 27.390347],
                            [120.09684, 27.37962],
                            [120.077007, 27.369187],
                            [120.052303, 27.338682],
                            [120.027549, 27.342259],
                            [120.026614, 27.350801],
                            [120.015984, 27.36477],
                            [120.009586, 27.363928],
                            [120.005206, 27.376675],
                            [119.994232, 27.379199],
                            [119.988326, 27.371375],
                            [119.960275, 27.366116],
                            [119.964015, 27.360478],
                            [119.960176, 27.351853],
                            [119.937932, 27.3346],
                            [119.944035, 27.314146],
                            [119.933503, 27.316545],
                            [119.903286, 27.317597],
                            [119.899054, 27.311494],
                            [119.887637, 27.313304],
                            [119.865589, 27.306232],
                            [119.871298, 27.315408],
                            [119.856731, 27.314819],
                            [119.8462, 27.324037],
                            [119.835077, 27.312967],
                            [119.844822, 27.306653],
                            [119.840146, 27.298908],
                            [119.822331, 27.301433],
                            [119.819526, 27.296045],
                            [119.795756, 27.310441],
                            [119.790491, 27.302612],
                            [119.77056, 27.305685],
                            [119.769772, 27.324373],
                            [119.777991, 27.320164],
                            [119.784979, 27.323574],
                            [119.781485, 27.330476],
                            [119.768394, 27.335736],
                            [119.769132, 27.345415],
                            [119.751022, 27.350086],
                            [119.74743, 27.359973],
                            [119.740491, 27.362203],
                            [119.750481, 27.373226],
                            [119.740294, 27.375708],
                            [119.739555, 27.386813],
                            [119.733847, 27.388706],
                            [119.724349, 27.401703],
                            [119.71303, 27.402838],
                            [119.704319, 27.416927],
                            [119.704713, 27.424706],
                            [119.689506, 27.430845],
                            [119.685471, 27.438413],
                            [119.693886, 27.438665],
                            [119.703433, 27.447284],
                            [119.704024, 27.458508],
                            [119.709929, 27.46246],
                            [119.706681, 27.470656],
                            [119.710717, 27.482508],
                            [119.709634, 27.496797],
                            [119.702892, 27.500285],
                            [119.708551, 27.514276],
                            [119.689506, 27.534064],
                            [119.690589, 27.537256],
                            [119.670559, 27.536584],
                            [119.659339, 27.539693],
                            [119.668837, 27.556493],
                            [119.672036, 27.556409],
                            [119.675038, 27.574383],
                            [119.645461, 27.578205],
                            [119.630894, 27.582698],
                            [119.626465, 27.620481],
                            [119.64113, 27.625392],
                            [119.647528, 27.640543],
                            [119.639654, 27.652671],
                            [119.644033, 27.663496],
                            [119.635569, 27.668405],
                            [119.643, 27.673188],
                            [119.646937, 27.685732],
                            [119.65614, 27.69345],
                            [119.650923, 27.695547],
                            [119.650726, 27.717147],
                            [119.665982, 27.721886],
                            [119.678581, 27.734005],
                            [119.680205, 27.744193],
                            [119.696986, 27.753626],
                            [119.719427, 27.76046],
                            [119.725874, 27.767712],
                            [119.734831, 27.766622],
                            [119.756189, 27.795625],
                            [119.768148, 27.805306],
                            [119.773069, 27.794075],
                            [119.785077, 27.795793],
                            [119.787882, 27.808993],
                            [119.785766, 27.822485],
                            [119.793886, 27.826381],
                            [119.785766, 27.833503],
                            [119.788965, 27.85319],
                            [119.785077, 27.861651],
                            [119.790097, 27.867095],
                            [119.800186, 27.890545],
                            [119.791032, 27.898584],
                            [119.786455, 27.909302],
                            [119.804713, 27.922111],
                            [119.815146, 27.92073],
                            [119.825284, 27.911771],
                            [119.83306, 27.911353],
                            [119.843099, 27.92705],
                            [119.85117, 27.932198],
                            [119.831436, 27.951617],
                            [119.833601, 27.956178],
                            [119.854861, 27.961911],
                            [119.861997, 27.949525],
                            [119.865688, 27.950864],
                            [119.86554, 27.966388],
                            [119.875235, 27.974128],
                            [119.892115, 27.951366],
                            [119.90683, 27.954253],
                            [119.928631, 27.968814],
                            [119.96244, 27.97622],
                            [119.968739, 27.962496],
                            [119.962145, 27.950236],
                            [119.966919, 27.937597],
                            [120.001269, 27.941029],
                            [120.009389, 27.947892],
                            [120.020511, 27.939606],
                            [120.031781, 27.941322],
                            [120.043001, 27.951115],
                            [120.063572, 27.951073],
                            [120.064311, 27.961241],
                            [120.074301, 27.972287],
                            [120.084389, 27.967099],
                            [120.096889, 27.980613],
                            [120.11746, 27.982621],
                            [120.143888, 27.976596],
                            [120.145758, 27.979692],
                            [120.171939, 27.978563],
                            [120.176713, 27.972203],
                            [120.174842, 27.960404],
                            [120.178337, 27.952956],
                            [120.187835, 27.948562],
                            [120.202057, 27.935965],
                            [120.218691, 27.93563],
                            [120.229961, 27.931361],
                            [120.241575, 27.934961],
                            [120.24561, 27.943415],
                            [120.248957, 27.964003],
                            [120.257471, 27.96735],
                            [120.265591, 27.95714],
                            [120.276516, 27.959609],
                            [120.295168, 27.977057],
                            [120.324646, 27.978981],
                            [120.328928, 27.966681],
                            [120.336064, 27.970697],
                            [120.349154, 27.987683],
                            [120.335522, 27.990444],
                            [120.344479, 28.019011],
                            [120.348711, 28.021018],
                            [120.34881, 28.034902],
                            [120.344922, 28.040003],
                            [120.350286, 28.052588],
                            [120.357176, 28.050581],
                            [120.372432, 28.054929],
                            [120.37381, 28.066174],
                            [120.362294, 28.080093],
                            [120.368446, 28.088912],
                            [120.383652, 28.09539],
                            [120.390542, 28.094303],
                            [120.411851, 28.11457],
                            [120.405601, 28.124222],
                            [120.408013, 28.131617],
                            [120.38567, 28.14206],
                            [120.385916, 28.147365],
                            [120.421546, 28.160188],
                            [120.413672, 28.172633],
                            [120.422087, 28.182823],
                            [120.431044, 28.186915],
                            [120.425188, 28.196351],
                            [120.41195, 28.199482],
                            [120.415788, 28.213927],
                            [120.438426, 28.234463],
                            [120.433505, 28.246984],
                            [120.421448, 28.253827],
                            [120.426418, 28.268056],
                            [120.417019, 28.288832],
                            [120.414164, 28.302931],
                            [120.402796, 28.305976],
                            [120.394971, 28.315485],
                            [120.377698, 28.31757],
                            [120.369971, 28.331332],
                            [120.357914, 28.32883],
                            [120.346595, 28.335126],
                            [120.360768, 28.3453],
                            [120.359883, 28.359391],
                            [120.353485, 28.367228],
                            [120.334686, 28.371355],
                            [120.33503, 28.384484],
                            [120.344725, 28.392444],
                            [120.337638, 28.395528],
                            [120.331684, 28.407571],
                            [120.338819, 28.412363],
                            [120.33818, 28.427112],
                            [120.34379, 28.431903],
                            [120.366723, 28.424279],
                            [120.374302, 28.410821],
                            [120.381684, 28.42557],
                            [120.381044, 28.436277],
                            [120.372137, 28.446982],
                            [120.384341, 28.458894],
                            [120.387786, 28.479467],
                            [120.398957, 28.465017],
                            [120.405995, 28.480425],
                            [120.419135, 28.491875],
                            [120.414952, 28.496871],
                            [120.414952, 28.512358],
                            [120.422186, 28.522223],
                            [120.422727, 28.533627],
                            [120.430503, 28.534293],
                            [120.434145, 28.553727],
                            [120.4307, 28.568165],
                            [120.441871, 28.573324],
                            [120.446349, 28.584307],
                            [120.471891, 28.586928],
                            [120.493495, 28.577776],
                            [120.501566, 28.56001],
                            [120.524056, 28.55535],
                            [120.528781, 28.548359],
                            [120.541232, 28.543365],
                            [120.549204, 28.533585],
                            [120.554716, 28.535958],
                            [120.567856, 28.531879],
                            [120.572236, 28.537498],
                            [120.583358, 28.530797],
                            [120.598811, 28.53396],
                            [120.624303, 28.533377],
                            [120.627157, 28.547402],
                            [120.621202, 28.55639],
                            [120.631291, 28.564005],
                            [120.640002, 28.557847],
                            [120.649647, 28.563006],
                            [120.63946, 28.577443],
                            [120.653043, 28.585014],
                            [120.669234, 28.579606],
                            [120.687344, 28.582476],
                            [120.701026, 28.592751],
                            [120.70201, 28.606352],
                            [120.709096, 28.611509],
                            [120.729372, 28.603773],
                            [120.743496, 28.611592],
                            [120.757817, 28.604314],
                            [120.758703, 28.591586],
                            [120.782916, 28.590547],
                            [120.793644, 28.583766],
                            [120.798713, 28.588758],
                            [120.798221, 28.576528],
                            [120.802601, 28.572201],
                            [120.825829, 28.566335],
                            [120.829225, 28.555558],
                            [120.843054, 28.542034],
                            [120.83267, 28.524595],
                            [120.845071, 28.514189],
                            [120.854323, 28.515313],
                            [120.86953, 28.491167],
                            [120.894481, 28.485546],
                            [120.91082, 28.48921],
                            [120.914412, 28.495997],
                            [120.92765, 28.505031],
                            [120.944776, 28.503449],
                            [120.954028, 28.498911],
                            [120.954471, 28.509027],
                            [120.962198, 28.509027],
                            [120.95767, 28.494831],
                            [120.965593, 28.482965],
                            [120.98705, 28.481715],
                            [120.99517, 28.473346],
                            [121.002946, 28.478717],
                            [121.01771, 28.478592],
                            [121.025436, 28.472763],
                            [121.036115, 28.481715],
                            [121.049895, 28.478259],
                            [121.070417, 28.480341],
                            [121.076864, 28.484089],
                            [121.078734, 28.495331],
                            [121.085131, 28.500993],
                            [121.088182, 28.51727],
                            [121.104816, 28.537289],
                            [121.121352, 28.532503],
                            [121.129866, 28.521723],
                            [121.145565, 28.523929],
                            [121.156736, 28.520475],
                            [121.16958, 28.505905],
                            [121.180949, 28.478343],
                            [121.195171, 28.473012],
                            [121.19463, 28.467099],
                            [121.209098, 28.458853],
                            [121.206096, 28.455979],
                            [121.214413, 28.43836],
                            [121.226815, 28.435569],
                            [121.222829, 28.422029],
                            [121.236165, 28.422696],
                            [121.25772, 28.408113],
                            [121.251274, 28.405279],
                            [121.246155, 28.385776],
                            [121.227553, 28.384818],
                            [121.222041, 28.372897],
                            [121.204866, 28.368437],
                            [121.21589, 28.351512],
                            [121.205949, 28.318654],
                            [121.173911, 28.277485],
                            [121.155358, 28.274064],
                            [121.147385, 28.263132],
                            [121.146401, 28.236133],
                            [121.136805, 28.168583],
                            [121.123271, 28.148117],
                            [121.108409, 28.139011]
                        ]
                    ],
                    [
                        [
                            [120.971745, 27.649859],
                            [120.967759, 27.658042],
                            [120.97957, 27.670419],
                            [120.988281, 27.662783],
                            [120.986509, 27.655104],
                            [120.974747, 27.645033],
                            [120.971745, 27.649859]
                        ]
                    ],
                    [
                        [
                            [121.199945, 27.62493],
                            [121.213577, 27.633324],
                            [121.220811, 27.630303],
                            [121.209, 27.61855],
                            [121.198321, 27.614646],
                            [121.191677, 27.62195],
                            [121.199945, 27.62493]
                        ]
                    ],
                    [
                        [
                            [121.113133, 27.918344],
                            [121.123812, 27.921274],
                            [121.123911, 27.911353],
                            [121.113379, 27.904403],
                            [121.108163, 27.910934],
                            [121.113133, 27.918344]
                        ]
                    ],
                    [
                        [
                            [121.131047, 27.770143],
                            [121.138281, 27.776682],
                            [121.149846, 27.772029],
                            [121.136952, 27.766999],
                            [121.131047, 27.770143]
                        ]
                    ],
                    [
                        [
                            [121.131047, 27.762472],
                            [121.139118, 27.765155],
                            [121.144383, 27.758531],
                            [121.133114, 27.753123],
                            [121.131047, 27.762472]
                        ]
                    ],
                    [
                        [
                            [121.107277, 27.444005],
                            [121.09399, 27.453001],
                            [121.086066, 27.452413],
                            [121.066381, 27.461325],
                            [121.063379, 27.458298],
                            [121.071942, 27.444972],
                            [121.066283, 27.444972],
                            [121.047976, 27.458046],
                            [121.050043, 27.464688],
                            [121.058852, 27.463847],
                            [121.055013, 27.473893],
                            [121.070515, 27.471161],
                            [121.066234, 27.478222],
                            [121.084147, 27.472379],
                            [121.089364, 27.462628],
                            [121.105407, 27.454893],
                            [121.107277, 27.444005]
                        ]
                    ],
                    [
                        [
                            [120.903388, 27.69387],
                            [120.912099, 27.699238],
                            [120.911951, 27.689171],
                            [120.903388, 27.69387]
                        ]
                    ],
                    [
                        [
                            [121.217415, 27.613681],
                            [121.228685, 27.616409],
                            [121.224945, 27.607048],
                            [121.217415, 27.613681]
                        ]
                    ],
                    [
                        [
                            [121.083655, 27.791896],
                            [121.091037, 27.793237],
                            [121.096893, 27.783053],
                            [121.090545, 27.776221],
                            [121.073566, 27.778023],
                            [121.083655, 27.791896]
                        ]
                    ],
                    [
                        [
                            [121.145761, 27.760669],
                            [121.155013, 27.756645],
                            [121.146696, 27.754171],
                            [121.145761, 27.760669]
                        ]
                    ],
                    [
                        [
                            [120.826223, 27.686193],
                            [120.833113, 27.687368],
                            [120.842758, 27.675537],
                            [120.832473, 27.67688],
                            [120.826223, 27.686193]
                        ]
                    ],
                    [
                        [
                            [121.224108, 27.817876],
                            [121.213281, 27.820096],
                            [121.225043, 27.824496],
                            [121.224108, 27.817876]
                        ]
                    ],
                    [
                        [
                            [120.824943, 27.646208],
                            [120.8339, 27.649985],
                            [120.821991, 27.634835],
                            [120.824943, 27.646208]
                        ]
                    ],
                    [
                        [
                            [121.204325, 27.609735],
                            [121.208951, 27.618172],
                            [121.216923, 27.618928],
                            [121.210033, 27.608476],
                            [121.204325, 27.609735]
                        ]
                    ],
                    [
                        [
                            [121.098173, 27.937514],
                            [121.080259, 27.947181],
                            [121.063527, 27.947809],
                            [121.049993, 27.94128],
                            [121.03833, 27.948939],
                            [121.040544, 27.964296],
                            [121.076027, 27.986344],
                            [121.094334, 27.984127],
                            [121.120663, 27.986637],
                            [121.134049, 27.980529],
                            [121.152946, 27.961576],
                            [121.147385, 27.953374],
                            [121.125978, 27.944126],
                            [121.098173, 27.937514]
                        ]
                    ],
                    [
                        [
                            [120.896548, 27.711444],
                            [120.899451, 27.706033],
                            [120.887394, 27.704523],
                            [120.896548, 27.711444]
                        ]
                    ],
                    [
                        [
                            [121.18587, 27.962957],
                            [121.171352, 27.978605],
                            [121.177356, 27.990527],
                            [121.194974, 28.000148],
                            [121.220122, 27.991489],
                            [121.24025, 27.993748],
                            [121.237543, 27.988143],
                            [121.206195, 27.976889],
                            [121.18587, 27.962957]
                        ]
                    ],
                    [
                        [
                            [121.04394, 27.979316],
                            [121.043251, 27.993372],
                            [121.074108, 28.007426],
                            [121.089068, 28.004916],
                            [121.08961, 27.998684],
                            [121.075436, 27.990025],
                            [121.04394, 27.979316]
                        ]
                    ],
                    [
                        [
                            [121.079029, 27.428743],
                            [121.076962, 27.434125],
                            [121.088084, 27.431602],
                            [121.090397, 27.424538],
                            [121.079029, 27.428743]
                        ]
                    ],
                    [
                        [
                            [121.112986, 27.473136],
                            [121.12337, 27.466327],
                            [121.112346, 27.463511],
                            [121.106539, 27.473178],
                            [121.112986, 27.473136]
                        ]
                    ],
                    [
                        [
                            [121.09458, 27.494023],
                            [121.09458, 27.486333],
                            [121.085673, 27.4923],
                            [121.09458, 27.494023]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 330400,
                "name": "嘉兴市",
                "center": [120.750865, 30.762653],
                "centroid": [120.78354, 30.620057],
                "childrenNum": 7,
                "level": "city",
                "parent": {
                    "adcode": 330000
                },
                "subFeatureIndex": 3,
                "acroutes": [100000, 330000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [120.489066, 30.763861],
                            [120.50442, 30.757959],
                            [120.517462, 30.772287],
                            [120.56382, 30.83552],
                            [120.580897, 30.845688],
                            [120.588968, 30.854432],
                            [120.602994, 30.848901],
                            [120.616872, 30.849999],
                            [120.625681, 30.855896],
                            [120.644726, 30.854839],
                            [120.655405, 30.847518],
                            [120.658703, 30.86529],
                            [120.663082, 30.861346],
                            [120.673073, 30.874927],
                            [120.682817, 30.88253],
                            [120.699943, 30.867811],
                            [120.704274, 30.872935],
                            [120.702551, 30.884034],
                            [120.713279, 30.885051],
                            [120.709835, 30.907531],
                            [120.712689, 30.919683],
                            [120.709441, 30.933175],
                            [120.697581, 30.950321],
                            [120.684441, 30.955156],
                            [120.69822, 30.970796],
                            [120.705504, 30.966449],
                            [120.710081, 30.971892],
                            [120.725583, 30.971527],
                            [120.736114, 30.963728],
                            [120.745957, 30.962509],
                            [120.758457, 30.974532],
                            [120.769677, 30.977294],
                            [120.769923, 30.996626],
                            [120.802896, 31.005397],
                            [120.820908, 31.006371],
                            [120.840052, 30.997803],
                            [120.847335, 30.9896],
                            [120.853241, 30.992971],
                            [120.865642, 30.989803],
                            [120.868054, 30.995367],
                            [120.891331, 31.003732],
                            [120.895121, 31.017374],
                            [120.910081, 31.016928],
                            [120.918103, 31.012786],
                            [120.940101, 31.010026],
                            [120.936312, 31.017131],
                            [120.949993, 31.017618],
                            [120.949107, 31.029959],
                            [120.95831, 31.028579],
                            [120.963182, 31.016603],
                            [120.989511, 31.01441],
                            [121.000534, 30.973923],
                            [120.99143, 30.968358],
                            [121.000042, 30.934719],
                            [120.99896, 30.909522],
                            [121.002552, 30.904848],
                            [120.99266, 30.90184],
                            [120.993842, 30.889645],
                            [121.008507, 30.888141],
                            [121.021893, 30.875171],
                            [121.014806, 30.871024],
                            [121.016283, 30.86285],
                            [121.003979, 30.846095],
                            [120.997779, 30.844061],
                            [120.989117, 30.832306],
                            [120.994629, 30.821485],
                            [121.010918, 30.834625],
                            [121.030062, 30.828564],
                            [121.037936, 30.813877],
                            [121.039954, 30.827221],
                            [121.06205, 30.837797],
                            [121.060525, 30.8452],
                            [121.080456, 30.848739],
                            [121.09773, 30.857116],
                            [121.104816, 30.849349],
                            [121.114757, 30.851463],
                            [121.123566, 30.847274],
                            [121.120614, 30.836333],
                            [121.134639, 30.833038],
                            [121.137641, 30.826245],
                            [121.128143, 30.809971],
                            [121.126273, 30.788567],
                            [121.117267, 30.785474],
                            [121.122976, 30.779003],
                            [121.140643, 30.776927],
                            [121.1527, 30.778962],
                            [121.174649, 30.772002],
                            [121.191825, 30.77884],
                            [121.200338, 30.773631],
                            [121.200092, 30.783277],
                            [121.218006, 30.784945],
                            [121.226224, 30.775096],
                            [121.232277, 30.755801],
                            [121.256392, 30.743954],
                            [121.269778, 30.73072],
                            [121.272041, 30.723268],
                            [121.265841, 30.709502],
                            [121.270663, 30.70156],
                            [121.27465, 30.677402],
                            [121.257031, 30.673653],
                            [121.244974, 30.654787],
                            [121.231687, 30.644109],
                            [121.221008, 30.63987],
                            [121.188872, 30.633063],
                            [121.172632, 30.625807],
                            [121.15088, 30.611783],
                            [121.149206, 30.60004],
                            [121.11648, 30.585482],
                            [121.085377, 30.575204],
                            [121.058359, 30.564028],
                            [121.071598, 30.542692],
                            [121.093153, 30.515842],
                            [121.119236, 30.48976],
                            [121.099501, 30.443661],
                            [121.086952, 30.397131],
                            [121.06018, 30.376371],
                            [121.040102, 30.352868],
                            [121.032572, 30.337006],
                            [121.01392, 30.323635],
                            [120.99517, 30.319914],
                            [120.954373, 30.306418],
                            [120.916036, 30.285762],
                            [120.86702, 30.271729],
                            [120.825288, 30.262687],
                            [120.789362, 30.263137],
                            [120.739904, 30.276639],
                            [120.721941, 30.286334],
                            [120.710868, 30.297542],
                            [120.706045, 30.309444],
                            [120.704126, 30.330791],
                            [120.70388, 30.365867],
                            [120.692955, 30.377965],
                            [120.658998, 30.385607],
                            [120.633899, 30.389449],
                            [120.567856, 30.387855],
                            [120.498761, 30.38904],
                            [120.460227, 30.382665],
                            [120.43882, 30.373388],
                            [120.413771, 30.318319],
                            [120.378091, 30.344937],
                            [120.388524, 30.370118],
                            [120.400926, 30.377025],
                            [120.398318, 30.38479],
                            [120.362835, 30.374695],
                            [120.342953, 30.37163],
                            [120.319282, 30.379314],
                            [120.315689, 30.394311],
                            [120.306388, 30.396232],
                            [120.322038, 30.404731],
                            [120.332963, 30.417314],
                            [120.330749, 30.427282],
                            [120.340345, 30.433899],
                            [120.337245, 30.464324],
                            [120.341379, 30.472286],
                            [120.329174, 30.468407],
                            [120.326123, 30.500414],
                            [120.317707, 30.521596],
                            [120.299892, 30.5198],
                            [120.301959, 30.530002],
                            [120.300237, 30.552932],
                            [120.295955, 30.564681],
                            [120.309439, 30.568107],
                            [120.319134, 30.579079],
                            [120.302599, 30.595636],
                            [120.303189, 30.60901],
                            [120.30939, 30.612639],
                            [120.332717, 30.615044],
                            [120.340099, 30.631351],
                            [120.344971, 30.662733],
                            [120.353977, 30.662815],
                            [120.364607, 30.654542],
                            [120.38129, 30.658943],
                            [120.387934, 30.67072],
                            [120.406093, 30.670761],
                            [120.407963, 30.675691],
                            [120.455011, 30.68555],
                            [120.441182, 30.695572],
                            [120.444479, 30.701763],
                            [120.462885, 30.701397],
                            [120.475287, 30.710724],
                            [120.486261, 30.727992],
                            [120.471891, 30.746682],
                            [120.469972, 30.764431],
                            [120.489066, 30.763861]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 330500,
                "name": "湖州市",
                "center": [120.102398, 30.867198],
                "centroid": [119.873716, 30.743051],
                "childrenNum": 5,
                "level": "city",
                "parent": {
                    "adcode": 330000
                },
                "subFeatureIndex": 4,
                "acroutes": [100000, 330000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [120.299892, 30.5198],
                            [120.285817, 30.507802],
                            [120.277451, 30.504822],
                            [120.25191, 30.506536],
                            [120.239262, 30.50523],
                            [120.224597, 30.509761],
                            [120.205404, 30.505843],
                            [120.201762, 30.514413],
                            [120.195659, 30.503598],
                            [120.185079, 30.502618],
                            [120.185915, 30.494618],
                            [120.173809, 30.492046],
                            [120.180551, 30.482534],
                            [120.175039, 30.476818],
                            [120.149793, 30.467509],
                            [120.146004, 30.482697],
                            [120.11121, 30.476206],
                            [120.096742, 30.48678],
                            [120.099252, 30.495801],
                            [120.068297, 30.496618],
                            [120.065836, 30.483595],
                            [120.059488, 30.47343],
                            [120.059242, 30.459016],
                            [120.0681, 30.445948],
                            [120.062145, 30.434634],
                            [120.064754, 30.4301],
                            [120.046102, 30.427445],
                            [120.041525, 30.433368],
                            [120.013818, 30.435614],
                            [120.00368, 30.444273],
                            [119.982962, 30.445294],
                            [119.965048, 30.431571],
                            [119.955895, 30.433654],
                            [119.950728, 30.444232],
                            [119.934979, 30.446764],
                            [119.931436, 30.456443],
                            [119.921544, 30.462528],
                            [119.90934, 30.456321],
                            [119.90304, 30.459424],
                            [119.890048, 30.457056],
                            [119.872578, 30.462487],
                            [119.880796, 30.476206],
                            [119.867115, 30.477757],
                            [119.854123, 30.493964],
                            [119.851121, 30.502006],
                            [119.836013, 30.496577],
                            [119.815884, 30.510659],
                            [119.794182, 30.505638],
                            [119.784044, 30.511026],
                            [119.766376, 30.514087],
                            [119.768936, 30.551341],
                            [119.743246, 30.550158],
                            [119.729073, 30.551749],
                            [119.71175, 30.566516],
                            [119.69241, 30.556155],
                            [119.695018, 30.542325],
                            [119.70486, 30.525963],
                            [119.709191, 30.508822],
                            [119.704713, 30.494577],
                            [119.708896, 30.487964],
                            [119.701711, 30.467999],
                            [119.695362, 30.464488],
                            [119.694919, 30.452727],
                            [119.709191, 30.434062],
                            [119.686012, 30.417559],
                            [119.681091, 30.408735],
                            [119.668099, 30.399501],
                            [119.6555, 30.40518],
                            [119.646691, 30.39378],
                            [119.633256, 30.395292],
                            [119.63739, 30.410369],
                            [119.631829, 30.424667],
                            [119.642951, 30.428507],
                            [119.650579, 30.440352],
                            [119.635569, 30.441782],
                            [119.627941, 30.431775],
                            [119.594968, 30.421644],
                            [119.581779, 30.423646],
                            [119.572823, 30.431326],
                            [119.565933, 30.443375],
                            [119.55176, 30.43978],
                            [119.535273, 30.424055],
                            [119.533452, 30.409429],
                            [119.513127, 30.401666],
                            [119.490391, 30.408203],
                            [119.467015, 30.408122],
                            [119.450234, 30.410818],
                            [119.441031, 30.392472],
                            [119.435716, 30.391492],
                            [119.418147, 30.376085],
                            [119.403038, 30.373347],
                            [119.393836, 30.383033],
                            [119.371444, 30.383932],
                            [119.366572, 30.388386],
                            [119.368934, 30.399746],
                            [119.360912, 30.410737],
                            [119.349544, 30.408612],
                            [119.352989, 30.424831],
                            [119.349692, 30.438841],
                            [119.336158, 30.44558],
                            [119.334485, 30.478084],
                            [119.330351, 30.488249],
                            [119.336355, 30.507149],
                            [119.328678, 30.521637],
                            [119.326562, 30.532981],
                            [119.313619, 30.531186],
                            [119.28793, 30.512618],
                            [119.272133, 30.510495],
                            [119.26165, 30.51776],
                            [119.261896, 30.525554],
                            [119.242556, 30.530043],
                            [119.236945, 30.546731],
                            [119.245508, 30.561417],
                            [119.264751, 30.57345],
                            [119.264751, 30.582056],
                            [119.254121, 30.588663],
                            [119.253678, 30.596452],
                            [119.240095, 30.604933],
                            [119.245853, 30.618877],
                            [119.255006, 30.615126],
                            [119.278383, 30.617613],
                            [119.291227, 30.616023],
                            [119.311946, 30.621241],
                            [119.323117, 30.630291],
                            [119.333648, 30.652219],
                            [119.343147, 30.6642],
                            [119.354564, 30.66693],
                            [119.372379, 30.680376],
                            [119.379367, 30.679358],
                            [119.391523, 30.685224],
                            [119.395657, 30.678706],
                            [119.400037, 30.658862],
                            [119.412684, 30.642968],
                            [119.433649, 30.644476],
                            [119.448314, 30.655846],
                            [119.45294, 30.671616],
                            [119.465982, 30.683921],
                            [119.482763, 30.704452],
                            [119.480303, 30.738091],
                            [119.484584, 30.744605],
                            [119.478777, 30.753074],
                            [119.479564, 30.771229],
                            [119.491523, 30.777253],
                            [119.507124, 30.769642],
                            [119.524496, 30.776032],
                            [119.554515, 30.825635],
                            [119.561208, 30.829459],
                            [119.575726, 30.829743],
                            [119.573758, 30.853334],
                            [119.558945, 30.871186],
                            [119.559092, 30.891718],
                            [119.556336, 30.896718],
                            [119.563817, 30.919236],
                            [119.580352, 30.929152],
                            [119.582173, 30.947437],
                            [119.579565, 30.962671],
                            [119.585864, 30.976401],
                            [119.607468, 30.991875],
                            [119.616277, 31.002392],
                            [119.624004, 31.005316],
                            [119.634043, 31.019485],
                            [119.631337, 31.046317],
                            [119.634978, 31.064174],
                            [119.629516, 31.082311],
                            [119.634683, 31.093751],
                            [119.649152, 31.105109],
                            [119.624152, 31.11602],
                            [119.623807, 31.130254],
                            [119.638128, 31.135526],
                            [119.641573, 31.148136],
                            [119.662537, 31.159852],
                            [119.663719, 31.165973],
                            [119.678039, 31.168203],
                            [119.682764, 31.160501],
                            [119.703876, 31.151906],
                            [119.713128, 31.167635],
                            [119.740491, 31.173432],
                            [119.755353, 31.170756],
                            [119.779319, 31.178782],
                            [119.793394, 31.168041],
                            [119.791278, 31.156609],
                            [119.800973, 31.156325],
                            [119.809881, 31.148501],
                            [119.823316, 31.154136],
                            [119.829762, 31.161393],
                            [119.823463, 31.165811],
                            [119.826465, 31.173188],
                            [119.837587, 31.173675],
                            [119.842164, 31.16877],
                            [119.866623, 31.168324],
                            [119.878729, 31.160785],
                            [119.900235, 31.169176],
                            [119.920954, 31.170392],
                            [119.921052, 31.16119],
                            [119.936751, 31.146555],
                            [119.946249, 31.106245],
                            [119.969773, 31.074277],
                            [119.988523, 31.059223],
                            [120.001712, 31.027118],
                            [120.017017, 31.017821],
                            [120.05245, 31.005722],
                            [120.09438, 30.973233],
                            [120.111014, 30.955928],
                            [120.135128, 30.941911],
                            [120.149646, 30.937482],
                            [120.221791, 30.926876],
                            [120.250778, 30.926226],
                            [120.308061, 30.932281],
                            [120.343347, 30.939961],
                            [120.371103, 30.948777],
                            [120.35944, 30.931915],
                            [120.362688, 30.921674],
                            [120.35693, 30.908872],
                            [120.360129, 30.892775],
                            [120.358012, 30.887084],
                            [120.364656, 30.880457],
                            [120.372432, 30.882164],
                            [120.37942, 30.890783],
                            [120.394676, 30.890783],
                            [120.423515, 30.90306],
                            [120.418003, 30.925576],
                            [120.423416, 30.927445],
                            [120.434981, 30.920821],
                            [120.442265, 30.90058],
                            [120.434489, 30.887978],
                            [120.439558, 30.885213],
                            [120.452353, 30.867893],
                            [120.44128, 30.856303],
                            [120.454469, 30.849633],
                            [120.460375, 30.839872],
                            [120.461015, 30.828279],
                            [120.455257, 30.816847],
                            [120.477255, 30.800002],
                            [120.477009, 30.785596],
                            [120.489066, 30.763861],
                            [120.469972, 30.764431],
                            [120.471891, 30.746682],
                            [120.486261, 30.727992],
                            [120.475287, 30.710724],
                            [120.462885, 30.701397],
                            [120.444479, 30.701763],
                            [120.441182, 30.695572],
                            [120.455011, 30.68555],
                            [120.407963, 30.675691],
                            [120.406093, 30.670761],
                            [120.387934, 30.67072],
                            [120.38129, 30.658943],
                            [120.364607, 30.654542],
                            [120.353977, 30.662815],
                            [120.344971, 30.662733],
                            [120.340099, 30.631351],
                            [120.332717, 30.615044],
                            [120.30939, 30.612639],
                            [120.303189, 30.60901],
                            [120.302599, 30.595636],
                            [120.319134, 30.579079],
                            [120.309439, 30.568107],
                            [120.295955, 30.564681],
                            [120.300237, 30.552932],
                            [120.301959, 30.530002],
                            [120.299892, 30.5198]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 330600,
                "name": "绍兴市",
                "center": [120.582112, 29.997117],
                "centroid": [120.640942, 29.732872],
                "childrenNum": 6,
                "level": "city",
                "parent": {
                    "adcode": 330000
                },
                "subFeatureIndex": 5,
                "acroutes": [100000, 330000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [119.973119, 29.674804],
                            [119.973464, 29.68995],
                            [119.967411, 29.694889],
                            [119.951269, 29.699292],
                            [119.937735, 29.70748],
                            [119.933454, 29.699415],
                            [119.922529, 29.697769],
                            [119.914655, 29.704682],
                            [119.912489, 29.720399],
                            [119.901367, 29.728627],
                            [119.900481, 29.74467],
                            [119.889064, 29.753102],
                            [119.890343, 29.762931],
                            [119.904369, 29.754582],
                            [119.913572, 29.755857],
                            [119.927204, 29.744423],
                            [119.944576, 29.755528],
                            [119.960275, 29.755158],
                            [119.973119, 29.765809],
                            [119.991968, 29.753143],
                            [120.010915, 29.757214],
                            [120.011505, 29.761491],
                            [120.030059, 29.770538],
                            [120.030059, 29.78275],
                            [120.036604, 29.788548],
                            [120.030059, 29.806307],
                            [120.038425, 29.82283],
                            [120.065639, 29.822049],
                            [120.074252, 29.82731],
                            [120.095807, 29.816583],
                            [120.102746, 29.823981],
                            [120.101122, 29.830269],
                            [120.109931, 29.845967],
                            [120.131289, 29.858827],
                            [120.144773, 29.874109],
                            [120.150285, 29.887582],
                            [120.150039, 29.905036],
                            [120.159734, 29.906227],
                            [120.166329, 29.917273],
                            [120.17627, 29.913578],
                            [120.185079, 29.904502],
                            [120.204813, 29.924048],
                            [120.200433, 29.929467],
                            [120.221004, 29.942235],
                            [120.250729, 29.936693],
                            [120.255207, 29.94363],
                            [120.264754, 29.930986],
                            [120.265296, 29.924499],
                            [120.2744, 29.919531],
                            [120.284144, 29.922159],
                            [120.291034, 29.935666],
                            [120.312048, 29.927702],
                            [120.325188, 29.93854],
                            [120.326073, 29.946216],
                            [120.340493, 29.956068],
                            [120.346447, 29.973797],
                            [120.360473, 29.973674],
                            [120.364312, 29.978516],
                            [120.360473, 29.98857],
                            [120.362835, 29.99776],
                            [120.35693, 30.011708],
                            [120.345808, 30.019707],
                            [120.343593, 30.034924],
                            [120.331831, 30.037918],
                            [120.324941, 30.048621],
                            [120.33818, 30.060881],
                            [120.338623, 30.070229],
                            [120.333701, 30.09548],
                            [120.313327, 30.107078],
                            [120.299302, 30.097365],
                            [120.286851, 30.106791],
                            [120.300286, 30.118348],
                            [120.303731, 30.126666],
                            [120.297825, 30.128182],
                            [120.312245, 30.1374],
                            [120.318002, 30.12601],
                            [120.327993, 30.125191],
                            [120.339607, 30.142112],
                            [120.353386, 30.142194],
                            [120.352008, 30.150674],
                            [120.358751, 30.147847],
                            [120.37317, 30.155507],
                            [120.387835, 30.156163],
                            [120.399007, 30.136335],
                            [120.411359, 30.132607],
                            [120.410867, 30.149527],
                            [120.420956, 30.152763],
                            [120.426074, 30.144283],
                            [120.422875, 30.135884],
                            [120.429617, 30.132443],
                            [120.44694, 30.135434],
                            [120.451172, 30.15096],
                            [120.465001, 30.155466],
                            [120.466182, 30.169556],
                            [120.484096, 30.172218],
                            [120.498072, 30.169187],
                            [120.506143, 30.159767],
                            [120.518495, 30.155384],
                            [120.529371, 30.157514],
                            [120.550927, 30.15563],
                            [120.563427, 30.147929],
                            [120.568348, 30.151329],
                            [120.593496, 30.146782],
                            [120.609145, 30.152845],
                            [120.612787, 30.16628],
                            [120.642708, 30.217258],
                            [120.669037, 30.23314],
                            [120.693939, 30.262032],
                            [120.721941, 30.286334],
                            [120.739904, 30.276639],
                            [120.789362, 30.263137],
                            [120.825288, 30.262687],
                            [120.86702, 30.271729],
                            [120.893447, 30.228843],
                            [120.916233, 30.188394],
                            [120.92765, 30.165215],
                            [120.931194, 30.146618],
                            [120.939461, 30.125723],
                            [120.930455, 30.115192],
                            [120.93828, 30.113021],
                            [120.950141, 30.091012],
                            [120.959737, 30.094537],
                            [120.96766, 30.089987],
                            [120.973861, 30.078305],
                            [120.969924, 30.07027],
                            [120.98144, 30.067359],
                            [120.986656, 30.054402],
                            [120.992562, 30.050425],
                            [120.986509, 30.044274],
                            [120.990151, 30.027787],
                            [121.018202, 30.010765],
                            [121.039511, 30.013923],
                            [121.034737, 30.003955],
                            [121.038133, 29.998704],
                            [121.05142, 30.006786],
                            [121.064413, 30.006827],
                            [121.075781, 30.001986],
                            [121.082621, 29.991072],
                            [121.091627, 29.987257],
                            [121.085869, 29.972648],
                            [121.07647, 29.970391],
                            [121.066135, 29.960829],
                            [121.045072, 29.955616],
                            [121.042021, 29.933203],
                            [121.0308, 29.918792],
                            [121.031637, 29.911073],
                            [121.023172, 29.897357],
                            [121.016578, 29.894934],
                            [121.031096, 29.874602],
                            [121.060574, 29.854143],
                            [121.063133, 29.859032],
                            [121.077011, 29.849007],
                            [121.085771, 29.849295],
                            [121.10649, 29.836228],
                            [121.096499, 29.815966],
                            [121.104964, 29.805485],
                            [121.096007, 29.797839],
                            [121.092612, 29.788959],
                            [121.08208, 29.778433],
                            [121.055111, 29.760669],
                            [121.045515, 29.76729],
                            [121.033999, 29.76877],
                            [121.024796, 29.763918],
                            [121.03518, 29.746439],
                            [121.014954, 29.741667],
                            [121.010722, 29.73525],
                            [121.019727, 29.723403],
                            [121.035869, 29.72114],
                            [121.034787, 29.715997],
                            [121.009639, 29.709003],
                            [121.006785, 29.698592],
                            [121.01397, 29.693119],
                            [121.010229, 29.68674],
                            [120.992956, 29.685259],
                            [120.992414, 29.675833],
                            [121.017759, 29.669742],
                            [121.038428, 29.675751],
                            [121.054226, 29.68567],
                            [121.058802, 29.683859],
                            [121.068399, 29.66686],
                            [121.074895, 29.66085],
                            [121.074206, 29.637259],
                            [121.08774, 29.628077],
                            [121.101716, 29.626265],
                            [121.113281, 29.613745],
                            [121.110181, 29.607444],
                            [121.117562, 29.605508],
                            [121.105702, 29.585447],
                            [121.115643, 29.586724],
                            [121.120417, 29.575601],
                            [121.113478, 29.56596],
                            [121.112986, 29.554834],
                            [121.130948, 29.554174],
                            [121.140348, 29.543006],
                            [121.155702, 29.54177],
                            [121.169334, 29.537112],
                            [121.183557, 29.538802],
                            [121.20585, 29.536947],
                            [121.213183, 29.530311],
                            [121.225585, 29.532908],
                            [121.231539, 29.51308],
                            [121.216726, 29.496795],
                            [121.228488, 29.490733],
                            [121.219827, 29.477785],
                            [121.216972, 29.452666],
                            [121.224059, 29.449242],
                            [121.217514, 29.439217],
                            [121.209197, 29.436742],
                            [121.218252, 29.421146],
                            [121.215102, 29.417267],
                            [121.226815, 29.414749],
                            [121.231441, 29.393825],
                            [121.226421, 29.384662],
                            [121.230063, 29.362658],
                            [121.213134, 29.353575],
                            [121.20024, 29.342384],
                            [121.193399, 29.341434],
                            [121.194187, 29.322189],
                            [121.180456, 29.32921],
                            [121.175092, 29.323097],
                            [121.163084, 29.325039],
                            [121.160574, 29.340154],
                            [121.149846, 29.330903],
                            [121.133704, 29.338337],
                            [121.122041, 29.336396],
                            [121.117956, 29.33111],
                            [121.120368, 29.318719],
                            [121.117513, 29.304509],
                            [121.096155, 29.305707],
                            [121.099501, 29.317893],
                            [121.074698, 29.322106],
                            [121.056539, 29.322891],
                            [121.04084, 29.309549],
                            [121.024009, 29.308103],
                            [121.020515, 29.317728],
                            [121.005554, 29.319421],
                            [120.990889, 29.309219],
                            [120.964806, 29.306327],
                            [120.956883, 29.282447],
                            [120.942611, 29.289595],
                            [120.928093, 29.291702],
                            [120.915347, 29.303311],
                            [120.904225, 29.295462],
                            [120.903782, 29.276042],
                            [120.891627, 29.270009],
                            [120.890692, 29.260462],
                            [120.897335, 29.253478],
                            [120.900042, 29.240788],
                            [120.882227, 29.239217],
                            [120.867266, 29.24455],
                            [120.862148, 29.252362],
                            [120.853634, 29.253519],
                            [120.838428, 29.237895],
                            [120.82391, 29.229503],
                            [120.806144, 29.234009],
                            [120.776518, 29.225079],
                            [120.773171, 29.231859],
                            [120.776567, 29.242111],
                            [120.772384, 29.262859],
                            [120.775091, 29.276951],
                            [120.759047, 29.281125],
                            [120.756784, 29.28629],
                            [120.773024, 29.304633],
                            [120.76141, 29.313391],
                            [120.749894, 29.31591],
                            [120.738723, 29.30959],
                            [120.725927, 29.310251],
                            [120.720415, 29.303187],
                            [120.711508, 29.302113],
                            [120.699844, 29.318843],
                            [120.707866, 29.341311],
                            [120.704667, 29.347587],
                            [120.697433, 29.341847],
                            [120.687935, 29.341889],
                            [120.670218, 29.325534],
                            [120.653683, 29.33429],
                            [120.645218, 29.328054],
                            [120.624106, 29.336355],
                            [120.600976, 29.334166],
                            [120.590986, 29.348496],
                            [120.579125, 29.340113],
                            [120.571399, 29.34288],
                            [120.57819, 29.357704],
                            [120.566675, 29.367324],
                            [120.553781, 29.371493],
                            [120.55949, 29.379626],
                            [120.550484, 29.390936],
                            [120.53823, 29.391514],
                            [120.523761, 29.401461],
                            [120.511163, 29.419412],
                            [120.511852, 29.44029],
                            [120.515592, 29.451593],
                            [120.522186, 29.456997],
                            [120.515247, 29.468546],
                            [120.496448, 29.466773],
                            [120.497777, 29.474361],
                            [120.474844, 29.492877],
                            [120.461458, 29.48496],
                            [120.427796, 29.477207],
                            [120.410375, 29.450645],
                            [120.398465, 29.45576],
                            [120.383997, 29.456172],
                            [120.367314, 29.445571],
                            [120.36441, 29.433854],
                            [120.369971, 29.428655],
                            [120.372825, 29.414915],
                            [120.361999, 29.415038],
                            [120.343692, 29.41021],
                            [120.334243, 29.403483],
                            [120.333308, 29.395146],
                            [120.325335, 29.380658],
                            [120.317953, 29.379791],
                            [120.307619, 29.365714],
                            [120.289902, 29.355598],
                            [120.278288, 29.363443],
                            [120.266723, 29.376571],
                            [120.261359, 29.390358],
                            [120.264016, 29.400842],
                            [120.277992, 29.416771],
                            [120.281536, 29.440785],
                            [120.267215, 29.452253],
                            [120.261801, 29.469165],
                            [120.269676, 29.481042],
                            [120.282077, 29.489249],
                            [120.268494, 29.49865],
                            [120.250925, 29.496052],
                            [120.249449, 29.504793],
                            [120.241821, 29.512008],
                            [120.227057, 29.514441],
                            [120.223809, 29.52182],
                            [120.207864, 29.528951],
                            [120.2119, 29.535711],
                            [120.200728, 29.549476],
                            [120.186506, 29.548776],
                            [120.185472, 29.541357],
                            [120.17125, 29.521614],
                            [120.157421, 29.512544],
                            [120.13877, 29.508463],
                            [120.127057, 29.494279],
                            [120.114212, 29.497496],
                            [120.102893, 29.506608],
                            [120.093346, 29.500299],
                            [120.079616, 29.504711],
                            [120.07558, 29.513163],
                            [120.085029, 29.514523],
                            [120.091722, 29.532249],
                            [120.08808, 29.536412],
                            [120.073612, 29.537648],
                            [120.05875, 29.542635],
                            [120.051122, 29.549682],
                            [120.054714, 29.558213],
                            [120.040147, 29.570162],
                            [120.02996, 29.56596],
                            [120.007076, 29.57247],
                            [120.006486, 29.593563],
                            [120.019232, 29.617864],
                            [120.035078, 29.617452],
                            [120.045216, 29.626389],
                            [120.044625, 29.631618],
                            [120.031732, 29.636806],
                            [120.024744, 29.647923],
                            [120.036702, 29.653852],
                            [120.037194, 29.663979],
                            [120.029468, 29.667807],
                            [120.029074, 29.653275],
                            [120.021692, 29.647964],
                            [120.002598, 29.655087],
                            [119.991082, 29.654346],
                            [119.988818, 29.661179],
                            [119.973119, 29.674804]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 330700,
                "name": "金华市",
                "center": [119.649506, 29.089524],
                "centroid": [119.957007, 29.115117],
                "childrenNum": 9,
                "level": "city",
                "parent": {
                    "adcode": 330000
                },
                "subFeatureIndex": 6,
                "acroutes": [100000, 330000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [119.322428, 28.800897],
                            [119.331631, 28.807912],
                            [119.345558, 28.827711],
                            [119.336355, 28.835222],
                            [119.338028, 28.843149],
                            [119.331926, 28.846966],
                            [119.311306, 28.842153],
                            [119.310912, 28.85124],
                            [119.319672, 28.867794],
                            [119.333599, 28.865181],
                            [119.34546, 28.899734],
                            [119.333796, 28.907945],
                            [119.327152, 28.924739],
                            [119.315587, 28.943231],
                            [119.311503, 28.959853],
                            [119.304613, 28.969345],
                            [119.316621, 28.970256],
                            [119.325922, 28.979125],
                            [119.328038, 28.987579],
                            [119.321542, 29.00059],
                            [119.327349, 29.03808],
                            [119.334682, 29.022216],
                            [119.332369, 29.043423],
                            [119.334288, 29.052369],
                            [119.327841, 29.067649],
                            [119.332517, 29.075971],
                            [119.32602, 29.086238],
                            [119.305351, 29.085617],
                            [119.299987, 29.090709],
                            [119.302595, 29.100893],
                            [119.292507, 29.105901],
                            [119.282762, 29.118317],
                            [119.267703, 29.119104],
                            [119.267162, 29.133919],
                            [119.251119, 29.141656],
                            [119.253333, 29.154772],
                            [119.241522, 29.165735],
                            [119.242162, 29.189683],
                            [119.233353, 29.195845],
                            [119.234928, 29.221937],
                            [119.244918, 29.228634],
                            [119.260912, 29.247815],
                            [119.270656, 29.251659],
                            [119.288077, 29.268852],
                            [119.286011, 29.279348],
                            [119.318294, 29.279885],
                            [119.322625, 29.296164],
                            [119.328629, 29.299263],
                            [119.3242, 29.307979],
                            [119.348806, 29.319504],
                            [119.344278, 29.324378],
                            [119.348462, 29.336231],
                            [119.333058, 29.355061],
                            [119.340145, 29.38235],
                            [119.328629, 29.393413],
                            [119.337093, 29.411159],
                            [119.346395, 29.408724],
                            [119.360223, 29.416276],
                            [119.368294, 29.415699],
                            [119.378137, 29.42981],
                            [119.388521, 29.429728],
                            [119.39354, 29.411242],
                            [119.399938, 29.411242],
                            [119.404761, 29.400677],
                            [119.426759, 29.405547],
                            [119.43232, 29.415162],
                            [119.427793, 29.422177],
                            [119.437143, 29.424116],
                            [119.443147, 29.404556],
                            [119.451365, 29.397292],
                            [119.451858, 29.385611],
                            [119.457566, 29.370379],
                            [119.45481, 29.365259],
                            [119.461454, 29.350932],
                            [119.471493, 29.349033],
                            [119.480204, 29.332968],
                            [119.49231, 29.331069],
                            [119.500037, 29.335735],
                            [119.510421, 29.333464],
                            [119.522724, 29.350024],
                            [119.523905, 29.366003],
                            [119.536061, 29.373145],
                            [119.545411, 29.367365],
                            [119.558551, 29.372154],
                            [119.574594, 29.372773],
                            [119.582075, 29.379131],
                            [119.592901, 29.377686],
                            [119.604565, 29.369636],
                            [119.616277, 29.368273],
                            [119.617606, 29.380369],
                            [119.606238, 29.388088],
                            [119.625529, 29.410499],
                            [119.624939, 29.417762],
                            [119.642508, 29.432946],
                            [119.664408, 29.424075],
                            [119.673413, 29.425024],
                            [119.676317, 29.419206],
                            [119.688916, 29.421764],
                            [119.691179, 29.438763],
                            [119.707272, 29.433235],
                            [119.715835, 29.448995],
                            [119.707124, 29.464215],
                            [119.70678, 29.472382],
                            [119.719575, 29.491146],
                            [119.718837, 29.505288],
                            [119.726908, 29.511555],
                            [119.735422, 29.510936],
                            [119.74492, 29.516419],
                            [119.722626, 29.542759],
                            [119.741081, 29.551908],
                            [119.750678, 29.550713],
                            [119.764211, 29.557347],
                            [119.761652, 29.566536],
                            [119.769182, 29.579556],
                            [119.764949, 29.594675],
                            [119.779319, 29.603984],
                            [119.776514, 29.626841],
                            [119.79118, 29.654963],
                            [119.817607, 29.673076],
                            [119.824448, 29.671841],
                            [119.835422, 29.678138],
                            [119.852499, 29.668877],
                            [119.859536, 29.671347],
                            [119.879271, 29.66793],
                            [119.895708, 29.660644],
                            [119.911702, 29.66649],
                            [119.921249, 29.66402],
                            [119.924792, 29.669906],
                            [119.936161, 29.666531],
                            [119.973119, 29.674804],
                            [119.988818, 29.661179],
                            [119.991082, 29.654346],
                            [120.002598, 29.655087],
                            [120.021692, 29.647964],
                            [120.029074, 29.653275],
                            [120.029468, 29.667807],
                            [120.037194, 29.663979],
                            [120.036702, 29.653852],
                            [120.024744, 29.647923],
                            [120.031732, 29.636806],
                            [120.044625, 29.631618],
                            [120.045216, 29.626389],
                            [120.035078, 29.617452],
                            [120.019232, 29.617864],
                            [120.006486, 29.593563],
                            [120.007076, 29.57247],
                            [120.02996, 29.56596],
                            [120.040147, 29.570162],
                            [120.054714, 29.558213],
                            [120.051122, 29.549682],
                            [120.05875, 29.542635],
                            [120.073612, 29.537648],
                            [120.08808, 29.536412],
                            [120.091722, 29.532249],
                            [120.085029, 29.514523],
                            [120.07558, 29.513163],
                            [120.079616, 29.504711],
                            [120.093346, 29.500299],
                            [120.102893, 29.506608],
                            [120.114212, 29.497496],
                            [120.127057, 29.494279],
                            [120.13877, 29.508463],
                            [120.157421, 29.512544],
                            [120.17125, 29.521614],
                            [120.185472, 29.541357],
                            [120.186506, 29.548776],
                            [120.200728, 29.549476],
                            [120.2119, 29.535711],
                            [120.207864, 29.528951],
                            [120.223809, 29.52182],
                            [120.227057, 29.514441],
                            [120.241821, 29.512008],
                            [120.249449, 29.504793],
                            [120.250925, 29.496052],
                            [120.268494, 29.49865],
                            [120.282077, 29.489249],
                            [120.269676, 29.481042],
                            [120.261801, 29.469165],
                            [120.267215, 29.452253],
                            [120.281536, 29.440785],
                            [120.277992, 29.416771],
                            [120.264016, 29.400842],
                            [120.261359, 29.390358],
                            [120.266723, 29.376571],
                            [120.278288, 29.363443],
                            [120.289902, 29.355598],
                            [120.307619, 29.365714],
                            [120.317953, 29.379791],
                            [120.325335, 29.380658],
                            [120.333308, 29.395146],
                            [120.334243, 29.403483],
                            [120.343692, 29.41021],
                            [120.361999, 29.415038],
                            [120.372825, 29.414915],
                            [120.369971, 29.428655],
                            [120.36441, 29.433854],
                            [120.367314, 29.445571],
                            [120.383997, 29.456172],
                            [120.398465, 29.45576],
                            [120.410375, 29.450645],
                            [120.427796, 29.477207],
                            [120.461458, 29.48496],
                            [120.474844, 29.492877],
                            [120.497777, 29.474361],
                            [120.496448, 29.466773],
                            [120.515247, 29.468546],
                            [120.522186, 29.456997],
                            [120.515592, 29.451593],
                            [120.511852, 29.44029],
                            [120.511163, 29.419412],
                            [120.523761, 29.401461],
                            [120.53823, 29.391514],
                            [120.550484, 29.390936],
                            [120.55949, 29.379626],
                            [120.553781, 29.371493],
                            [120.566675, 29.367324],
                            [120.57819, 29.357704],
                            [120.571399, 29.34288],
                            [120.579125, 29.340113],
                            [120.590986, 29.348496],
                            [120.600976, 29.334166],
                            [120.624106, 29.336355],
                            [120.645218, 29.328054],
                            [120.653683, 29.33429],
                            [120.670218, 29.325534],
                            [120.687935, 29.341889],
                            [120.697433, 29.341847],
                            [120.704667, 29.347587],
                            [120.707866, 29.341311],
                            [120.699844, 29.318843],
                            [120.711508, 29.302113],
                            [120.720415, 29.303187],
                            [120.725927, 29.310251],
                            [120.738723, 29.30959],
                            [120.749894, 29.31591],
                            [120.76141, 29.313391],
                            [120.773024, 29.304633],
                            [120.756784, 29.28629],
                            [120.759047, 29.281125],
                            [120.775091, 29.276951],
                            [120.772384, 29.262859],
                            [120.776567, 29.242111],
                            [120.773171, 29.231859],
                            [120.776518, 29.225079],
                            [120.783063, 29.221193],
                            [120.773171, 29.205687],
                            [120.77824, 29.19965],
                            [120.759884, 29.189022],
                            [120.749648, 29.176035],
                            [120.731095, 29.164494],
                            [120.712295, 29.143767],
                            [120.722187, 29.130236],
                            [120.734441, 29.13127],
                            [120.746843, 29.122911],
                            [120.736606, 29.11331],
                            [120.723614, 29.119145],
                            [120.709884, 29.098409],
                            [120.701222, 29.097457],
                            [120.694382, 29.086942],
                            [120.704864, 29.075888],
                            [120.702207, 29.060195],
                            [120.691626, 29.052079],
                            [120.70073, 29.044334],
                            [120.693151, 29.040565],
                            [120.701714, 29.022713],
                            [120.713575, 29.035264],
                            [120.724451, 29.023873],
                            [120.720317, 29.012356],
                            [120.72824, 29.009829],
                            [120.72952, 28.99711],
                            [120.72199, 28.995245],
                            [120.726665, 28.98128],
                            [120.717315, 28.973779],
                            [120.69886, 28.972992],
                            [120.696695, 28.980037],
                            [120.677699, 28.977302],
                            [120.673319, 28.973158],
                            [120.673417, 28.959895],
                            [120.659638, 28.937136],
                            [120.664953, 28.923786],
                            [120.663771, 28.916488],
                            [120.64699, 28.90048],
                            [120.619086, 28.895628],
                            [120.60447, 28.890692],
                            [120.590051, 28.881111],
                            [120.579962, 28.869371],
                            [120.56323, 28.861696],
                            [120.542757, 28.867048],
                            [120.533604, 28.866301],
                            [120.533948, 28.879534],
                            [120.525484, 28.878663],
                            [120.514706, 28.890734],
                            [120.509982, 28.874888],
                            [120.494972, 28.86601],
                            [120.502206, 28.857215],
                            [120.498466, 28.849207],
                            [120.486802, 28.846012],
                            [120.481143, 28.828167],
                            [120.473909, 28.839206],
                            [120.441773, 28.841406],
                            [120.426713, 28.831985],
                            [120.418101, 28.851655],
                            [120.406881, 28.845182],
                            [120.404715, 28.853813],
                            [120.392954, 28.847132],
                            [120.392855, 28.834558],
                            [120.388475, 28.829454],
                            [120.368446, 28.838044],
                            [120.357914, 28.839372],
                            [120.347284, 28.858252],
                            [120.338278, 28.860244],
                            [120.331388, 28.868914],
                            [120.316428, 28.876879],
                            [120.315394, 28.887042],
                            [120.303239, 28.892808],
                            [120.314312, 28.9191],
                            [120.303977, 28.931664],
                            [120.277894, 28.930544],
                            [120.271004, 28.950112],
                            [120.264951, 28.93896],
                            [120.255453, 28.931],
                            [120.258603, 28.927103],
                            [120.250729, 28.913792],
                            [120.261752, 28.911429],
                            [120.260719, 28.865471],
                            [120.241821, 28.857256],
                            [120.236506, 28.844808],
                            [120.216526, 28.832608],
                            [120.215148, 28.825885],
                            [120.20186, 28.810029],
                            [120.200335, 28.80181],
                            [120.209341, 28.795832],
                            [120.198858, 28.783958],
                            [120.183553, 28.785162],
                            [120.178435, 28.775239],
                            [120.165344, 28.774325],
                            [120.145561, 28.784],
                            [120.131437, 28.759708],
                            [120.111309, 28.762324],
                            [120.109882, 28.767224],
                            [120.097037, 28.768553],
                            [120.083946, 28.787031],
                            [120.049202, 28.763155],
                            [120.028976, 28.758047],
                            [120.025679, 28.764151],
                            [120.010669, 28.772207],
                            [120.005304, 28.780886],
                            [119.982421, 28.796662],
                            [119.971643, 28.794255],
                            [119.967607, 28.787819],
                            [119.948562, 28.787197],
                            [119.942164, 28.793009],
                            [119.921298, 28.796164],
                            [119.921003, 28.784],
                            [119.906731, 28.768553],
                            [119.89807, 28.750363],
                            [119.886751, 28.744632],
                            [119.882371, 28.7492],
                            [119.87179, 28.742306],
                            [119.874448, 28.73541],
                            [119.86618, 28.718503],
                            [119.849644, 28.716591],
                            [119.826367, 28.695317],
                            [119.813867, 28.68684],
                            [119.811751, 28.65392],
                            [119.794969, 28.632883],
                            [119.777252, 28.630887],
                            [119.764949, 28.638704],
                            [119.752449, 28.635253],
                            [119.749398, 28.622696],
                            [119.772725, 28.608556],
                            [119.773955, 28.603233],
                            [119.767065, 28.588009],
                            [119.754122, 28.592668],
                            [119.7399, 28.591462],
                            [119.739309, 28.584848],
                            [119.720461, 28.56596],
                            [119.717705, 28.553769],
                            [119.707813, 28.545738],
                            [119.703581, 28.533211],
                            [119.674742, 28.530006],
                            [119.660224, 28.539953],
                            [119.644722, 28.541867],
                            [119.638276, 28.528508],
                            [119.629171, 28.525386],
                            [119.613374, 28.5278],
                            [119.574201, 28.523888],
                            [119.568492, 28.532295],
                            [119.542458, 28.532628],
                            [119.535175, 28.543782],
                            [119.53488, 28.555724],
                            [119.514653, 28.561675],
                            [119.498413, 28.54865],
                            [119.494427, 28.554018],
                            [119.498068, 28.584848],
                            [119.509879, 28.603357],
                            [119.507911, 28.615335],
                            [119.488423, 28.626438],
                            [119.482025, 28.639453],
                            [119.468442, 28.633632],
                            [119.461208, 28.634879],
                            [119.455696, 28.650886],
                            [119.462241, 28.661237],
                            [119.458895, 28.683848],
                            [119.46421, 28.70824],
                            [119.460814, 28.73944],
                            [119.463767, 28.742306],
                            [119.479663, 28.739647],
                            [119.473019, 28.749782],
                            [119.470854, 28.765356],
                            [119.430696, 28.755596],
                            [119.421198, 28.749159],
                            [119.413619, 28.751983],
                            [119.412438, 28.76166],
                            [119.387684, 28.786948],
                            [119.371887, 28.784789],
                            [119.368737, 28.774118],
                            [119.359534, 28.768304],
                            [119.358206, 28.761037],
                            [119.346247, 28.757008],
                            [119.338422, 28.761161],
                            [119.327694, 28.779806],
                            [119.328629, 28.800565],
                            [119.322428, 28.800897]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 330800,
                "name": "衢州市",
                "center": [118.87263, 28.941708],
                "centroid": [118.679569, 28.932446],
                "childrenNum": 6,
                "level": "city",
                "parent": {
                    "adcode": 330000
                },
                "subFeatureIndex": 7,
                "acroutes": [100000, 330000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [119.322428, 28.800897],
                            [119.311503, 28.811897],
                            [119.302644, 28.80401],
                            [119.291325, 28.806003],
                            [119.276512, 28.802931],
                            [119.271148, 28.786532],
                            [119.255745, 28.776152],
                            [119.24851, 28.763612],
                            [119.238028, 28.761992],
                            [119.213569, 28.768968],
                            [119.187536, 28.770173],
                            [119.169573, 28.748868],
                            [119.161207, 28.748162],
                            [119.137683, 28.738027],
                            [119.122378, 28.737072],
                            [119.097132, 28.743261],
                            [119.087831, 28.735203],
                            [119.080793, 28.740146],
                            [119.063962, 28.733541],
                            [119.047575, 28.722159],
                            [119.043687, 28.71227],
                            [119.02971, 28.709694],
                            [119.007958, 28.694569],
                            [119.001659, 28.683058],
                            [118.991472, 28.676491],
                            [118.983992, 28.663856],
                            [118.962683, 28.642405],
                            [118.956974, 28.647394],
                            [118.930202, 28.640534],
                            [118.925527, 28.63359],
                            [118.923657, 28.619244],
                            [118.916619, 28.610885],
                            [118.917112, 28.599739],
                            [118.909139, 28.589756],
                            [118.908549, 28.574447],
                            [118.91406, 28.563921],
                            [118.902938, 28.548859],
                            [118.890192, 28.539745],
                            [118.889306, 28.533003],
                            [118.878332, 28.522056],
                            [118.868046, 28.521723],
                            [118.864552, 28.529923],
                            [118.854562, 28.532212],
                            [118.851019, 28.53962],
                            [118.83842, 28.539911],
                            [118.821786, 28.547444],
                            [118.809385, 28.536249],
                            [118.795359, 28.534335],
                            [118.780546, 28.526552],
                            [118.777298, 28.518435],
                            [118.765142, 28.524096],
                            [118.751215, 28.52447],
                            [118.7428, 28.509152],
                            [118.726953, 28.499827],
                            [118.723164, 28.493249],
                            [118.729709, 28.479508],
                            [118.725379, 28.460894],
                            [118.731136, 28.456479],
                            [118.723951, 28.433153],
                            [118.723459, 28.411196],
                            [118.734975, 28.416779],
                            [118.753233, 28.417321],
                            [118.757564, 28.407488],
                            [118.738371, 28.369813],
                            [118.742012, 28.364435],
                            [118.724001, 28.338337],
                            [118.717898, 28.33817],
                            [118.701904, 28.327078],
                            [118.700182, 28.310397],
                            [118.689896, 28.291001],
                            [118.674788, 28.271435],
                            [118.666668, 28.269725],
                            [118.651363, 28.27711],
                            [118.64024, 28.27348],
                            [118.632465, 28.261297],
                            [118.623016, 28.256623],
                            [118.595703, 28.256999],
                            [118.598016, 28.270643],
                            [118.584482, 28.284327],
                            [118.568833, 28.285245],
                            [118.558596, 28.282324],
                            [118.547474, 28.28658],
                            [118.546244, 28.275024],
                            [118.530201, 28.270434],
                            [118.514157, 28.269641],
                            [118.505643, 28.279905],
                            [118.495604, 28.273104],
                            [118.492947, 28.262715],
                            [118.502691, 28.246817],
                            [118.490683, 28.238428],
                            [118.481037, 28.245982],
                            [118.463862, 28.243061],
                            [118.445161, 28.254745],
                            [118.448852, 28.261505],
                            [118.438616, 28.261255],
                            [118.430446, 28.280781],
                            [118.433202, 28.28829],
                            [118.459679, 28.30168],
                            [118.47085, 28.316694],
                            [118.481923, 28.32099],
                            [118.48709, 28.328996],
                            [118.469423, 28.328204],
                            [118.473901, 28.339046],
                            [118.469275, 28.355848],
                            [118.455151, 28.383984],
                            [118.431135, 28.398362],
                            [118.44024, 28.411946],
                            [118.456529, 28.415988],
                            [118.450131, 28.418154],
                            [118.459334, 28.42982],
                            [118.465929, 28.448232],
                            [118.463321, 28.455854],
                            [118.482169, 28.47118],
                            [118.472179, 28.479384],
                            [118.461647, 28.482631],
                            [118.454315, 28.476385],
                            [118.438124, 28.492999],
                            [118.421785, 28.492125],
                            [118.415043, 28.497412],
                            [118.421933, 28.502991],
                            [118.430791, 28.500785],
                            [118.445555, 28.513273],
                            [118.437287, 28.521682],
                            [118.433251, 28.516479],
                            [118.425328, 28.525261],
                            [118.428133, 28.534668],
                            [118.420702, 28.544739],
                            [118.428084, 28.54736],
                            [118.41337, 28.555142],
                            [118.409433, 28.569247],
                            [118.417307, 28.572825],
                            [118.415683, 28.583475],
                            [118.421588, 28.596287],
                            [118.414059, 28.595372],
                            [118.417749, 28.607558],
                            [118.425279, 28.611426],
                            [118.433399, 28.627062],
                            [118.427789, 28.63147],
                            [118.422129, 28.646812],
                            [118.432612, 28.651551],
                            [118.432858, 28.676533],
                            [118.414994, 28.686591],
                            [118.418832, 28.692242],
                            [118.402247, 28.703005],
                            [118.39147, 28.700512],
                            [118.392503, 28.710442],
                            [118.401903, 28.714473],
                            [118.399738, 28.727559],
                            [118.392356, 28.738858],
                            [118.396293, 28.754932],
                            [118.386942, 28.754807],
                            [118.383694, 28.774201],
                            [118.378724, 28.784622],
                            [118.38335, 28.787363],
                            [118.371932, 28.801769],
                            [118.368192, 28.811275],
                            [118.331873, 28.814803],
                            [118.320554, 28.821236],
                            [118.310564, 28.821983],
                            [118.295308, 28.835222],
                            [118.304314, 28.840078],
                            [118.297424, 28.847837],
                            [118.293881, 28.860866],
                            [118.287926, 28.864517],
                            [118.28143, 28.891356],
                            [118.276115, 28.89596],
                            [118.269865, 28.918644],
                            [118.256824, 28.92362],
                            [118.237631, 28.91852],
                            [118.224983, 28.911843],
                            [118.199392, 28.902969],
                            [118.193487, 28.908277],
                            [118.196686, 28.915949],
                            [118.206036, 28.919598],
                            [118.227837, 28.942443],
                            [118.223802, 28.947832],
                            [118.199392, 28.954672],
                            [118.195997, 28.965034],
                            [118.186597, 28.97697],
                            [118.16514, 28.986709],
                            [118.147178, 28.984803],
                            [118.147867, 28.977799],
                            [118.133743, 28.983891],
                            [118.125918, 28.994499],
                            [118.132463, 29.008379],
                            [118.127296, 29.016085],
                            [118.113713, 29.009208],
                            [118.110022, 28.991723],
                            [118.099933, 28.990397],
                            [118.110662, 29.003739],
                            [118.10702, 29.011984],
                            [118.097079, 28.998726],
                            [118.090681, 29.010451],
                            [118.088073, 29.029424],
                            [118.072177, 29.038991],
                            [118.066961, 29.053942],
                            [118.076902, 29.062845],
                            [118.07577, 29.074563],
                            [118.045898, 29.088846],
                            [118.037974, 29.101886],
                            [118.053083, 29.116248],
                            [118.03891, 29.126346],
                            [118.045012, 29.149104],
                            [118.04137, 29.160853],
                            [118.028378, 29.169251],
                            [118.033447, 29.177151],
                            [118.042453, 29.210319],
                            [118.05141, 29.217596],
                            [118.057906, 29.214784],
                            [118.07326, 29.217017],
                            [118.081971, 29.234587],
                            [118.075573, 29.24736],
                            [118.080445, 29.266331],
                            [118.077886, 29.278769],
                            [118.071931, 29.287033],
                            [118.078132, 29.290587],
                            [118.105101, 29.284926],
                            [118.115878, 29.293685],
                            [118.136105, 29.283893],
                            [118.152886, 29.28629],
                            [118.169373, 29.29761],
                            [118.176607, 29.297404],
                            [118.176066, 29.305914],
                            [118.166567, 29.313886],
                            [118.179756, 29.321404],
                            [118.1833, 29.332225],
                            [118.207808, 29.347587],
                            [118.208694, 29.360346],
                            [118.204018, 29.36786],
                            [118.208792, 29.377521],
                            [118.194323, 29.388253],
                            [118.193044, 29.39527],
                            [118.204264, 29.395394],
                            [118.218093, 29.420361],
                            [118.232955, 29.42391],
                            [118.248507, 29.431337],
                            [118.255692, 29.42618],
                            [118.267798, 29.427871],
                            [118.277641, 29.423374],
                            [118.286154, 29.426716],
                            [118.291371, 29.41999],
                            [118.316125, 29.42259],
                            [118.315977, 29.450562],
                            [118.306627, 29.479434],
                            [118.310564, 29.496011],
                            [118.324442, 29.496918],
                            [118.344964, 29.475681],
                            [118.345751, 29.465123],
                            [118.352543, 29.45279],
                            [118.366371, 29.45015],
                            [118.372917, 29.437815],
                            [118.384137, 29.433276],
                            [118.390289, 29.423951],
                            [118.402051, 29.425189],
                            [118.413173, 29.420568],
                            [118.405397, 29.408147],
                            [118.425771, 29.397623],
                            [118.423655, 29.387345],
                            [118.441224, 29.375911],
                            [118.448754, 29.37525],
                            [118.456234, 29.365879],
                            [118.470112, 29.360098],
                            [118.479167, 29.366539],
                            [118.488813, 29.367241],
                            [118.505742, 29.359273],
                            [118.517504, 29.363484],
                            [118.524344, 29.36142],
                            [118.519079, 29.344366],
                            [118.528577, 29.345275],
                            [118.55151, 29.335694],
                            [118.571687, 29.338337],
                            [118.589059, 29.327888],
                            [118.596047, 29.330821],
                            [118.603823, 29.323552],
                            [118.603478, 29.316447],
                            [118.617209, 29.303146],
                            [118.614404, 29.296577],
                            [118.634138, 29.272984],
                            [118.63276, 29.263149],
                            [118.619177, 29.276786],
                            [118.610614, 29.279472],
                            [118.606677, 29.267116],
                            [118.615437, 29.25075],
                            [118.607612, 29.239713],
                            [118.620112, 29.219291],
                            [118.631825, 29.219622],
                            [118.633646, 29.205605],
                            [118.626855, 29.19568],
                            [118.638321, 29.192165],
                            [118.670162, 29.200518],
                            [118.68463, 29.202545],
                            [118.708843, 29.188774],
                            [118.743735, 29.213668],
                            [118.753036, 29.213875],
                            [118.765438, 29.220614],
                            [118.767259, 29.234133],
                            [118.763912, 29.248311],
                            [118.774985, 29.250998],
                            [118.784778, 29.259099],
                            [118.786402, 29.266744],
                            [118.793637, 29.267943],
                            [118.816865, 29.281703],
                            [118.82656, 29.280298],
                            [118.828775, 29.287446],
                            [118.855743, 29.303311],
                            [118.860664, 29.31496],
                            [118.878332, 29.326567],
                            [118.886354, 29.322354],
                            [118.900428, 29.332638],
                            [118.927053, 29.310375],
                            [118.94408, 29.306286],
                            [118.948017, 29.301122],
                            [118.962092, 29.296164],
                            [118.961895, 29.290215],
                            [118.949641, 29.281744],
                            [118.963322, 29.267653],
                            [118.966816, 29.269348],
                            [118.988224, 29.243558],
                            [118.984828, 29.239465],
                            [118.987141, 29.226071],
                            [118.998903, 29.216355],
                            [119.003234, 29.207714],
                            [119.013076, 29.212386],
                            [119.030596, 29.215074],
                            [119.062929, 29.226278],
                            [119.075675, 29.224004],
                            [119.085222, 29.230578],
                            [119.106384, 29.227518],
                            [119.12351, 29.236737],
                            [119.132565, 29.235456],
                            [119.12912, 29.227063],
                            [119.138126, 29.220242],
                            [119.151758, 29.22789],
                            [119.170459, 29.217596],
                            [119.177693, 29.207259],
                            [119.189504, 29.205191],
                            [119.194918, 29.216314],
                            [119.189504, 29.227105],
                            [119.201709, 29.229379],
                            [119.204465, 29.223549],
                            [119.213668, 29.225203],
                            [119.210272, 29.23066],
                            [119.2148, 29.246947],
                            [119.200922, 29.257487],
                            [119.192211, 29.258479],
                            [119.20038, 29.272158],
                            [119.200282, 29.29038],
                            [119.208156, 29.284389],
                            [119.228727, 29.284182],
                            [119.227103, 29.276827],
                            [119.239308, 29.258933],
                            [119.237782, 29.250708],
                            [119.260912, 29.247815],
                            [119.244918, 29.228634],
                            [119.234928, 29.221937],
                            [119.233353, 29.195845],
                            [119.242162, 29.189683],
                            [119.241522, 29.165735],
                            [119.253333, 29.154772],
                            [119.251119, 29.141656],
                            [119.267162, 29.133919],
                            [119.267703, 29.119104],
                            [119.282762, 29.118317],
                            [119.292507, 29.105901],
                            [119.302595, 29.100893],
                            [119.299987, 29.090709],
                            [119.305351, 29.085617],
                            [119.32602, 29.086238],
                            [119.332517, 29.075971],
                            [119.327841, 29.067649],
                            [119.334288, 29.052369],
                            [119.332369, 29.043423],
                            [119.334682, 29.022216],
                            [119.327349, 29.03808],
                            [119.321542, 29.00059],
                            [119.328038, 28.987579],
                            [119.325922, 28.979125],
                            [119.316621, 28.970256],
                            [119.304613, 28.969345],
                            [119.311503, 28.959853],
                            [119.315587, 28.943231],
                            [119.327152, 28.924739],
                            [119.333796, 28.907945],
                            [119.34546, 28.899734],
                            [119.333599, 28.865181],
                            [119.319672, 28.867794],
                            [119.310912, 28.85124],
                            [119.311306, 28.842153],
                            [119.331926, 28.846966],
                            [119.338028, 28.843149],
                            [119.336355, 28.835222],
                            [119.345558, 28.827711],
                            [119.331631, 28.807912],
                            [119.322428, 28.800897]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 330900,
                "name": "舟山市",
                "center": [122.106863, 30.016028],
                "centroid": [122.146626, 30.056537],
                "childrenNum": 4,
                "level": "city",
                "parent": {
                    "adcode": 330000
                },
                "subFeatureIndex": 8,
                "acroutes": [100000, 330000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [122.256887, 30.065104],
                            [122.269929, 30.062439],
                            [122.291632, 30.065145],
                            [122.31176, 30.038656],
                            [122.32677, 30.031848],
                            [122.334102, 30.021266],
                            [122.343896, 30.020446],
                            [122.346898, 30.011544],
                            [122.340303, 30.006539],
                            [122.344289, 29.995257],
                            [122.341287, 29.976834],
                            [122.331986, 29.962183],
                            [122.324112, 29.941291],
                            [122.308955, 29.943466],
                            [122.279033, 29.937514],
                            [122.239958, 29.962593],
                            [122.192616, 29.978886],
                            [122.168944, 29.989103],
                            [122.139958, 29.987092],
                            [122.120863, 29.98381],
                            [122.108806, 30.00494],
                            [122.092468, 30.006786],
                            [122.073422, 30.005145],
                            [122.038875, 29.989595],
                            [122.026424, 29.992426],
                            [122.012005, 30.021184],
                            [121.99857, 30.037548],
                            [121.981247, 30.048826],
                            [121.978196, 30.059282],
                            [121.992221, 30.074656],
                            [121.983461, 30.100316],
                            [121.948471, 30.147888],
                            [121.935085, 30.16161],
                            [121.936414, 30.167795],
                            [121.949997, 30.176068],
                            [121.955164, 30.184012],
                            [121.977211, 30.174471],
                            [121.996306, 30.161405],
                            [122.036808, 30.148912],
                            [122.048767, 30.147233],
                            [122.072684, 30.154114],
                            [122.095716, 30.158088],
                            [122.110922, 30.154811],
                            [122.119978, 30.14924],
                            [122.121454, 30.141088],
                            [122.133019, 30.136622],
                            [122.144879, 30.118798],
                            [122.156641, 30.112611],
                            [122.169486, 30.117118],
                            [122.182429, 30.117036],
                            [122.191631, 30.108677],
                            [122.240746, 30.108103],
                            [122.258315, 30.098595],
                            [122.279525, 30.102857],
                            [122.293896, 30.100316],
                            [122.304083, 30.086544],
                            [122.290943, 30.074451],
                            [122.281642, 30.077403],
                            [122.265943, 30.076214],
                            [122.256543, 30.071828],
                            [122.256887, 30.065104]
                        ]
                    ],
                    [
                        [
                            [122.625097, 30.817539],
                            [122.615845, 30.82474],
                            [122.622243, 30.826001],
                            [122.636269, 30.819939],
                            [122.637745, 30.814447],
                            [122.625097, 30.817539]
                        ]
                    ],
                    [
                        [
                            [122.150932, 30.190073],
                            [122.166484, 30.198385],
                            [122.176621, 30.199982],
                            [122.178196, 30.191752],
                            [122.196356, 30.193635],
                            [122.218206, 30.188885],
                            [122.204181, 30.18176],
                            [122.208118, 30.175167],
                            [122.197586, 30.175904],
                            [122.184495, 30.163453],
                            [122.190696, 30.161078],
                            [122.176474, 30.155138],
                            [122.170125, 30.139121],
                            [122.162891, 30.137933],
                            [122.150686, 30.146659],
                            [122.1436, 30.166935],
                            [122.150932, 30.190073]
                        ]
                    ],
                    [
                        [
                            [122.207773, 29.70316],
                            [122.208216, 29.715627],
                            [122.217813, 29.711759],
                            [122.226179, 29.714105],
                            [122.232773, 29.706122],
                            [122.229624, 29.701637],
                            [122.262301, 29.688057],
                            [122.281642, 29.688633],
                            [122.277606, 29.677933],
                            [122.270864, 29.685135],
                            [122.250391, 29.688139],
                            [122.24611, 29.67999],
                            [122.229082, 29.693489],
                            [122.207773, 29.70316]
                        ]
                    ],
                    [
                        [
                            [122.427607, 30.738538],
                            [122.432183, 30.742325],
                            [122.450441, 30.743017],
                            [122.460432, 30.730272],
                            [122.467075, 30.730272],
                            [122.473621, 30.715204],
                            [122.486514, 30.711132],
                            [122.504871, 30.713249],
                            [122.50615, 30.720051],
                            [122.528345, 30.724897],
                            [122.536268, 30.717567],
                            [122.526672, 30.713983],
                            [122.539664, 30.703678],
                            [122.535186, 30.698301],
                            [122.513778, 30.702049],
                            [122.510136, 30.69492],
                            [122.499605, 30.70323],
                            [122.490501, 30.695775],
                            [122.487154, 30.701193],
                            [122.4499, 30.691457],
                            [122.444241, 30.697079],
                            [122.437055, 30.691743],
                            [122.427607, 30.69602],
                            [122.430264, 30.706529],
                            [122.442518, 30.716345],
                            [122.441681, 30.733082],
                            [122.427607, 30.738538]
                        ]
                    ],
                    [
                        [
                            [122.163088, 30.329809],
                            [122.173816, 30.337578],
                            [122.178147, 30.350579],
                            [122.18174, 30.340971],
                            [122.191877, 30.337414],
                            [122.191287, 30.329155],
                            [122.209003, 30.32985],
                            [122.213383, 30.33443],
                            [122.228344, 30.329564],
                            [122.221602, 30.324657],
                            [122.231887, 30.305968],
                            [122.248177, 30.304496],
                            [122.239466, 30.296479],
                            [122.224456, 30.290425],
                            [122.231395, 30.277989],
                            [122.237202, 30.277007],
                            [122.229427, 30.260436],
                            [122.230116, 30.23269],
                            [122.208856, 30.229129],
                            [122.208413, 30.235514],
                            [122.199604, 30.234327],
                            [122.194141, 30.24374],
                            [122.146356, 30.246237],
                            [122.134446, 30.251884],
                            [122.101031, 30.275084],
                            [122.057822, 30.291775],
                            [122.051867, 30.300078],
                            [122.058511, 30.304618],
                            [122.06791, 30.301714],
                            [122.092812, 30.299996],
                            [122.124357, 30.319995],
                            [122.133019, 30.314515],
                            [122.137743, 30.32159],
                            [122.144043, 30.315538],
                            [122.163088, 30.329809]
                        ]
                    ],
                    [
                        [
                            [122.317468, 30.249593],
                            [122.318699, 30.26551],
                            [122.322685, 30.26997],
                            [122.349457, 30.267392],
                            [122.358807, 30.271238],
                            [122.385727, 30.270993],
                            [122.400343, 30.275657],
                            [122.407233, 30.27267],
                            [122.409595, 30.25704],
                            [122.429477, 30.250861],
                            [122.418798, 30.246278],
                            [122.417174, 30.23887],
                            [122.407725, 30.236005],
                            [122.408217, 30.227778],
                            [122.397193, 30.225241],
                            [122.391534, 30.239893],
                            [122.381986, 30.238134],
                            [122.380707, 30.253889],
                            [122.363236, 30.254871],
                            [122.362055, 30.239566],
                            [122.34862, 30.233222],
                            [122.336809, 30.23576],
                            [122.32923, 30.230193],
                            [122.318403, 30.236455],
                            [122.309004, 30.23531],
                            [122.305559, 30.228883],
                            [122.298472, 30.234082],
                            [122.29173, 30.226509],
                            [122.284545, 30.226837],
                            [122.275982, 30.23535],
                            [122.278, 30.243004],
                            [122.317468, 30.249593]
                        ]
                    ],
                    [
                        [
                            [122.675245, 30.848779],
                            [122.679133, 30.861102],
                            [122.690108, 30.849105],
                            [122.698523, 30.848128],
                            [122.695472, 30.839018],
                            [122.687991, 30.838082],
                            [122.669192, 30.845566],
                            [122.675245, 30.848779]
                        ]
                    ],
                    [
                        [
                            [122.782824, 30.789748],
                            [122.782135, 30.7823],
                            [122.775689, 30.788038],
                            [122.782824, 30.789748]
                        ]
                    ],
                    [
                        [
                            [122.331002, 29.938089],
                            [122.351868, 29.959105],
                            [122.356691, 29.950321],
                            [122.372734, 29.954139],
                            [122.377164, 29.949008],
                            [122.397882, 29.939648],
                            [122.401573, 29.945806],
                            [122.410235, 29.94478],
                            [122.408955, 29.951429],
                            [122.424309, 29.945765],
                            [122.420618, 29.937309],
                            [122.430215, 29.916904],
                            [122.410923, 29.91793],
                            [122.41363, 29.912551],
                            [122.43489, 29.906227],
                            [122.432085, 29.893989],
                            [122.434053, 29.883557],
                            [122.418601, 29.881462],
                            [122.41929, 29.873082],
                            [122.401819, 29.870042],
                            [122.398079, 29.853609],
                            [122.413236, 29.84835],
                            [122.416189, 29.828995],
                            [122.386366, 29.834009],
                            [122.378345, 29.84309],
                            [122.369978, 29.862031],
                            [122.376819, 29.871151],
                            [122.376327, 29.88676],
                            [122.372341, 29.893209],
                            [122.362744, 29.8944],
                            [122.341337, 29.908198],
                            [122.327213, 29.923103],
                            [122.331002, 29.938089]
                        ]
                    ],
                    [
                        [
                            [122.430412, 30.408653],
                            [122.41112, 30.411268],
                            [122.404821, 30.4176],
                            [122.387695, 30.417477],
                            [122.378295, 30.413556],
                            [122.375441, 30.419357],
                            [122.365156, 30.417151],
                            [122.352409, 30.421971],
                            [122.348079, 30.410696],
                            [122.318305, 30.407182],
                            [122.285923, 30.417028],
                            [122.280411, 30.420337],
                            [122.279378, 30.444477],
                            [122.281838, 30.460118],
                            [122.278689, 30.474369],
                            [122.287596, 30.47739],
                            [122.303984, 30.46657],
                            [122.314959, 30.470245],
                            [122.337006, 30.465794],
                            [122.35615, 30.464651],
                            [122.372734, 30.47886],
                            [122.383414, 30.472858],
                            [122.373817, 30.46167],
                            [122.381445, 30.455953],
                            [122.402459, 30.458281],
                            [122.411268, 30.452686],
                            [122.432282, 30.445376],
                            [122.428542, 30.430549],
                            [122.432725, 30.420092],
                            [122.440796, 30.413556],
                            [122.430412, 30.408653]
                        ]
                    ],
                    [
                        [
                            [122.327163, 30.519474],
                            [122.340008, 30.522371],
                            [122.34611, 30.528044],
                            [122.343699, 30.504006],
                            [122.31924, 30.512781],
                            [122.317518, 30.518046],
                            [122.327163, 30.519474]
                        ]
                    ],
                    [
                        [
                            [122.450737, 30.426097],
                            [122.459693, 30.426424],
                            [122.46427, 30.436799],
                            [122.476081, 30.436023],
                            [122.474211, 30.429528],
                            [122.485727, 30.415762],
                            [122.469634, 30.414413],
                            [122.450737, 30.426097]
                        ]
                    ],
                    [
                        [
                            [122.477361, 30.229784],
                            [122.489516, 30.231298],
                            [122.503493, 30.22565],
                            [122.503197, 30.215907],
                            [122.481445, 30.221147],
                            [122.477361, 30.229784]
                        ]
                    ],
                    [
                        [
                            [122.264762, 29.845391],
                            [122.282527, 29.845515],
                            [122.302065, 29.838488],
                            [122.302951, 29.83368],
                            [122.319289, 29.829447],
                            [122.323768, 29.821844],
                            [122.318354, 29.817857],
                            [122.297882, 29.81798],
                            [122.297045, 29.811486],
                            [122.31614, 29.806389],
                            [122.309447, 29.794098],
                            [122.328443, 29.777693],
                            [122.317222, 29.774198],
                            [122.310136, 29.766796],
                            [122.296799, 29.778968],
                            [122.28484, 29.779667],
                            [122.267862, 29.792782],
                            [122.248571, 29.804334],
                            [122.24109, 29.820323],
                            [122.23046, 29.822707],
                            [122.221257, 29.835817],
                            [122.234446, 29.846542],
                            [122.248374, 29.848761],
                            [122.264762, 29.845391]
                        ]
                    ],
                    [
                        [
                            [122.302951, 30.499108],
                            [122.321848, 30.49425],
                            [122.31427, 30.491066],
                            [122.302951, 30.499108]
                        ]
                    ],
                    [
                        [
                            [122.217222, 29.638577],
                            [122.231002, 29.634748],
                            [122.21983, 29.629971],
                            [122.217222, 29.638577]
                        ]
                    ],
                    [
                        [
                            [122.703247, 30.19732],
                            [122.704724, 30.207065],
                            [122.711564, 30.209357],
                            [122.70807, 30.188476],
                            [122.703247, 30.19732]
                        ]
                    ],
                    [
                        [
                            [122.426918, 30.032094],
                            [122.428197, 30.038656],
                            [122.433463, 30.022004],
                            [122.426918, 30.032094]
                        ]
                    ],
                    [
                        [
                            [122.189564, 29.810007],
                            [122.183708, 29.815186],
                            [122.190598, 29.820652],
                            [122.201179, 29.815227],
                            [122.195618, 29.804704],
                            [122.189564, 29.810007]
                        ]
                    ],
                    [
                        [
                            [122.470766, 30.730069],
                            [122.46678, 30.742936],
                            [122.452115, 30.743343],
                            [122.452607, 30.757592],
                            [122.470077, 30.752585],
                            [122.46801, 30.744035],
                            [122.470766, 30.730069]
                        ]
                    ],
                    [
                        [
                            [122.52554, 30.221557],
                            [122.516682, 30.231339],
                            [122.529428, 30.230439],
                            [122.52554, 30.221557]
                        ]
                    ],
                    [
                        [
                            [122.269683, 30.222621],
                            [122.274653, 30.230234],
                            [122.282823, 30.227942],
                            [122.269683, 30.222621]
                        ]
                    ],
                    [
                        [
                            [122.636072, 30.204281],
                            [122.640895, 30.210913],
                            [122.650344, 30.210995],
                            [122.654527, 30.189704],
                            [122.646308, 30.18692],
                            [122.643848, 30.197853],
                            [122.636072, 30.204281]
                        ]
                    ],
                    [
                        [
                            [121.943697, 30.77709],
                            [121.969731, 30.789178],
                            [121.987989, 30.753318],
                            [121.990794, 30.739353],
                            [121.988235, 30.711172],
                            [121.992812, 30.695368],
                            [122.010971, 30.669497],
                            [122.024357, 30.662489],
                            [122.034495, 30.661633],
                            [122.063284, 30.650222],
                            [122.072536, 30.649448],
                            [122.081592, 30.639666],
                            [122.07918, 30.634775],
                            [122.102113, 30.622994],
                            [122.11358, 30.621078],
                            [122.113629, 30.613781],
                            [122.12672, 30.609826],
                            [122.134298, 30.612394],
                            [122.136907, 30.600244],
                            [122.133265, 30.595514],
                            [122.123078, 30.598368],
                            [122.090745, 30.600325],
                            [122.071011, 30.611294],
                            [122.052851, 30.625399],
                            [122.024406, 30.643701],
                            [122.015007, 30.645291],
                            [121.997044, 30.658821],
                            [121.968205, 30.688361],
                            [121.961119, 30.705877],
                            [121.958609, 30.740493],
                            [121.955607, 30.75686],
                            [121.943697, 30.77709]
                        ]
                    ],
                    [
                        [
                            [122.18233, 29.650764],
                            [122.174358, 29.659945],
                            [122.158117, 29.655293],
                            [122.141484, 29.660521],
                            [122.132822, 29.668548],
                            [122.133117, 29.683036],
                            [122.125686, 29.693119],
                            [122.111168, 29.70032],
                            [122.109052, 29.713899],
                            [122.095962, 29.716491],
                            [122.079968, 29.70139],
                            [122.073816, 29.701802],
                            [122.047881, 29.717972],
                            [122.065155, 29.749893],
                            [122.071405, 29.7728],
                            [122.083659, 29.783203],
                            [122.10856, 29.783655],
                            [122.120863, 29.790973],
                            [122.131395, 29.78863],
                            [122.137842, 29.774527],
                            [122.141385, 29.75779],
                            [122.146651, 29.749647],
                            [122.182133, 29.728833],
                            [122.200785, 29.711183],
                            [122.211366, 29.692255],
                            [122.192517, 29.655334],
                            [122.18233, 29.650764]
                        ]
                    ],
                    [
                        [
                            [122.232626, 29.682666],
                            [122.24296, 29.675298],
                            [122.234594, 29.672005],
                            [122.232626, 29.682666]
                        ]
                    ],
                    [
                        [
                            [122.358807, 30.600081],
                            [122.374358, 30.587399],
                            [122.356543, 30.593353],
                            [122.358807, 30.600081]
                        ]
                    ],
                    [
                        [
                            [122.077901, 30.596411],
                            [122.100096, 30.592415],
                            [122.082231, 30.587236],
                            [122.085233, 30.578834],
                            [122.071749, 30.572553],
                            [122.055607, 30.585482],
                            [122.055164, 30.591681],
                            [122.077901, 30.596411]
                        ]
                    ],
                    [
                        [
                            [122.36176, 29.839556],
                            [122.376868, 29.841734],
                            [122.371209, 29.835529],
                            [122.378788, 29.834379],
                            [122.375933, 29.825748],
                            [122.369289, 29.828091],
                            [122.36176, 29.839556]
                        ]
                    ],
                    [
                        [
                            [122.229968, 29.661056],
                            [122.243502, 29.661015],
                            [122.245913, 29.654716],
                            [122.229968, 29.661056]
                        ]
                    ],
                    [
                        [
                            [122.461367, 29.943877],
                            [122.456987, 29.92569],
                            [122.449162, 29.939238],
                            [122.459546, 29.948638],
                            [122.461367, 29.943877]
                        ]
                    ],
                    [
                        [
                            [122.570717, 30.644313],
                            [122.547046, 30.650752],
                            [122.54803, 30.663467],
                            [122.555757, 30.667419],
                            [122.558709, 30.679072],
                            [122.575639, 30.66583],
                            [122.587893, 30.665341],
                            [122.582922, 30.655113],
                            [122.568798, 30.65442],
                            [122.570717, 30.644313]
                        ]
                    ],
                    [
                        [
                            [122.179377, 30.226428],
                            [122.186956, 30.230644],
                            [122.200244, 30.226755],
                            [122.204574, 30.214106],
                            [122.190942, 30.212264],
                            [122.186415, 30.21779],
                            [122.179082, 30.214884],
                            [122.179377, 30.226428]
                        ]
                    ],
                    [
                        [
                            [122.424949, 30.6212],
                            [122.432725, 30.61745],
                            [122.423965, 30.612272],
                            [122.424949, 30.6212]
                        ]
                    ],
                    [
                        [
                            [122.209003, 30.222375],
                            [122.216681, 30.22082],
                            [122.225441, 30.229293],
                            [122.23735, 30.232322],
                            [122.245322, 30.218405],
                            [122.228295, 30.220451],
                            [122.215746, 30.218036],
                            [122.209003, 30.222375]
                        ]
                    ],
                    [
                        [
                            [122.15546, 29.619429],
                            [122.160824, 29.619346],
                            [122.152704, 29.60695],
                            [122.14419, 29.608474],
                            [122.15546, 29.619429]
                        ]
                    ],
                    [
                        [
                            [122.065204, 30.179631],
                            [122.059003, 30.17832],
                            [122.033068, 30.161201],
                            [122.024013, 30.162593],
                            [122.017664, 30.186469],
                            [122.030115, 30.198057],
                            [122.040056, 30.196051],
                            [122.04291, 30.201497],
                            [122.055755, 30.200309],
                            [122.065696, 30.192202],
                            [122.065204, 30.179631]
                        ]
                    ],
                    [
                        [
                            [122.391484, 29.970309],
                            [122.376819, 29.973305],
                            [122.367813, 29.980486],
                            [122.372291, 29.988364],
                            [122.373128, 30.001658],
                            [122.380018, 30.024506],
                            [122.397784, 30.026721],
                            [122.40861, 30.031725],
                            [122.41053, 30.024301],
                            [122.403345, 30.0154],
                            [122.41801, 30.006293],
                            [122.414418, 29.998458],
                            [122.39675, 29.999114],
                            [122.393502, 29.985123],
                            [122.398571, 29.975151],
                            [122.391484, 29.970309]
                        ]
                    ],
                    [
                        [
                            [121.888087, 30.092078],
                            [121.880114, 30.085274],
                            [121.893402, 30.082691],
                            [121.89537, 30.073303],
                            [121.906935, 30.055797],
                            [121.915597, 30.057273],
                            [121.92475, 30.052598],
                            [121.924849, 30.037877],
                            [121.934199, 30.011749],
                            [121.932821, 29.994806],
                            [121.915646, 29.984097],
                            [121.890941, 29.974495],
                            [121.874258, 29.96481],
                            [121.850882, 29.969652],
                            [121.85039, 29.977285],
                            [121.837004, 29.987174],
                            [121.835232, 29.993001],
                            [121.844041, 30.007893],
                            [121.843156, 30.02869],
                            [121.839809, 30.047268],
                            [121.854081, 30.068179],
                            [121.848667, 30.101218],
                            [121.85979, 30.10171],
                            [121.885774, 30.094742],
                            [121.888087, 30.092078]
                        ]
                    ],
                    [
                        [
                            [122.325638, 30.226919],
                            [122.335628, 30.227778],
                            [122.332183, 30.220247],
                            [122.325638, 30.226919]
                        ]
                    ],
                    [
                        [
                            [121.830803, 30.066375],
                            [121.821994, 30.082076],
                            [121.833264, 30.082855],
                            [121.844927, 30.077239],
                            [121.852506, 30.065596],
                            [121.847437, 30.06166],
                            [121.830803, 30.066375]
                        ]
                    ],
                    [
                        [
                            [122.038235, 29.759229],
                            [122.043944, 29.753801],
                            [122.043599, 29.742654],
                            [122.031837, 29.736814],
                            [122.029721, 29.716944],
                            [122.016335, 29.714475],
                            [122.011365, 29.74611],
                            [122.024357, 29.756844],
                            [122.038235, 29.759229]
                        ]
                    ],
                    [
                        [
                            [122.32239, 29.83257],
                            [122.323965, 29.839515],
                            [122.332872, 29.826652],
                            [122.32239, 29.83257]
                        ]
                    ],
                    [
                        [
                            [122.716486, 30.17574],
                            [122.72185, 30.181965],
                            [122.728051, 30.17271],
                            [122.718553, 30.168368],
                            [122.716486, 30.17574]
                        ]
                    ],
                    [
                        [
                            [122.514516, 30.649],
                            [122.522784, 30.643579],
                            [122.514221, 30.641786],
                            [122.514516, 30.649]
                        ]
                    ],
                    [
                        [
                            [122.1436, 30.610927],
                            [122.13607, 30.61533],
                            [122.149997, 30.619081],
                            [122.1436, 30.610927]
                        ]
                    ],
                    [
                        [
                            [121.940351, 30.114537],
                            [121.950341, 30.113594],
                            [121.963481, 30.10339],
                            [121.957674, 30.084659],
                            [121.945961, 30.064448],
                            [121.928638, 30.06658],
                            [121.929623, 30.078469],
                            [121.916483, 30.083265],
                            [121.911266, 30.095685],
                            [121.923323, 30.106628],
                            [121.940351, 30.114537]
                        ]
                    ],
                    [
                        [
                            [121.957428, 30.287684],
                            [121.931542, 30.304414],
                            [121.921502, 30.307563],
                            [121.940252, 30.331731],
                            [121.976079, 30.337619],
                            [121.981001, 30.343384],
                            [121.989121, 30.340031],
                            [121.986168, 30.331036],
                            [121.992763, 30.328092],
                            [122.000883, 30.308504],
                            [121.989022, 30.289525],
                            [121.979869, 30.288502],
                            [121.968304, 30.294556],
                            [121.957428, 30.287684]
                        ]
                    ],
                    [
                        [
                            [122.526278, 30.666767],
                            [122.533365, 30.672268],
                            [122.544881, 30.663344],
                            [122.540894, 30.657884],
                            [122.526278, 30.666767]
                        ]
                    ],
                    [
                        [
                            [122.680856, 30.190523],
                            [122.673178, 30.208334],
                            [122.687007, 30.205345],
                            [122.694094, 30.187698],
                            [122.689222, 30.180982],
                            [122.688434, 30.191301],
                            [122.680856, 30.190523]
                        ]
                    ],
                    [
                        [
                            [122.226572, 29.808856],
                            [122.239023, 29.801867],
                            [122.224702, 29.801867],
                            [122.226572, 29.808856]
                        ]
                    ],
                    [
                        [
                            [122.41678, 30.682047],
                            [122.435431, 30.674672],
                            [122.425737, 30.668886],
                            [122.408807, 30.672472],
                            [122.41678, 30.682047]
                        ]
                    ],
                    [
                        [
                            [122.178492, 29.978393],
                            [122.193255, 29.965179],
                            [122.195962, 29.958694],
                            [122.182921, 29.955288],
                            [122.170765, 29.966164],
                            [122.154426, 29.971253],
                            [122.14355, 29.968462],
                            [122.141877, 29.974823],
                            [122.16924, 29.988241],
                            [122.178492, 29.978393]
                        ]
                    ],
                    [
                        [
                            [121.618106, 30.604811],
                            [121.617712, 30.60848],
                            [121.637397, 30.608847],
                            [121.618106, 30.604811]
                        ]
                    ],
                    [
                        [
                            [122.127802, 30.218364],
                            [122.146946, 30.222007],
                            [122.151917, 30.21603],
                            [122.140647, 30.214393],
                            [122.129476, 30.207433],
                            [122.127802, 30.218364]
                        ]
                    ],
                    [
                        [
                            [121.863825, 30.116955],
                            [121.870567, 30.106628],
                            [121.861168, 30.104292],
                            [121.863825, 30.116955]
                        ]
                    ],
                    [
                        [
                            [122.225047, 29.738294],
                            [122.234299, 29.739775],
                            [122.241287, 29.731918],
                            [122.233561, 29.731013],
                            [122.225047, 29.738294]
                        ]
                    ],
                    [
                        [
                            [122.197734, 29.726776],
                            [122.206789, 29.728833],
                            [122.219683, 29.724102],
                            [122.217124, 29.717355],
                            [122.197734, 29.726776]
                        ]
                    ],
                    [
                        [
                            [122.759941, 30.137073],
                            [122.763435, 30.142112],
                            [122.773326, 30.140432],
                            [122.784793, 30.12601],
                            [122.767126, 30.12347],
                            [122.759941, 30.137073]
                        ]
                    ],
                    [
                        [
                            [122.287941, 29.723938],
                            [122.269978, 29.730725],
                            [122.251573, 29.731178],
                            [122.238236, 29.741996],
                            [122.213285, 29.771525],
                            [122.21422, 29.780366],
                            [122.233856, 29.784477],
                            [122.246159, 29.783367],
                            [122.261021, 29.773622],
                            [122.255706, 29.76108],
                            [122.258364, 29.753307],
                            [122.280017, 29.746233],
                            [122.296602, 29.749606],
                            [122.309545, 29.743518],
                            [122.313187, 29.731466],
                            [122.296848, 29.729985],
                            [122.287941, 29.723938]
                        ]
                    ],
                    [
                        [
                            [122.153836, 30.578957],
                            [122.156739, 30.584503],
                            [122.167862, 30.583687],
                            [122.153836, 30.578957]
                        ]
                    ],
                    [
                        [
                            [122.259053, 30.519882],
                            [122.267567, 30.526901],
                            [122.277901, 30.524493],
                            [122.275244, 30.513148],
                            [122.25738, 30.511842],
                            [122.259053, 30.519882]
                        ]
                    ],
                    [
                        [
                            [122.192468, 29.796194],
                            [122.202015, 29.790891],
                            [122.198324, 29.785217],
                            [122.182429, 29.788013],
                            [122.175686, 29.797181],
                            [122.192468, 29.796194]
                        ]
                    ],
                    [
                        [
                            [122.452115, 29.973469],
                            [122.450244, 29.964728],
                            [122.444683, 29.968216],
                            [122.452115, 29.973469]
                        ]
                    ],
                    [
                        [
                            [122.146257, 29.96247],
                            [122.163088, 29.965713],
                            [122.170273, 29.957833],
                            [122.166336, 29.94634],
                            [122.140696, 29.943712],
                            [122.132232, 29.956519],
                            [122.146257, 29.96247]
                        ]
                    ],
                    [
                        [
                            [122.467469, 30.408857],
                            [122.477853, 30.410491],
                            [122.476376, 30.403587],
                            [122.467469, 30.408857]
                        ]
                    ],
                    [
                        [
                            [122.283019, 29.860388],
                            [122.284545, 29.875588],
                            [122.301474, 29.883844],
                            [122.319191, 29.878792],
                            [122.340057, 29.883598],
                            [122.348423, 29.878833],
                            [122.342961, 29.870782],
                            [122.343305, 29.86047],
                            [122.329968, 29.85895],
                            [122.323915, 29.852541],
                            [122.309004, 29.849582],
                            [122.293403, 29.852089],
                            [122.283019, 29.860388]
                        ]
                    ],
                    [
                        [
                            [122.264122, 30.269888],
                            [122.30177, 30.270052],
                            [122.304821, 30.262523],
                            [122.312941, 30.265142],
                            [122.315844, 30.250165],
                            [122.291878, 30.248324],
                            [122.276277, 30.244232],
                            [122.261612, 30.234736],
                            [122.25423, 30.237356],
                            [122.254574, 30.253235],
                            [122.264122, 30.269888]
                        ]
                    ],
                    [
                        [
                            [122.331199, 30.595677],
                            [122.343207, 30.599632],
                            [122.341337, 30.593597],
                            [122.326031, 30.590131],
                            [122.331199, 30.595677]
                        ]
                    ],
                    [
                        [
                            [122.78125, 30.694187],
                            [122.775196, 30.704167],
                            [122.758218, 30.70213],
                            [122.75748, 30.713901],
                            [122.782086, 30.730028],
                            [122.792815, 30.729499],
                            [122.799508, 30.716467],
                            [122.7906, 30.717444],
                            [122.787647, 30.711498],
                            [122.791732, 30.698423],
                            [122.78125, 30.694187]
                        ]
                    ],
                    [
                        [
                            [121.977999, 30.100275],
                            [121.982822, 30.095234],
                            [121.973865, 30.084905],
                            [121.966483, 30.097447],
                            [121.977999, 30.100275]
                        ]
                    ],
                    [
                        [
                            [122.648375, 30.812494],
                            [122.640255, 30.816318],
                            [122.643355, 30.826733],
                            [122.660629, 30.819858],
                            [122.648375, 30.812494]
                        ]
                    ],
                    [
                        [
                            [121.981001, 30.06699],
                            [121.975538, 30.075148],
                            [121.981739, 30.083224],
                            [121.988579, 30.083634],
                            [121.99045, 30.07109],
                            [121.981001, 30.06699]
                        ]
                    ],
                    [
                        [
                            [122.145322, 29.966328],
                            [122.146454, 29.963496],
                            [122.129033, 29.960541],
                            [122.128393, 29.96641],
                            [122.145322, 29.966328]
                        ]
                    ],
                    [
                        [
                            [122.069436, 29.992385],
                            [122.076867, 30.000714],
                            [122.093796, 29.985492],
                            [122.078147, 29.97273],
                            [122.072241, 29.972853],
                            [122.069436, 29.992385]
                        ]
                    ],
                    [
                        [
                            [122.391583, 30.740615],
                            [122.386366, 30.759384],
                            [122.395274, 30.760523],
                            [122.391583, 30.740615]
                        ]
                    ],
                    [
                        [
                            [122.452804, 29.956889],
                            [122.458955, 29.95106],
                            [122.450687, 29.945929],
                            [122.444831, 29.955042],
                            [122.452804, 29.956889]
                        ]
                    ],
                    [
                        [
                            [122.16422, 29.799278],
                            [122.161218, 29.8038],
                            [122.174259, 29.807664],
                            [122.180017, 29.802361],
                            [122.174948, 29.797222],
                            [122.16422, 29.799278]
                        ]
                    ],
                    [
                        [
                            [122.284988, 30.635835],
                            [122.277212, 30.638933],
                            [122.284742, 30.648714],
                            [122.292616, 30.650548],
                            [122.295766, 30.640726],
                            [122.284988, 30.635835]
                        ]
                    ],
                    [
                        [
                            [122.83627, 30.698708],
                            [122.826821, 30.709136],
                            [122.810777, 30.712476],
                            [122.804232, 30.723024],
                            [122.814616, 30.732879],
                            [122.831053, 30.728521],
                            [122.836811, 30.719155],
                            [122.839911, 30.703759],
                            [122.83627, 30.698708]
                        ]
                    ],
                    [
                        [
                            [122.132379, 29.983769],
                            [122.143206, 29.987051],
                            [122.143108, 29.978311],
                            [122.132379, 29.983769]
                        ]
                    ],
                    [
                        [
                            [122.227852, 29.715627],
                            [122.235382, 29.717725],
                            [122.233364, 29.70999],
                            [122.227852, 29.715627]
                        ]
                    ],
                    [
                        [
                            [122.213137, 29.958161],
                            [122.19296, 29.975972],
                            [122.20482, 29.973879],
                            [122.239811, 29.960049],
                            [122.274604, 29.93891],
                            [122.273374, 29.932259],
                            [122.237399, 29.944739],
                            [122.213137, 29.958161]
                        ]
                    ],
                    [
                        [
                            [122.096208, 29.944862],
                            [122.097733, 29.938745],
                            [122.083511, 29.935625],
                            [122.079672, 29.939566],
                            [122.081542, 29.953687],
                            [122.090942, 29.956314],
                            [122.096208, 29.944862]
                        ]
                    ],
                    [
                        [
                            [122.108314, 29.963086],
                            [122.112842, 29.978434],
                            [122.128245, 29.973797],
                            [122.125883, 29.96087],
                            [122.110922, 29.958735],
                            [122.108314, 29.963086]
                        ]
                    ],
                    [
                        [
                            [121.969091, 30.064038],
                            [121.974406, 30.062111],
                            [121.974997, 30.049523],
                            [121.964071, 30.053787],
                            [121.969091, 30.064038]
                        ]
                    ],
                    [
                        [
                            [122.028983, 29.955042],
                            [122.042271, 29.964522],
                            [122.05108, 29.964974],
                            [122.058462, 29.952907],
                            [122.047782, 29.93423],
                            [122.037005, 29.929508],
                            [122.031198, 29.935215],
                            [122.028983, 29.955042]
                        ]
                    ],
                    [
                        [
                            [122.2561, 29.864702],
                            [122.249899, 29.875588],
                            [122.267222, 29.875793],
                            [122.278246, 29.867701],
                            [122.274161, 29.862401],
                            [122.2561, 29.864702]
                        ]
                    ],
                    [
                        [
                            [122.193747, 29.766262],
                            [122.200342, 29.765151],
                            [122.201277, 29.755487],
                            [122.189171, 29.75524],
                            [122.193747, 29.766262]
                        ]
                    ],
                    [
                        [
                            [122.288827, 29.93074],
                            [122.288138, 29.936118],
                            [122.301573, 29.941865],
                            [122.311809, 29.942029],
                            [122.315352, 29.931027],
                            [122.30674, 29.922118],
                            [122.291435, 29.924623],
                            [122.288827, 29.93074]
                        ]
                    ],
                    [
                        [
                            [122.212399, 29.69172],
                            [122.228836, 29.690732],
                            [122.229673, 29.685423],
                            [122.215844, 29.684312],
                            [122.212399, 29.69172]
                        ]
                    ],
                    [
                        [
                            [122.042418, 29.981635],
                            [122.046749, 29.988693],
                            [122.054672, 29.988693],
                            [122.051424, 29.976834],
                            [122.042418, 29.981635]
                        ]
                    ],
                    [
                        [
                            [122.300687, 29.894646],
                            [122.309496, 29.896084],
                            [122.314713, 29.88943],
                            [122.299899, 29.890539],
                            [122.300687, 29.894646]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 331000,
                "name": "台州市",
                "center": [121.428599, 28.661378],
                "centroid": [121.136679, 28.757098],
                "childrenNum": 9,
                "level": "city",
                "parent": {
                    "adcode": 330000
                },
                "subFeatureIndex": 9,
                "acroutes": [100000, 330000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [121.60846, 29.169127],
                            [121.616531, 29.143518],
                            [121.659936, 29.118359],
                            [121.661511, 29.106108],
                            [121.65536, 29.092738],
                            [121.651915, 29.075888],
                            [121.658952, 29.058497],
                            [121.699454, 29.039985],
                            [121.712643, 29.028926],
                            [121.71535, 29.012274],
                            [121.711265, 28.986005],
                            [121.718352, 28.970422],
                            [121.743352, 28.954257],
                            [121.772043, 28.898365],
                            [121.776423, 28.879783],
                            [121.774602, 28.863895],
                            [121.759051, 28.85597],
                            [121.738677, 28.856592],
                            [121.704228, 28.863646],
                            [121.668352, 28.872939],
                            [121.660084, 28.869661],
                            [121.687348, 28.863355],
                            [121.69222, 28.855265],
                            [121.702899, 28.825262],
                            [121.70472, 28.804633],
                            [121.694582, 28.772872],
                            [121.689415, 28.719167],
                            [121.679129, 28.698891],
                            [121.646305, 28.682809],
                            [121.587397, 28.67221],
                            [121.540842, 28.655583],
                            [121.557082, 28.644982],
                            [121.568844, 28.626563],
                            [121.586216, 28.586553],
                            [121.596157, 28.575238],
                            [121.615054, 28.571743],
                            [121.634247, 28.562715],
                            [121.63907, 28.549108],
                            [121.64222, 28.520808],
                            [121.652653, 28.502616],
                            [121.667811, 28.485713],
                            [121.671108, 28.472596],
                            [121.664513, 28.444858],
                            [121.681935, 28.440318],
                            [121.691826, 28.418446],
                            [121.692761, 28.407321],
                            [121.687151, 28.400904],
                            [121.658903, 28.392403],
                            [121.658854, 28.378441],
                            [121.646403, 28.365102],
                            [121.63656, 28.359558],
                            [121.635871, 28.347468],
                            [121.66033, 28.355639],
                            [121.666433, 28.344091],
                            [121.672633, 28.347801],
                            [121.669336, 28.333375],
                            [121.656935, 28.318613],
                            [121.645665, 28.296674],
                            [121.649011, 28.278319],
                            [121.637053, 28.269767],
                            [121.634297, 28.259461],
                            [121.624208, 28.250489],
                            [121.579523, 28.24185],
                            [121.571944, 28.258709],
                            [121.571452, 28.279404],
                            [121.564365, 28.28804],
                            [121.525979, 28.303598],
                            [121.499306, 28.305934],
                            [121.488774, 28.301429],
                            [121.477652, 28.284327],
                            [121.459739, 28.271853],
                            [121.456048, 28.250322],
                            [121.446402, 28.238595],
                            [121.419581, 28.218018],
                            [121.402357, 28.197311],
                            [121.391333, 28.159102],
                            [121.3778, 28.150289],
                            [121.37214, 28.131282],
                            [121.361215, 28.126144],
                            [121.343154, 28.127397],
                            [121.33774, 28.135961],
                            [121.328144, 28.134165],
                            [121.310083, 28.110726],
                            [121.307425, 28.088494],
                            [121.297829, 28.06446],
                            [121.282278, 28.054636],
                            [121.261165, 28.034442],
                            [121.238675, 28.028838],
                            [121.176175, 28.022315],
                            [121.149797, 28.025284],
                            [121.140988, 28.031389],
                            [121.13587, 28.050581],
                            [121.135279, 28.070522],
                            [121.121106, 28.125266],
                            [121.108409, 28.139011],
                            [121.123271, 28.148117],
                            [121.136805, 28.168583],
                            [121.146401, 28.236133],
                            [121.147385, 28.263132],
                            [121.155358, 28.274064],
                            [121.173911, 28.277485],
                            [121.205949, 28.318654],
                            [121.21589, 28.351512],
                            [121.204866, 28.368437],
                            [121.222041, 28.372897],
                            [121.227553, 28.384818],
                            [121.246155, 28.385776],
                            [121.251274, 28.405279],
                            [121.25772, 28.408113],
                            [121.236165, 28.422696],
                            [121.222829, 28.422029],
                            [121.226815, 28.435569],
                            [121.214413, 28.43836],
                            [121.206096, 28.455979],
                            [121.209098, 28.458853],
                            [121.19463, 28.467099],
                            [121.195171, 28.473012],
                            [121.180949, 28.478343],
                            [121.16958, 28.505905],
                            [121.156736, 28.520475],
                            [121.145565, 28.523929],
                            [121.129866, 28.521723],
                            [121.121352, 28.532503],
                            [121.104816, 28.537289],
                            [121.088182, 28.51727],
                            [121.085131, 28.500993],
                            [121.078734, 28.495331],
                            [121.076864, 28.484089],
                            [121.070417, 28.480341],
                            [121.049895, 28.478259],
                            [121.036115, 28.481715],
                            [121.025436, 28.472763],
                            [121.01771, 28.478592],
                            [121.002946, 28.478717],
                            [120.99517, 28.473346],
                            [120.98705, 28.481715],
                            [120.965593, 28.482965],
                            [120.95767, 28.494831],
                            [120.962198, 28.509027],
                            [120.954471, 28.509027],
                            [120.954028, 28.498911],
                            [120.944776, 28.503449],
                            [120.92765, 28.505031],
                            [120.914412, 28.495997],
                            [120.91082, 28.48921],
                            [120.894481, 28.485546],
                            [120.86953, 28.491167],
                            [120.854323, 28.515313],
                            [120.845071, 28.514189],
                            [120.83267, 28.524595],
                            [120.843054, 28.542034],
                            [120.829225, 28.555558],
                            [120.825829, 28.566335],
                            [120.802601, 28.572201],
                            [120.798221, 28.576528],
                            [120.798713, 28.588758],
                            [120.793644, 28.583766],
                            [120.782916, 28.590547],
                            [120.758703, 28.591586],
                            [120.757817, 28.604314],
                            [120.743496, 28.611592],
                            [120.729372, 28.603773],
                            [120.709096, 28.611509],
                            [120.70201, 28.606352],
                            [120.701026, 28.592751],
                            [120.687344, 28.582476],
                            [120.669234, 28.579606],
                            [120.653043, 28.585014],
                            [120.63946, 28.577443],
                            [120.649647, 28.563006],
                            [120.640002, 28.557847],
                            [120.631291, 28.564005],
                            [120.621202, 28.55639],
                            [120.627157, 28.547402],
                            [120.624303, 28.533377],
                            [120.598811, 28.53396],
                            [120.583358, 28.530797],
                            [120.572236, 28.537498],
                            [120.567856, 28.531879],
                            [120.554716, 28.535958],
                            [120.549204, 28.533585],
                            [120.541232, 28.543365],
                            [120.528781, 28.548359],
                            [120.524056, 28.55535],
                            [120.501566, 28.56001],
                            [120.493495, 28.577776],
                            [120.471891, 28.586928],
                            [120.446349, 28.584307],
                            [120.441871, 28.573324],
                            [120.4307, 28.568165],
                            [120.434145, 28.553727],
                            [120.430503, 28.534293],
                            [120.422727, 28.533627],
                            [120.422186, 28.522223],
                            [120.414952, 28.512358],
                            [120.414952, 28.496871],
                            [120.419135, 28.491875],
                            [120.405995, 28.480425],
                            [120.398957, 28.465017],
                            [120.387786, 28.479467],
                            [120.379715, 28.498037],
                            [120.36628, 28.499785],
                            [120.341034, 28.49633],
                            [120.336802, 28.509236],
                            [120.324252, 28.512358],
                            [120.313376, 28.522181],
                            [120.304223, 28.506988],
                            [120.292658, 28.511983],
                            [120.290935, 28.539037],
                            [120.311556, 28.557639],
                            [120.322087, 28.554143],
                            [120.326221, 28.56388],
                            [120.322481, 28.573449],
                            [120.332963, 28.580563],
                            [120.349597, 28.574198],
                            [120.361359, 28.580188],
                            [120.371152, 28.573615],
                            [120.3807, 28.581852],
                            [120.381733, 28.599864],
                            [120.371644, 28.606394],
                            [120.368839, 28.618205],
                            [120.353288, 28.626896],
                            [120.349745, 28.633008],
                            [120.356733, 28.637665],
                            [120.357471, 28.646853],
                            [120.336211, 28.654378],
                            [120.32253, 28.6698],
                            [120.324056, 28.686341],
                            [120.331585, 28.701301],
                            [120.349499, 28.704334],
                            [120.355503, 28.712187],
                            [120.351861, 28.723986],
                            [120.343101, 28.721909],
                            [120.347481, 28.730218],
                            [120.362934, 28.734538],
                            [120.369971, 28.740893],
                            [120.368987, 28.763861],
                            [120.386064, 28.787114],
                            [120.40068, 28.785494],
                            [120.409883, 28.798572],
                            [120.408111, 28.806626],
                            [120.415099, 28.822315],
                            [120.426713, 28.831985],
                            [120.441773, 28.841406],
                            [120.473909, 28.839206],
                            [120.481143, 28.828167],
                            [120.486802, 28.846012],
                            [120.498466, 28.849207],
                            [120.502206, 28.857215],
                            [120.494972, 28.86601],
                            [120.509982, 28.874888],
                            [120.514706, 28.890734],
                            [120.525484, 28.878663],
                            [120.533948, 28.879534],
                            [120.533604, 28.866301],
                            [120.542757, 28.867048],
                            [120.56323, 28.861696],
                            [120.579962, 28.869371],
                            [120.590051, 28.881111],
                            [120.60447, 28.890692],
                            [120.619086, 28.895628],
                            [120.64699, 28.90048],
                            [120.663771, 28.916488],
                            [120.664953, 28.923786],
                            [120.659638, 28.937136],
                            [120.673417, 28.959895],
                            [120.673319, 28.973158],
                            [120.677699, 28.977302],
                            [120.696695, 28.980037],
                            [120.69886, 28.972992],
                            [120.717315, 28.973779],
                            [120.726665, 28.98128],
                            [120.72199, 28.995245],
                            [120.72952, 28.99711],
                            [120.72824, 29.009829],
                            [120.720317, 29.012356],
                            [120.724451, 29.023873],
                            [120.713575, 29.035264],
                            [120.701714, 29.022713],
                            [120.693151, 29.040565],
                            [120.70073, 29.044334],
                            [120.691626, 29.052079],
                            [120.702207, 29.060195],
                            [120.704864, 29.075888],
                            [120.694382, 29.086942],
                            [120.701222, 29.097457],
                            [120.709884, 29.098409],
                            [120.723614, 29.119145],
                            [120.736606, 29.11331],
                            [120.746843, 29.122911],
                            [120.734441, 29.13127],
                            [120.722187, 29.130236],
                            [120.712295, 29.143767],
                            [120.731095, 29.164494],
                            [120.749648, 29.176035],
                            [120.759884, 29.189022],
                            [120.77824, 29.19965],
                            [120.773171, 29.205687],
                            [120.783063, 29.221193],
                            [120.776518, 29.225079],
                            [120.806144, 29.234009],
                            [120.82391, 29.229503],
                            [120.838428, 29.237895],
                            [120.853634, 29.253519],
                            [120.862148, 29.252362],
                            [120.867266, 29.24455],
                            [120.882227, 29.239217],
                            [120.900042, 29.240788],
                            [120.897335, 29.253478],
                            [120.890692, 29.260462],
                            [120.891627, 29.270009],
                            [120.903782, 29.276042],
                            [120.904225, 29.295462],
                            [120.915347, 29.303311],
                            [120.928093, 29.291702],
                            [120.942611, 29.289595],
                            [120.956883, 29.282447],
                            [120.964806, 29.306327],
                            [120.990889, 29.309219],
                            [121.005554, 29.319421],
                            [121.020515, 29.317728],
                            [121.024009, 29.308103],
                            [121.04084, 29.309549],
                            [121.056539, 29.322891],
                            [121.074698, 29.322106],
                            [121.099501, 29.317893],
                            [121.096155, 29.305707],
                            [121.117513, 29.304509],
                            [121.120368, 29.318719],
                            [121.117956, 29.33111],
                            [121.122041, 29.336396],
                            [121.133704, 29.338337],
                            [121.149846, 29.330903],
                            [121.160574, 29.340154],
                            [121.163084, 29.325039],
                            [121.175092, 29.323097],
                            [121.180456, 29.32921],
                            [121.194187, 29.322189],
                            [121.190742, 29.312358],
                            [121.201077, 29.312482],
                            [121.196992, 29.303229],
                            [121.180899, 29.292033],
                            [121.175289, 29.278274],
                            [121.179325, 29.258727],
                            [121.166824, 29.258892],
                            [121.158852, 29.244756],
                            [121.174403, 29.223095],
                            [121.164708, 29.2116],
                            [121.173517, 29.20639],
                            [121.202701, 29.203578],
                            [121.225338, 29.203868],
                            [121.233705, 29.196797],
                            [121.232966, 29.186623],
                            [121.238872, 29.175745],
                            [121.251028, 29.163542],
                            [121.253045, 29.157172],
                            [121.264364, 29.1544],
                            [121.257622, 29.149311],
                            [121.258754, 29.129243],
                            [121.256096, 29.114055],
                            [121.270713, 29.11033],
                            [121.271746, 29.101803],
                            [121.295221, 29.092696],
                            [121.298616, 29.114593],
                            [121.308213, 29.11451],
                            [121.316973, 29.105653],
                            [121.323813, 29.117159],
                            [121.336609, 29.121959],
                            [121.348715, 29.135574],
                            [121.345418, 29.145173],
                            [121.361904, 29.173305],
                            [121.356343, 29.186044],
                            [121.366924, 29.189146],
                            [121.378784, 29.199236],
                            [121.385378, 29.196921],
                            [121.403833, 29.17864],
                            [121.401225, 29.160978],
                            [121.407032, 29.156882],
                            [121.431048, 29.159778],
                            [121.450044, 29.159612],
                            [121.470517, 29.147615],
                            [121.484542, 29.142856],
                            [121.508361, 29.140622],
                            [121.529719, 29.136277],
                            [121.53592, 29.139795],
                            [121.555802, 29.168961],
                            [121.564267, 29.173056],
                            [121.60846, 29.169127]
                        ]
                    ],
                    [
                        [
                            [121.84911, 28.733666],
                            [121.855557, 28.736075],
                            [121.846994, 28.741433],
                            [121.851177, 28.748868],
                            [121.875833, 28.749034],
                            [121.893008, 28.762532],
                            [121.909544, 28.761867],
                            [121.896109, 28.757341],
                            [121.893008, 28.752108],
                            [121.880508, 28.748702],
                            [121.866089, 28.738027],
                            [121.873077, 28.727518],
                            [121.865547, 28.721992],
                            [121.859642, 28.727891],
                            [121.846797, 28.729055],
                            [121.84911, 28.733666]
                        ]
                    ],
                    [
                        [
                            [121.749651, 28.69058],
                            [121.761856, 28.689333],
                            [121.765252, 28.705124],
                            [121.780508, 28.699182],
                            [121.772732, 28.694195],
                            [121.790006, 28.690913],
                            [121.801571, 28.702423],
                            [121.808559, 28.699431],
                            [121.800045, 28.695317],
                            [121.794041, 28.679608],
                            [121.781689, 28.680066],
                            [121.778687, 28.687629],
                            [121.768254, 28.690746],
                            [121.75226, 28.683349],
                            [121.749651, 28.69058]
                        ]
                    ],
                    [
                        [
                            [121.919928, 28.707285],
                            [121.916581, 28.717215],
                            [121.942664, 28.720663],
                            [121.920617, 28.704916],
                            [121.919928, 28.707285]
                        ]
                    ],
                    [
                        [
                            [121.387347, 28.119292],
                            [121.401323, 28.129862],
                            [121.401569, 28.122968],
                            [121.387347, 28.119292]
                        ]
                    ],
                    [
                        [
                            [121.837349, 28.770505],
                            [121.850538, 28.784747],
                            [121.844386, 28.788816],
                            [121.852949, 28.793092],
                            [121.857034, 28.803637],
                            [121.850734, 28.808286],
                            [121.861561, 28.813765],
                            [121.872388, 28.807871],
                            [121.865498, 28.799361],
                            [121.862693, 28.78209],
                            [121.843254, 28.770629],
                            [121.837349, 28.770505]
                        ]
                    ],
                    [
                        [
                            [121.687397, 28.384526],
                            [121.69532, 28.381317],
                            [121.686118, 28.374648],
                            [121.687397, 28.384526]
                        ]
                    ],
                    [
                        [
                            [121.889563, 28.471513],
                            [121.876128, 28.472554],
                            [121.874111, 28.47701],
                            [121.883116, 28.484089],
                            [121.883658, 28.495456],
                            [121.871305, 28.49429],
                            [121.87037, 28.500035],
                            [121.880065, 28.501909],
                            [121.8873, 28.511359],
                            [121.896994, 28.514231],
                            [121.899455, 28.500701],
                            [121.918943, 28.497371],
                            [121.908313, 28.479092],
                            [121.889563, 28.471513]
                        ]
                    ],
                    [
                        [
                            [121.678588, 28.278319],
                            [121.677604, 28.285954],
                            [121.686413, 28.2895],
                            [121.688775, 28.273939],
                            [121.678588, 28.278319]
                        ]
                    ],
                    [
                        [
                            [121.410674, 28.079425],
                            [121.404227, 28.077627],
                            [121.40718, 28.089873],
                            [121.400831, 28.092506],
                            [121.410526, 28.101617],
                            [121.410674, 28.079425]
                        ]
                    ],
                    [
                        [
                            [121.869534, 28.423946],
                            [121.871256, 28.433111],
                            [121.889711, 28.451189],
                            [121.920617, 28.45273],
                            [121.910823, 28.440068],
                            [121.893451, 28.430278],
                            [121.88602, 28.433986],
                            [121.869534, 28.423946]
                        ]
                    ],
                    [
                        [
                            [121.687397, 29.09667],
                            [121.681885, 29.109336],
                            [121.691777, 29.11124],
                            [121.697092, 29.094062],
                            [121.687397, 29.09667]
                        ]
                    ],
                    [
                        [
                            [121.695271, 29.088474],
                            [121.710084, 29.082719],
                            [121.694385, 29.084707],
                            [121.695271, 29.088474]
                        ]
                    ],
                    [
                        [
                            [121.672633, 29.062224],
                            [121.680507, 29.054688],
                            [121.665842, 29.059615],
                            [121.672633, 29.062224]
                        ]
                    ],
                    [
                        [
                            [121.67908, 28.371063],
                            [121.688431, 28.373064],
                            [121.687348, 28.366269],
                            [121.67908, 28.371063]
                        ]
                    ],
                    [
                        [
                            [121.851227, 28.423487],
                            [121.855607, 28.431819],
                            [121.860872, 28.426737],
                            [121.851227, 28.423487]
                        ]
                    ],
                    [
                        [
                            [121.634592, 28.225448],
                            [121.644927, 28.232836],
                            [121.644828, 28.222985],
                            [121.634592, 28.225448]
                        ]
                    ],
                    [
                        [
                            [121.502062, 28.072235],
                            [121.504867, 28.085736],
                            [121.528834, 28.101742],
                            [121.532279, 28.093426],
                            [121.527111, 28.086363],
                            [121.516137, 28.087199],
                            [121.511068, 28.077084],
                            [121.502062, 28.072235]
                        ]
                    ],
                    [
                        [
                            [121.346353, 28.087784],
                            [121.345565, 28.096059],
                            [121.359443, 28.098065],
                            [121.373961, 28.10989],
                            [121.372091, 28.099903],
                            [121.356786, 28.089121],
                            [121.346353, 28.087784]
                        ]
                    ],
                    [
                        [
                            [121.81727, 28.610428],
                            [121.823274, 28.607267],
                            [121.803933, 28.599115],
                            [121.81727, 28.610428]
                        ]
                    ],
                    [
                        [
                            [121.685576, 29.115917],
                            [121.690153, 29.120883],
                            [121.694385, 29.113061],
                            [121.685576, 29.115917]
                        ]
                    ],
                    [
                        [
                            [121.145122, 28.013239],
                            [121.149649, 28.019805],
                            [121.166185, 28.021771],
                            [121.145122, 28.013239]
                        ]
                    ],
                    [
                        [
                            [121.940105, 28.441526],
                            [121.94355, 28.450731],
                            [121.945174, 28.436652],
                            [121.940105, 28.441526]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "adcode": 331100,
                "name": "丽水市",
                "center": [119.921786, 28.451993],
                "centroid": [119.517145, 28.197644],
                "childrenNum": 9,
                "level": "city",
                "parent": {
                    "adcode": 330000
                },
                "subFeatureIndex": 10,
                "acroutes": [100000, 330000]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [120.426713, 28.831985],
                            [120.415099, 28.822315],
                            [120.408111, 28.806626],
                            [120.409883, 28.798572],
                            [120.40068, 28.785494],
                            [120.386064, 28.787114],
                            [120.368987, 28.763861],
                            [120.369971, 28.740893],
                            [120.362934, 28.734538],
                            [120.347481, 28.730218],
                            [120.343101, 28.721909],
                            [120.351861, 28.723986],
                            [120.355503, 28.712187],
                            [120.349499, 28.704334],
                            [120.331585, 28.701301],
                            [120.324056, 28.686341],
                            [120.32253, 28.6698],
                            [120.336211, 28.654378],
                            [120.357471, 28.646853],
                            [120.356733, 28.637665],
                            [120.349745, 28.633008],
                            [120.353288, 28.626896],
                            [120.368839, 28.618205],
                            [120.371644, 28.606394],
                            [120.381733, 28.599864],
                            [120.3807, 28.581852],
                            [120.371152, 28.573615],
                            [120.361359, 28.580188],
                            [120.349597, 28.574198],
                            [120.332963, 28.580563],
                            [120.322481, 28.573449],
                            [120.326221, 28.56388],
                            [120.322087, 28.554143],
                            [120.311556, 28.557639],
                            [120.290935, 28.539037],
                            [120.292658, 28.511983],
                            [120.304223, 28.506988],
                            [120.313376, 28.522181],
                            [120.324252, 28.512358],
                            [120.336802, 28.509236],
                            [120.341034, 28.49633],
                            [120.36628, 28.499785],
                            [120.379715, 28.498037],
                            [120.387786, 28.479467],
                            [120.384341, 28.458894],
                            [120.372137, 28.446982],
                            [120.381044, 28.436277],
                            [120.381684, 28.42557],
                            [120.374302, 28.410821],
                            [120.366723, 28.424279],
                            [120.34379, 28.431903],
                            [120.33818, 28.427112],
                            [120.338819, 28.412363],
                            [120.331684, 28.407571],
                            [120.337638, 28.395528],
                            [120.344725, 28.392444],
                            [120.33503, 28.384484],
                            [120.334686, 28.371355],
                            [120.353485, 28.367228],
                            [120.359883, 28.359391],
                            [120.360768, 28.3453],
                            [120.346595, 28.335126],
                            [120.357914, 28.32883],
                            [120.369971, 28.331332],
                            [120.377698, 28.31757],
                            [120.394971, 28.315485],
                            [120.402796, 28.305976],
                            [120.414164, 28.302931],
                            [120.417019, 28.288832],
                            [120.426418, 28.268056],
                            [120.421448, 28.253827],
                            [120.433505, 28.246984],
                            [120.438426, 28.234463],
                            [120.415788, 28.213927],
                            [120.41195, 28.199482],
                            [120.425188, 28.196351],
                            [120.431044, 28.186915],
                            [120.422087, 28.182823],
                            [120.413672, 28.172633],
                            [120.421546, 28.160188],
                            [120.385916, 28.147365],
                            [120.38567, 28.14206],
                            [120.408013, 28.131617],
                            [120.405601, 28.124222],
                            [120.411851, 28.11457],
                            [120.390542, 28.094303],
                            [120.383652, 28.09539],
                            [120.368446, 28.088912],
                            [120.362294, 28.080093],
                            [120.37381, 28.066174],
                            [120.372432, 28.054929],
                            [120.357176, 28.050581],
                            [120.350286, 28.052588],
                            [120.344922, 28.040003],
                            [120.34881, 28.034902],
                            [120.348711, 28.021018],
                            [120.344479, 28.019011],
                            [120.335522, 27.990444],
                            [120.349154, 27.987683],
                            [120.336064, 27.970697],
                            [120.328928, 27.966681],
                            [120.324646, 27.978981],
                            [120.295168, 27.977057],
                            [120.276516, 27.959609],
                            [120.265591, 27.95714],
                            [120.257471, 27.96735],
                            [120.248957, 27.964003],
                            [120.24561, 27.943415],
                            [120.241575, 27.934961],
                            [120.229961, 27.931361],
                            [120.218691, 27.93563],
                            [120.202057, 27.935965],
                            [120.187835, 27.948562],
                            [120.178337, 27.952956],
                            [120.174842, 27.960404],
                            [120.176713, 27.972203],
                            [120.171939, 27.978563],
                            [120.145758, 27.979692],
                            [120.143888, 27.976596],
                            [120.11746, 27.982621],
                            [120.096889, 27.980613],
                            [120.084389, 27.967099],
                            [120.074301, 27.972287],
                            [120.064311, 27.961241],
                            [120.063572, 27.951073],
                            [120.043001, 27.951115],
                            [120.031781, 27.941322],
                            [120.020511, 27.939606],
                            [120.009389, 27.947892],
                            [120.001269, 27.941029],
                            [119.966919, 27.937597],
                            [119.962145, 27.950236],
                            [119.968739, 27.962496],
                            [119.96244, 27.97622],
                            [119.928631, 27.968814],
                            [119.90683, 27.954253],
                            [119.892115, 27.951366],
                            [119.875235, 27.974128],
                            [119.86554, 27.966388],
                            [119.865688, 27.950864],
                            [119.861997, 27.949525],
                            [119.854861, 27.961911],
                            [119.833601, 27.956178],
                            [119.831436, 27.951617],
                            [119.85117, 27.932198],
                            [119.843099, 27.92705],
                            [119.83306, 27.911353],
                            [119.825284, 27.911771],
                            [119.815146, 27.92073],
                            [119.804713, 27.922111],
                            [119.786455, 27.909302],
                            [119.791032, 27.898584],
                            [119.800186, 27.890545],
                            [119.790097, 27.867095],
                            [119.785077, 27.861651],
                            [119.788965, 27.85319],
                            [119.785766, 27.833503],
                            [119.793886, 27.826381],
                            [119.785766, 27.822485],
                            [119.787882, 27.808993],
                            [119.785077, 27.795793],
                            [119.773069, 27.794075],
                            [119.768148, 27.805306],
                            [119.756189, 27.795625],
                            [119.734831, 27.766622],
                            [119.725874, 27.767712],
                            [119.719427, 27.76046],
                            [119.696986, 27.753626],
                            [119.680205, 27.744193],
                            [119.678581, 27.734005],
                            [119.665982, 27.721886],
                            [119.650726, 27.717147],
                            [119.650923, 27.695547],
                            [119.65614, 27.69345],
                            [119.646937, 27.685732],
                            [119.643, 27.673188],
                            [119.635569, 27.668405],
                            [119.606238, 27.67474],
                            [119.595018, 27.666895],
                            [119.583945, 27.665175],
                            [119.578925, 27.669832],
                            [119.566523, 27.663748],
                            [119.550135, 27.663832],
                            [119.549299, 27.670167],
                            [119.539161, 27.67537],
                            [119.541917, 27.663916],
                            [119.537094, 27.658923],
                            [119.525923, 27.660307],
                            [119.52046, 27.650069],
                            [119.511503, 27.653468],
                            [119.501169, 27.649901],
                            [119.49797, 27.625896],
                            [119.500923, 27.608224],
                            [119.488718, 27.59882],
                            [119.481877, 27.585679],
                            [119.48483, 27.570394],
                            [119.477497, 27.553847],
                            [119.474643, 27.539314],
                            [119.466523, 27.52646],
                            [119.45171, 27.51352],
                            [119.438472, 27.508772],
                            [119.432861, 27.513016],
                            [119.422674, 27.536584],
                            [119.41667, 27.539651],
                            [119.394968, 27.539272],
                            [119.376808, 27.534988],
                            [119.360027, 27.524402],
                            [119.341867, 27.506797],
                            [119.347674, 27.492763],
                            [119.334682, 27.480029],
                            [119.285026, 27.457626],
                            [119.276463, 27.435512],
                            [119.267851, 27.421468],
                            [119.251069, 27.420753],
                            [119.24728, 27.4295],
                            [119.243441, 27.419828],
                            [119.222674, 27.417053],
                            [119.209485, 27.422099],
                            [119.19477, 27.418735],
                            [119.180252, 27.428238],
                            [119.16849, 27.424874],
                            [119.153973, 27.428532],
                            [119.147526, 27.424832],
                            [119.138766, 27.434419],
                            [119.12853, 27.43177],
                            [119.121394, 27.438329],
                            [119.125921, 27.452203],
                            [119.118884, 27.461451],
                            [119.131286, 27.46309],
                            [119.130744, 27.4728],
                            [119.115095, 27.482845],
                            [119.088126, 27.464099],
                            [119.072525, 27.472253],
                            [119.066423, 27.466957],
                            [119.055301, 27.477591],
                            [119.037191, 27.480617],
                            [119.020803, 27.497931],
                            [118.998903, 27.496335],
                            [118.990734, 27.503352],
                            [118.982761, 27.49604],
                            [118.990439, 27.48856],
                            [118.988322, 27.477255],
                            [118.966029, 27.473346],
                            [118.955448, 27.449849],
                            [118.949198, 27.456364],
                            [118.933352, 27.463595],
                            [118.910763, 27.460862],
                            [118.901462, 27.464688],
                            [118.897722, 27.478978],
                            [118.889454, 27.481332],
                            [118.89034, 27.494107],
                            [118.886501, 27.501251],
                            [118.879907, 27.49957],
                            [118.873607, 27.517764],
                            [118.857859, 27.516671],
                            [118.859631, 27.527594],
                            [118.869178, 27.539903],
                            [118.889011, 27.547505],
                            [118.896048, 27.563129],
                            [118.910222, 27.570352],
                            [118.90407, 27.575979],
                            [118.902741, 27.592313],
                            [118.913913, 27.619138],
                            [118.902643, 27.623671],
                            [118.903726, 27.638864],
                            [118.89531, 27.655566],
                            [118.879907, 27.667944],
                            [118.874641, 27.682795],
                            [118.880546, 27.689297],
                            [118.875035, 27.700958],
                            [118.878479, 27.70532],
                            [118.900084, 27.704985],
                            [118.897968, 27.718909],
                            [118.890438, 27.718741],
                            [118.880645, 27.731153],
                            [118.87218, 27.734424],
                            [118.853972, 27.774251],
                            [118.839995, 27.779322],
                            [118.839405, 27.788585],
                            [118.851462, 27.796003],
                            [118.847131, 27.812513],
                            [118.838814, 27.820641],
                            [118.835418, 27.838195],
                            [118.826314, 27.846614],
                            [118.835763, 27.866509],
                            [118.82656, 27.874843],
                            [118.831531, 27.886316],
                            [118.820408, 27.89536],
                            [118.81844, 27.916711],
                            [118.803725, 27.918302],
                            [118.804562, 27.927092],
                            [118.767111, 27.941824],
                            [118.754168, 27.942745],
                            [118.753479, 27.948018],
                            [118.729906, 27.97258],
                            [118.732514, 27.990904],
                            [118.72656, 28.000399],
                            [118.726609, 28.014201],
                            [118.733499, 28.026455],
                            [118.732662, 28.035947],
                            [118.720359, 28.045438],
                            [118.718784, 28.063624],
                            [118.73532, 28.074994],
                            [118.743144, 28.088536],
                            [118.763518, 28.094721],
                            [118.765142, 28.102912],
                            [118.773607, 28.107968],
                            [118.785369, 28.106715],
                            [118.802298, 28.117286],
                            [118.800428, 28.13312],
                            [118.805891, 28.153088],
                            [118.798115, 28.168917],
                            [118.782908, 28.172633],
                            [118.775182, 28.167998],
                            [118.760959, 28.167413],
                            [118.769276, 28.185746],
                            [118.782121, 28.193178],
                            [118.794769, 28.205953],
                            [118.804168, 28.207874],
                            [118.812387, 28.225573],
                            [118.802052, 28.240431],
                            [118.781186, 28.243102],
                            [118.754513, 28.253452],
                            [118.740881, 28.267514],
                            [118.739355, 28.27736],
                            [118.727298, 28.281115],
                            [118.730152, 28.2968],
                            [118.722327, 28.31048],
                            [118.713518, 28.312899],
                            [118.700182, 28.310397],
                            [118.701904, 28.327078],
                            [118.717898, 28.33817],
                            [118.724001, 28.338337],
                            [118.742012, 28.364435],
                            [118.738371, 28.369813],
                            [118.757564, 28.407488],
                            [118.753233, 28.417321],
                            [118.734975, 28.416779],
                            [118.723459, 28.411196],
                            [118.723951, 28.433153],
                            [118.731136, 28.456479],
                            [118.725379, 28.460894],
                            [118.729709, 28.479508],
                            [118.723164, 28.493249],
                            [118.726953, 28.499827],
                            [118.7428, 28.509152],
                            [118.751215, 28.52447],
                            [118.765142, 28.524096],
                            [118.777298, 28.518435],
                            [118.780546, 28.526552],
                            [118.795359, 28.534335],
                            [118.809385, 28.536249],
                            [118.821786, 28.547444],
                            [118.83842, 28.539911],
                            [118.851019, 28.53962],
                            [118.854562, 28.532212],
                            [118.864552, 28.529923],
                            [118.868046, 28.521723],
                            [118.878332, 28.522056],
                            [118.889306, 28.533003],
                            [118.890192, 28.539745],
                            [118.902938, 28.548859],
                            [118.91406, 28.563921],
                            [118.908549, 28.574447],
                            [118.909139, 28.589756],
                            [118.917112, 28.599739],
                            [118.916619, 28.610885],
                            [118.923657, 28.619244],
                            [118.925527, 28.63359],
                            [118.930202, 28.640534],
                            [118.956974, 28.647394],
                            [118.962683, 28.642405],
                            [118.983992, 28.663856],
                            [118.991472, 28.676491],
                            [119.001659, 28.683058],
                            [119.007958, 28.694569],
                            [119.02971, 28.709694],
                            [119.043687, 28.71227],
                            [119.047575, 28.722159],
                            [119.063962, 28.733541],
                            [119.080793, 28.740146],
                            [119.087831, 28.735203],
                            [119.097132, 28.743261],
                            [119.122378, 28.737072],
                            [119.137683, 28.738027],
                            [119.161207, 28.748162],
                            [119.169573, 28.748868],
                            [119.187536, 28.770173],
                            [119.213569, 28.768968],
                            [119.238028, 28.761992],
                            [119.24851, 28.763612],
                            [119.255745, 28.776152],
                            [119.271148, 28.786532],
                            [119.276512, 28.802931],
                            [119.291325, 28.806003],
                            [119.302644, 28.80401],
                            [119.311503, 28.811897],
                            [119.322428, 28.800897],
                            [119.328629, 28.800565],
                            [119.327694, 28.779806],
                            [119.338422, 28.761161],
                            [119.346247, 28.757008],
                            [119.358206, 28.761037],
                            [119.359534, 28.768304],
                            [119.368737, 28.774118],
                            [119.371887, 28.784789],
                            [119.387684, 28.786948],
                            [119.412438, 28.76166],
                            [119.413619, 28.751983],
                            [119.421198, 28.749159],
                            [119.430696, 28.755596],
                            [119.470854, 28.765356],
                            [119.473019, 28.749782],
                            [119.479663, 28.739647],
                            [119.463767, 28.742306],
                            [119.460814, 28.73944],
                            [119.46421, 28.70824],
                            [119.458895, 28.683848],
                            [119.462241, 28.661237],
                            [119.455696, 28.650886],
                            [119.461208, 28.634879],
                            [119.468442, 28.633632],
                            [119.482025, 28.639453],
                            [119.488423, 28.626438],
                            [119.507911, 28.615335],
                            [119.509879, 28.603357],
                            [119.498068, 28.584848],
                            [119.494427, 28.554018],
                            [119.498413, 28.54865],
                            [119.514653, 28.561675],
                            [119.53488, 28.555724],
                            [119.535175, 28.543782],
                            [119.542458, 28.532628],
                            [119.568492, 28.532295],
                            [119.574201, 28.523888],
                            [119.613374, 28.5278],
                            [119.629171, 28.525386],
                            [119.638276, 28.528508],
                            [119.644722, 28.541867],
                            [119.660224, 28.539953],
                            [119.674742, 28.530006],
                            [119.703581, 28.533211],
                            [119.707813, 28.545738],
                            [119.717705, 28.553769],
                            [119.720461, 28.56596],
                            [119.739309, 28.584848],
                            [119.7399, 28.591462],
                            [119.754122, 28.592668],
                            [119.767065, 28.588009],
                            [119.773955, 28.603233],
                            [119.772725, 28.608556],
                            [119.749398, 28.622696],
                            [119.752449, 28.635253],
                            [119.764949, 28.638704],
                            [119.777252, 28.630887],
                            [119.794969, 28.632883],
                            [119.811751, 28.65392],
                            [119.813867, 28.68684],
                            [119.826367, 28.695317],
                            [119.849644, 28.716591],
                            [119.86618, 28.718503],
                            [119.874448, 28.73541],
                            [119.87179, 28.742306],
                            [119.882371, 28.7492],
                            [119.886751, 28.744632],
                            [119.89807, 28.750363],
                            [119.906731, 28.768553],
                            [119.921003, 28.784],
                            [119.921298, 28.796164],
                            [119.942164, 28.793009],
                            [119.948562, 28.787197],
                            [119.967607, 28.787819],
                            [119.971643, 28.794255],
                            [119.982421, 28.796662],
                            [120.005304, 28.780886],
                            [120.010669, 28.772207],
                            [120.025679, 28.764151],
                            [120.028976, 28.758047],
                            [120.049202, 28.763155],
                            [120.083946, 28.787031],
                            [120.097037, 28.768553],
                            [120.109882, 28.767224],
                            [120.111309, 28.762324],
                            [120.131437, 28.759708],
                            [120.145561, 28.784],
                            [120.165344, 28.774325],
                            [120.178435, 28.775239],
                            [120.183553, 28.785162],
                            [120.198858, 28.783958],
                            [120.209341, 28.795832],
                            [120.200335, 28.80181],
                            [120.20186, 28.810029],
                            [120.215148, 28.825885],
                            [120.216526, 28.832608],
                            [120.236506, 28.844808],
                            [120.241821, 28.857256],
                            [120.260719, 28.865471],
                            [120.261752, 28.911429],
                            [120.250729, 28.913792],
                            [120.258603, 28.927103],
                            [120.255453, 28.931],
                            [120.264951, 28.93896],
                            [120.271004, 28.950112],
                            [120.277894, 28.930544],
                            [120.303977, 28.931664],
                            [120.314312, 28.9191],
                            [120.303239, 28.892808],
                            [120.315394, 28.887042],
                            [120.316428, 28.876879],
                            [120.331388, 28.868914],
                            [120.338278, 28.860244],
                            [120.347284, 28.858252],
                            [120.357914, 28.839372],
                            [120.368446, 28.838044],
                            [120.388475, 28.829454],
                            [120.392855, 28.834558],
                            [120.392954, 28.847132],
                            [120.404715, 28.853813],
                            [120.406881, 28.845182],
                            [120.418101, 28.851655],
                            [120.426713, 28.831985]
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                adcode: '310000',
                name: '上海市',
                center: [121.472644, 31.231706],
                centroid: [121.438734, 31.07256],
                childrenNum: 16,
                level: 'province',
                parent: { adcode: 100000 },
                subFeatureIndex: 8,
                acroutes: [100000],
            },
            geometry: {
                type: 'MultiPolygon',
                coordinates: [
                    [
                        [
                            [120.901349, 31.017327],
                            [120.890878, 31.094229],
                            [120.859465, 31.100379],
                            [120.881023, 31.134706],
                            [120.930298, 31.141365],
                            [121.018377, 31.134194],
                            [121.076892, 31.158267],
                            [121.060261, 31.245289],
                            [121.090442, 31.291838],
                            [121.138485, 31.276495],
                            [121.160659, 31.283144],
                            [121.129862, 31.302577],
                            [121.130478, 31.343987],
                            [121.113848, 31.37465],
                            [121.143413, 31.392021],
                            [121.174826, 31.44922],
                            [121.240731, 31.493627],
                            [121.247507, 31.476785],
                            [121.301093, 31.49873],
                            [121.301093, 31.49873],
                            [121.343593, 31.511996],
                            [121.404571, 31.479337],
                            [121.520984, 31.394575],
                            [121.599208, 31.37465],
                            [121.722396, 31.3036],
                            [121.809859, 31.196669],
                            [121.946598, 31.066039],
                            [121.977395, 31.016301],
                            [121.990945, 30.96859],
                            [121.994025, 30.862823],
                            [121.954605, 30.825828],
                            [121.970004, 30.789333],
                            [121.943518, 30.776993],
                            [121.904714, 30.814007],
                            [121.681128, 30.818633],
                            [121.601056, 30.805269],
                            [121.517288, 30.775451],
                            [121.426129, 30.730192],
                            [121.362071, 30.679764],
                            [121.274608, 30.677191],
                            [121.272144, 30.723504],
                            [121.232108, 30.755909],
                            [121.21671, 30.785734],
                            [121.174826, 30.771851],
                            [121.123087, 30.77905],
                            [121.13787, 30.826342],
                            [121.097833, 30.857171],
                            [121.060261, 30.845354],
                            [121.038087, 30.814007],
                            [120.991892, 30.837133],
                            [121.020225, 30.872069],
                            [120.993124, 30.889532],
                            [121.000515, 30.938309],
                            [120.989428, 31.01425],
                            [120.949392, 31.030148],
                            [120.940153, 31.010146],
                            [120.901349, 31.017327],
                        ],
                    ],
                    [
                        [
                            [121.974931, 31.61704],
                            [121.995873, 31.493117],
                            [121.981706, 31.464024],
                            [121.890547, 31.428795],
                            [121.819098, 31.437987],
                            [121.682976, 31.491075],
                            [121.625693, 31.501792],
                            [121.547469, 31.531382],
                            [121.434136, 31.590535],
                            [121.395332, 31.585437],
                            [121.371926, 31.553314],
                            [121.289391, 31.61653],
                            [121.145261, 31.75403],
                            [121.118775, 31.759119],
                            [121.200079, 31.834907],
                            [121.265369, 31.863883],
                            [121.323267, 31.868458],
                            [121.384861, 31.833382],
                            [121.431673, 31.769295],
                            [121.49881, 31.753012],
                            [121.599824, 31.703128],
                            [121.64294, 31.697527],
                            [121.715005, 31.673592],
                            [121.974931, 31.61704],
                        ],
                    ],
                    [
                        [
                            [121.779062, 31.310247],
                            [121.727939, 31.35472],
                            [121.572107, 31.435944],
                            [121.509897, 31.4824],
                            [121.520984, 31.494137],
                            [121.567179, 31.48342],
                            [121.585657, 31.454836],
                            [121.742106, 31.407345],
                            [121.792613, 31.363408],
                            [121.793845, 31.31945],
                            [121.779062, 31.310247],
                        ],
                    ],
                    [
                        [
                            [121.801852, 31.356765],
                            [121.792613, 31.377715],
                            [121.845584, 31.37465],
                            [121.951525, 31.337343],
                            [122.040837, 31.324051],
                            [122.116597, 31.320984],
                            [122.122756, 31.307179],
                            [122.097503, 31.255522],
                            [122.016199, 31.282121],
                            [121.932431, 31.283144],
                            [121.840656, 31.295418],
                            [121.8037, 31.328652],
                            [121.801852, 31.356765],
                        ],
                    ],
                    [
                        [
                            [121.626925, 31.445135],
                            [121.579498, 31.479848],
                            [121.631853, 31.456878],
                            [121.626925, 31.445135],
                        ],
                    ],
                    [
                        [
                            [121.943518, 31.215608],
                            [121.950909, 31.228915],
                            [122.008808, 31.221238],
                            [121.995873, 31.160828],
                            [121.959533, 31.159291],
                            [121.943518, 31.215608],
                        ],
                    ],
                    [
                        [
                            [121.88254, 31.240684],
                            [121.923808, 31.234032],
                            [121.909026, 31.195133],
                            [121.88254, 31.240684],
                        ],
                    ],
                ],
            },
        },
    ],
};

export default {
    changsanjiaoMapJson
}

